export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A scalar type representing a date in the ISO 8601 form e.g. 2022-03-20 */
  Date: { input: any; output: any; }
  /** A scalar type representing a DateTime in the ISO 8601 format e.g. 2005-08-15T15:52:01.000+00:00 */
  DateTime: { input: any; output: any; }
  /** Can represent any JSON-serializable value, including scalars, arrays, and objects. */
  JSON: { input: any; output: any; }
  /** Represents specifically JSON objects. */
  JSONObject: { input: any; output: any; }
  Long: { input: any; output: any; }
  /** Empty return type, useful for mutations without payloads. */
  Void: { input: any; output: any; }
};

export type AccountConfirmation = {
  __typename?: 'AccountConfirmation';
  accountId: Scalars['ID']['output'];
  confirmationType: ConfirmationType;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  creationTimestamp: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  supplierId: Scalars['ID']['output'];
};

export enum AccountNotificationRolesInput {
  Accounting = 'ACCOUNTING',
  Bookings = 'BOOKINGS',
  CustomerQuestion = 'CUSTOMER_QUESTION',
  ProductQuality = 'PRODUCT_QUALITY',
  Reviews = 'REVIEWS'
}

export enum AccountRoleInput {
  Admin = 'ADMIN',
  Finance = 'FINANCE',
  Ops = 'OPS',
  Ticketing = 'TICKETING'
}

export enum AccountStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Unconfirmed = 'UNCONFIRMED'
}

export type AccountSubscriptionStateInput = {
  state: SubscriptionState;
  subscriptionId: Scalars['String']['input'];
};

/** Enum representing different bank account types */
export enum AccountType {
  Cacc = 'CACC',
  Svgs = 'SVGS'
}

export enum AcquisitionMedium {
  Bpo = 'bpo',
  Sales = 'sales'
}

export type ActOnSupplierCancellationInput = {
  /** The action to be taken for the supplier cancellation request. */
  action: SupplierCancellationAction;
  /** The ID of the booking for which the cancellation is accepted */
  bookingId: Scalars['ID']['input'];
  /** The preferred refund method. It is used only in case the action is to accept the supplier cancellation */
  preferredRefundMethod?: InputMaybe<RefundMethod>;
};

export type ActOnSupplierCancellationPayload = {
  __typename?: 'ActOnSupplierCancellationPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ActivateCustomerPayload = OperationResult & {
  __typename?: 'ActivateCustomerPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Activity = {
  __typename?: 'Activity';
  /**
   * The traveler can be asked a set of structured questions during checkout
   * The possible questions are predefined by GetYourGuide.
   * A supplier has to contact support for setting up these questions.
   * This field stores the selected questions.
   */
  activityCheckoutQuestions?: Maybe<Array<ActivityCheckoutQuestion>>;
  /** Class of the activity selected by the supplier */
  activityClass?: Maybe<ActivityClass>;
  /**
   * Field denoting whether a product is getting a timed boost to gather traffic and assess performance.
   * Boost we give to all new activities during the first 30 days of online or until they get 5 bookings before
   * the 30 days or until they go offline.
   */
  assessmentStatus?: Maybe<ActivityAssessmentStatus>;
  audience?: Maybe<Array<Tag>>;
  authorizedBadge?: Maybe<AuthorizedBadge>;
  /**
   * Flag that indicates if there are any constraints on the availability of the tour. E.g. there are only a fixed amount
   * of tickets per hour. True if the tour has at least one constraint on availability.
   */
  availabilityConstrained?: Maybe<Scalars['Boolean']['output']>;
  availabilityDebugInfo?: Maybe<AvailabilityDebugInfo>;
  /**
   * A flag that indicates if the tour is one of the best seller tours for the past 2 months.
   * To be a bestselling tour the amount of bookings will be compared with other tours for the same location.
   * If a tour is above a certain threshold it is flagged as a bestselling tour.
   * This information is further used for the ranking of the activity.
   * This flag is automatically updated in the catalog service from an s3 file provided by R&R.
   */
  bestseller?: Maybe<Scalars['Boolean']['output']>;
  /** The amount of bookings associated with a tour for a given time period */
  bookingCount: Scalars['Int']['output'];
  broadcasts?: Maybe<Array<Broadcast>>;
  /** Toggle the ability the supplier has to add options */
  canSupplierAddOptions?: Maybe<Scalars['Boolean']['output']>;
  /** Toggle the ability the supplier has to edit text on his activities */
  canSupplierEditText?: Maybe<Scalars['Boolean']['output']>;
  /** Toggle the ability the supplier has to edit any visual on his activities */
  canSupplierEditVisuals?: Maybe<Scalars['Boolean']['output']>;
  cancellationPolicy?: Maybe<CancellationPolicy>;
  /** Cancellation policy type set by the supplier. Not necessarily what is shown to the customer. */
  cancellationPolicyType?: Maybe<CancellationPolicyType>;
  /** Activity category computed based on its class and other properties */
  category?: Maybe<ActivityCategory>;
  /**
   * A flag that indicates if the supplier of the tour is a certified partner.
   * If yes the tour is going to be higher/more prominent in the search results.
   * On an Activity Detail Page this is shown with the GetYourGuide Certified badge.
   */
  certifiedPartner?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates GetYourGuide's commission percentage for the given activity */
  commissionRate?: Maybe<Scalars['Float']['output']>;
  completeness?: Maybe<TourCompleteness>;
  /** The time the activity was created */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  deals?: Maybe<Array<Deal>>;
  drinks?: Maybe<Array<Tag>>;
  drinksAlcoholic?: Maybe<Array<Tag>>;
  drinksNonAlcoholic?: Maybe<Array<Tag>>;
  /**
   * GetYourGuide believes in connecting travelers to incredible experiences like showcasing tours
   * and activities that promote eco-friendly travel and environmental protection while positively
   * impacting the destination.
   */
  ecoCertified?: Maybe<Scalars['Boolean']['output']>;
  /** Emergency phone number provided by the supplier */
  emergencyPhoneNumber?: Maybe<PhoneNumber>;
  /** Provides information if and how we enforce 3D secure payment during checkout. */
  enforce3DSecure?: Maybe<Enforce3DSecure>;
  /** External rating of an activity */
  externalRating?: Maybe<Scalars['Float']['output']>;
  /**
   * This column holds a list of fields the supplier has already entered (modified in any way).
   * Used only for internal purposes to distinguish if a field is automatically set or conscious decision by supplier.
   * Same field exists on the option 'ActivityOption.fieldsEntered'.
   */
  fieldsEntered?: Maybe<Array<Scalars['String']['output']>>;
  /** The first time the activity went online */
  firstOnlineTimestamp?: Maybe<Scalars['DateTime']['output']>;
  food?: Maybe<Array<Tag>>;
  freeTextCancellationPolicies?: Maybe<Array<FreeTextCancellationPolicy>>;
  fromLocation?: Maybe<Location>;
  /** An object containing all the information regarding AI generated fields */
  generatedContentFields?: Maybe<GeneratedContentFields>;
  /** An object containing all the information about user's input to generate content */
  generatedContentUserInput?: Maybe<GeneratedContentUserInput>;
  /**
   * Indicates the type of guide as part of the tour. Used in tour categorisation logic.
   * Automatically set to NONE for city cards and hohos.
   */
  guideType?: Maybe<GuideType>;
  hasModifications?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A flag that indicates if the supplier has to pay MWST (VAT taxes) as part of the offer.
   * This field is bound to German suppliers.
   */
  hasMwst?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The hash code is an alternative identifier for a tour.
   * It is used to render URLs so a supplier can view (preview) a tour that is actually not online
   * and thus not available through the normal URL.
   */
  hash?: Maybe<Scalars['String']['output']>;
  /**
   * The hash code is an alternative identifier for a tour.
   * It is used to render URLs so a supplier can view (preview) a tour that is actually not online
   * and thus not available through the normal URL.
   */
  hashCode?: Maybe<Scalars['String']['output']>;
  /** This flag does indicates how the traveller will receive the voucher. */
  howToReceiveVoucher?: Maybe<HowToReceiveVoucher>;
  /** The unique identifier of the activity */
  id: Scalars['ID']['output'];
  /** A user can provide an activity to redirect the customer to in case this activity is offline */
  ifOfflineRedirectToActivity?: Maybe<Activity>;
  insights?: Maybe<ActivityInsights>;
  insurancePolicyConsent?: Maybe<Scalars['Boolean']['output']>;
  internalKeywords?: Maybe<Array<Tag>>;
  /** Indicates if Itinerary creation is allowed for the activity based on business categories  */
  isItineraryAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** A flag that indicates this is test data */
  isTestData?: Maybe<Scalars['Boolean']['output']>;
  itemsToBring?: Maybe<Array<Tag>>;
  itineraries?: Maybe<Array<ActivityItinerary>>;
  keywords?: Maybe<Array<Tag>>;
  keywordsSuggestion?: Maybe<Array<Tag>>;
  locationExtractorSuggestions?: Maybe<Array<Location>>;
  locationSuggestion?: Maybe<LocationSuggestion>;
  locations?: Maybe<Array<ActivityLocation>>;
  /**
   * Marks the master language ID of the activity. In most cases it should be 29 (English).
   * This is a legacy field from times when we allowed suppliers to create non-English content.
   */
  masterLanguageId?: Maybe<Scalars['Int']['output']>;
  meals?: Maybe<Array<ActivityMeal>>;
  /** Activity new business category computed based on its class and other properties */
  newBusinessCategory?: Maybe<ActivityNewBusinessCategory>;
  notSuitableFor?: Maybe<Array<Tag>>;
  /**
   * Indicates if the activity is online and thus visible for travelers.
   * For an activity to be online the following has to apply:
   * - The supplier status of the tour is 'active'.
   * - The status of the tour is 'active'.
   * - The status of the supplier is 'active'.
   * - The tour has at least one active option.
   * - The tour has at least one next availability.
   */
  online?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<ActivityOption>>;
  /** Flag that indicates if the tour is a GetYourGuide Originals tour. */
  originals?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Marks if the activity happens outside of the city.
   * Automatically set to false when the tour has no transportation types OR when the tour class is city card or hoho.
   */
  outsideTheCity?: Maybe<Scalars['Boolean']['output']>;
  /** Type of overnight stay provided during the activity. Mainly used for categorisation of the tour. */
  overnightStay?: Maybe<OvernightStay>;
  pictureInsights?: Maybe<Array<PictureInsight>>;
  pictures?: Maybe<Array<ActivityPicture>>;
  primaryCategory?: Maybe<Category>;
  primaryLocation?: Maybe<Location>;
  /**
   * Activity type computed based on its class and other properties.
   * Deprecated in favor of the Activity.Category field.
   */
  productType?: Maybe<ActivityProductType>;
  /** Latest tour comment of type rejection reason. */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rentalItems?: Maybe<Array<Tag>>;
  restrictions?: Maybe<Array<Tag>>;
  /** Reviews array */
  reviews?: Maybe<Reviews>;
  searchInsights?: Maybe<SearchActivityInsights>;
  /** Non-localised text of the activity - in master language. */
  sourceText?: Maybe<ActivityTranslation>;
  /**
   * The internal status of the activity. Indicates the current point in the lifecycle of an activity from
   * GetYourGuide???s perspective.
   */
  status?: Maybe<ActivityStatus>;
  /** A way to tell what type of relationship the owner of the activity has with GetYourGuide. */
  strategicRelationships?: Maybe<Array<Scalars['String']['output']>>;
  supplier?: Maybe<Supplier>;
  /** True if supplier accepts mobile vouchers */
  supplierAcceptsOnlineVouchers?: Maybe<Scalars['Boolean']['output']>;
  /** Code given to the activity by the supplier */
  supplierActivityCode?: Maybe<Scalars['String']['output']>;
  /**
   * Field we toggle when we realize a single activity is actually multiple experiences bundled into one.
   * Used for analytics purposes and to derive activity types.
   */
  supplierBundle?: Maybe<Scalars['Boolean']['output']>;
  /** True if supplier has a content agreement */
  supplierHasContentAgreement?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Activity status set by the supplier. Not the status of the supplier.
   * Indicates the current point in the lifecycle of an activity from the supplier???s perspective.
   */
  supplierStatus?: Maybe<ActivitySupplierStatus>;
  /**
   * Indicates who is creating a voucher for the tour. The voucher can be created by GetYourGuide or the supplier.
   * When true the supplier will create the voucher.
   */
  supplierVoucherRequired?: Maybe<Scalars['Boolean']['output']>;
  themeGroups?: Maybe<Array<Tag>>;
  themes?: Maybe<Array<Tag>>;
  /** A flag that indicates if we need to book into another system. */
  thirdPartyBooking?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Array of all possible translations for an activity - manually and machine translated.
   * Does not include text in the master language of the activity. See `Activity.sourceText` for that.
   * See `ActivityTranslation.autoTranslated` to distinguish between the two.
   */
  translations?: Maybe<Array<ActivityTranslation>>;
  transportationTypes?: Maybe<Array<TransportationType>>;
  unclassifiedAttributes?: Maybe<Array<Tag>>;
  /** The last time the activity was updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who made the last change to the activity */
  updateUser?: Maybe<User>;
  /** Customer facing URL of the activity. */
  url?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the itinerary will be shown to the traveler or not. */
  useItinerary?: Maybe<Scalars['Boolean']['output']>;
};


export type ActivityBookingCountArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};


export type ActivitySearchInsightsArgs = {
  languageIsoCode?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityTranslationsArgs = {
  languageIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivityAcceptExternalReviewError = {
  __typename?: 'ActivityAcceptExternalReviewError';
  code: ActivityAcceptExternalReviewErrorCode;
};

export enum ActivityAcceptExternalReviewErrorCode {
  /** Invalid JWT token error */
  InvalidToken = 'INVALID_TOKEN',
  /** Error while storing the review rating. */
  StorageError = 'STORAGE_ERROR'
}

export type ActivityAcceptExternalReviewResult = ActivityAcceptExternalReviewError | ActivityAcceptExternalReviewSuccess;

export type ActivityAcceptExternalReviewSuccess = {
  __typename?: 'ActivityAcceptExternalReviewSuccess';
  /** Accepted rating value of the external reviews. */
  rating: Scalars['Float']['output'];
};

/** The possible statuses an activity assessment can have */
export enum ActivityAssessmentStatus {
  Assessed = 'ASSESSED',
  InProgress = 'IN_PROGRESS',
  Off = 'OFF'
}

export type ActivityCardBlock = {
  __typename?: 'ActivityCardBlock';
  activityType?: Maybe<TravelerActivityType>;
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  price?: Maybe<Money>;
  title: Scalars['String']['output'];
};

export type ActivityCardListBlock = {
  __typename?: 'ActivityCardListBlock';
  cards: Array<Maybe<ActivityCardBlock>>;
  context?: Maybe<ActivityCardListBlockContext>;
  id: Scalars['ID']['output'];
};

export type ActivityCardListBlockContext = {
  __typename?: 'ActivityCardListBlockContext';
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
};

export enum ActivityCategory {
  AttractionTicket = 'ATTRACTION_TICKET',
  AttractionWalkingTour = 'ATTRACTION_WALKING_TOUR',
  CityCard = 'CITY_CARD',
  CityCruise = 'CITY_CRUISE',
  CityMotorizedTour = 'CITY_MOTORIZED_TOUR',
  CityWalkingTour = 'CITY_WALKING_TOUR',
  DayTrip = 'DAY_TRIP',
  HopOnHopOff = 'HOP_ON_HOP_OFF',
  MultiDayTrip = 'MULTI_DAY_TRIP',
  Other = 'OTHER',
  Transfer = 'TRANSFER',
  Unknown = 'UNKNOWN'
}

export enum ActivityCheckoutQuestion {
  BookingMedicalConditions = 'BOOKING_MEDICAL_CONDITIONS',
  BookingMobilityIssues = 'BOOKING_MOBILITY_ISSUES',
  BookingShippingAddress = 'BOOKING_SHIPPING_ADDRESS',
  BookingWheelchair = 'BOOKING_WHEELCHAIR',
  TravelerAges = 'TRAVELER_AGES',
  TravelerChildrenAges = 'TRAVELER_CHILDREN_AGES',
  TravelerDatesOfBirth = 'TRAVELER_DATES_OF_BIRTH',
  TravelerHeights = 'TRAVELER_HEIGHTS',
  TravelerIdDetails = 'TRAVELER_ID_DETAILS',
  TravelerIdNumbers = 'TRAVELER_ID_NUMBERS',
  TravelerNames = 'TRAVELER_NAMES',
  TravelerPassportDetails = 'TRAVELER_PASSPORT_DETAILS',
  TravelerPassportNumbers = 'TRAVELER_PASSPORT_NUMBERS',
  TravelerWeights = 'TRAVELER_WEIGHTS'
}

export enum ActivityClass {
  AttractionTicket = 'ATTRACTION_TICKET',
  CityCard = 'CITY_CARD',
  HopOnHopOff = 'HOP_ON_HOP_OFF',
  Other = 'OTHER',
  Rental = 'RENTAL',
  Tour = 'TOUR',
  Transfer = 'TRANSFER'
}

export type ActivityComment = {
  __typename?: 'ActivityComment';
  /** The text of the comment */
  comment: Scalars['String']['output'];
  /** The timestamp of when this comment was created */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who created this comment */
  creationUser?: Maybe<User>;
  /** The unique identifier of the activity comment. */
  id: Scalars['ID']['output'];
  /** The status of the comment */
  status: EntityStatus;
  /** The ID of the tour associated with this comment */
  tourId: Scalars['Int']['output'];
  /** The type of the activity comment. */
  type: ActivityCommentType;
  /** The timestamp of when this comment was last edited */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who last updated this comment */
  updateUser?: Maybe<User>;
};

export type ActivityCommentCreateInput = {
  /** The text of the comment */
  comment: Scalars['String']['input'];
  /** The ID of the tour associated with this comment */
  tourId: Scalars['Int']['input'];
  /** The type of the activity comment. */
  type: ActivityCommentType;
};

export type ActivityCommentCreatePayload = {
  __typename?: 'ActivityCommentCreatePayload';
  /** The comment that was created */
  comment?: Maybe<ActivityComment>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export enum ActivityCommentType {
  CancellationPolicyRequest = 'CANCELLATION_POLICY_REQUEST',
  ContentReset = 'CONTENT_RESET',
  General = 'GENERAL',
  RejectReason = 'REJECT_REASON',
  StatusChange = 'STATUS_CHANGE',
  SupplierStatusChangeReason = 'SUPPLIER_STATUS_CHANGE_REASON'
}

export type ActivityCopyInput = {
  copyReason: ActivityCopyRequestCopyReasonEnum;
  copyReasonText?: InputMaybe<Scalars['String']['input']>;
  newSupplierId: Scalars['String']['input'];
  originalTourId: Scalars['ID']['input'];
};

export type ActivityCopyPayload = {
  __typename?: 'ActivityCopyPayload';
  /** The new activity if it was successfully copied */
  activity?: Maybe<Activity>;
  /** All errors related to the operation */
  errors?: Maybe<Array<Error>>;
  /** Whether the operation was successful or not */
  success: Scalars['Boolean']['output'];
};

/** The possible reasons for copying an activity */
export enum ActivityCopyRequestCopyReasonEnum {
  DifferentProduct = 'DIFFERENT_PRODUCT',
  Other = 'OTHER',
  SameProduct = 'SAME_PRODUCT'
}

export type ActivityCreateInput = {
  activityClass: ActivityClass;
  supplierId: Scalars['ID']['input'];
};

/**
 * Payload containing all relevant fields related to an activity create operation,
 * operation errors are also available here.
 */
export type ActivityCreatePayload = {
  __typename?: 'ActivityCreatePayload';
  /** The activity that was created. */
  activity?: Maybe<Activity>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type ActivityExternalReviewRatingError = {
  __typename?: 'ActivityExternalReviewRatingError';
  code: ActivityExternalReviewRatingErrorCodes;
};

export enum ActivityExternalReviewRatingErrorCodes {
  /** Error while parsing the page for the external review rating. */
  ParseError = 'PARSE_ERROR',
  /** Error while processing the page for the external review rating. */
  ProcessError = 'PROCESS_ERROR',
  /** The URL provided is not valid. */
  UrlNotFound = 'URL_NOT_FOUND',
  /** URL not supported. */
  UrlNotSupported = 'URL_NOT_SUPPORTED'
}

export type ActivityExternalReviewRatingPayload = ActivityExternalReviewRatingError | ActivityExternalReviewRatingPending | ActivityExternalReviewRatingSuccess;

export type ActivityExternalReviewRatingPending = {
  __typename?: 'ActivityExternalReviewRatingPending';
  /** Rating of the external review. */
  status: ActivityExternalReviewRatingStatus;
};

export enum ActivityExternalReviewRatingStatus {
  /** The request to BrightData is in-progress */
  Pending = 'PENDING',
  /** The request to BrightData is finished successfully */
  Success = 'SUCCESS'
}

export type ActivityExternalReviewRatingSuccess = {
  __typename?: 'ActivityExternalReviewRatingSuccess';
  /** Rating of the external review. */
  rating: Scalars['Float']['output'];
  /** Token to be used when importing the rating into the activity */
  token: Scalars['String']['output'];
};

export enum ActivityField {
  TourAdditionalInformation = 'TOUR_ADDITIONAL_INFORMATION',
  TourDescription = 'TOUR_DESCRIPTION',
  TourExclusions = 'TOUR_EXCLUSIONS',
  TourHighlights = 'TOUR_HIGHLIGHTS',
  TourInclusions = 'TOUR_INCLUSIONS',
  TourShortDescription = 'TOUR_SHORT_DESCRIPTION',
  TourSlug = 'TOUR_SLUG',
  TourTitle = 'TOUR_TITLE',
  TourVoucherInformation = 'TOUR_VOUCHER_INFORMATION'
}

export type ActivityGenerateContentInput = {
  activityId: Scalars['Int']['input'];
  inputText?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityInsights = {
  __typename?: 'ActivityInsights';
  insights: Array<Insight>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ActivityInsightsQuery = {
  entities: Array<InsightEntityInput>;
  supplierId: Scalars['ID']['input'];
};

export type ActivityItinerary = {
  __typename?: 'ActivityItinerary';
  activity?: Maybe<Activity>;
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<ActivityItineraryItem>>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<User>;
};

export type ActivityItineraryDuration = {
  __typename?: 'ActivityItineraryDuration';
  hours?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['String']['output']>;
};

export type ActivityItineraryDurationInput = {
  hours?: InputMaybe<Scalars['String']['input']>;
  minutes?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityItineraryInnerLocationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityItineraryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<ActivityItineraryItemInput>>;
};

export type ActivityItineraryItem = {
  __typename?: 'ActivityItineraryItem';
  activityTypes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  creationUser?: Maybe<User>;
  duration?: Maybe<ActivityItineraryDuration>;
  durationUnit?: Maybe<ActivityItineraryItemDurationUnit>;
  hasEntryIncluded?: Maybe<Scalars['Boolean']['output']>;
  hasExtraCosts?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  importance?: Maybe<ActivityItineraryItemImportance>;
  location?: Maybe<ActivityItineraryLocation>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  showOnMap?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ActivityItineraryItemStatus>;
  title?: Maybe<Scalars['String']['output']>;
  transportationType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ActivityItineraryItemType>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<User>;
};

export enum ActivityItineraryItemDurationUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

export enum ActivityItineraryItemDurationUnitInput {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

export enum ActivityItineraryItemImportance {
  Major = 'MAJOR',
  Minor = 'MINOR'
}

export enum ActivityItineraryItemImportanceInput {
  Major = 'MAJOR',
  Minor = 'MINOR'
}

export type ActivityItineraryItemInput = {
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration?: InputMaybe<ActivityItineraryDurationInput>;
  durationUnit?: InputMaybe<ActivityItineraryItemDurationUnitInput>;
  hasEntryIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  hasExtraCosts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importance?: InputMaybe<ActivityItineraryItemImportanceInput>;
  location?: InputMaybe<ActivityItineraryLocationInput>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  showOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ActivityItineraryItemStatusInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  transportationType?: InputMaybe<TransportationTypeMode>;
  type?: InputMaybe<ActivityItineraryItemTypeInput>;
};

export enum ActivityItineraryItemStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export enum ActivityItineraryItemStatusInput {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export enum ActivityItineraryItemType {
  Activity = 'ACTIVITY',
  Break = 'BREAK',
  DropOff = 'DROP_OFF',
  FoodStop = 'FOOD_STOP',
  MeetingPoint = 'MEETING_POINT',
  PhotoStop = 'PHOTO_STOP',
  PickUp = 'PICK_UP',
  Transfer = 'TRANSFER',
  TransferStop = 'TRANSFER_STOP',
  Visit = 'VISIT'
}

export enum ActivityItineraryItemTypeInput {
  Activity = 'ACTIVITY',
  Break = 'BREAK',
  DropOff = 'DROP_OFF',
  FoodStop = 'FOOD_STOP',
  MeetingPoint = 'MEETING_POINT',
  PhotoStop = 'PHOTO_STOP',
  PickUp = 'PICK_UP',
  Transfer = 'TRANSFER',
  TransferStop = 'TRANSFER_STOP',
  Visit = 'VISIT'
}

export type ActivityItineraryLocation = {
  __typename?: 'ActivityItineraryLocation';
  genericLocation?: Maybe<ActivityItineraryLocationItem>;
  gygLocation?: Maybe<Location>;
  gygLocationId?: Maybe<Scalars['Int']['output']>;
  locationSuggestionGooglePlace?: Maybe<GooglePlace>;
  locationSuggestionGooglePlaceId?: Maybe<Scalars['Int']['output']>;
};

export type ActivityItineraryLocationInput = {
  genericLocation?: InputMaybe<ActivityItineraryInnerLocationInput>;
  gygLocation?: InputMaybe<ActivityItineraryInnerLocationInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  locationSuggestionGooglePlace?: InputMaybe<ActivityItineraryLocationSuggestionGooglePlace>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityItineraryLocationItem = {
  __typename?: 'ActivityItineraryLocationItem';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ActivityItineraryLocationSuggestionGooglePlace = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLimitedSearch = {
  __typename?: 'ActivityLimitedSearch';
  items: Array<ActivityLimitedSearchResult>;
  pagination: Pagination;
};

export type ActivityLimitedSearchResult = {
  __typename?: 'ActivityLimitedSearchResult';
  id: Scalars['ID']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ActivityLocation = {
  __typename?: 'ActivityLocation';
  accessMode?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Activity>;
  boosted?: Maybe<Scalars['Boolean']['output']>;
  entranceType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includeInRanking?: Maybe<Scalars['Boolean']['output']>;
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  lastModificationUser?: Maybe<User>;
  location?: Maybe<Location>;
  revenueRelevant?: Maybe<Scalars['Boolean']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
};

export type ActivityLocationInput = {
  accessMode?: InputMaybe<Scalars['String']['input']>;
  boosted?: InputMaybe<Scalars['Boolean']['input']>;
  entranceType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeInRanking?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  revenueRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityMeal = {
  __typename?: 'ActivityMeal';
  activity?: Maybe<Activity>;
  allYouCanEat?: Maybe<Scalars['Boolean']['output']>;
  dietaryRestrictions?: Maybe<Array<Tag>>;
  drinksAlcoholic?: Maybe<Array<Tag>>;
  drinksNonAlcoholic?: Maybe<Array<Tag>>;
  foodTypes?: Maybe<Array<Tag>>;
  id?: Maybe<Scalars['ID']['output']>;
  isDrinksIncluded?: Maybe<Scalars['Boolean']['output']>;
  numberOfDishes?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<User>;
};

export type ActivityMealInput = {
  allYouCanEat?: InputMaybe<Scalars['Boolean']['input']>;
  dietaryRestrictions?: InputMaybe<Array<Scalars['ID']['input']>>;
  drinksAlcoholic?: InputMaybe<Array<Scalars['ID']['input']>>;
  drinksNonAlcoholic?: InputMaybe<Array<Scalars['ID']['input']>>;
  foodTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDrinksIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfDishes?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityMissingAttributes = {
  __typename?: 'ActivityMissingAttributes';
  /** The tour attributes */
  attributes?: Maybe<Array<MissingAttribute>>;
  /** The tour thumbnail */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** The tour code */
  tour_code?: Maybe<Scalars['String']['output']>;
  /** The tour id */
  tour_id: Scalars['ID']['output'];
  /** The title of the tour */
  tour_title?: Maybe<Scalars['String']['output']>;
};

export type ActivityNewBusinessCategory = {
  __typename?: 'ActivityNewBusinessCategory';
  level1?: Maybe<Scalars['String']['output']>;
  level2?: Maybe<Scalars['String']['output']>;
  level3?: Maybe<Scalars['String']['output']>;
};

export type ActivityOption = {
  __typename?: 'ActivityOption';
  /** The supplier activity this option belongs to */
  activity?: Maybe<Activity>;
  /** Do not use - this field is not implemented yet. Query pricingConfigurations instead. */
  availabilityAndPricing?: Maybe<Array<AvailabilityAndPricing>>;
  availabilityDebugInfo?: Maybe<AvailabilityDebugInfo>;
  /** Indicates the type of booking confirmation to the traveler. */
  bookingEngine?: Maybe<ActivityOptionBookingEngine>;
  completeness?: Maybe<OptionCompletenessValue>;
  /** Flag that indicates if the option is connected to boxoffice. */
  connectedToBoxOffice: Scalars['Boolean']['output'];
  /** Flag that indicates if the option is connected to code generator. */
  connectedToCodeGenerator: Scalars['Boolean']['output'];
  connectivitySettings?: Maybe<ConnectivitySettings>;
  /** Cutoff time in seconds */
  cutoffTimeSeconds?: Maybe<Scalars['Int']['output']>;
  deals?: Maybe<Array<Deal>>;
  /** Drop off information */
  dropOff?: Maybe<DropOff>;
  /**
   * Information about the duration of the activity, i.e. how long it lasts.
   * An option can have either duration or validity. If both are set, duration overrides validity.
   */
  duration?: Maybe<Duration>;
  /**
   * This column holds a list of fields the supplier has already entered (modified in any way).
   * Used only for internal purposes to distinguish if a field is automatically set or conscious decision by supplier.
   * Same field exists on the activity 'Activity.fieldsEntered'.
   */
  fieldsEntered?: Maybe<Array<Scalars['String']['output']>>;
  /** Information about group size constraints for an activity. */
  groupSize?: Maybe<GroupSize>;
  /**
   * When true, the option has future availability.
   * An option that has availability is bookable if its status is 'active'.
   */
  hasAvailability?: Maybe<Scalars['Boolean']['output']>;
  hasModifications?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the option */
  id: Scalars['ID']['output'];
  inactiveAvailabilityBlocks?: Maybe<Array<AvailabilityBlock>>;
  inventoryConfiguration?: Maybe<InventoryConfiguration>;
  inventorySettings?: Maybe<InventorySettings>;
  /** Has free sale booking engine. */
  isFreeSale: Scalars['Boolean']['output'];
  /** Has booking engine on demand. */
  isOnDemand: Scalars['Boolean']['output'];
  /** Audio guide languages offered for this option */
  languagesAudioGuide?: Maybe<Array<ConductionLanguage>>;
  /** Booklet languages offered for this option */
  languagesBooklet?: Maybe<Array<ConductionLanguage>>;
  /** Live guide languages offered for this option */
  languagesLiveGuide?: Maybe<Array<ConductionLanguage>>;
  /** Last available date this option is bookable. */
  lastAvailabilityDate?: Maybe<Scalars['Date']['output']>;
  /** Meeting point information */
  meetingPoint?: Maybe<MeetingPoint>;
  /** Next available date this option is bookable. */
  nextAvailabilityDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The traveler can be asked a set of structured questions during checkout.
   * The possible questions are predefined by GetYourGuide.
   * A supplier has to contact support for setting up these questions.
   * This field stores the selected questions.
   * On activity level the field 'Activity.activityCheckoutQuestion' exists with a different set of possible questions.
   * At checkout a combination of all the questions is presented to the traveler.
   */
  optionCheckoutQuestions?: Maybe<Array<ActivityOptionCheckoutQuestions>>;
  /**
   * Deprecated field previously used to mark certain options within experiences.
   * No longer in use.
   */
  originalsReferenceCode?: Maybe<Scalars['String']['output']>;
  /** Pick up information */
  pickUp?: Maybe<PickUp>;
  pricingConfigurations?: Maybe<Array<ActivityOptionPricing>>;
  /** Indicates the type of pricing of the option. */
  pricingEngine?: Maybe<ActivityOptionPricingEngine>;
  /**
   * Flag that indicates if the tour option is private.
   * Private means a tour will take place with a single booking only.
   * This can be a single person or a single group.
   * In any case, the person that books is fully in charge about who will be on the tour.
   */
  private?: Maybe<Scalars['Boolean']['output']>;
  searchInsights?: Maybe<SearchActivityOptionInsights>;
  /** Skip the line type provided as part of this option */
  skipTheLineType?: Maybe<ActivityOptionSkipTheLineType>;
  /** Non-localised text of the option - in master language. */
  sourceText?: Maybe<ActivityOptionTranslation>;
  /** Specifies a special visibility of the option depending on a number code. */
  specialOffer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Used when an option is a special offer to generate a special URL.
   * Only people with this URL have access to the option and can book it.
   */
  specialOfferHashCode?: Maybe<Scalars['String']['output']>;
  /** Defines how the traveler will get to the activity. */
  startingPlaceType?: Maybe<ActivityOptionStartingPlaceType>;
  /**
   * Indicates the current point in the lifecycle of an option.
   * Unlike the activity, this is a combined status that is manipulated both by GetYourGuide as well as the supplier.
   */
  status?: Maybe<ActivityOptionStatus>;
  /** A flag indicating if the supplier app is enabled for the supplier of this option. */
  supplierAppEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** An identification of the option in the supplier???s system. Provided by the supplier. */
  supplierOptionCode?: Maybe<Scalars['String']['output']>;
  /** Defines the timezone which is used when communicating date / time with regards to this option. */
  timezone?: Maybe<Scalars['String']['output']>;
  /**
   * Array of all possible translations for an activity option - manually and machine translated.
   * Does not include text in the master language of the option. See `ActivityOption.sourceText` for that.
   * See `ActivityOptionText.autoTranslated` to distinguish between the two.
   */
  translations?: Maybe<Array<ActivityOptionTranslation>>;
  /** The last time the option was updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who made the last change to the option */
  updateUser?: Maybe<User>;
  /**
   * Information about the validity of the ticket, i.e. when and for how long the ticket is valid.
   * An option can have either duration or validity. If both are set, duration overrides validity.
   */
  validity?: Maybe<Validity>;
  /** Value added tax code to determine how tax needs to be computed for the activity during purchase. */
  vatCategoryPurchase?: Maybe<ActivityOptionVatCategoryPurchase>;
  /** Value added tax code to determine how tax needs to be computed for the activity during sale. */
  vatCategorySale?: Maybe<ActivityOptionVatCategorySale>;
  /** Flag that indicates if people in a wheelchair can participate. */
  wheelchairAccessible?: Maybe<Scalars['Boolean']['output']>;
};


export type ActivityOptionSearchInsightsArgs = {
  languageIsoCode?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityOptionTranslationsArgs = {
  languageIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ActivityOptionBookingEngine {
  /**
   * The supplier does not need to confirm the booking manually.
   * The booking will be confirmed immediately by the system.
   * Default value.
   */
  FreeSale = 'FREE_SALE',
  /**
   * After booking, the traveler will get an email saying that the booking will be confirmed within 48 hours.
   * All the supplier has to do in this case is to hit a button to confirm the booking manually.
   * The system will then send a confirmation to the traveler.
   */
  OnDemand = 'ON_DEMAND'
}

export enum ActivityOptionCheckoutQuestions {
  BookingChildSafetySeat = 'BOOKING_CHILD_SAFETY_SEAT',
  BookingCruiseDetails = 'BOOKING_CRUISE_DETAILS',
  BookingDropOffAddress = 'BOOKING_DROP_OFF_ADDRESS',
  BookingFlightDetails = 'BOOKING_FLIGHT_DETAILS',
  TravelerDietaryRestrictions = 'TRAVELER_DIETARY_RESTRICTIONS',
  TravelerDivingLevels = 'TRAVELER_DIVING_LEVELS',
  TravelerDriverLicenses = 'TRAVELER_DRIVER_LICENSES',
  TravelerShoeSizes = 'TRAVELER_SHOE_SIZES',
  TravelerSkillLevels = 'TRAVELER_SKILL_LEVELS'
}

export type ActivityOptionCopyInput = {
  /** The option ID to copy. */
  optionId: Scalars['ID']['input'];
};

/** Payload containing all relevant fields related to an activity option copy operation. */
export type ActivityOptionCopyPayload = {
  __typename?: 'ActivityOptionCopyPayload';
  /** The activity option that was just copied. */
  activityOption?: Maybe<ActivityOption>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type ActivityOptionCreateInput = {
  /** The activity of the option being created. */
  activityId: Scalars['ID']['input'];
};

/** Payload containing all relevant fields related to an activity option create operation. */
export type ActivityOptionCreatePayload = {
  __typename?: 'ActivityOptionCreatePayload';
  /** The activity option that was just created. */
  activityOption?: Maybe<ActivityOption>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type ActivityOptionDebug = {
  /** Unique identifer for the Tour Option ID */
  activityOptionId: Scalars['ID']['input'];
  /** End date using an ISO 8601 local date-time (assumed to be in the tour option's timezone) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Start date using an ISO 8601 local date-time (assumed to be in the tour option's timezone) */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityOptionLimitedSearch = {
  __typename?: 'ActivityOptionLimitedSearch';
  items: Array<ActivityOptionLimitedSearchResult>;
  pagination: Pagination;
};

export type ActivityOptionLimitedSearchResult = {
  __typename?: 'ActivityOptionLimitedSearchResult';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ActivityOptionMissingAttributes = {
  __typename?: 'ActivityOptionMissingAttributes';
  attributes?: Maybe<Array<MissingAttribute>>;
  tour_option_code?: Maybe<Scalars['String']['output']>;
  tour_option_id: Scalars['ID']['output'];
  tour_option_title?: Maybe<Scalars['String']['output']>;
};

/** Entity holding fields for a pricing */
export type ActivityOptionPricing = {
  __typename?: 'ActivityOptionPricing';
  /** Addons associated with the Pricing */
  addons?: Maybe<Array<Addon>>;
  /** Maximum group vacancines per time slot */
  groupVacanciesPerTimeSlot?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the pricing */
  id: Scalars['ID']['output'];
  /** The maximum number of vacancies for a timeslot for individual pricing */
  maxIndividualParticipantsPerTimeSlot?: Maybe<Scalars['Int']['output']>;
  /** The name of the pricing */
  name?: Maybe<Scalars['String']['output']>;
  /** The min participants per booking or first booking only and the max participants for every booking */
  participantsRange?: Maybe<PricingParticipants>;
  /** The price set-up per pricing category */
  pricesPerCategory?: Maybe<Array<PricingCategory>>;
  /** PricingToAvailabilityBlocks that are connected to this Pricing */
  pricingToAvailabilityBlocks?: Maybe<Array<PricingToAvailabilityBlock>>;
  /** This is a derived field. If the pricing contains any netRatePrice, breakagePrice or returnPrice, this flag will turn true. */
  usesFixedNetRates?: Maybe<Scalars['Boolean']['output']>;
};

export enum ActivityOptionPricingEngine {
  /** Pricing over API. */
  Ape = 'APE',
  /**
   * The standard pricing engine.
   * Default value.
   */
  Standard = 'STANDARD'
}

export type ActivityOptionSearch = {
  __typename?: 'ActivityOptionSearch';
  items: Array<ActivityOption>;
  pagination: Pagination;
};

export enum ActivityOptionSkipTheLineType {
  NoSkipTheLine = 'NO_SKIP_THE_LINE',
  ThroughExpressElevators = 'THROUGH_EXPRESS_ELEVATORS',
  ThroughExpressSecurityCheck = 'THROUGH_EXPRESS_SECURITY_CHECK',
  ThroughSeparateEntrance = 'THROUGH_SEPARATE_ENTRANCE',
  TicketLine = 'TICKET_LINE'
}

/** Entity holding fields relevant to an activity option source text. */
export type ActivityOptionSourceTextInput = {
  /** The description of the activity option in the given language. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A free text description of the drop off offering in the given language. */
  dropOffDescription?: InputMaybe<Scalars['String']['input']>;
  /** A free text description of the meeting point in the given language. */
  meetingPointDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-text field which allows the supplier to specify what the customer is looking for at the meeting point
   * (e.g. a guide who is wearing/holding X, a specific desk or line, the main entrance, etc.).
   * Should incorporate voucher exchange information where it exists.
   */
  meetingPointOnceYouArrive?: InputMaybe<Scalars['String']['input']>;
  /** A free text description of the pick up offering in the given language. */
  pickUpDescription?: InputMaybe<Scalars['String']['input']>;
  /** If marked true this activity option text will not be send to manual translation. */
  skipManualTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A free text question, the supplier wants to ask the customer in the final step of booking.
   * (e.g. are you vegetarian?)
   */
  supplierRequestedQuestion?: InputMaybe<Scalars['String']['input']>;
  /** The title of the activity option in the given language. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ActivityOptionStartingPlaceType {
  /** The traveler will have to go to a 'MeetingPoint.Location'. */
  MeetingPoint = 'MEETING_POINT',
  /** Both a 'MeetingPoint.Location' as well as a 'PickUp.Type' are available. */
  MeetingPointPickUp = 'MEETING_POINT_PICK_UP',
  /** The traveler will be picked up. Defined by 'PickUp.Type'. */
  PickUp = 'PICK_UP'
}

export enum ActivityOptionStatus {
  /** The option is active and bookable. */
  Active = 'ACTIVE',
  /** The option is active, but has no availability. */
  AvailabilityExpiredOrBlocked = 'AVAILABILITY_EXPIRED_OR_BLOCKED',
  /** The supplier is happy with the data and wants GetYourGuide to check it. */
  Check = 'CHECK',
  /** The option is not bookable, but can become bookable again. */
  Deactivated = 'DEACTIVATED',
  /**
   * The only case when an option is 'deleted' is if the supplier deletes the option before submitting it -
   * i.e. when status = 'temp'. Then the option record is completely deleted from the system and not retrievable.
   */
  Deleted = 'DELETED',
  /**
   * When an option gets removed sometime after it was submitted.
   * The option cannot be completely deleted, because other data might still reference it. Option data can be retrieved.
   */
  Removed = 'REMOVED',
  /** GetYourGuide found some problems and wants the supplier to revise the data. */
  Revise = 'REVISE',
  /**
   * The option has been created by the supplier, but has not yet been assessed.
   * Default value.
   */
  Temp = 'TEMP'
}

export enum ActivityOptionStatusTransition {
  Activate = 'ACTIVATE',
  Deactivate = 'DEACTIVATE',
  Delete = 'DELETE',
  Revise = 'REVISE'
}

export type ActivityOptionStatusTransitionInput = {
  optionId: Scalars['ID']['input'];
  statusTransition: ActivityOptionStatusTransition;
};

/** Entity holding fields relevant to an activity option translation */
export type ActivityOptionTranslation = {
  __typename?: 'ActivityOptionTranslation';
  /** The activity option this translation belongs to */
  activityOption?: Maybe<ActivityOption>;
  /** When true the text has been machine translated by either Google Autotranslate or DeepL */
  autoTranslated?: Maybe<Scalars['Boolean']['output']>;
  /** The description of the activity option in the given language */
  description?: Maybe<Scalars['String']['output']>;
  /** A free text description of the drop off offering in the given language */
  dropOffDescription?: Maybe<Scalars['String']['output']>;
  /** The language this translation is in */
  languageID?: Maybe<Scalars['Int']['output']>;
  /** A free text description of the meeting point in the given language */
  meetingPointDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Free-text field which allows the supplier to specify what the customer is looking for at the meeting point
   * (e.g. a guide who is wearing/holding X, a specific desk or line, the main entrance, etc.).
   * Should incorporate voucher exchange information where it exists.
   */
  meetingPointOnceYouArrive?: Maybe<Scalars['String']['output']>;
  /** A free text description of the pick up offering in the given language */
  pickUpDescription?: Maybe<Scalars['String']['output']>;
  /** The last time the source activity text (non-translated, English) was updated */
  sourceUpdateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A free text question, the supplier wants to ask the customer in the final step of booking.
   * (e.g. are you vegetarian?)
   */
  supplierRequestedQuestion?: Maybe<Scalars['String']['output']>;
  /** The title of the activity option in the given language */
  title?: Maybe<Scalars['String']['output']>;
  /** The last time the activity translation was updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who made the last change to the activity translation */
  updateUser?: Maybe<User>;
};

export type ActivityOptionUpdateInput = {
  /** The supplier activity this option belongs to */
  activityId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates the type of booking confirmation to the traveler. */
  bookingEngine?: InputMaybe<ActivityOptionBookingEngine>;
  /** Cutoff time in seconds */
  cutoffTimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Drop off information */
  dropOff?: InputMaybe<DropOffInput>;
  /**
   * Information about the duration of the activity, i.e. how long it lasts.
   * An option can have either duration or validity. If both are set, duration overrides validity.
   */
  duration?: InputMaybe<DurationInput>;
  /** Information about group size constraints for an activity. */
  groupSize?: InputMaybe<GroupSizeInput>;
  /**
   * When true, the option has future availability.
   * An option that has availability is bookable if its status is 'active'.
   */
  hasAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier of the option */
  id: Scalars['ID']['input'];
  /** Audio guide languages offered for this option */
  languagesAudioGuide?: InputMaybe<Array<ConductionLanguageInput>>;
  /** Booklet languages offered for this option */
  languagesBooklet?: InputMaybe<Array<ConductionLanguageInput>>;
  /** Live guide languages offered for this option */
  languagesLiveGuide?: InputMaybe<Array<ConductionLanguageInput>>;
  /** Meeting point information */
  meetingPoint?: InputMaybe<MeetingPointInput>;
  /**
   * The traveler can be asked a set of structured questions during checkout.
   * The possible questions are predefined by GetYourGuide.
   * A supplier has to contact support for setting up these questions.
   * This field stores the selected questions.
   * On activity level the field 'Activity.activityCheckoutQuestion' exists with a different set of possible questions.
   * At checkout a combination of all the questions is presented to the traveler.
   */
  optionCheckoutQuestions?: InputMaybe<Array<ActivityOptionCheckoutQuestions>>;
  /**
   * Deprecated field previously used to mark certain options within experiences.
   * No longer in use.
   */
  originalsReferenceCode?: InputMaybe<Scalars['String']['input']>;
  /** Pick up information */
  pickUp?: InputMaybe<PickUpInput>;
  /** Indicates the type of the pricing engine of the option. */
  pricingEngine?: InputMaybe<ActivityOptionPricingEngine>;
  /**
   * Flag that indicates if the tour option is private.
   * Private means a tour will take place with a single booking only.
   * This can be a single person or a single group.
   * In any case, the person that books is fully in charge about who will be on the tour.
   */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to refresh the delivery cache immediately after updating the option or not */
  refreshCache?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skip the line type provided as part of this option */
  skipTheLineType?: InputMaybe<ActivityOptionSkipTheLineType>;
  /** Non-localised text of the activity option - in master language. */
  sourceText?: InputMaybe<ActivityOptionSourceTextInput>;
  /** Specifies a special visibility of the option depending on a number code. */
  specialOffer?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Used when an option is a special offer to generate a special URL.
   * Only people with this URL have access to the option and can book it.
   */
  specialOfferHashCode?: InputMaybe<Scalars['String']['input']>;
  /** Defines how the traveler will get to the activity. */
  startingPlaceType?: InputMaybe<ActivityOptionStartingPlaceType>;
  /**
   * Indicates the current point in the lifecycle of an option.
   * Unlike the activity, this is a combined status that is manipulated both by GetYourGuide as well as the supplier.
   */
  status?: InputMaybe<ActivityOptionStatus>;
  /** A flag indicating if the supplier app is enabled for the supplier of this option. */
  supplierAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** An identification of the option in the supplier?s system. Provided by the supplier. */
  supplierOptionCode?: InputMaybe<Scalars['String']['input']>;
  /** Defines the timezone which is used when communicating date / time with regards to this option. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Information about the validity of the ticket, i.e. when and for how long the ticket is valid.
   * An option can have either duration or validity. If both are set, duration overrides validity.
   */
  validity?: InputMaybe<ValidityInput>;
  /** Value added tax code to determine how tax needs to be computed for the activity during purchase. */
  vatCategoryPurchase?: InputMaybe<ActivityOptionVatCategoryPurchase>;
  /** Value added tax code to determine how tax needs to be computed for the activity during sale. */
  vatCategorySale?: InputMaybe<ActivityOptionVatCategorySale>;
  /** Flag that indicates if people in a wheelchair can participate. */
  wheelchairAccessible?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Payload containing all relevant fields related to an activity option update operation.
 * Operation errors are also available here.
 */
export type ActivityOptionUpdatePayload = {
  __typename?: 'ActivityOptionUpdatePayload';
  /** The activity option that was just updated. */
  activityOption?: Maybe<ActivityOption>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

/**
 * Payload containing all relevant fields related to an activity option update operation.
 * In addition this contains the recalculated option completeness.
 * Operation errors are also available here.
 */
export type ActivityOptionUpdateWithCompletenessPayload = {
  __typename?: 'ActivityOptionUpdateWithCompletenessPayload';
  /** The activity option that was just updated. */
  activityOption?: Maybe<ActivityOption>;
  /** The refreshed option completeness */
  completeness?: Maybe<OptionCompletenessValue>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export enum ActivityOptionVatCategoryPurchase {
  Ci_07 = 'CI_07',
  De_00 = 'DE_00',
  De_07 = 'DE_07',
  De_19 = 'DE_19',
  DeOther = 'DE_OTHER',
  Dub_00 = 'DUB_00',
  Dub_05 = 'DUB_05',
  Eu_00 = 'EU_00',
  Fl_7G = 'FL_7G',
  Fl_65G = 'FL_65G',
  Fl_75G = 'FL_75G',
  Fr_00 = 'FR_00',
  Fr_10 = 'FR_10',
  Fr_20 = 'FR_20',
  Fr_55 = 'FR_55',
  Gr_00 = 'GR_00',
  Hu_27 = 'HU_27',
  It_00 = 'IT_00',
  It_05 = 'IT_05',
  It_10 = 'IT_10',
  It_22 = 'IT_22',
  Jp_00 = 'JP_00',
  Jp_08 = 'JP_08',
  Jp_10 = 'JP_10',
  Nl_09 = 'NL_09',
  Nl_21 = 'NL_21',
  Ny_00 = 'NY_00',
  Ny_9G = 'NY_9G',
  Pt_00 = 'PT_00',
  Pt_06 = 'PT_06',
  Pt_23 = 'PT_23',
  Rw_00 = 'RW_00',
  Sp_00 = 'SP_00',
  Sp_10 = 'SP_10',
  Sp_21 = 'SP_21',
  Toms = 'TOMS'
}

export enum ActivityOptionVatCategorySale {
  Ci_07 = 'CI_07',
  De_00 = 'DE_00',
  De_07 = 'DE_07',
  De_19 = 'DE_19',
  DeOther = 'DE_OTHER',
  Dub_00 = 'DUB_00',
  Dub_05 = 'DUB_05',
  Eu_00 = 'EU_00',
  Fl_7G = 'FL_7G',
  Fl_65G = 'FL_65G',
  Fl_75G = 'FL_75G',
  Fr_00 = 'FR_00',
  Fr_02 = 'FR_02',
  Fr_10 = 'FR_10',
  Fr_20 = 'FR_20',
  Fr_55 = 'FR_55',
  Gr_24 = 'GR_24',
  Hu_27 = 'HU_27',
  It_00 = 'IT_00',
  It_05 = 'IT_05',
  It_10 = 'IT_10',
  It_22 = 'IT_22',
  Jp_00 = 'JP_00',
  Jp_08 = 'JP_08',
  Jp_10 = 'JP_10',
  Nl_09 = 'NL_09',
  Ny_00 = 'NY_00',
  Ny_9G = 'NY_9G',
  Pt_06 = 'PT_06',
  Pt_23 = 'PT_23',
  Rw_00 = 'RW_00',
  Sp_00 = 'SP_00',
  Sp_10 = 'SP_10',
  Sp_21 = 'SP_21',
  Toms = 'TOMS'
}

export type ActivityPicture = {
  __typename?: 'ActivityPicture';
  activity?: Maybe<Activity>;
  checked?: Maybe<Scalars['Boolean']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  originalFileName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ActivityPictureSource>;
  status?: Maybe<ActivityPictureStatus>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<User>;
  url?: Maybe<Scalars['String']['output']>;
  verticalAlignment?: Maybe<ActivityPictureVerticalAlignment>;
};

export type ActivityPictureInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ActivityPictureSource>;
  url?: InputMaybe<Scalars['String']['input']>;
  verticalAlignment?: InputMaybe<ActivityPictureVerticalAlignment>;
};

export enum ActivityPictureSource {
  ContentCreator = 'CONTENT_CREATOR',
  Gyg = 'GYG',
  GygPhotoshoot = 'GYG_PHOTOSHOOT',
  Supplier = 'SUPPLIER',
  ThirdParty = 'THIRD_PARTY'
}

export enum ActivityPictureStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export enum ActivityPictureVerticalAlignment {
  Bottom = 'BOTTOM',
  Center = 'CENTER',
  Top = 'TOP'
}

export enum ActivityProductType {
  AttractionTicket = 'ATTRACTION_TICKET',
  Bundle = 'BUNDLE',
  CityCard = 'CITY_CARD',
  DayTrip = 'DAY_TRIP',
  GuidedCityCruise = 'GUIDED_CITY_CRUISE',
  GuidedExperience = 'GUIDED_EXPERIENCE',
  GuidedMixedTransportTour = 'GUIDED_MIXED_TRANSPORT_TOUR',
  GuidedMotorizedTour = 'GUIDED_MOTORIZED_TOUR',
  GuidedWalkingTour = 'GUIDED_WALKING_TOUR',
  HopOnHopOff = 'HOP_ON_HOP_OFF',
  LandTransport = 'LAND_TRANSPORT',
  MultiDayTrip = 'MULTI_DAY_TRIP',
  Other = 'OTHER',
  WaterTransport = 'WATER_TRANSPORT'
}

export type ActivityReviewStats = {
  __typename?: 'ActivityReviewStats';
  /** Activity id the review stats belongs to */
  activityId: Scalars['Int']['output'];
  /** Total # of reviews */
  reviewCount: Scalars['Int']['output'];
  /** average rating for all the reviews */
  reviewsAverageRating: Scalars['Float']['output'];
};

export type ActivityReviewStatsResult = {
  __typename?: 'ActivityReviewStatsResult';
  /** stats for the filtered activities */
  stats: Array<ActivityReviewStats>;
};

export type ActivitySearch = {
  __typename?: 'ActivitySearch';
  items: Array<Activity>;
  pagination: Pagination;
};

export type ActivitySearchStats = {
  __typename?: 'ActivitySearchStats';
  all: Scalars['Int']['output'];
  bookable: Scalars['Int']['output'];
  expired: Scalars['Int']['output'];
  expiringSoon: Scalars['Int']['output'];
  missingInfo: Scalars['Int']['output'];
  notBookable: Scalars['Int']['output'];
  temp: Scalars['Int']['output'];
};

export type ActivitySourceTextInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exclusions?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Array<Scalars['String']['input']>>;
  inclusions?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  skipManualTranslation?: Scalars['Boolean']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  voucherInformation?: InputMaybe<Scalars['String']['input']>;
};

/** The possible statuses an activity can have */
export enum ActivityStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
  New = 'NEW',
  QualityCheckFailed = 'QUALITY_CHECK_FAILED',
  Rejected = 'REJECTED'
}

export enum ActivityStatusTransition {
  Activate = 'ACTIVATE',
  Deactivate = 'DEACTIVATE',
  Delete = 'DELETE',
  Reject = 'REJECT',
  Undelete = 'UNDELETE'
}

export type ActivityStatusTransitionInput = {
  /** The activity id. */
  activityId: Scalars['ID']['input'];
  /**
   * Whether the status transitions is initiated from Supplier Portal of GYGAdmin.
   * Depending on this, a different combination of gygStatus and supplierStatus will be transitioned.
   */
  isSupplierPortal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The reason for the transition */
  reason: Scalars['String']['input'];
  /** The activity status transition to perform. */
  transition: ActivityStatusTransition;
};

export type ActivitySubmitInput = {
  /** The activity to submit */
  activityId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Indicates whether the submission should be internal or not.
   * If true, the activity and the options will not be activated, but remain in an intermediary status
   * and are manually activated later.
   * Internal submission is used for tour that require further downstream configurations before going online.
   * It is used by internal teams only.
   */
  delayedSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The activity options to submit.
   * They can either be submitted standalone, in case of adding a new option to an existing product,
   * or together with the activity for the case of submitting a new activity.
   */
  optionIds: Array<Scalars['ID']['input']>;
};

export type ActivitySubmitPayload = {
  __typename?: 'ActivitySubmitPayload';
  /** The activity that was just submitted. */
  activity?: Maybe<Activity>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export enum ActivitySupplierStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
  Temp = 'TEMP'
}

export type ActivityTagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Entity holding fields relevant to an activity translation */
export type ActivityTranslation = {
  __typename?: 'ActivityTranslation';
  /** The activity this translation belongs to */
  activity?: Maybe<Activity>;
  /** Additional information about the activity in the given language */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  /** When true the text has been machine translated by either Google Autotranslate or DeepL */
  autoTranslated?: Maybe<Scalars['Boolean']['output']>;
  /** The description of the activity in the given language */
  description?: Maybe<Scalars['String']['output']>;
  /** Free text of what the activity explicitly excludes in the given language */
  exclusions?: Maybe<Scalars['String']['output']>;
  /** A list of highlights of the activity in the given language */
  highlights?: Maybe<Array<Scalars['String']['output']>>;
  /** Free text of what the activity explicitly includes in the given language */
  inclusions?: Maybe<Scalars['String']['output']>;
  /** The language this translation is in */
  languageID?: Maybe<Scalars['Int']['output']>;
  /** A shorter version of the description */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** A string that is embedded in the URL for SEO reasons. Usually same as title. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The last time the source activity text (non-translated, English) was updated */
  sourceUpdateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The title of the activity in the given language */
  title?: Maybe<Scalars['String']['output']>;
  /** The last time the activity translation was updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who made the last change to the activity translation */
  updateUser?: Maybe<User>;
  /** Voucher information about the activity in the given language */
  voucherInformation?: Maybe<Scalars['String']['output']>;
};

export type ActivityUpdateInput = {
  activityCheckoutQuestions?: InputMaybe<Array<ActivityCheckoutQuestion>>;
  activityClass?: InputMaybe<ActivityClass>;
  assessmentStatus?: InputMaybe<ActivityAssessmentStatus>;
  authorizedBadge?: InputMaybe<AuthorizedBadgeInput>;
  availabilityConstrained?: InputMaybe<Scalars['Boolean']['input']>;
  canSupplierEditText?: InputMaybe<Scalars['Boolean']['input']>;
  canSupplierEditVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationPolicy?: InputMaybe<CancellationPolicyInput>;
  cancellationPolicyType?: InputMaybe<CancellationPolicyType>;
  certifiedPartner?: InputMaybe<Scalars['Boolean']['input']>;
  commissionRate?: InputMaybe<Scalars['Int']['input']>;
  drinks?: InputMaybe<Array<ActivityTagInput>>;
  drinksAlcoholic?: InputMaybe<Array<ActivityTagInput>>;
  drinksNonAlcoholic?: InputMaybe<Array<ActivityTagInput>>;
  ecoCertified?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyPhoneNumber?: InputMaybe<PhoneNumberInput>;
  enforce3DSecure?: InputMaybe<Enforce3DSecure>;
  food?: InputMaybe<Array<ActivityTagInput>>;
  freeTextCancellationPolicies?: InputMaybe<Array<FreeTextCancellationPolicyInput>>;
  generatedContentFields?: InputMaybe<GeneratedContentFieldsInput>;
  guideType?: InputMaybe<GuideType>;
  hasMwst?: InputMaybe<Scalars['Boolean']['input']>;
  hashCode?: InputMaybe<Scalars['String']['input']>;
  howToReceiveVoucher?: InputMaybe<HowToReceiveVoucher>;
  id: Scalars['ID']['input'];
  ifOfflineRedirectToActivityId?: InputMaybe<Scalars['ID']['input']>;
  insurancePolicyConsent?: InputMaybe<Scalars['Boolean']['input']>;
  internalKeywords?: InputMaybe<Array<ActivityTagInput>>;
  itemsToBring?: InputMaybe<Array<ActivityTagInput>>;
  itineraries?: InputMaybe<Array<ActivityItineraryInput>>;
  keywords?: InputMaybe<Array<ActivityTagInput>>;
  locationSuggestion?: InputMaybe<LocationSuggestionInput>;
  locations?: InputMaybe<Array<ActivityLocationInput>>;
  meals?: InputMaybe<Array<ActivityMealInput>>;
  notSuitableFor?: InputMaybe<Array<ActivityTagInput>>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  originals?: InputMaybe<Scalars['Boolean']['input']>;
  outsideTheCity?: InputMaybe<Scalars['Boolean']['input']>;
  pictures?: InputMaybe<Array<ActivityPictureInput>>;
  primaryCategoryId?: InputMaybe<Scalars['ID']['input']>;
  primaryLocationId?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<ActivityProductType>;
  refreshCache?: InputMaybe<Scalars['Boolean']['input']>;
  rentalItems?: InputMaybe<Array<ActivityTagInput>>;
  restrictions?: InputMaybe<Array<ActivityTagInput>>;
  sourceText?: InputMaybe<ActivitySourceTextInput>;
  status?: InputMaybe<ActivityStatus>;
  strategicRelationships?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierAcceptsOnlineVouchers?: InputMaybe<Scalars['Boolean']['input']>;
  supplierActivityCode?: InputMaybe<Scalars['String']['input']>;
  supplierBundle?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierStatus?: InputMaybe<ActivitySupplierStatus>;
  supplierVoucherRequired?: InputMaybe<Scalars['Boolean']['input']>;
  thirdPartyBooking?: InputMaybe<Scalars['Boolean']['input']>;
  transportationTypes?: InputMaybe<Array<TransportationTypeInput>>;
  unclassifiedAttributes?: InputMaybe<Array<ActivityTagInput>>;
  useItinerary?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Payload containing all relevant fields related to an activity update operation, operation errors
 * are also available here.
 */
export type ActivityUpdatePayload = {
  __typename?: 'ActivityUpdatePayload';
  /** The activity that was just updated. */
  activity?: Maybe<Activity>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type ActivityUpdateWithCompletenessPayload = {
  __typename?: 'ActivityUpdateWithCompletenessPayload';
  /** The activity that was just updated. */
  activity?: Maybe<Activity>;
  /** The refreshed tour completeness. */
  completeness?: Maybe<TourCompleteness>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type Addon = {
  __typename?: 'Addon';
  commissionRate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  pricingId?: Maybe<Scalars['ID']['output']>;
  pricingScales?: Maybe<Array<PricingScale>>;
  resolvedCommissionRate?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<AddonText>;
};

export type AddonInput = {
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  pricingId?: InputMaybe<Scalars['ID']['input']>;
  pricingScales?: InputMaybe<Array<PricingScaleInput>>;
  text?: InputMaybe<AddonTextInput>;
};

export type AddonText = {
  __typename?: 'AddonText';
  addonId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  languageId?: Maybe<Scalars['ID']['output']>;
};

export type AddonTextInput = {
  addonId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddressCountry = {
  __typename?: 'AddressCountry';
  /** The iso code of the country */
  isoCode: Scalars['String']['output'];
  /** The name of the country */
  name: Scalars['String']['output'];
};

export enum AddressType {
  Account = 'ACCOUNT',
  Billing = 'BILLING',
  Lead = 'LEAD',
  Newsletter = 'NEWSLETTER',
  Other = 'OTHER'
}

export type AdminSearchFilter = {
  /** The column this filter should be applied against */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The type of filter being applied (e.g. and, or, etc.) */
  filterType?: InputMaybe<AdminSearchFilterType>;
  /** The filter operation (e.g. equals, less than, etc.) */
  operation?: InputMaybe<AdminSearchFilterOperation>;
  /** The filter value */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum AdminSearchFilterOperation {
  BeginsWith = 'BEGINS_WITH',
  Contains = 'CONTAINS',
  ContainsIgnoreCase = 'CONTAINS_IGNORE_CASE',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  NotEquals = 'NOT_EQUALS'
}

export enum AdminSearchFilterType {
  And = 'AND',
  In = 'IN',
  Or = 'OR'
}

export type AdminSearchOrder = {
  column?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<AdminSearchOrderDirection>;
};

export enum AdminSearchOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AdminSearchQuery = {
  /** List of filters all search results should pass */
  filters?: InputMaybe<Array<AdminSearchFilter>>;
  /** Maximum number of results to be returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The page of results to return */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** How to order the search results */
  sort?: InputMaybe<Array<AdminSearchOrder>>;
};

export type AdminSearchResult = {
  __typename?: 'AdminSearchResult';
  /** The number of result items */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The page of results */
  page?: Maybe<Scalars['Int']['output']>;
  /** List of search result items */
  results?: Maybe<Array<AdminSearchResultItem>>;
  /** The total number of pages given the search limit */
  totalPages?: Maybe<Scalars['Int']['output']>;
  /** The total number of result items */
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type AdminSearchResultItem = {
  __typename?: 'AdminSearchResultItem';
  /** An issue search result record */
  qualityIssue?: Maybe<QualityIssueAdminSearchResultItem>;
  /** A rule search result record */
  qualityRule?: Maybe<QualityRuleAdminSearchResultItem>;
};

export type AgeRange = {
  __typename?: 'AgeRange';
  /** The maximum age */
  maxAge?: Maybe<Scalars['Int']['output']>;
  /** The minimum age */
  minAge?: Maybe<Scalars['Int']['output']>;
};

export type AgeRangeInput = {
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
};

export type Agenda = {
  __typename?: 'Agenda';
  items?: Maybe<Array<AgendaItem>>;
  pagination: Pagination;
};

export type AgendaInput = {
  activityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bookedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  likelyToSelloutOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  supplierId: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaItem = {
  __typename?: 'AgendaItem';
  activity?: Maybe<Activity>;
  activityOption?: Maybe<ActivityOption>;
  bookableUntil?: Maybe<Scalars['String']['output']>;
  bookings?: Maybe<Array<Booking>>;
  bookingsId?: Maybe<Array<Scalars['ID']['output']>>;
  cutOffTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  dateTime?: Maybe<Scalars['String']['output']>;
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  isOrphan?: Maybe<Scalars['Boolean']['output']>;
  likelyToSellout?: Maybe<Scalars['Boolean']['output']>;
  openingHours?: Maybe<Array<SlotTime>>;
  reservedVacancies?: Maybe<Scalars['Int']['output']>;
  temporaryBookingsCount: Scalars['Int']['output'];
  totalVacancies?: Maybe<Scalars['Int']['output']>;
};

export type AggregatedBillingDetails = {
  __typename?: 'AggregatedBillingDetails';
  /** The list of billing details items */
  billingDetailsItems: Array<BillingDetailsItem>;
  /** The customer total price in customer's currency */
  customerTotalPrice: Money;
  /** The supplier total price in supplier's currency */
  supplierTotalPrice: Money;
  /** The supplier total share in supplier's currency */
  supplierTotalShare: Money;
};

export type Answer = {
  __typename?: 'Answer';
  /** The answer */
  answer: Array<AnswerInfo>;
  /** The category id (e.g free_text_answer) */
  id: Scalars['ID']['output'];
};

export type AnswerInfo = {
  __typename?: 'AnswerInfo';
  /** The question key (e.g FirstName) */
  key: Scalars['String']['output'];
  /** The question value (e.g John) */
  value: Scalars['String']['output'];
};

export type AnswerInfoInput = {
  /** The question key (e.g FirstName) */
  key: Scalars['String']['input'];
  /** The answer */
  value: Scalars['String']['input'];
};

export type ApproveCouponInput = {
  /** The ID of the coupon */
  couponId: Scalars['ID']['input'];
};

export type AuthorizedBadge = {
  __typename?: 'AuthorizedBadge';
  activity?: Maybe<Activity>;
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  pictureFileName?: Maybe<Scalars['String']['output']>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<User>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AuthorizedBadgeDeleteInput = {
  activityId: Scalars['Int']['input'];
};

export type AuthorizedBadgeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  pictureFileName?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorizedBadgeUploadInput = {
  /** The ID of the activity of the badge. */
  activityId: Scalars['Int']['input'];
  /** Image file encoded as Base64 string */
  file?: InputMaybe<Scalars['String']['input']>;
  /** File name of the uploaded picture */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the POI whose image to use. */
  poiId?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityAndPricing = {
  __typename?: 'AvailabilityAndPricing';
  availabilityBlock: AvailabilityBlock;
  overlappingSchedules?: Maybe<Array<OverlappingSchedule>>;
  /** Prices in these dateranges override the default prices for that range */
  priceOverrides?: Maybe<Array<PriceOverride>>;
  pricing: ActivityOptionPricing;
  status?: Maybe<AvailabilityAndPricingStatus>;
};

export type AvailabilityAndPricingInput = {
  availabilityBlockInput: AvailabilityBlockInput;
  priceOverridesInput?: InputMaybe<Array<PriceOverrideInput>>;
  pricingInput: PricingInput;
};

export type AvailabilityAndPricingOverlapException = {
  __typename?: 'AvailabilityAndPricingOverlapException';
  /** A list with the name of the Schedules that overlaps */
  overlappingSchedules?: Maybe<Array<Scalars['String']['output']>>;
  /** A list with the time slots that overlaps */
  overlappingSlots?: Maybe<Array<Weekday>>;
  /** A list with the special dates that overlaps */
  overlappingSpecialDates?: Maybe<Array<SpecialDate>>;
};

export type AvailabilityAndPricingPayload = {
  __typename?: 'AvailabilityAndPricingPayload';
  /** The created Availability and Pricing */
  availabilityAndPricing?: Maybe<AvailabilityAndPricing>;
  /** Details of the error if update fails */
  errorDetails?: Maybe<AvailabilityAndPricingOverlapException>;
  /** Message with details of the error, if the creation fails */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag that indicates if the Availability and Pricing was created */
  success: Scalars['Boolean']['output'];
};

export enum AvailabilityAndPricingStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Expired = 'EXPIRED'
}

export type AvailabilityBlock = {
  __typename?: 'AvailabilityBlock';
  /** The ID of the Activity related to the Availability Block */
  activityId: Scalars['ID']['output'];
  /** The ID of the Activity Option related to the Availability Block */
  activityOptionId?: Maybe<Scalars['ID']['output']>;
  /** The Activity Option Pricing which the Availability Block is attached to */
  activityOptionPricingId?: Maybe<Scalars['ID']['output']>;
  /** Date ranges between which this block will not have any availbility */
  closedDateRanges?: Maybe<Array<InventoryDateRange>>;
  /** The unique identifier of an availability block */
  id: Scalars['ID']['output'];
  /** The name of the availability block */
  name: Scalars['String']['output'];
  /** PricingToAvailabilityBlocks that are connected to this AvailabilityBlock */
  pricingToAvailabilityBlocks?: Maybe<Array<PricingToAvailabilityBlock>>;
  /** List of special dates that overrides the default weekday schedule */
  specialDates?: Maybe<Array<SpecialDate>>;
  /** Max vacancies for all special dates */
  specialDatesMaxVacancies?: Maybe<Scalars['Int']['output']>;
  /** The type for the Availability Block */
  type: AvailabilityType;
  /** Date range where the Availability Block is valid */
  validityDateRange: DateRange;
  /** List with the availibilities per day */
  weekdays?: Maybe<Array<Weekday>>;
};

export type AvailabilityBlockInput = {
  activityId: Scalars['ID']['input'];
  closedDateRanges?: InputMaybe<Array<InventoryDateRangeInput>>;
  dataRange: InventoryDateRangeOptionalEndDateInput;
  name: Scalars['String']['input'];
  specialDates?: InputMaybe<Array<SpecialDateInput>>;
  specialDatesMaxVacancies?: InputMaybe<Scalars['Int']['input']>;
  type: AvailabilityType;
  weekdays?: InputMaybe<Array<WeekdayInput>>;
};

export type AvailabilityBlockSearch = {
  __typename?: 'AvailabilityBlockSearch';
  items: Array<AvailabilityBlock>;
  pagination: Pagination;
};

export type AvailabilityDebugInfo = {
  __typename?: 'AvailabilityDebugInfo';
  availabilityDebug?: Maybe<Array<AvailabilityDebugMetaInfo>>;
  bookingReason?: Maybe<Scalars['String']['output']>;
  bookingStatus?: Maybe<Scalars['String']['output']>;
};

export type AvailabilityDebugMetaInfo = {
  __typename?: 'AvailabilityDebugMetaInfo';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AvailabilityToPricingInput = {
  /** The ID of the Activity Option related to the Availability Block */
  activityOptionId: Scalars['ID']['input'];
  /** The Activity Option Pricing which the Availability Block is attached to */
  activityOptionPricingId?: InputMaybe<Scalars['ID']['input']>;
  /** The unique identifier of an availability block */
  availabilityBlockId: Scalars['ID']['input'];
};

export enum AvailabilityType {
  OpeningHours = 'opening_hours',
  StartingTimes = 'starting_times'
}

export type BankDetails = {
  __typename?: 'BankDetails';
  /** Bank account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Type of the bank account */
  accountType?: Maybe<AccountType>;
  /** Address associated with the bank account */
  address?: Maybe<Scalars['String']['output']>;
  /** Name of the bank */
  bankName?: Maybe<Scalars['String']['output']>;
  /** The beneficiary name of the bank account */
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  /** City of the bank account */
  city?: Maybe<Scalars['String']['output']>;
  /** ISO code for the country of the bank account */
  country?: Maybe<Scalars['String']['output']>;
  /** International Bank Account Number */
  iban?: Maybe<Scalars['String']['output']>;
  /** The intermediate bank of the bank account */
  intermediateBank?: Maybe<Scalars['String']['output']>;
  /** National ID of the bank account */
  nationalId?: Maybe<Scalars['String']['output']>;
  /** Routing number of the bank account */
  routingNumber?: Maybe<Scalars['String']['output']>;
  /** SWIFT/BIC code of the bank account */
  swiftBic?: Maybe<Scalars['String']['output']>;
  /** Zip code of the bank account */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BankDetailsInput = {
  /** Bank account number */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Type of the bank account */
  accountType?: InputMaybe<AccountType>;
  /** Address associated with the bank account */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Name of the bank */
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** The beneficiary name of the bank account */
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  /** City of the bank account */
  city?: InputMaybe<Scalars['String']['input']>;
  /** ISO code for the country of the bank account */
  country?: InputMaybe<Scalars['String']['input']>;
  /** International Bank Account Number */
  iban?: InputMaybe<Scalars['String']['input']>;
  /** The intermediate bank of the bank account */
  intermediateBank?: InputMaybe<Scalars['String']['input']>;
  /** National ID of the bank account */
  nationalId?: InputMaybe<Scalars['String']['input']>;
  /** Routing number of the bank account */
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  /** SWIFT/BIC code of the bank account */
  swiftBic?: InputMaybe<Scalars['String']['input']>;
  /** Zip code of the bank account */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type BankValidationProblem = {
  __typename?: 'BankValidationProblem';
  /** The field ID of the invalid field */
  fieldId?: Maybe<Scalars['String']['output']>;
  /** The arguments for the error message */
  messageArgs?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message for the invalid field */
  messageId: Scalars['String']['output'];
};

export type BatchUploadTicketCsvFileInput = {
  file: Scalars['String']['input'];
};

export type BatchUploadTicketFileInput = {
  csv?: InputMaybe<BatchUploadTicketCsvFileInput>;
  pdf?: InputMaybe<BatchUploadTicketPdfFileInput>;
  type: BatchUploadTicketFileType;
};

export enum BatchUploadTicketFileType {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type BatchUploadTicketInput = {
  activityOptionId: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
  file: BatchUploadTicketFileInput;
  impairmentCost: Scalars['Float']['input'];
  invoiceReference: Scalars['String']['input'];
  isPrepaid: Scalars['Boolean']['input'];
  pdfCodePrefix?: InputMaybe<Scalars['String']['input']>;
  purchaseDate: Scalars['DateTime']['input'];
  purchasePrice: Scalars['Float']['input'];
  returnCost: Scalars['Float']['input'];
  ticketCategory: Scalars['String']['input'];
  ticketCodeType: Scalars['String']['input'];
};

/** Payload with result of the operation of batch uploading tickets. */
export type BatchUploadTicketPayload = {
  __typename?: 'BatchUploadTicketPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type BatchUploadTicketPdfFileInput = {
  file: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
};

export type Billing = {
  __typename?: 'Billing';
  /** The Payment Service Provider's ID for the billing transaction */
  firstTransactionProviderId: Scalars['String']['output'];
  /** The unique identifier of a billing */
  id: Scalars['ID']['output'];
  /** The payment method for the billing */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the transaction corresponding to a billing */
  transactionId: Scalars['ID']['output'];
  /** The status of the transaction provider */
  transactionProviderStatus?: Maybe<Scalars['String']['output']>;
  /** The type of transaction */
  transactionType?: Maybe<TransactionType>;
};

export type BillingDetailsItem = {
  __typename?: 'BillingDetailsItem';
  /** The commission rate expressed as a percentage */
  commissionRate: Scalars['Float']['output'];
  /** The customer price of the item in customer's currency */
  customerPrice: Money;
  /** The customer total price in customer's currency */
  customerTotalPrice: Money;
  /** Flag whether the item has an age range set or not */
  hasAgeRange: Scalars['Boolean']['output'];
  /** Flag whether the item has a deal applied or not */
  hasDeal: Scalars['Boolean']['output'];
  /** Flag whether the item has an age range or not */
  hasMaxAge: Scalars['Boolean']['output'];
  /** Flag whether the item has a minimum age set or not */
  hasMinAge: Scalars['Boolean']['output'];
  /** Flag whether the item has a related pax item */
  hasRelatedPaxItem: Scalars['Boolean']['output'];
  /** The unique identifier of the booking billing details item - unique only per booking */
  id: Scalars['ID']['output'];
  /** Flag whether the item is using fixed price net rates */
  isFixedPriceNetRate: Scalars['Boolean']['output'];
  /** The type of the billing details item */
  itemType: Scalars['String']['output'];
  /** The maximum age for the item */
  maxAge?: Maybe<Scalars['Int']['output']>;
  /** The max number of participants */
  maxGroupSize: Scalars['Int']['output'];
  /** The minimum age for the item */
  minAge?: Maybe<Scalars['Int']['output']>;
  /** The number of participants for the item */
  numberOfParticipants: Scalars['Int']['output'];
  /** The quantity of the item */
  quantity: Scalars['Int']['output'];
  /** The related pax billing details item that associated to this item if any */
  relatedPaxItem?: Maybe<BillingDetailsItem>;
  /** The supplier price of the item in supplier's currency */
  supplierPrice: Money;
  /** The supplier share in supplier's currency */
  supplierShare: Money;
  /** The supplier total price in supplier's currency */
  supplierTotalPrice: Money;
  /** The supplier total share in supplier's currency */
  supplierTotalShare: Money;
  /** The translated name of a billing details item */
  translatedName: Scalars['String']['output'];
};

export type BlockType = ActivityCardBlock | ActivityCardListBlock | IntroBannerBlock | IntroBannerBlockV2;

export type BlockUnblockAvailabilityInput = {
  /** Array of activity ids as strings to block or unblock */
  activityIds: Array<Scalars['Int']['input']>;
  /** Local start date and time in ISO 8601 local date-time */
  endTime: Scalars['String']['input'];
  /** Local start date and time in ISO 8601 local date-time */
  startTime: Scalars['String']['input'];
};

export type BlockUnblockAvailabilityPayload = {
  __typename?: 'BlockUnblockAvailabilityPayload';
  /** Message with details of the error, if the creation fails */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag that indicates if the block or unblock was successful */
  success: Scalars['Boolean']['output'];
};

export type Booking = {
  __typename?: 'Booking';
  /** Flag whether the booking was accepted by the supplier or not */
  acceptedBySupplier: Scalars['Boolean']['output'];
  /** The activity option for this booking */
  activityOption: ActivityOption;
  /** The description of the api credentials used for the booking */
  apiCredentialsDescription?: Maybe<Scalars['String']['output']>;
  /** A unique identifier of the booking that is not numerically sequential and is easy to pronounce */
  bookingReference: Scalars['String']['output'];
  /** The type of the booking */
  bookingType: BookingType;
  /** Link to the box office logs */
  boxOfficeLogsURL?: Maybe<Scalars['String']['output']>;
  /** The booking's calculated customer total price from the billing details in customer's currency */
  calculatedCustomerTotalPrice: Money;
  /** The booking's calculated supplier total price from the billing details in supplier's currency */
  calculatedSupplierTotalPrice: Money;
  /** The booking's calculated supplier total share from the billing details in supplier's currency */
  calculatedSupplierTotalShare: Money;
  /** Indicates if a cancellation compensation can be added to the booking */
  canAddCancellationCompensationRetroactively: Scalars['Boolean']['output'];
  /** Flag indicating if a connector can be added to the booking */
  canAddConnector: Scalars['Boolean']['output'];
  canChargeSupplierForCancellation: Scalars['Boolean']['output'];
  /** Whether the tickets can be edited manually for the booking or not */
  canEditTicketsManually: Scalars['Boolean']['output'];
  /** Flag indicating if the cancellation fees can be removed */
  canRemoveCancellationFees: Scalars['Boolean']['output'];
  /** Flag indicating if a connector can be removed from the booking */
  canRemoveConnector: Scalars['Boolean']['output'];
  /** Flag indicating if the voucher can be resent to the customer */
  canResendVouchersToCustomer: Scalars['Boolean']['output'];
  /** Flag indicating if it is possible to retry to confirm the booking */
  canRetryUnconfirmed: Scalars['Boolean']['output'];
  /** Flag indicating if the supplier status can be updated */
  canUpdateSupplierStatus: Scalars['Boolean']['output'];
  /** The date when the booking was cancelled if it was eventually cancelled in server's timezone (Europe/Zurich) */
  cancellationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The list of cancellation fees of the booking */
  cancellationRequests: Array<BookingCancellationRequest>;
  /** The ISO code of the language the booking will be carried out with */
  conductionLanguage?: Maybe<Scalars['String']['output']>;
  /** The tour option link id representing the language that the tour is conducted in */
  conductionLanguageDetails?: Maybe<LegacyConductionLanguage>;
  /** The date when the booking was confirmed in server's timezone (Europe/Zurich) */
  confirmationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The confirmation user of the booking if it was manually confirmed */
  confirmationUser?: Maybe<Scalars['String']['output']>;
  /** The connector failure reason of the booking */
  connectorFailureReason?: Maybe<Scalars['String']['output']>;
  /** The connector status of the booking */
  connectorStatus?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  /** The date when the booking was created in server's timezone (Europe/Zurich) */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The customer the booking belongs to */
  customer?: Maybe<Customer>;
  /** The customer's accommodation */
  customerAccommodation?: Maybe<Scalars['String']['output']>;
  /** The customer's address */
  customerAddress?: Maybe<CustomerAddress>;
  /** The historic customer facing cancellation policy that was current at the time the booking was created */
  customerCancellationPolicy: BookingCancellationPolicy;
  /** The customer's comment for the booking */
  customerComment?: Maybe<Scalars['String']['output']>;
  /** The customer facing flexibility policy booked for the booking */
  customerFlexibilityPolicy: BookingFlexibilityPolicy;
  /** The booking's customer total price in customer's currency */
  customerTotalPrice: Money;
  /** The list of "discount" booking billing details */
  discountBookingBillingDetails: Array<BillingDetailsItem>;
  /** The guide status of the booking */
  guideStatus: BookingGuideStatus;
  /** The associated Gyg Campaign of the booking if there is any */
  gygCampaign?: Maybe<GygCampaign>;
  /** Flag whether the booking has a third party voucher or not */
  hasThirdPartyBookingVoucher: Scalars['Boolean']['output'];
  /** The hashcode string uniquely identifying the booking */
  hashCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether the booking is canceled */
  isCanceled: Scalars['Boolean']['output'];
  /** Flag whether the booking is connected to the Box Office */
  isConnectedToBoxOffice: Scalars['Boolean']['output'];
  /** Wether the booking is currently reserved */
  isCurrentlyReserved: Scalars['Boolean']['output'];
  /** Whether the booking is editable or not */
  isEditable: Scalars['Boolean']['output'];
  /** Whether editing the booking is forbidden due to the age of the booking or not */
  isEditingForbiddenDueToBookingAge: Scalars['Boolean']['output'];
  /** Flag indicating if the bookings is made with an expedia reseller */
  isExpedia: Scalars['Boolean']['output'];
  /** Whether the external reference is editable (only for partner 1010) */
  isExternalReferenceStringEditable: Scalars['Boolean']['output'];
  /** Indicates if the supplier is external or not */
  isExternalSupplier: Scalars['Boolean']['output'];
  /** Whether the booking has been marked as fraud or not */
  isFraud: Scalars['Boolean']['output'];
  /** Whether the customer has a monthly master bill or we requested a credit card payment at booking */
  isMasterBill: Scalars['Boolean']['output'];
  /** Flag representing whether the booking was created from a device with a mobile user agent */
  isMobileSource: Scalars['Boolean']['output'];
  /** Flag whether booking is for an on-demand tour or not */
  isOnDemand: Scalars['Boolean']['output'];
  /** Whether the booking is not confirmed by the supplier */
  isPending: Scalars['Boolean']['output'];
  /** Flag whether the booking's customer total price is matching the calculated customer total price from the billing details */
  isStandardCustomerTotalPrice: Scalars['Boolean']['output'];
  /** Flag whether the booking's supplier share is matching the calculated supplier share from the billing details */
  isStandardSupplierShare: Scalars['Boolean']['output'];
  /** Flag whether the booking's supplier total price is matching the calculated supplier total price from the billing details */
  isStandardSupplierTotalPrice: Scalars['Boolean']['output'];
  /** Whether the booking was altered through supplier contact */
  isSupplierContact: Scalars['Boolean']['output'];
  /** Whether the booking was altered through supplier email */
  isSupportEmail: Scalars['Boolean']['output'];
  /** Whether the booking was altered through phone */
  isSupportPhone: Scalars['Boolean']['output'];
  /** Whether the booking is for testing */
  isTestData: Scalars['Boolean']['output'];
  /** Whether the booking was made via the TUI api or not - only for bookings pre 2019-04-01 */
  isTuiApiBooking: Scalars['Boolean']['output'];
  /** The modification logs of the booking as a single string */
  modificationLog: Scalars['String']['output'];
  /** The partner associated with the booking */
  partner?: Maybe<Partner>;
  /** The adjustment payments made to the partner */
  partnerAdjustmentPayments: Array<PartnerAdjustmentPayment>;
  /** The partner's commission rate for revenue share on the booking amount */
  partnerCommissionForRevenueShare?: Maybe<Scalars['Float']['output']>;
  /** The GYG commission rate for transactions */
  partnerGygTransactionCommission?: Maybe<Scalars['Float']['output']>;
  /** The payment made to the partner */
  partnerPaymentId?: Maybe<Scalars['ID']['output']>;
  /** The type of revenue model agreed with the partner (fixed or share) */
  partnerRevenueModel?: Maybe<Scalars['String']['output']>;
  /** The share of the booking's value that belongs to the partner */
  partnerShare?: Maybe<Money>;
  /** The total value of the booking in the partner's currency */
  partnerTotalPrice?: Maybe<Money>;
  /** The partner type used */
  partnerType?: Maybe<BookingPartnerType>;
  pickupNote: Scalars['String']['output'];
  /** The type of pricing for the booking (e.g. group/individual) */
  priceType?: Maybe<Scalars['String']['output']>;
  /** The list of "reduction" booking billing details */
  reductionBookingBillingDetails: Array<BillingDetailsItem>;
  /** The booking's refunds */
  refunds: Array<Refund>;
  /** The rescheduled bookings (from and to) */
  rescheduledBookings?: Maybe<RescheduledBookings>;
  /** The reference string used by the reseller to identify the booking */
  resellerReferenceCode?: Maybe<Scalars['String']['output']>;
  /**
   * restrictedCustomerAddress introduced for the supplierBookingsSearch query.
   * Use the fields from customerAddress elsewhere
   */
  restrictedCustomerAddress: RestrictedCustomerAddress;
  /** The booking's shopping cart */
  shoppingCart: ShoppingCart;
  /** The list of "standard" booking billing details */
  standardBookingBillingDetails: AggregatedBillingDetails;
  /** The status of the booking */
  status: BookingStatus;
  /** The booking's supplier */
  supplier: Supplier;
  /** The supplier adjustment payments associated with this booking */
  supplierAdjustmentPayments: Array<SupplierAdjustmentPayment>;
  /** The booking's supplier total applicable cancellation fee */
  supplierCancellationFee: Money;
  /** The historic supplier facing cancellation policy that was current at the time the booking was created */
  supplierCancellationPolicy?: Maybe<BookingCancellationPolicy>;
  /** The supplier invoice containing the booking */
  supplierInvoiceId?: Maybe<Scalars['ID']['output']>;
  /** The supplier requested answer as a string */
  supplierRequestedAnswer: SupplierRequestedAnswer;
  /** Whether the supplier should be paid for this booking */
  supplierShouldGetPaid: Scalars['Boolean']['output'];
  /** The booking's supplier total price in supplier's currency */
  supplierTotalPrice: Money;
  /** The booking's supplier total share in supplier's currency */
  supplierTotalShare: Money;
  /** The temporary masked email address */
  temporaryMaskedEmailAddress?: Maybe<Scalars['String']['output']>;
  /** Represents the ticket code type of the associated tickets for the booking */
  ticketCodeType?: Maybe<BookingTicketCodeType>;
  tickets: Array<BookingTicket>;
  /** The total number of participants for the booking */
  totalNumberOfParticipants: Scalars['Int']['output'];
  /** The start date of the tour in the tour's timezone */
  tourStart?: Maybe<Scalars['DateTime']['output']>;
  /** The translated language name the booking will be carried out with */
  translatedConductionLanguageName?: Maybe<Scalars['String']['output']>;
  /** An aggregation between the tour start datetime, tour start datetime type and tour option timezone translated */
  translatedTourStart: Scalars['String']['output'];
};

export type BookingCancellationPolicy = {
  __typename?: 'BookingCancellationPolicy';
  allowsFeeAdjustment: Scalars['Boolean']['output'];
  /** The unique identifier of the booking */
  bookingId: Scalars['ID']['output'];
  cancellationText: Scalars['String']['output'];
  /** Flag whether the policy permits cancellation for free at the moment or not */
  isCurrentlyCancellableForFree: Scalars['Boolean']['output'];
  /** Flag describing if the booking can still be cancelled by the customer who made it */
  isSelfCancellationPossible: Scalars['Boolean']['output'];
  /** Flag whether the policy permits cancellation at all or not */
  isStillCancellable: Scalars['Boolean']['output'];
};

export type BookingCancellationReason = {
  __typename?: 'BookingCancellationReason';
  /** A flag indicating whether an additional text field for the cancellation reason should be filled */
  fillOutMandatory: Scalars['Boolean']['output'];
  /** The ordering for this cancellation reason */
  ordering: Scalars['Int']['output'];
  /** The reason id */
  reasonId: Scalars['Int']['output'];
  /** The sub-reasons associated with this reason */
  subReasons: Array<BookingCancellationReason>;
};

export type BookingCancellationReasons = {
  __typename?: 'BookingCancellationReasons';
  /** The list of possible reasons */
  reasons: Array<BookingCancellationReason>;
};

export enum BookingCancellationReasonsFilter {
  Cancellation = 'CANCELLATION',
  RefundDiscount = 'REFUND_DISCOUNT',
  RefundReduction = 'REFUND_REDUCTION',
  SupplierRejection = 'SUPPLIER_REJECTION',
  SupplierSelfCancellation = 'SUPPLIER_SELF_CANCELLATION'
}

export type BookingCancellationReasonsInput = {
  /** The booking cancellation reason filter */
  bookingCancellationReasonFilter: BookingCancellationReasonsFilter;
};

export type BookingCancellationRequest = {
  __typename?: 'BookingCancellationRequest';
  /** An alternative date in case there was a rescheduling instead of a simple cancellation in server's timezone (Europe/Zurich) */
  alternativeDate?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the booking associated with the request */
  bookingId: Scalars['ID']['output'];
  /** The entity that triggered the cancellation */
  cancelledBy: CanceledByEntity;
  /** The date when the cancellation was triggered in server's timezone (Europe/Zurich) */
  dateOfCancellation?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the booking cancellation request */
  id: Scalars['ID']['output'];
  /** Custom reason description for the cancellation */
  reason: Scalars['String']['output'];
  /** A predefined text of the cancellation reason in a specific language */
  reasonText?: Maybe<Scalars['String']['output']>;
};

export enum BookingCategory {
  FreeNoTicket = 'FREE_NO_TICKET',
  FreeTicketRequired = 'FREE_TICKET_REQUIRED',
  NotPermitted = 'NOT_PERMITTED',
  Standard = 'STANDARD'
}

export type BookingFlexibilityPolicy = {
  __typename?: 'BookingFlexibilityPolicy';
  /** The unique identifier of the booking */
  bookingId: Scalars['ID']['output'];
  /** The text shown for the flexibility policy */
  flexibilityPolicyText: Scalars['String']['output'];
  /** Bool flag indicating whether booking has a flexibility upgrade */
  hasFlexibilityUpgrade: Scalars['Boolean']['output'];
};

export enum BookingGuideStatus {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED'
}

export type BookingLevelInput = {
  /** The answers */
  answer: Array<AnswerInfoInput>;
  /** The category id (e.g free_text_answer) */
  id: Scalars['ID']['input'];
};

export enum BookingOperation {
  AddConnector = 'ADD_CONNECTOR',
  ChargeCancellationCompensationRetroactively = 'CHARGE_CANCELLATION_COMPENSATION_RETROACTIVELY',
  RemoveCancellationFees = 'REMOVE_CANCELLATION_FEES',
  RemoveConnector = 'REMOVE_CONNECTOR',
  ResendVouchersToCustomer = 'RESEND_VOUCHERS_TO_CUSTOMER',
  RetryUnconfirmed = 'RETRY_UNCONFIRMED',
  RetryUnconfirmedWithReservation = 'RETRY_UNCONFIRMED_WITH_RESERVATION',
  UpdateSupplierStatus = 'UPDATE_SUPPLIER_STATUS'
}

export type BookingOperationInput = {
  /** The unique identifier of the booking */
  bookingId: Scalars['ID']['input'];
  /** The operation to be executed */
  operation: BookingOperation;
};

export type BookingOperationPayload = {
  __typename?: 'BookingOperationPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum BookingPartnerType {
  GygSem = 'GYG_SEM',
  Reseller = 'RESELLER',
  Sem = 'SEM',
  Supplier = 'SUPPLIER'
}

export type BookingSearch = {
  __typename?: 'BookingSearch';
  items: Array<Booking>;
  pagination: Pagination;
  totalItems: Scalars['Int']['output'];
};

export enum BookingStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Deleted = 'DELETED',
  DeletedByCustomer = 'DELETED_BY_CUSTOMER',
  DeletedByDaemon = 'DELETED_BY_DAEMON',
  Temp = 'TEMP'
}

export type BookingTicket = {
  __typename?: 'BookingTicket';
  bookingId: Scalars['ID']['output'];
  category?: Maybe<BookingTicketCategory>;
  code: Scalars['String']['output'];
  codeType: BookingTicketCodeType;
  label: Scalars['String']['output'];
  sequenceNumber: Scalars['Int']['output'];
};

export enum BookingTicketCategory {
  Adult = 'ADULT',
  Child = 'CHILD',
  Collective = 'COLLECTIVE',
  EuCitizen = 'EU_CITIZEN',
  EuCitizenStudent = 'EU_CITIZEN_STUDENT',
  Group = 'GROUP',
  Infant = 'INFANT',
  Military = 'MILITARY',
  Senior = 'SENIOR',
  Student = 'STUDENT',
  Youth = 'YOUTH'
}

export enum BookingTicketCodeType {
  Aztec = 'AZTEC',
  BarcodeCode39 = 'BARCODE_CODE39',
  BarcodeCode128 = 'BARCODE_CODE128',
  Code25Interleaved = 'CODE25INTERLEAVED',
  DataMatrix = 'DATA_MATRIX',
  Ean13 = 'EAN13',
  Itf = 'ITF',
  PdfFile = 'PDF_FILE',
  QrCode = 'QR_CODE',
  Text = 'TEXT'
}

export enum BookingType {
  Api = 'API',
  GygCampaign = 'GYG_CAMPAIGN',
  ProductTesting = 'PRODUCT_TESTING',
  SoapApi = 'SOAP_API',
  Standard = 'STANDARD',
  TestBooking = 'TEST_BOOKING'
}

/** A bounding box is an area defined by two longitudes and two latitudes. */
export type BoundingBox = {
  __typename?: 'BoundingBox';
  /** North East Latitude is a decimal number between -90.0 and 90.0. */
  neLat?: Maybe<Scalars['String']['output']>;
  /** North East Longitude is a decimal number between -180.0 and 180.0. */
  neLng?: Maybe<Scalars['String']['output']>;
  /** South West Latitude is a decimal number between -90.0 and 90.0. */
  swLat?: Maybe<Scalars['String']['output']>;
  /** South West Longitude is a decimal number between -180.0 and 180.0. */
  swLng?: Maybe<Scalars['String']['output']>;
};

export type BoundingBoxInput = {
  neLat: Scalars['Float']['input'];
  neLng: Scalars['Float']['input'];
  swLat: Scalars['Float']['input'];
  swLng: Scalars['Float']['input'];
};

export type BrazeChannel = {
  __typename?: 'BrazeChannel';
  /** Current state of the permission (enabled/disabled) */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Last time the permission was updated (can be missing for old entries) */
  latestUpdate?: Maybe<Scalars['String']['output']>;
  /** Channel name [email/app] */
  name: Scalars['String']['output'];
};

export type BrazeCommunicationSentInfo = {
  __typename?: 'BrazeCommunicationSentInfo';
  /** The date of the communication sent to the customer */
  date: Scalars['String']['output'];
  /** The name of the communication sent to the customer  */
  name: Scalars['String']['output'];
};

export type BrazePermission = {
  __typename?: 'BrazePermission';
  /** Channel name (email/app) */
  channels: Array<BrazeChannel>;
  /** Permission that this refers to */
  name: Scalars['String']['output'];
};

export type BrazePermissions = {
  __typename?: 'BrazePermissions';
  /** Latest communications received, either canvases or campaigns */
  latestCommunicationsReceived: Array<BrazeCommunicationSentInfo>;
  /** The permissions found on customer's profile in Braze */
  permissions: Array<BrazePermission>;
};

export type Broadcast = {
  __typename?: 'Broadcast';
  /** The activities on which we'll display this broadcast */
  activity?: Maybe<Activity>;
  /** Each create/update operation return a gettextKey, which we'll include after we perform one of those */
  gettextKey?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the broadcast */
  id: Scalars['ID']['output'];
  /** Is the broadcast dismissible? */
  isDismissible: Scalars['Boolean']['output'];
  /** Is the broadcast enabled? */
  isEnabled: Scalars['Boolean']['output'];
  /** Wheter this is a info/warning type of broadcast */
  level: BroadcastLevel;
  /** List of locations that this broadcast applies to */
  locations?: Maybe<Array<Maybe<Location>>>;
  /** In case we want to propagate the alert to the ADP that encapsulates the tour */
  propagateToAdp: Scalars['Boolean']['output'];
};

export type BroadcastCreateInput = {
  activityId?: InputMaybe<Scalars['String']['input']>;
  isDismissible: Scalars['Boolean']['input'];
  isEnabled: Scalars['Boolean']['input'];
  level: BroadcastLevel;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propagateToAdp: Scalars['Boolean']['input'];
};

export type BroadcastCreatePayload = {
  __typename?: 'BroadcastCreatePayload';
  /** The updated broadcast itself */
  broadcast?: Maybe<Broadcast>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export enum BroadcastLevel {
  Info = 'INFO',
  Urgent = 'URGENT'
}

export type BroadcastUpdateInput = {
  activityId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDismissible: Scalars['Boolean']['input'];
  isEnabled: Scalars['Boolean']['input'];
  level: BroadcastLevel;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propagateToAdp: Scalars['Boolean']['input'];
};

export type BroadcastUpdatePayload = {
  __typename?: 'BroadcastUpdatePayload';
  /** The updated broadcast itself */
  broadcast?: Maybe<Broadcast>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type BusinessPartnerKeyInput = {
  /** ID of the associated business partner */
  businessPartnerId: Scalars['Int']['input'];
  /** Type of the associated business partner */
  businessPartnerType: BusinessPartnerType;
};

/** Enum representing different types of business partners */
export enum BusinessPartnerType {
  Customer = 'CUSTOMER',
  Freelancer = 'FREELANCER',
  Reseller = 'RESELLER',
  Supplier = 'SUPPLIER'
}

export type CalendarInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  activityOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['ID']['input'];
};

export type CalendarItem = {
  __typename?: 'CalendarItem';
  calendarOptions: Array<Maybe<CalendarOption>>;
  date: Scalars['String']['output'];
};

export type CalendarOption = {
  __typename?: 'CalendarOption';
  activityOption?: Maybe<ActivityOption>;
  editable: Scalars['Boolean']['output'];
  pricingType: PricingType;
  timeSlots: Array<Maybe<CalendarTimeSlot>>;
};

export type CalendarTimeSlot = {
  __typename?: 'CalendarTimeSlot';
  bookable: Scalars['Boolean']['output'];
  reservedVacancies: Scalars['Int']['output'];
  time: Scalars['String']['output'];
  timeSlotId: Scalars['ID']['output'];
  totalVacancies: Scalars['Int']['output'];
};

export type CancelBookingInput = {
  /** The unique identifier of the booking */
  bookingId: Scalars['ID']['input'];
  /** The cancellation fee. Only one is provided and based on it the rest are calculated. If not provided the default of refunding the whole amount is used. */
  cancellationFee?: InputMaybe<CancellationFee>;
  /** Specifies if the supplier gets commission or not in case of fraud. If nothing is specified it will default to NO_FRAUD and the regular flow for calculating fees */
  fraudType?: InputMaybe<FraudType>;
  /** The preferred refund method */
  preferredRefundMethod: RefundMethod;
  /** The reason for the cancellation */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The reason id for the cancellation */
  reasonId: Scalars['Int']['input'];
  /** The rescheduled booking id associated with this cancellation if any */
  rescheduledBookingId?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelBookingPayload = {
  __typename?: 'CancelBookingPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CancelBookingsInBulkInput = {
  /** The date from which the bookings are cancelled */
  fromDate: Scalars['DateTime']['input'];
  /** The option id for which the bookings are cancelled */
  optionId?: InputMaybe<Scalars['Int']['input']>;
  /** The reason id for the cancellation */
  reasonId: Scalars['Int']['input'];
  /** The date to which the bookings are cancelled */
  toDate: Scalars['DateTime']['input'];
  /** The tour id for which the bookings are cancelled */
  tourId: Scalars['Int']['input'];
};

export type CancelCouponInput = {
  /** The ID of the coupon */
  couponId: Scalars['ID']['input'];
  /** Indicates if the coupon was cancelled for fraud related reasons */
  isFraud: Scalars['Boolean']['input'];
};

export enum CanceledByEntity {
  Api = 'API',
  BoxOffice = 'BOX_OFFICE',
  Customer = 'CUSTOMER',
  Gyg = 'GYG',
  SoapApi = 'SOAP_API',
  Supplier = 'SUPPLIER'
}

export type CancellationFee = {
  /** It specifies which cancellation fee is provided. */
  type: CancellationFeeType;
  /**
   * For TOTAL_FEE_PERCENTAGE and CUSTOMER_REFUND_PERCENTAGE it must be a value between 0 and 100 with increments of up to 0.01.
   * For the other fields it must be a positive numeric value with increments of up to 0.01 (currency-specific).
   */
  value: Scalars['Float']['input'];
};

export enum CancellationFeeType {
  CustomerRefundCustomerCurrency = 'CUSTOMER_REFUND_CUSTOMER_CURRENCY',
  CustomerRefundPercentage = 'CUSTOMER_REFUND_PERCENTAGE',
  TotalFeeCustomerCurrency = 'TOTAL_FEE_CUSTOMER_CURRENCY',
  TotalFeePercentage = 'TOTAL_FEE_PERCENTAGE',
  TotalFeeSupplierCurrency = 'TOTAL_FEE_SUPPLIER_CURRENCY'
}

export type CancellationFees = {
  __typename?: 'CancellationFees';
  /** Determines if the customer is over indebted */
  customerOverIndebted: Scalars['Boolean']['output'];
  /** The customer refund in customer's currency */
  customerRefundCustomerCurrency: Money;
  /** The amount that the customer will receive expressed as a percentage of the total price of the booking */
  customerRefundPercentage: Scalars['Float']['output'];
  /** The GYG fee in supplier's currency */
  gygFeeSupplierCurrency: Money;
  /** The supplier fee in supplier's currency */
  supplierFeeSupplierCurrency: Money;
  /** The total fee in customer's currency */
  totalFeeCustomerCurrency: Money;
  /** The total fee expressed as a percentage of the total price of the booking */
  totalFeePercentage: Scalars['Float']['output'];
  /** Total fee in supplier's currency */
  totalFeeSupplierCurrency: Money;
};

export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  /** The unit of the cancellation policy */
  feeUnit?: Maybe<CancellationPolicyFeeUnit>;
  /** The value of the cancellation policy fee */
  feeValue?: Maybe<Scalars['Int']['output']>;
  /** How many minutes before the start of the activity is it possible to cancel */
  offsetInMinutes?: Maybe<Scalars['Int']['output']>;
};

export enum CancellationPolicyFeeUnit {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type CancellationPolicyInput = {
  feeUnit: CancellationPolicyFeeUnit;
  feeValue: Scalars['Int']['input'];
  offsetInMinutes: Scalars['Int']['input'];
};

export enum CancellationPolicyType {
  Custom = 'CUSTOM',
  Freetext = 'FREETEXT',
  NotCancellable = 'NOT_CANCELLABLE',
  Standard = 'STANDARD'
}

/** Entity holding fields relevant to a category */
export type Category = {
  __typename?: 'Category';
  /** The unique identifier of the category */
  id: Scalars['ID']['output'];
  /** Wheter or not the category is externally exposed */
  isPublic: Scalars['Boolean']['output'];
  /** The name of the category */
  name: Scalars['String']['output'];
  /** The different parent levels of the category */
  primaryParent?: Maybe<Category>;
  /** The second level parent of a category */
  secondaryParent?: Maybe<Category>;
  /** The current status of the category */
  status?: Maybe<CategoryStatus>;
  /** The tags assigned to the category */
  tags: Array<Tag>;
  /** The translations of the category */
  translations: Array<CategoryTranslation>;
  /** The last time the category was updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who made the last change to the category */
  updateUser?: Maybe<User>;
};

export type CategoryConfiguration = {
  __typename?: 'CategoryConfiguration';
  ageFrom?: Maybe<Scalars['Int']['output']>;
  ageTo?: Maybe<Scalars['Int']['output']>;
  bookingCategory?: Maybe<BookingCategory>;
  category?: Maybe<Scalars['String']['output']>;
  groupSizeMax?: Maybe<Scalars['Int']['output']>;
  groupSizeMin?: Maybe<Scalars['Int']['output']>;
  maxTicketAmount?: Maybe<Scalars['Int']['output']>;
  minTicketAmount?: Maybe<Scalars['Int']['output']>;
};

/** The possible statuses a category can have */
export enum CategoryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

/** Entity holding fields relevant to a category translation */
export type CategoryTranslation = {
  __typename?: 'CategoryTranslation';
  /** The category this translation belongs to */
  category?: Maybe<Category>;
  /** The localized description of the category in the given language */
  description?: Maybe<Scalars['String']['output']>;
  /** The language this translation is in */
  languageId: Scalars['Int']['output'];
  /** The localized name of the category in the given language */
  name: Scalars['String']['output'];
  /** The last time the category translation was updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who made the last change to the category translation */
  updateUser?: Maybe<User>;
};

export type ChangePasswordInput = {
  accountId: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type CleanAvailabilityInput = {
  activityOptionIds: Array<Scalars['ID']['input']>;
};

/** Entity holding fields relevant to a comment */
export type Comment = {
  __typename?: 'Comment';
  /** The content of the comment */
  comment: Scalars['String']['output'];
  /** When the comment was created */
  creationTime?: Maybe<Scalars['String']['output']>;
  /** The user that created this comment */
  creationUser?: Maybe<CommentUser>;
  /** Date of the comment */
  date?: Maybe<Scalars['String']['output']>;
  /** The entity related to this comment */
  entity: Scalars['String']['output'];
  /** The id of the comments for the specified entity */
  entityId: Scalars['Int']['output'];
  /** The unique identifier of the comment */
  id: Scalars['ID']['output'];
  /** The last time the comment was updated */
  lastModificationTime?: Maybe<Scalars['String']['output']>;
  /** The user that las updated this comment */
  lastModificationUser?: Maybe<CommentUser>;
  /** The current status of the comment */
  status?: Maybe<CommentStatus>;
  /** The type of the comment for the specified entity */
  type: Scalars['String']['output'];
};

/** Entity holding all comments of a given entity and id */
export type CommentList = {
  __typename?: 'CommentList';
  /** The list of comments written so far for the given entity and entityId */
  all?: Maybe<Array<Comment>>;
  /** The entity related to this comment */
  entity: Scalars['String']['output'];
  /** The key of the comments for the specified entity */
  entityId: Scalars['Int']['output'];
};

/** The possible statuses a comment can have */
export enum CommentStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type CommentUser = Customer | Staff | Supplier;

export type CommunicationChannel = {
  __typename?: 'CommunicationChannel';
  /** The descriptive text of the Channel */
  description: Scalars['String']['output'];
  /** Current state of the channel (enabled/disabled) */
  isEnabled: Scalars['Boolean']['output'];
  /** Defines wheter this is a read-only channel or not (in case it can't be disabled) */
  isReadOnly: Scalars['Boolean']['output'];
  /** The unique identifier of the Channel */
  name: Scalars['ID']['output'];
  /** The title (summarized description) of the Channel */
  title: Scalars['String']['output'];
};

export enum CompanyRegistrationNumberType {
  Default = 'DEFAULT',
  Ein = 'EIN',
  Itin = 'ITIN',
  Ssn = 'SSN'
}

export type CompleteAccountInput = {
  confirmationCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum CompletenessStatus {
  CompletedNotAllowed = 'completed_not_allowed',
  CompletedOptional = 'completed_optional',
  CompletedRequired = 'completed_required',
  MissingDependency = 'missing_dependency',
  MissingNotAllowed = 'missing_not_allowed',
  MissingOptional = 'missing_optional',
  MissingRequired = 'missing_required'
}

export type ComputedCancellationFeesInput = {
  /** The ID of the booking for which we recompute the cancellation fees */
  bookingId: Scalars['ID']['input'];
  /** The cancellation fee based on which the rest are computed. */
  fee?: InputMaybe<CancellationFee>;
  /** The cancellation reason ID based on which the fees are computed. */
  reasonId?: InputMaybe<Scalars['Int']['input']>;
};

export type ComputedCancellationFeesPayload = {
  __typename?: 'ComputedCancellationFeesPayload';
  fees: CancellationFees;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ConductionLanguage = {
  __typename?: 'ConductionLanguage';
  conductionLanguageType?: Maybe<ConductionLanguageType>;
  id?: Maybe<Scalars['ID']['output']>;
  languageID?: Maybe<Scalars['Int']['output']>;
  option?: Maybe<ActivityOption>;
  status?: Maybe<ConductionLanguageStatus>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<User>;
};

export type ConductionLanguageInput = {
  conductionLanguageType?: InputMaybe<ConductionLanguageType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageID?: InputMaybe<Scalars['Int']['input']>;
};

export enum ConductionLanguageStatus {
  Active = 'ACTIVE',
  Removed = 'REMOVED'
}

export enum ConductionLanguageType {
  AudioGuide = 'AUDIO_GUIDE',
  Booklet = 'BOOKLET',
  LiveGuide = 'LIVE_GUIDE'
}

export enum ConfirmationType {
  ForgotPassword = 'forgotPassword',
  Registration = 'registration',
  SupplierAccount = 'supplierAccount'
}

export type ConnectDisconnectByActivityOptionIdsInput = {
  /** The tour option ids which to connect to or disconnect from the reservation system */
  activityOptionIds: Array<Scalars['Int']['input']>;
  /** The connection operation on the tour options */
  operation: ConnectionOperation;
};

export enum ConnectionOperation {
  Connect = 'CONNECT',
  Disconnect = 'DISCONNECT'
}

export type ConnectivityClient = {
  __typename?: 'ConnectivityClient';
  id?: Maybe<Scalars['Int']['output']>;
  integrationId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ConnectivitySettings = {
  __typename?: 'ConnectivitySettings';
  /** Method on how the product is connected */
  acquisitionChannel?: Maybe<Scalars['String']['output']>;
  /** Is enabled availability? */
  availabilityUpdateEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Client ID for Multiclient integrations */
  clientId?: Maybe<Scalars['Int']['output']>;
  /** Type of the code generator used */
  codeGeneratorType?: Maybe<Scalars['String']['output']>;
  /** Product identifier. Often in the form of a stringified json. */
  externalProductId?: Maybe<Scalars['String']['output']>;
  /** Is connected to Boxoffice? */
  managedByConnector?: Maybe<Scalars['Boolean']['output']>;
  /** Is enabled price over API? */
  priceUpdateEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Key that defines the integrator id */
  sourceConfigId?: Maybe<Scalars['Int']['output']>;
  /** Key that defines the integrator in format "key:id" */
  sourceConfigKey?: Maybe<Scalars['String']['output']>;
  /** Target of the connection */
  target?: Maybe<Scalars['String']['output']>;
};

export type ConnectivitySettingsInput = {
  availabilityUpdateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  priceUpdateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sourceConfigKey?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectivitySettingsPayload = {
  __typename?: 'ConnectivitySettingsPayload';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConnectivitySourceConfig = {
  __typename?: 'ConnectivitySourceConfig';
  clients: Array<ConnectivityClient>;
  connectionMethod?: Maybe<Scalars['String']['output']>;
  sourceConfigId?: Maybe<Scalars['Int']['output']>;
  sourceConfigKey?: Maybe<Scalars['String']['output']>;
  sourceConfigLabel?: Maybe<Scalars['String']['output']>;
};

export type ContentReview = {
  __typename?: 'ContentReview';
  /** The timestamp of when the entity associated with this content review was activated */
  activationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the staff member who is assigned to this content review */
  assignedStaffId?: Maybe<Scalars['Int']['output']>;
  /** The checks associated with this content review */
  contentReviewChecks: Array<ContentReviewCheck>;
  /** The comments associated with this content review */
  contentReviewComments: Array<ContentReviewComment>;
  /** The quality issues associated with this content review */
  contentReviewQualityIssues: Array<ContentReviewQualityIssue>;
  /** Used to differentiate between different types of content review items */
  context?: Maybe<Scalars['String']['output']>;
  /** In case the creation user is staff, this field contains the extra information */
  creationStaff?: Maybe<Staff>;
  /** The timestamp of when this content review was created */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user whose actions led to the creation of this content review */
  creationUser?: Maybe<User>;
  /** JSON string representation of the current state of the content review */
  currentState?: Maybe<Scalars['String']['output']>;
  /** The entity of the content review */
  entity?: Maybe<Scalars['String']['output']>;
  /** The id of the associated entity */
  entityId?: Maybe<Scalars['Int']['output']>;
  /** The timestamp of when this content review was finalized */
  finalizedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Uniquely identifies a content review */
  id: Scalars['ID']['output'];
  /** The timestamp of when the entity associated with this content review was set to in_progress */
  inProgressTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Language ID used for entity submission */
  masterLanguageId?: Maybe<Scalars['Int']['output']>;
  /** JSON string representation of the previous state of the content review */
  previousState?: Maybe<Scalars['String']['output']>;
  /** The priority assigned to this content review */
  priority?: Maybe<Scalars['Int']['output']>;
  /** A flag indicating whether the changes made to the entity that is associated with this content review have been reverted */
  reverted?: Maybe<Scalars['Boolean']['output']>;
  /** The sections of the entity that is under review */
  reviewSection?: Maybe<Scalars['String']['output']>;
  /** The status of the content review */
  reviewStatus?: Maybe<Scalars['String']['output']>;
  /** A flag indicating whether an email regarding this content review has already been sent out to the supplier */
  supplierEmailSent?: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp of when this content review was last edited */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who last updated this content review */
  updateUser?: Maybe<User>;
};

export type ContentReviewCheck = {
  __typename?: 'ContentReviewCheck';
  /** The ID of the staff who is assigned to this check */
  assignedStaffId?: Maybe<Scalars['Int']['output']>;
  /** The category of the check */
  category?: Maybe<Scalars['String']['output']>;
  /** The ID of the content review associated with this check */
  contentReviewId?: Maybe<Scalars['Int']['output']>;
  /** The timestamp of when this check was created */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of this check */
  id: Scalars['ID']['output'];
  /** The status of the check */
  status?: Maybe<Scalars['String']['output']>;
  /** The type of the check */
  type?: Maybe<Scalars['String']['output']>;
  /** The timestamp of when this check was last modified */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who last modified this check */
  updateUser?: Maybe<User>;
};

export type ContentReviewCheckInput = {
  /** The staff ID assigned to this check */
  assignedStaffId?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier of the content review check */
  id: Scalars['ID']['input'];
  /** The status of the check */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ContentReviewComment = {
  __typename?: 'ContentReviewComment';
  /** The contents of this comment */
  comment?: Maybe<Scalars['String']['output']>;
  /** The ID of the content review associated with this comment */
  contentReviewId?: Maybe<Scalars['Int']['output']>;
  /** In case the creation user is staff, this field contains the extra information */
  creationStaff?: Maybe<Staff>;
  /** The timestamp of when this comment was created */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who created this comment */
  creationUser?: Maybe<User>;
  /** The unique identifier of this comment */
  id: Scalars['ID']['output'];
  /** In case the update user is staff, this field contains the extra information */
  updateStaff?: Maybe<Staff>;
  /** The timestamp of when this comment was last updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who last updated this comment */
  updateUser?: Maybe<User>;
};

export type ContentReviewCommentCreateInput = {
  /** The text of the comment */
  comment: Scalars['String']['input'];
  /** The id of the content review associated with the comment */
  contentReviewId: Scalars['Int']['input'];
};

export type ContentReviewCommentEditInput = {
  /** The text of the comment */
  comment: Scalars['String']['input'];
  /** The id of the content review associated with the comment */
  contentReviewId: Scalars['Int']['input'];
  /** The id of the comment */
  id: Scalars['ID']['input'];
};

export type ContentReviewCommentMutatePayload = {
  __typename?: 'ContentReviewCommentMutatePayload';
  /** The content review associated to the mutated comment */
  contentReview?: Maybe<ContentReview>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type ContentReviewPrioritizeInput = {
  /** The id of the content review to prioritize */
  contentReviewId?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to deprioritize the content reviews matching the given arguments */
  deprioritize?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the delayed tour push item whose blocking queue items to prioritize */
  xtmDelayedTourPushId?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentReviewPrioritizePayload = {
  __typename?: 'ContentReviewPrioritizePayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type ContentReviewQualityIssue = {
  __typename?: 'ContentReviewQualityIssue';
  /** The ID of the content review associated with this quality issue */
  contentReviewId?: Maybe<Scalars['Int']['output']>;
  /** The timestamp of when this quality issue was created */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who created this quality issue */
  creationUser?: Maybe<User>;
  /** The entity of this quality issue */
  entity?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity associated with this quality issue */
  entityId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of this quality issue */
  id: Scalars['ID']['output'];
  /** The description of this quality issue */
  qualityIssueDescription?: Maybe<Scalars['String']['output']>;
  /** The subtype of this quality issue */
  qualityIssueSubtype?: Maybe<Scalars['String']['output']>;
  /** The type of this quality issue */
  qualityIssueType?: Maybe<Scalars['String']['output']>;
  /** The status of this quality issue */
  status?: Maybe<Scalars['String']['output']>;
  /** The timestamp of when this quality issue was last updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who last updated this quality issue */
  updateUser?: Maybe<User>;
};

export type ContentReviewQualityIssueInput = {
  /** The id of the associated content review */
  contentReviewId: Scalars['Int']['input'];
  /** The entity of the quality issue */
  entity: Scalars['String']['input'];
  /** The id of the associated entity */
  entityId: Scalars['String']['input'];
  /** The unique identifier of the quality issue */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The description of the quality issue */
  qualityIssueDescription?: InputMaybe<Scalars['String']['input']>;
  /** The subtype of the quality issue */
  qualityIssueSubtype: Scalars['String']['input'];
  /** The type of the quality issue */
  qualityIssueType: Scalars['String']['input'];
  /** The status of the quality issue */
  status: Scalars['String']['input'];
};

export type ContentReviewUpdateInput = {
  /** The id of the staff currently assigned */
  assignedStaffId?: InputMaybe<Scalars['Int']['input']>;
  /** The quality issues associated with the content review */
  contentReviewQualityIssues: Array<ContentReviewQualityIssueInput>;
  /** Unique identifier of a content review */
  id: Scalars['ID']['input'];
  /** The review status of the content review */
  reviewStatus?: InputMaybe<Scalars['String']['input']>;
};

export type ContentReviewUpdatePayload = {
  __typename?: 'ContentReviewUpdatePayload';
  /** The content review that is being updated. */
  contentReview?: Maybe<ContentReview>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

/**
 * A Continent holds the information for what we identify as a continent across
 * our different domains.
 */
export type Continent = {
  __typename?: 'Continent';
  /**
   * Given bounding box of the continent, such definition is generally used to draw an
   * area around the exact continent coordinates.
   */
  boundingBox?: Maybe<BoundingBox>;
  /**
   * Given coordinates of the continent, such coordinates are generally used to
   * pinpoint a continent in a map.
   */
  coordinates?: Maybe<Coordinates>;
  /** Uniquely identifies a continent. */
  id: Scalars['ID']['output'];
  /** Unlocalized name of the continent. */
  name: Scalars['String']['output'];
};

export type ConvertRefundInput = {
  /** To what should the refund be converted to */
  convertTo: ConvertTo;
  /** The ID of refund to be converted */
  refundId: Scalars['ID']['input'];
};

export type ConvertRefundPayload = {
  __typename?: 'ConvertRefundPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ConvertTo {
  Coupon = 'COUPON',
  PromoCode = 'PROMO_CODE'
}

/**
 * Coordinates holds the Latitude and Longitude which are the units that represent the coordinates at
 * geographic coordinate system.
 */
export type Coordinates = {
  __typename?: 'Coordinates';
  /**
   * In geography, latitude is a geographic coordinate that specifies the north–south
   * position of a point on the Earth's surface.
   */
  latitude?: Maybe<Scalars['String']['output']>;
  /**
   * Longitude is a geographic coordinate that specifies the east–west position of a
   * point on the Earth's surface, or the surface of a celestial body.
   */
  longitude?: Maybe<Scalars['String']['output']>;
};

export type CoordinatesInput = {
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
};

export type CopyBillingToLeadCustomerAddressInput = {
  /** The id of the customer address */
  id: Scalars['ID']['input'];
};

export type CopyBillingToLeadCustomerAddressPayload = OperationResult & {
  __typename?: 'CopyBillingToLeadCustomerAddressPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CoreKeyword = {
  __typename?: 'CoreKeyword';
  tag?: Maybe<Tag>;
  themeGroupId?: Maybe<Scalars['Int']['output']>;
  themeGroupName?: Maybe<Scalars['String']['output']>;
  themeId?: Maybe<Scalars['Int']['output']>;
  themeName?: Maybe<Scalars['String']['output']>;
};

/**
 * A Country holds the information for the what we identify as a country across
 * our different domains.
 */
export type Country = {
  __typename?: 'Country';
  /** Localized alternative names the country can have for each given language. */
  aliases?: Maybe<Array<CountryAlias>>;
  /**
   * Given bounding box of the country, such definition is generally used to draw an
   * area around the exact country coordinates.
   */
  boundingBox?: Maybe<BoundingBox>;
  /** The continent the country belongs to. */
  continent?: Maybe<Continent>;
  /**
   * Given coordinates of the country, such coordinates are generally used to
   * pinpoint a country in a map.
   */
  coordinates?: Maybe<Coordinates>;
  /** The base currency used in the country. */
  currencyId?: Maybe<Scalars['Int']['output']>;
  financeCurrencies: Array<Currency>;
  /** Uniquely identifies a country. */
  id: Scalars['ID']['output'];
  /**
   * ISO 3166 is a standard published by the International Organization for Standardization (ISO)
   * that defines codes for the names of countries, dependent territories, special areas of geographical
   * interest, and their principal subdivisions.
   */
  isoCode?: Maybe<Scalars['String']['output']>;
  /**
   * The ISO country codes are internationally recognized codes that designate every country and most of
   * the dependent areas a two-letter combination or a three-letter combination; it is like an acronym,
   * that stands for a country or a state.
   */
  isoCodeThree?: Maybe<Scalars['String']['output']>;
  /** The last time this country was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this country. */
  lastModificationUser?: Maybe<User>;
  /** The location associated with this country. */
  location?: Maybe<Location>;
  /** Unlocalized name of the country. */
  name: Scalars['String']['output'];
  /** Country international phone prefix */
  phonePrefix?: Maybe<Scalars['String']['output']>;
  /** Available country pictures. */
  pictures?: Maybe<Array<CountryPicture>>;
  /** Sales area of the country. */
  salesArea?: Maybe<Scalars['String']['output']>;
  /** Localized free text fields of the country for each language. */
  translations?: Maybe<Array<CountryTranslation>>;
};

/**
 * A CountryAlias holds the information for the possible aliases of
 * the country name in the different languages, a single country can have
 * multiple aliases for the same language.
 */
export type CountryAlias = {
  __typename?: 'CountryAlias';
  /** Identifies the country that this alias belongs to. */
  country?: Maybe<Country>;
  /** Uniquely identifies a country alias. */
  id: Scalars['ID']['output'];
  /** The language in which this alias was created for. */
  languageId: Scalars['Int']['output'];
  /** The last time this country alias was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this country alias. */
  lastModificationUser?: Maybe<User>;
  /**
   * The localized name of the country alias for the associated
   * country and language.
   */
  name: Scalars['String']['output'];
};

/** A CountryPicture holds the information for the possible pictures a country can have. */
export type CountryPicture = {
  __typename?: 'CountryPicture';
  /** Identifies the country that this picture belongs to. */
  country?: Maybe<Country>;
  /** File name generated while storing the picture. */
  filename: Scalars['String']['output'];
  /** Uniquely identifies a country picture. */
  id: Scalars['ID']['output'];
  /** The last time this country picture was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this country picture. */
  lastModificationUser?: Maybe<User>;
  /**
   * Type of the picture, generally used to facilitate the selection of which image to be used
   * on different layout positions.
   */
  type: CountryPictureType;
};

/** Possible alternatives for the country picture type. */
export enum CountryPictureType {
  /** Default picture shown for the given country. */
  Normal = 'NORMAL',
  /** Optimzed picture to be shown in horizontally wide sections. */
  Wide = 'WIDE'
}

/**
 * A CountryTranslation holds the translations for the text fields of a
 * country in the associated language.
 */
export type CountryTranslation = {
  __typename?: 'CountryTranslation';
  /** The language in which this translation was created for. */
  languageId: Scalars['Int']['output'];
  /** The last time this country translation was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this country translation. */
  lastModificationUser?: Maybe<User>;
  /** The localized name of the country in the given language. */
  name?: Maybe<Scalars['String']['output']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  /** The bank account associated with the purchase of the coupon, if the coupon was purchased */
  billingBankAccount?: Maybe<Scalars['String']['output']>;
  /** The date the coupon was purchased, if the coupon was purchased in server's timezone (Europe/Zurich) */
  billingDate?: Maybe<Scalars['DateTime']['output']>;
  /** An enum representing the status of the billing associated with the coupon */
  billingStatus?: Maybe<CouponBillingStatus>;
  /** The list of booking ids that used the coupon TODO: Replace with Booking entity */
  bookingIds: Array<Scalars['Int']['output']>;
  /** True if the coupon can be approved or cancelled */
  canApproveOrCancel: Scalars['Boolean']['output'];
  /** True if the coupon can be cancelled for fraud */
  canCancelForFraud: Scalars['Boolean']['output'];
  /** True if the user can edit the coupon */
  canEditCoupon: Scalars['Boolean']['output'];
  /** True if the coupon can be refunded, false otherwise */
  canRefund: Scalars['Boolean']['output'];
  /** True if it is possible to refund the remaining amount, false otherwise */
  canRefundRemainingAmount: Scalars['Boolean']['output'];
  /** An enum representing the way the coupon was charged. For more details, see CouponChargeType's description. */
  chargeType?: Maybe<CouponChargeType>;
  /** The code of the coupon */
  code?: Maybe<Scalars['String']['output']>;
  /** The date and time the coupon was created */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The customer address associated with the coupon. This can be empty if the coupon was not purchased. */
  customerAddress?: Maybe<CustomerAddress>;
  /** The personalized message attached to the coupon */
  customerMessage: Scalars['String']['output'];
  /** The date the coupon expires */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** The formatted code of the coupon */
  formattedCode: Scalars['String']['output'];
  /** The id of the shopping cart associated with the coupon (if it is a refund for another booking) */
  formattedCodeWithStatus: Scalars['String']['output'];
  /** A string concatenating the restrictions that apply to the coupon */
  formattedRestrictions: Scalars['String']['output'];
  /** The GYG campaign that created the coupon. This can be null as some coupons are not necessarily attached to a campaign */
  gygCampaign?: Maybe<GygCampaign>;
  /** The unique identifier of the coupon */
  id: Scalars['ID']['output'];
  /** The initial value of the coupon. If the coupon is a PERCENTAGE (or uses percentages) coupon, this field will be null. */
  initialValueCash?: Maybe<Money>;
  /** True if the coupon can be cancelled, false otherwise */
  isCancellable: Scalars['Boolean']['output'];
  /** True if the coupon has expired, false otherwise */
  isExpired: Scalars['Boolean']['output'];
  /** True if this is a coupon used by resellers to perform master bill bookings (100% off), false otherwise. */
  isMasterBillCoupon: Scalars['Boolean']['output'];
  /** Whether the coupon is for testing */
  isTestData: Scalars['Boolean']['output'];
  /** The partner associated with the coupon */
  partner?: Maybe<Partner>;
  /** The percentage the partner (reseller) is owed when the coupon is purchased */
  partnerCommissionRate?: Maybe<Scalars['Float']['output']>;
  /** The total amount the partner (reseller) is owed when a coupon is purchased */
  partnerShare?: Maybe<Money>;
  /** A list with recommended tour ids associated with the coupon TODO: this field might be converted later to [Activity!]! */
  recommendedTourIds: Array<Scalars['Int']['output']>;
  /** A list of the refunds associated with the coupon, if any exist */
  refundList: Array<Refund>;
  /** The id of the shopping cart associated with the coupon (if it is a refund for another booking) */
  refundShoppingCartId?: Maybe<Scalars['Int']['output']>;
  /** The current value of the coupon. This value can mean different things depending on the type of the coupon (e.g.: cash=>amount, product_testing=>new amount). This value can be null depending on the type of the coupon */
  remainingValueCash?: Maybe<Money>;
  /** The current percentage of the coupon. This value can be null depending on the type of the coupon */
  remainingValuePercentage?: Maybe<Scalars['Float']['output']>;
  /** An enum representing the current status of the coupon */
  status: CouponStatus;
  /** An enum representing the type of the coupon */
  type: CouponType;
  /** The start date the coupon is valid from */
  validFromDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponActionPayload = {
  __typename?: 'CouponActionPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CouponBillingStatus {
  Done = 'DONE',
  Invoiced = 'INVOICED',
  Pending = 'PENDING'
}

export enum CouponChargeType {
  Bank = 'BANK',
  Discount = 'DISCOUNT',
  Refund = 'REFUND',
  ShoppingCart = 'SHOPPING_CART'
}

export enum CouponRefundType {
  CustomAmount = 'CUSTOM_AMOUNT',
  RemainingAmount = 'REMAINING_AMOUNT'
}

export type CouponSearch = {
  __typename?: 'CouponSearch';
  items: Array<Coupon>;
  pagination: Pagination;
  totalItems: Scalars['Int']['output'];
};

export enum CouponStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Deleted = 'DELETED',
  New = 'NEW',
  Pending = 'PENDING'
}

export enum CouponType {
  Cash = 'CASH',
  GygCampaign = 'GYG_CAMPAIGN',
  Percentage = 'PERCENTAGE',
  ProductTesting = 'PRODUCT_TESTING',
  TestBooking = 'TEST_BOOKING'
}

export type CreateAccountInput = {
  allowLogin: Scalars['Boolean']['input'];
  allowNotifications: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  notificationRoles: Array<AccountNotificationRolesInput>;
  phoneNr: Scalars['String']['input'];
  role?: InputMaybe<AccountRoleInput>;
  status: AccountStatus;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAvailabilityPayload = {
  __typename?: 'CreateAvailabilityPayload';
  availabilityBlock?: Maybe<AvailabilityBlock>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input holding fields necessary to create a category */
export type CreateCategoryInput = {
  /** Wheter or not the category is externally exposed */
  isPublic: Scalars['Boolean']['input'];
  /** The name of the category */
  name: Scalars['String']['input'];
  /** The parent category id */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** Tags to associate with the created category */
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Return type of CreateCategoryInput */
export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  /** The newly created Category */
  category?: Maybe<Category>;
};

/** Input holding fields necessary to create a comment */
export type CreateCommentInput = {
  /** The content of the comment */
  comment: Scalars['String']['input'];
  /** The date of the comment */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The entity related to this comment */
  entity: Scalars['String']['input'];
  /** The id of the comments for the specified entity */
  entityId: Scalars['Int']['input'];
  /** The type of the comment */
  type: Scalars['String']['input'];
};

/** Return type of CreateCommentInput */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /** The updated comment */
  comment?: Maybe<Comment>;
};

/** Creation input to initiate a new derived attribute configuration, it's disabled by default. */
export type CreateDerivedAttributeConfigurationInput = {
  entityType: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: RulesEngineDerivedAttributeType;
};

/** Payload containing all relevant fields related to a derived attribute create operation. */
export type CreateDerivedAttributeConfigurationPayload = {
  __typename?: 'CreateDerivedAttributeConfigurationPayload';
  /** The derived attribute that was created. */
  derivedAttributeConfiguration?: Maybe<DerivedAttributeConfiguration>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type CreateLocationPictureInput = {
  entityType: LocationPictureType;
  file: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
};

export type CreateManagingDirectorInput = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type CreatePartnerAdjustmentPaymentInput = {
  amount: Scalars['Float']['input'];
  bookingReference?: InputMaybe<Scalars['String']['input']>;
  gygComment?: InputMaybe<Scalars['String']['input']>;
  partnerComment?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['ID']['input'];
  reason: PartnerAdjustmentPaymentReason;
  subReason: PartnerAdjustmentPaymentSubReason;
};

export type CreatePartnerAdjustmentPaymentPayload = OperationResult & {
  __typename?: 'CreatePartnerAdjustmentPaymentPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreatePartnerNotificationInput = {
  email: Scalars['String']['input'];
  notificationType: PartnerNotificationType;
  partnerId: Scalars['ID']['input'];
};

export type CreatePictureInput = {
  activityId: Scalars['ID']['input'];
  copyright?: InputMaybe<Scalars['String']['input']>;
  /** Image file encoded as Base64 string */
  file: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  originalFilename: Scalars['String']['input'];
  source?: InputMaybe<ActivityPictureSource>;
};

/** Creation input to initiate a new quality issue configuration, it's disabled by default. */
export type CreateQualityIssueConfigurationInput = {
  entityType: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Payload containing all relevant fields related to a quality issue configuration create operation. */
export type CreateQualityIssueConfigurationPayload = {
  __typename?: 'CreateQualityIssueConfigurationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** The quality issue configuration that was created. */
  qualityIssueConfiguration?: Maybe<QualityIssueConfiguration>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type CreateQualityIssuePayload = {
  __typename?: 'CreateQualityIssuePayload';
  /** The created issue */
  issue: QualityIssue;
};

export type CreateQualityRulePayload = {
  __typename?: 'CreateQualityRulePayload';
  /** The created rule */
  rule: QualityRule;
};

export type CreateQualityTeamInput = {
  /** The name of team being created */
  name: Scalars['String']['input'];
};

export type CreateQualityTeamPayload = {
  __typename?: 'CreateQualityTeamPayload';
  /** The created team */
  team: QualityTeam;
};

/** Creation input to initiate a new restriction configuration, it's disabled by default. */
export type CreateRestrictionConfigurationInput = {
  entityType: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Payload containing all relevant fields related to a restriction configuration create operation. */
export type CreateRestrictionConfigurationPayload = {
  __typename?: 'CreateRestrictionConfigurationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** The restriction configuration that was created. */
  restrictionConfiguration?: Maybe<RestrictionConfiguration>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type CreateStaffAreaMappingInput = {
  continentId: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
  isPrimary: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  staffId: Scalars['ID']['input'];
};

export type CreateSupplierAdjustmentPaymentInput = {
  amount: Scalars['Float']['input'];
  bookingReference?: InputMaybe<Scalars['String']['input']>;
  gygComment?: InputMaybe<Scalars['String']['input']>;
  reason: SupplierAdjustmentPaymentReason;
  subReason: SupplierAdjustmentPaymentSubReason;
  supplierComment?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['ID']['input'];
};

export type CreateSupplierAdjustmentPaymentPayload = OperationResult & {
  __typename?: 'CreateSupplierAdjustmentPaymentPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateSupplierInput = {
  accountFirstName: Scalars['String']['input'];
  accountLastName: Scalars['String']['input'];
  accountLocale?: InputMaybe<Scalars['String']['input']>;
  acquired?: InputMaybe<Scalars['Boolean']['input']>;
  acquisitionMedium?: InputMaybe<AcquisitionMedium>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  companySizeEmployees?: InputMaybe<Scalars['String']['input']>;
  companySizeMonthlyBookings?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  currencyId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  isAutomatedData?: InputMaybe<Scalars['Boolean']['input']>;
  isTestData?: InputMaybe<Scalars['Boolean']['input']>;
  legalCompanyName: Scalars['String']['input'];
  legalStatus?: InputMaybe<LegalStatus>;
  managingDirectors?: InputMaybe<Array<CreateManagingDirectorInput>>;
  operationalLocations?: InputMaybe<Array<CreateSupplierInputOperationalLocations>>;
  password: Scalars['String']['input'];
  passwordConfirm: Scalars['String']['input'];
  phoneNr?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponse?: InputMaybe<Scalars['String']['input']>;
  reservationSystems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  supplierProfileServices?: InputMaybe<Array<CreateSupplierInputProfileServices>>;
  supplierProfileWeb?: InputMaybe<Array<CreateSupplierInputProfileWeb>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierInputOperationalLocations = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateSupplierInputProfileServices = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateSupplierInputProfileWeb = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateSupplierInsuranceInformationInput = {
  createInsuranceInformation: Array<SupplierInsurance>;
  supplierId: Scalars['Int']['input'];
};

export type CreateTagInput = {
  /** Non-localised tag description for internal purposes. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the tag should be hidden in the tag selector */
  hideFromTagSelector?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unlocalized name of the tag. */
  name: Scalars['String']['input'];
  /** Parent tag id. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** Tag status. */
  status?: InputMaybe<TagStatus>;
  /** Type of the given tag. */
  type: TagType;
};

/** Return type of [CreateTagInput] */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  /** The created Tags */
  tag?: Maybe<Tag>;
};

export type Currency = {
  __typename?: 'Currency';
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
};

export enum CurrencyType {
  Customer = 'CUSTOMER',
  Supplier = 'SUPPLIER'
}

export type CustomAvailabilityInput = {
  /** The activity option ids for which to delete availability blocks */
  activityOptionId: Scalars['ID']['input'];
  /** Pricing IDs for each day */
  dayPricingIds?: InputMaybe<DayPricingIds>;
  /** Number of days to create the availability blocks for */
  numberOfDays: Scalars['Int']['input'];
};

export type CustomAvailabilityPayload = {
  __typename?: 'CustomAvailabilityPayload';
  /** Message with details of the error, if the creation fails */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag that indicates if the custom availability creation was successful */
  success: Scalars['Boolean']['output'];
};

export type CustomCancellationPolicyInput = {
  /** The fee unit for the cancellation fee */
  feeUnit: CancellationPolicyFeeUnit;
  /** The fee value for the cancellation fee */
  feeValue: Scalars['Float']['input'];
  /** The time (in minutes) before the tour starts when the cancellation cuts off */
  offsetInMinutes: Scalars['Int']['input'];
};

/** Entity holding fields relevant for a customer */
export type Customer = {
  __typename?: 'Customer';
  /** Permissions as currently set in Braze */
  brazeCommunicationPreferences?: Maybe<BrazePermissions>;
  /** Whether the customer would like to receive specific communication preferences or not */
  communicationPreferences: Array<CustomerCommunicationPreferences>;
  customerAddresses: Array<CustomerAddress>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  dateOfLastLogin?: Maybe<Scalars['DateTime']['output']>;
  dateOfRegistration?: Maybe<Scalars['DateTime']['output']>;
  defaultBillingAddress?: Maybe<CustomerAddress>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the customer */
  id: Scalars['ID']['output'];
  isEmailValidated: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  localeCode?: Maybe<Scalars['String']['output']>;
  localeHost?: Maybe<Scalars['String']['output']>;
  loginMethods?: Maybe<Scalars['String']['output']>;
  mergedIntoCustomerId?: Maybe<Scalars['ID']['output']>;
  profilePictureName?: Maybe<Scalars['String']['output']>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  status: CustomerStatus;
  statusTransitions: Array<StatusTransition>;
  tempEmail?: Maybe<Scalars['String']['output']>;
  translatedNameOfLanguage?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  /** The suffix of the address */
  addressSuffix?: Maybe<Scalars['String']['output']>;
  /** An enum representing what kind of address this is (e.g. billing address, lead address etc.) */
  addressType?: Maybe<AddressType>;
  /** The name of the city of the customer */
  city?: Maybe<Scalars['String']['output']>;
  /** The name of the company of the customer */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The country ISO code */
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  /** The date of birth of the customer */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** The email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** The fax of the customer */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the customer address */
  id: Scalars['ID']['output'];
  /** True if the customer address is the lead address */
  isLeadAddress: Scalars['Boolean']['output'];
  /** True if the customer has subscribed the newsletter, false otherwise. Field provided by Customer Engagement */
  isNewsletterSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** The language ISO code */
  languageIsoCode?: Maybe<Scalars['String']['output']>;
  /** The last name of the customer */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the customer */
  phone?: Maybe<Scalars['String']['output']>;
  /** The name of the state of the customer */
  state?: Maybe<Scalars['String']['output']>;
  /** The name of the street of the customer */
  street?: Maybe<Scalars['String']['output']>;
  /** The name of the country of the customer translated to the customer chosen language */
  translatedNameOfCountry?: Maybe<Scalars['String']['output']>;
  /** he name of the language the customer has chosen translated */
  translatedNameOfLanguage?: Maybe<Scalars['String']['output']>;
  /** The zip code of the address of the customer */
  zip?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressSearch = {
  __typename?: 'CustomerAddressSearch';
  items: Array<CustomerAddress>;
  pagination: Pagination;
  totalItems: Scalars['Int']['output'];
};

/**
 * Entity holding customer's communication preferences (permissions to send messages to them)
 * Each permission is known as a category, which then holds the channels available to contact
 * the customer (email/app mainly)
 */
export type CustomerCommunicationPreferences = {
  __typename?: 'CustomerCommunicationPreferences';
  /** List of available channels of the Permission (email/app) */
  channels: Array<CommunicationChannel>;
  /** Customer to whom this permission applies */
  customer?: Maybe<Customer>;
  /** The descriptive text of the Permission */
  description: Scalars['String']['output'];
  /** The unique identifier of the permission */
  id: Scalars['ID']['output'];
  /** The permission's name */
  name: Scalars['String']['output'];
  /** The title (summarized description) of the Permission */
  title: Scalars['String']['output'];
};

export type CustomerSearch = {
  __typename?: 'CustomerSearch';
  items: Array<Customer>;
  pagination: Pagination;
  totalItems: Scalars['Int']['output'];
};

export enum CustomerStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Incomplete = 'INCOMPLETE',
  Locked = 'LOCKED'
}

export type DateRange = {
  __typename?: 'DateRange';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type DayPricingIds = {
  Friday: Scalars['ID']['input'];
  /** Identifier of the pricing related to specific day */
  Monday: Scalars['ID']['input'];
  Saturday: Scalars['ID']['input'];
  Sunday: Scalars['ID']['input'];
  Thursday: Scalars['ID']['input'];
  Tuesday: Scalars['ID']['input'];
  Wednesday: Scalars['ID']['input'];
};

/** Entity holding the conditions for a deal (aka special offer) */
export type Deal = {
  __typename?: 'Deal';
  /** The activity option to which the deal is applied */
  activityOptions?: Maybe<Array<ActivityOption>>;
  /** A flag indicating whether the deal was created by an external system via the API */
  createdByExternalSystem?: Maybe<Scalars['Boolean']['output']>;
  /** The time and date on which the deal was created */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The start and end date during which the deal is applied */
  dateRange?: Maybe<InventoryDateRange>;
  /** The unique identifier of a deal */
  id: Scalars['ID']['output'];
  /** A deal is expired when it's end date is in the past */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum number of vacancies to which the deal is limited */
  maxVacancies?: Maybe<Scalars['Int']['output']>;
  /** The name of the deal */
  name: Scalars['String']['output'];
  /** The notice period indicates the time as of when a deal is applicable / not applicable when compared to the travel date */
  noticePeriodInSeconds?: Maybe<Scalars['Int']['output']>;
  /** The percentage of discount set in the deal */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** The number of vacancies that have already been booked with the deal applied */
  reservedVacancies?: Maybe<Scalars['Int']['output']>;
  /** The status of the deal */
  status?: Maybe<DealStatus>;
  /** The categories to which the deal will be applied */
  ticketCategories?: Maybe<Array<Scalars['String']['output']>>;
  /** The timeslots to which the deal should be applied */
  timeSlots?: Maybe<Array<DealTimeSlot>>;
  /** Type of the deal which can be lastMinute, earlyBird or standard */
  type?: Maybe<DealType>;
  /** The time and date on which the deal was updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier for the user who updated the deal */
  updateUser?: Maybe<User>;
};

export type DealInput = {
  /** All Options to which this deal is applied */
  activityOptionIds: Array<Scalars['ID']['input']>;
  /** The start and end date during which the deal is applied */
  dateRange: InventoryDateRangeInput;
  /** The unique identifier of a deal */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The maximum number of vacancies to which the deal is limited */
  maxVacancies?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the deal */
  name: Scalars['String']['input'];
  /** The notice period indicates the time as of when a deal is applicable / not applicable when compared to the travel date */
  noticePeriodInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The percentage of discount set in the deal */
  percentage: Scalars['Float']['input'];
  /** The status of the deal */
  status: DealStatus;
  /** The categories to which the deal will be applied */
  ticketCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The timeslots to which the deal should be applied */
  timeSlots?: InputMaybe<Array<DealTimeSlotInput>>;
  /** Type of the deal which can be lastMinute, earlyBird or standard */
  type: DealType;
};

export type DealPayload = {
  __typename?: 'DealPayload';
  deal?: Maybe<Deal>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DealPreviewError = {
  __typename?: 'DealPreviewError';
  reason?: Maybe<DealPreviewErrorReason>;
};

export enum DealPreviewErrorReason {
  UnknownError = 'UNKNOWN_ERROR',
  UnsupportedActivity = 'UNSUPPORTED_ACTIVITY'
}

export type DealPreviewInput = {
  /** Option to which this deal is applied */
  activityOptionId: Scalars['ID']['input'];
  /** The percentage of discount set in the deal */
  percentage: Scalars['Float']['input'];
};

export type DealPreviewParameters = {
  __typename?: 'DealPreviewParameters';
  activityOption: ActivityOption;
  percentage: Scalars['Float']['output'];
};

export type DealPreviewResult = DealPreviewError | DealPreviewSuccess;

export type DealPreviewSuccess = {
  __typename?: 'DealPreviewSuccess';
  dealPreviewParameters: DealPreviewParameters;
  discountedFromPrice?: Maybe<Scalars['Float']['output']>;
  fromPrice?: Maybe<Scalars['Float']['output']>;
};

export type DealSearch = {
  __typename?: 'DealSearch';
  items: Array<Deal>;
  pagination: Pagination;
};

export enum DealStatus {
  Active = 'active',
  Deactivated = 'deactivated'
}

export type DealTimeSlot = {
  __typename?: 'DealTimeSlot';
  day: Scalars['String']['output'];
  timeSlots?: Maybe<Array<Scalars['String']['output']>>;
};

export type DealTimeSlotInput = {
  day: Scalars['String']['input'];
  timeSlots: Array<Scalars['String']['input']>;
};

export enum DealType {
  EarlyBird = 'earlyBird',
  LastMinute = 'lastMinute',
  Standard = 'standard'
}

export type DeleteAvailabilityByTourOptionIdAndFromDateInput = {
  /** Date after which all availability blocks will be deleted */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** The tour option ids for which to delete availability blocks */
  tourOptionIds: Array<Scalars['ID']['input']>;
};

/** Input holding fields necessary to delete a comment */
export type DeleteCommentInput = {
  /** The entity id of the comment */
  id: Scalars['ID']['input'];
};

/** Return type of DeleteCommentInput */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  /** If the comment was deleted or not */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomerPayload = OperationResult & {
  __typename?: 'DeleteCustomerPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Payload containing all relevant fields related to a derived attribute delete operation. */
export type DeleteDerivedAttributeConfigurationPayload = {
  __typename?: 'DeleteDerivedAttributeConfigurationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type DeleteLocationMutationPayload = {
  __typename?: 'DeleteLocationMutationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type DeletePartnerAdjustmentPaymentInput = {
  partnerAdjustmentPaymentId: Scalars['ID']['input'];
};

export type DeletePartnerAdjustmentPaymentPayload = OperationResult & {
  __typename?: 'DeletePartnerAdjustmentPaymentPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeletePictureInput = {
  deleteFromCDN?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Entity that holds the payload for the deletePricing mutation */
export type DeletePricingPayload = {
  __typename?: 'DeletePricingPayload';
  /** Status code for the request */
  deleted: Scalars['Boolean']['output'];
  /** Error message, if any */
  message?: Maybe<Scalars['String']['output']>;
};

/** Payload containing all relevant fields related to a quality issue configuration delete operation. */
export type DeleteQualityIssueConfigurationPayload = {
  __typename?: 'DeleteQualityIssueConfigurationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type DeleteQualityIssuePayload = {
  __typename?: 'DeleteQualityIssuePayload';
  message: Scalars['String']['output'];
  status: DeleteQualityIssueStatus;
};

export enum DeleteQualityIssueStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type DeleteQualityRulePayload = {
  __typename?: 'DeleteQualityRulePayload';
  message: Scalars['String']['output'];
  status: DeleteQualityRuleStatus;
};

export enum DeleteQualityRuleStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type DeleteRefundInput = {
  /** The ID of refund to be deleted */
  refundId: Scalars['ID']['input'];
};

export type DeleteRefundPayload = {
  __typename?: 'DeleteRefundPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Payload containing all relevant fields related to a restriction configuration delete operation. */
export type DeleteRestrictionConfigurationPayload = {
  __typename?: 'DeleteRestrictionConfigurationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type DeleteStaffAreaMappingInput = {
  staffAreaMappingId: Scalars['ID']['input'];
};

export type DeleteSupplierAdjustmentPaymentInput = {
  supplierAdjustmentPaymentId: Scalars['ID']['input'];
};

export type DeleteSupplierAdjustmentPaymentPayload = OperationResult & {
  __typename?: 'DeleteSupplierAdjustmentPaymentPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteSupplierInsuranceInformationInput = {
  insuranceId: Scalars['Int']['input'];
  supplierId: Scalars['Int']['input'];
};

export type DeleteTermsAndConditionsInput = {
  languageId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
};

export type DeleteTermsAndConditionsPayload = {
  __typename?: 'DeleteTermsAndConditionsPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DerivedAttributeConfiguration = {
  __typename?: 'DerivedAttributeConfiguration';
  /** Rules that are available for selection for the given entity type. */
  availableRules: Array<RulesEngineRule>;
  /** When the attribute was created. */
  creationTime?: Maybe<Scalars['DateTime']['output']>;
  /** If the attribute is enabled or not. */
  enabled: Scalars['Boolean']['output'];
  /** Which entity to consider as context. */
  entityType: Scalars['String']['output'];
  /** Unique identified of the attribute. */
  id: Scalars['ID']['output'];
  /** The field name to store the value in the provided entityType. */
  internalName: Scalars['String']['output'];
  /** The last time this attribute was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this attribute. */
  lastModificationUser?: Maybe<User>;
  /** If this derived attribute can have multiple values being evaluated and assigned. */
  multiple: Scalars['Boolean']['output'];
  /** Name of the attribute to show in the UI. */
  name: Scalars['String']['output'];
  /** Rules that define if this attribute should be evaluated. */
  options: Array<RulesEngineAttributeOption>;
  /** Order in which the attribute is evaluated. */
  order: Scalars['Int']['output'];
  /** Rules that define if this attribute should be evaluated. */
  rules: Array<RulesEngineRuleItem>;
  /** Type of derived attribute. */
  type: RulesEngineDerivedAttributeType;
};

export type DerivedAttributeConfigurationInput = {
  entityType: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  options: Array<RulesEngineAttributeOptionInput>;
  rules: Array<RulesEngineRuleItemInput>;
  type: RulesEngineDerivedAttributeType;
};

export type DerivedAttributeConfigurationOptionPreview = {
  __typename?: 'DerivedAttributeConfigurationOptionPreview';
  check: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type DerivedAttributeConfigurationPreview = {
  __typename?: 'DerivedAttributeConfigurationPreview';
  items: Array<DerivedAttributeConfigurationPreviewItem>;
};

export type DerivedAttributeConfigurationPreviewInput = {
  /** The preview configuration to be evaluated. */
  configuration: DerivedAttributeConfigurationInput;
  /** Entity ids to check against, if not provided will use a predefined list. */
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DerivedAttributeConfigurationPreviewItem = {
  __typename?: 'DerivedAttributeConfigurationPreviewItem';
  check: Scalars['Boolean']['output'];
  entityId: Scalars['ID']['output'];
  option: DerivedAttributeConfigurationOptionPreview;
};

export type DerivedAttributeConfigurationSearch = {
  __typename?: 'DerivedAttributeConfigurationSearch';
  items: Array<DerivedAttributeConfiguration>;
  pagination: Pagination;
};

export type DestinationLocation = {
  __typename?: 'DestinationLocation';
  /** The city in which the product is located. Must be in UN/LOCODE NameWoDiacritics format. */
  city: Scalars['String']['output'];
  /** The country in which the product is located. Must be in ISO 3166-1 format. */
  country?: Maybe<Scalars['String']['output']>;
};

export type DownloadUnsoldTicketsOnBatchInput = {
  batchId: Scalars['ID']['input'];
  staffEmail: Scalars['String']['input'];
};

/**
 * Payload with result of the operation of downloading the specified tickets
 * unsold in the batch upload.
 */
export type DownloadUnsoldTicketsOnBatchPayload = {
  __typename?: 'DownloadUnsoldTicketsOnBatchPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type DropOff = {
  __typename?: 'DropOff';
  /** Defines how the traveler will be dropped when the tour ends. */
  dropOffType?: Maybe<DropOffType>;
  /**
   * Describes the exact location with GPS coordinates where the tour ends.
   * This field holds a value only if 'DropOff.dropOffType' is set to 'SEPARATE_LOCATION'.
   */
  location?: Maybe<LogisticsLocation>;
  transportationTypes?: Maybe<Array<TransportationType>>;
};

export type DropOffInput = {
  /** Defines how the traveler will be dropped when the tour ends. */
  dropOffType: DropOffType;
  /**
   * Describes the exact location with GPS coordinates where the tour ends.
   * This field holds a value only if 'DropOff.dropOffType' is set to 'SEPARATE_LOCATION'.
   */
  location?: InputMaybe<LogisticsLocationInput>;
  transportationTypes?: InputMaybe<Array<TransportationTypeInput>>;
};

export enum DropOffType {
  None = 'NONE',
  SameAsMeetingPoint = 'SAME_AS_MEETING_POINT',
  SameAsPickUp = 'SAME_AS_PICK_UP',
  SeparateLocation = 'SEPARATE_LOCATION'
}

export type Duration = {
  __typename?: 'Duration';
  unit?: Maybe<DurationUnit>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DurationInput = {
  unit: DurationUnit;
  value: Scalars['Float']['input'];
};

export enum DurationUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

export type EditQualityIssuePayload = {
  __typename?: 'EditQualityIssuePayload';
  /** The edited issue */
  issue: QualityIssue;
};

export type EditQualityRulePayload = {
  __typename?: 'EditQualityRulePayload';
  /** The edited rule */
  rule: QualityRule;
};

export type EditTicketMonitorSettingsInput = {
  activityOptionId: Scalars['ID']['input'];
  advanceInventory?: InputMaybe<Array<TicketAdvanceInventoryMonitorInput>>;
  lowInventory?: InputMaybe<Array<TicketLowInventoryMonitorInput>>;
  preBuyQuantity?: InputMaybe<Array<TicketPreBuyQuantityMonitorInput>>;
  refundInventory?: InputMaybe<Array<TicketRefundInventoryMonitorInput>>;
};

/**
 * Payload containing all relevant fields related to the ticket monitor settings edit,
 * operation errors are also available here.
 */
export type EditTicketMonitorSettingsPayload = {
  __typename?: 'EditTicketMonitorSettingsPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** The monitor settings that were updated. */
  monitor?: Maybe<TicketMonitorSettings>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

/** Entity containing relevant fields for an email */
export type Email = {
  __typename?: 'Email';
  /** The categories of the email */
  categories?: Maybe<Scalars['String']['output']>;
  /** The date email was created in server's timezone (Europe/Zurich) */
  creationTimestamp: Scalars['DateTime']['output'];
  /** The error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The contact details of the sender */
  from?: Maybe<EmailContact>;
  /** The priority of the email */
  priority?: Maybe<EmailPriority>;
  /** The recipients of the email */
  recipients: Array<EmailRecipient>;
  /** The contact details of the reply target */
  replyTo?: Maybe<EmailContact>;
  /** The status of the email */
  status: EmailStatus;
  /** The subject of the email */
  subject: Scalars['String']['output'];
  /** The unique identifier of the email */
  uuid: Scalars['ID']['output'];
};

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  /** The filename of the attachment */
  fileName?: Maybe<Scalars['String']['output']>;
  /** The presigned URL to access the attachment entity */
  preSignedUrl?: Maybe<Scalars['String']['output']>;
};

export enum EmailAttachmentDisposition {
  Attachment = 'ATTACHMENT',
  Inline = 'INLINE'
}

export type EmailBody = {
  __typename?: 'EmailBody';
  /** The html body of the email (base64 encoded) */
  htmlBody?: Maybe<Scalars['String']['output']>;
  /** The text body of the email (base64 encoded) */
  textBody?: Maybe<Scalars['String']['output']>;
};

export type EmailContact = {
  __typename?: 'EmailContact';
  /** The mail address of the contact */
  email?: Maybe<Scalars['String']['output']>;
  /** The name of the contact */
  name?: Maybe<Scalars['String']['output']>;
};

export type EmailContext = {
  __typename?: 'EmailContext';
  /** The id of the context */
  contextId?: Maybe<Scalars['String']['output']>;
  /** The type of the context */
  contextType?: Maybe<Scalars['String']['output']>;
};

export enum EmailPriority {
  Drop = 'DROP',
  High = 'HIGH',
  Low = 'LOW'
}

export type EmailRecipient = {
  __typename?: 'EmailRecipient';
  /** The date mail was delivered in server's timezone (Europe/Zurich) */
  deliveredAtTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The number of recorded open events */
  mailOpenCount?: Maybe<Scalars['Int']['output']>;
  /** The delivery method for the recipient */
  method?: Maybe<RecipientMethod>;
  /** The contact details for the recipient */
  recipient?: Maybe<EmailContact>;
  /** Recipient entity ID (eg. "123) */
  recipientEntityId?: Maybe<Scalars['String']['output']>;
  /** Recipient entity type (eg. "customer") */
  recipientEntityType?: Maybe<Scalars['String']['output']>;
  /** The provider status of the recipient */
  status?: Maybe<RecipientStatus>;
  /** The date recipient was last updated in server's timezone (Europe/Zurich) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The number of recorded click events */
  urlClickCount?: Maybe<Scalars['Int']['output']>;
};

export type EmailSearch = {
  __typename?: 'EmailSearch';
  items: Array<Email>;
  pagination: Pagination;
};

export enum EmailStatus {
  Dispatched = 'DISPATCHED',
  Dropped = 'DROPPED',
  FailedExternal = 'FAILED_EXTERNAL',
  FailedInternal = 'FAILED_INTERNAL',
  FailedTemporary = 'FAILED_TEMPORARY',
  Processing = 'PROCESSING'
}

export enum EmailTypeEnum {
  ActivityDeactivation = 'ACTIVITY_DEACTIVATION',
  SupplierDeactivation = 'SUPPLIER_DEACTIVATION'
}

export type EmailWithContextsBodyAndAttachments = {
  __typename?: 'EmailWithContextsBodyAndAttachments';
  /** The attachments of the email */
  attachments: Array<EmailAttachment>;
  /** The contexts of the email */
  contexts: Array<EmailContext>;
  email: Email;
  /** The body of the email */
  emailBody: EmailBody;
};

export enum Enforce3DSecure {
  Always = 'ALWAYS',
  None = 'NONE',
  Within_48H = 'WITHIN_48H'
}

export type EntityNotFound = {
  __typename?: 'EntityNotFound';
  message?: Maybe<Scalars['String']['output']>;
};

export enum EntityStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
};

export type ExecuteRefundInput = {
  /** The ID of refund to be executed */
  refundId: Scalars['ID']['input'];
};

export type ExecuteRefundPayload = {
  __typename?: 'ExecuteRefundPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalRatingResponse = {
  __typename?: 'ExternalRatingResponse';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** Feature details */
export type Feature = {
  __typename?: 'Feature';
  /** Id of the feature */
  featureId: Scalars['Int']['output'];
  /** Label/ Name of the feature */
  featureLabel: Scalars['String']['output'];
};

export type Field = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** Field specific filter configuration. */
export type FilterInput = {
  /** Field to apply the filter to. */
  field: Scalars['String']['input'];
  /**
   * Filter by the values provided.
   * The behaviour of multiple values can be determined by the BE.
   * In general, enum fields can treat this array as a collection of OR filters.
   * For timestamp fields, the values can represent a range.
   */
  values: Array<Scalars['String']['input']>;
};

export type FinancialIssuedEntity = {
  issuingSource: IssuingSource;
};

export enum FinancialOperation {
  SupplierInvoice = 'SUPPLIER_INVOICE',
  SupplierPayment = 'SUPPLIER_PAYMENT'
}

export enum FraudType {
  FraudSupplierGetsCommission = 'FRAUD_SUPPLIER_GETS_COMMISSION',
  FraudSupplierGetsNothing = 'FRAUD_SUPPLIER_GETS_NOTHING',
  NoFraud = 'NO_FRAUD'
}

export type FreeTextCancellationPolicy = {
  __typename?: 'FreeTextCancellationPolicy';
  autoTranslate?: Maybe<Scalars['Boolean']['output']>;
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  languageId?: Maybe<Scalars['Int']['output']>;
};

export type FreeTextCancellationPolicyInput = {
  autoTranslate: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  languageId: Scalars['Int']['input'];
};

/** Search locations using a query. */
export type FuzzyLocationQuerySearchInput = {
  /** Max number of items to show. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Current selected item offset. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter results by. */
  query: Scalars['String']['input'];
};

/** fuzzy location search data. */
export type FuzzyLocationSearch = {
  __typename?: 'FuzzyLocationSearch';
  /** location items with city */
  items: Array<LocationWithCity>;
  /** pagination */
  pagination: Pagination;
};

export type GeneratedContentBooleanField = {
  __typename?: 'GeneratedContentBooleanField';
  checkSavedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  content: Scalars['Boolean']['output'];
  isAccepted: Scalars['Boolean']['output'];
};

export type GeneratedContentField = {
  __typename?: 'GeneratedContentField';
  checkSavedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  content: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
};

export type GeneratedContentFieldInput = {
  isAccepted: Scalars['Boolean']['input'];
};

/** An object holding all the information about all the AI generated fields on an activity. */
export type GeneratedContentFields = {
  __typename?: 'GeneratedContentFields';
  description?: Maybe<GeneratedContentField>;
  exclusions?: Maybe<GeneratedContentListField>;
  guideType?: Maybe<GeneratedContentField>;
  highlights?: Maybe<GeneratedContentListField>;
  inclusions?: Maybe<GeneratedContentListField>;
  isOutsideTheCity?: Maybe<GeneratedContentBooleanField>;
  knowBeforeYouGo?: Maybe<GeneratedContentListField>;
  notSuitableFor?: Maybe<GeneratedContentIntegerListField>;
  restrictions?: Maybe<GeneratedContentIntegerListField>;
  shortDescription?: Maybe<GeneratedContentField>;
  title?: Maybe<GeneratedContentField>;
  transportationTypes?: Maybe<GeneratedContentListField>;
  whatToBring?: Maybe<GeneratedContentIntegerListField>;
};

export type GeneratedContentFieldsInput = {
  description?: InputMaybe<GeneratedContentFieldInput>;
  highlights?: InputMaybe<GeneratedContentFieldInput>;
  shortDescription?: InputMaybe<GeneratedContentFieldInput>;
  title?: InputMaybe<GeneratedContentFieldInput>;
};

export type GeneratedContentIntegerListField = {
  __typename?: 'GeneratedContentIntegerListField';
  checkSavedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  content: Array<Maybe<Scalars['Int']['output']>>;
  isAccepted: Scalars['Boolean']['output'];
};

export type GeneratedContentListField = {
  __typename?: 'GeneratedContentListField';
  checkSavedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  content: Array<Maybe<Scalars['String']['output']>>;
  isAccepted: Scalars['Boolean']['output'];
};

export type GeneratedContentUserInput = {
  __typename?: 'GeneratedContentUserInput';
  inputText?: Maybe<Scalars['String']['output']>;
  inputUrl?: Maybe<Scalars['String']['output']>;
  inputUrlWebsiteContent?: Maybe<Scalars['String']['output']>;
};

/** Response returned when fetching active feature of the integration */
export type GetFeaturesResponse = {
  __typename?: 'GetFeaturesResponse';
  /** List of available features associated with the integration */
  availableFeatures?: Maybe<Array<Maybe<Feature>>>;
  /** List of enabled features associated with the integration */
  enabledFeatures?: Maybe<Array<Maybe<Feature>>>;
  /** Query used to get the features */
  queriedBy?: Maybe<Scalars['String']['output']>;
};

export type Glossary = {
  __typename?: 'Glossary';
  engineType?: Maybe<TranslationEngineType>;
  externalGlossaryId?: Maybe<Scalars['String']['output']>;
  glossaryId?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<Maybe<GlossaryItem>>>;
  sourceLanguageId?: Maybe<Scalars['Int']['output']>;
  targetLanguageId?: Maybe<Scalars['Int']['output']>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<User>;
};

export type GlossaryCreateInput = {
  /** The source language of the glossary */
  sourceLanguageId: Scalars['Int']['input'];
  /** The target language of the glossary */
  targetLanguageId: Scalars['Int']['input'];
  /** Translation engine type */
  translationEngine: TranslationEngineType;
};

export type GlossaryCreatePayload = {
  __typename?: 'GlossaryCreatePayload';
  /** The glossary that was created. */
  glossary?: Maybe<Glossary>;
};

export type GlossaryDeleteInput = {
  /** Unique identifier of a glossary */
  id: Scalars['ID']['input'];
};

export type GlossaryDeletePayload = {
  __typename?: 'GlossaryDeletePayload';
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type GlossaryItem = {
  __typename?: 'GlossaryItem';
  glossaryId?: Maybe<Scalars['ID']['output']>;
  glossaryItemId?: Maybe<Scalars['ID']['output']>;
  sourceText?: Maybe<Scalars['String']['output']>;
  targetText?: Maybe<Scalars['String']['output']>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<User>;
};

export type GlossaryItemCreateInput = {
  items: Array<GlossaryItemInput>;
};

export type GlossaryItemCreatePayload = {
  __typename?: 'GlossaryItemCreatePayload';
  /** The glossary item that was created. */
  glossaryItems?: Maybe<Array<Maybe<GlossaryItem>>>;
};

export type GlossaryItemDeleteInput = {
  /** Unique identifier of a glossary item */
  id: Scalars['ID']['input'];
};

export type GlossaryItemDeletePayload = {
  __typename?: 'GlossaryItemDeletePayload';
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type GlossaryItemEditInput = {
  /** Unique identifier of a glossary item */
  id: Scalars['ID']['input'];
  /** The source text of the glossary item */
  sourceText?: InputMaybe<Scalars['String']['input']>;
  /** The target text of the glossary item */
  targetText?: InputMaybe<Scalars['String']['input']>;
};

export type GlossaryItemEditPayload = {
  __typename?: 'GlossaryItemEditPayload';
  /** The glossary item that was edited. */
  glossaryItem?: Maybe<GlossaryItem>;
};

export type GlossaryItemInput = {
  /** Unique identifier of a glossary */
  glossaryId: Scalars['ID']['input'];
  /** The source text of the glossary item */
  sourceText: Scalars['String']['input'];
  /** The target text of the glossary item */
  targetText: Scalars['String']['input'];
};

export type GlossarySynchronizeInput = {
  /** Unique identifier of a glossary */
  id: Scalars['ID']['input'];
};

export type GlossarySynchronizePayload = {
  __typename?: 'GlossarySynchronizePayload';
  /** The glossary that is being synchronized. */
  glossary?: Maybe<Glossary>;
};

/** A GooglePlace holds the information for a given location within google maps. */
export type GooglePlace = {
  __typename?: 'GooglePlace';
  /** The complete address of the location. */
  address?: Maybe<Scalars['String']['output']>;
  /** Matches all the administrative_area levels. */
  area?: Maybe<Scalars['String']['output']>;
  /** A rectangle in geographical coordinates from points at the southwest and northeast corners. */
  boundingBox?: Maybe<BoundingBox>;
  /** An object describing a specific location with Latitude and Longitude in decimal degrees. */
  coordinates?: Maybe<Coordinates>;
  /** Country of which this place belongs. */
  country?: Maybe<Scalars['String']['output']>;
  /** Uniquely identifies a google place within our system. */
  id: Scalars['ID']['output'];
  /** The last time this google place was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this google place. */
  lastModificationUser?: Maybe<User>;
  /** Matches against both locality and sublocality types. */
  locality?: Maybe<Scalars['String']['output']>;
  /** Get location geoshape candidates for a given google place Id */
  locationGeoshapeCandidates?: Maybe<Array<LocationGeoshape>>;
  /** The default map zoom level. */
  mapZoomLevel?: Maybe<Scalars['Int']['output']>;
  /**
   * Contains the human-readable name for the returned result.
   * For establishment results, this is usually the canonicalized business name.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** Place IDs uniquely identify a place in the Google Places database and on Google Maps. */
  placeId: Scalars['String']['output'];
  /**
   * The google place location postal code.
   * Matches postal_code and postal_code_prefix.
   */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Matches the long or short name of a route. */
  route?: Maybe<Scalars['String']['output']>;
  /** The street number. */
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type GroupPricingCategory = PricingCategory & {
  __typename?: 'GroupPricingCategory';
  /** The commission rate set to a pricing category */
  commissionRate?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier of a pricing category */
  id?: Maybe<Scalars['ID']['output']>;
  /** Flag indicating the category is an extension for additional people on a group */
  isAdditionalPaxForGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Identifier of the pricing related to the category */
  pricingId?: Maybe<Scalars['ID']['output']>;
  /** The pricing scales for a pricing category */
  pricingScales?: Maybe<Array<PricingScale>>;
  /** The commission rate applied to a pricing category */
  resolvedCommissionRate?: Maybe<Scalars['Float']['output']>;
};

export type GroupSize = {
  __typename?: 'GroupSize';
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
};

export type GroupSizeInput = {
  maximum?: InputMaybe<Scalars['Int']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
};

export enum GuideType {
  Driver = 'DRIVER',
  HostGreeter = 'HOST_GREETER',
  Instructor = 'INSTRUCTOR',
  LiveTourGuide = 'LIVE_TOUR_GUIDE',
  None = 'NONE'
}

export type GygCampaign = {
  __typename?: 'GygCampaign';
  /** The type of the coupon associated with the GYG campaign */
  couponType: Scalars['String']['output'];
  /** The description of the GYG campaign */
  description: Scalars['String']['output'];
  /** The unique identifier of the GYG campaign */
  id: Scalars['ID']['output'];
  /** The name of the GYG campaign */
  name: Scalars['String']['output'];
};

export type HistoryQuery = {
  /** The cluster of the database, usually the name of the service */
  clusterName: Scalars['String']['input'];
  /** The name of the database, usually the name of the service */
  databaseName: Scalars['String']['input'];
  /** The primary key / id of the row */
  id: Scalars['Int']['input'];
  /** The name of the table */
  tableName: Scalars['String']['input'];
};

export type HistoryRecord = {
  __typename?: 'HistoryRecord';
  /** The values of all columns on the row after the operation (serialized JSON) */
  after?: Maybe<Scalars['JSON']['output']>;
  /** The values of all columns on the row before the operation (serialized JSON) */
  before?: Maybe<Scalars['JSON']['output']>;
  /** A character representing the type of operation (C for create, U for update, or D for destroy) */
  op?: Maybe<HistoryRecordOp>;
  /** The timestamp at which the operation was done */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

/** A character representing the type of operation (C for create, U for update, or D for destroy) */
export enum HistoryRecordOp {
  /** Create */
  C = 'C',
  /** Delete */
  D = 'D',
  /** Update */
  U = 'U'
}

export enum HowToReceiveVoucher {
  EmailAfterBooking = 'EMAIL_AFTER_BOOKING',
  ExchangedForTicket = 'EXCHANGED_FOR_TICKET',
  TicketInSeparateEmail = 'TICKET_IN_SEPARATE_EMAIL'
}

export type HyperwalletDetails = {
  __typename?: 'HyperwalletDetails';
  /** Hyperwallet bank account token */
  hyperwalletBankAccountToken?: Maybe<Scalars['String']['output']>;
  /** Hyperwallet Data encoded as JSON */
  hyperwalletData?: Maybe<Scalars['String']['output']>;
};

export type ImportActivityExternalReviewRatingRequest = {
  /** The id of the activity to import the external review rating for. */
  activityId: Scalars['Int']['input'];
  /** The URL of the external review rating to import. */
  url: Scalars['String']['input'];
};

export type IndividualPricingCategory = PricingCategory & {
  __typename?: 'IndividualPricingCategory';
  /** The min and max age for a pricing category */
  ageRange?: Maybe<AgeRange>;
  /** Flag indicating if a pricing category can be booked indepdently from other categories */
  bookIndependently?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates the booking type for the category */
  bookingType?: Maybe<PricingCategoryBookingType>;
  /** The commission rate set to a pricing category */
  commissionRate?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier of a pricing category */
  id?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the pricing related to the category */
  pricingId?: Maybe<Scalars['ID']['output']>;
  /** The pricing scales for a pricing category */
  pricingScales?: Maybe<Array<PricingScale>>;
  /** The commission rate applied to a pricing category */
  resolvedCommissionRate?: Maybe<Scalars['Float']['output']>;
  /** Category of the group (Infant, Child, Adult, etc.) */
  ticketCategory?: Maybe<Scalars['String']['output']>;
};

export type Insight = {
  __typename?: 'Insight';
  actionUrl?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['String']['output']>;
  activityOptionId?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<InsightUser>;
  attributes: Array<InsightAttribute>;
  comments?: Maybe<Array<Maybe<InsightComment>>>;
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<InsightUser>;
  entities: Array<InsightEntity>;
  expiryTimestamp?: Maybe<Scalars['DateTime']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insightType: InsightType;
  state: InsightState;
  status: InsightStatus;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<InsightUser>;
  version?: Maybe<Scalars['String']['output']>;
};

export type InsightAttribute = {
  __typename?: 'InsightAttribute';
  /** The name of the attribute */
  name: Scalars['String']['output'];
  /** The attribute's value */
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightComment = {
  __typename?: 'InsightComment';
  commenter: InsightUser;
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  text: Scalars['String']['output'];
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type InsightEntity = {
  __typename?: 'InsightEntity';
  /** The unique identifier of the entity */
  entityId: Scalars['Int']['output'];
  /** The type of entity */
  entityType: Scalars['String']['output'];
};

export type InsightEntityInput = {
  /** The id of the entity */
  entityId: Scalars['Int']['input'];
  /** The type of the entity (ex. activity or option) */
  entityType: Scalars['String']['input'];
};

export enum InsightGenerationType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export enum InsightState {
  Invalid = 'INVALID',
  InProgress = 'IN_PROGRESS',
  Reopened = 'REOPENED',
  Resolved = 'RESOLVED',
  Silenced = 'SILENCED',
  Todo = 'TODO'
}

export enum InsightStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type InsightType = {
  __typename?: 'InsightType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<InsightTypePriority>;
  status?: Maybe<InsightTypeStatus>;
  type?: Maybe<InsightGenerationType>;
};

export enum InsightTypePriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum InsightTypeStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type InsightUser = {
  __typename?: 'InsightUser';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<InsightUserType>;
};

export enum InsightUserType {
  Service = 'SERVICE',
  Staff = 'STAFF',
  Supplier = 'SUPPLIER'
}

export type InsuranceInformation = {
  __typename?: 'InsuranceInformation';
  coverageAmount?: Maybe<Scalars['Float']['output']>;
  coverageEndDate?: Maybe<Scalars['String']['output']>;
  coverageStartDate?: Maybe<Scalars['String']['output']>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['Int']['output']>;
};

export type IntroBannerBlock = {
  __typename?: 'IntroBannerBlock';
  context?: Maybe<IntroBannerBlockContext>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type IntroBannerBlockContext = {
  __typename?: 'IntroBannerBlockContext';
  id: Scalars['ID']['output'];
  locationId: Scalars['String']['output'];
};

export type IntroBannerBlockContextV2 = {
  __typename?: 'IntroBannerBlockContextV2';
  id: Scalars['ID']['output'];
  locationId: Scalars['String']['output'];
};

export type IntroBannerBlockV2 = {
  __typename?: 'IntroBannerBlockV2';
  context?: Maybe<IntroBannerBlockContextV2>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type InventoryConfiguration = {
  __typename?: 'InventoryConfiguration';
  availabilityType?: Maybe<AvailabilityType>;
  cutOffTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  minParticipantsOnlyForFirstBooking?: Maybe<Scalars['Boolean']['output']>;
  newTicketSource?: Maybe<NewTicketSource>;
  requiresConsistentToursAndTicketsSettings?: Maybe<Scalars['Boolean']['output']>;
  tourOptionId: Scalars['ID']['output'];
  updateTimestamp?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<User>;
  usesGroupPricing?: Maybe<Scalars['Boolean']['output']>;
  usesPricingOverApi?: Maybe<Scalars['Boolean']['output']>;
};

export type InventoryConfigurationInput = {
  availabilityType?: InputMaybe<AvailabilityType>;
  usesGroupPricing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InventoryDateRange = {
  __typename?: 'InventoryDateRange';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

/** ## add description */
export type InventoryDateRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type InventoryDateRangeOptionalEndDateInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type InventorySettings = {
  __typename?: 'InventorySettings';
  /** Inventory configuration for the given activity option. */
  configuration?: Maybe<TicketConfiguration>;
  /** All monitors associated with the given activity option. */
  monitor?: Maybe<TicketMonitorSettings>;
  /** Ticket batch related statistics. */
  ticketBatchStatistics?: Maybe<TicketsBatchStatisticsSearch>;
  /**
   * Ticket related statistics.
   *
   * Default filters for date interval from/to are required and by default if not
   * provided a 30 day future interval is set.
   */
  ticketStatistics?: Maybe<TicketsStatisticsSearch>;
};


export type InventorySettingsTicketBatchStatisticsArgs = {
  input?: InputMaybe<SearchInput>;
};


export type InventorySettingsTicketStatisticsArgs = {
  input?: InputMaybe<SearchInput>;
};

export enum InvoiceStatus {
  /** Blocked status means that the invoice, while created, will not be picked up by the payment run */
  Blocked = 'BLOCKED',
  /** Deleted status means that for all intends and purposes the invoice is inaccessible to any user */
  Deleted = 'DELETED',
  /** Paid status means that the invoice is part of a paid payment */
  Paid = 'PAID',
  /** Pending status means that the invoice has been attached to a payment but the payment has not been paid out */
  Pending = 'PENDING',
  /** Unchecked status means that the invoice has been created but not attached to a payment */
  Unchecked = 'UNCHECKED'
}

export enum InvoiceType {
  /** Hidden Internal invoice type for payout-by-checkout date suppliers */
  Internal = 'INTERNAL',
  /** Public invoice type for payout-by-checkout date suppliers */
  Prepaid = 'PREPAID',
  /** Regular invoice type for payout-by-travel date suppliers */
  Regular = 'REGULAR'
}

export enum IssuingSource {
  Gyg = 'GYG',
  Sap = 'SAP'
}

export type LayoutType = VerticalListLayout;

export type LegacyConductionLanguage = {
  __typename?: 'LegacyConductionLanguage';
  conductionLanguageType: LegacyConductionLanguageType;
  languageId: Scalars['Int']['output'];
};

export type LegacyConductionLanguageInput = {
  /** The conduction language type */
  conductionLanguageType: LegacyConductionLanguageType;
  /** The language id */
  languageId: Scalars['Int']['input'];
};

export enum LegacyConductionLanguageType {
  LanguageAudio = 'LANGUAGE_AUDIO',
  LanguageBooklet = 'LANGUAGE_BOOKLET',
  LanguageLive = 'LANGUAGE_LIVE'
}

export enum LegalStatus {
  Company = 'company',
  Individual = 'individual'
}

export type LegalText = {
  __typename?: 'LegalText';
  languageId?: Maybe<Scalars['Int']['output']>;
  updateTimestamp?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * A Location holds the information for the what we identify as a location across
 * our different domains.
 */
export type Location = {
  __typename?: 'Location';
  /**
   * Defines how customers can access a POI.
   * Potential values are elevator, foot, stairs.
   */
  accessModes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Localized alternative names the location can have for each given language. */
  aliases?: Maybe<Array<LocationAlias>>;
  /**
   * Given bounding box of the location, such definition is generally used to draw an
   * area around the exact location coordinates.
   */
  boundingBox?: Maybe<BoundingBox>;
  broadcasts?: Maybe<Array<Broadcast>>;
  /** This boolean field is used to mark locations with added business relevance. */
  businessRelevance?: Maybe<Scalars['Boolean']['output']>;
  /** Available location codes the given location can have. */
  codes?: Maybe<Array<LocationCode>>;
  /**
   * Given coordinates of the location, such coordinates are generally used to
   * pinpoint a location in a map.
   */
  coordinates?: Maybe<Coordinates>;
  /** The country in which this location is present. */
  country?: Maybe<Country>;
  /** Google place information associated with this location. */
  googlePlace?: Maybe<GooglePlace>;
  /** Uniquely identifies a location. */
  id: Scalars['ID']['output'];
  /** The last time this location was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this location. */
  lastModificationUser?: Maybe<User>;
  /** Unlocalized name of the location. */
  name: Scalars['String']['output'];
  /** The parent location. */
  parent?: Maybe<Location>;
  /** Available location pictures ordered ascending by the order field of the LocationPicture. */
  pictures?: Maybe<Array<LocationPicture>>;
  /** All the poi information if applicable to the location. */
  poiInformation?: Maybe<LocationDetails>;
  /** If the location is a POI then this field has it's types. */
  poiTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The priority of the location. */
  priority?: Maybe<Scalars['Int']['output']>;
  /** The source of the location. */
  source?: Maybe<Scalars['String']['output']>;
  /** The timezone that the location is in. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Localized free text fields of the location for each language. */
  translations?: Maybe<Array<LocationTranslation>>;
  /**
   * Type of the location, used to group and create an hierarchy across countries,
   * areas, cities and other possible type defined in the LocationType.
   */
  type?: Maybe<LocationType>;
  /** Boolean field indicating if the location has been optimized. */
  unoptimized?: Maybe<Scalars['Boolean']['output']>;
  /** Distinguishes the location?s relevance to the customer?s intention. */
  useCase?: Maybe<Scalars['String']['output']>;
};

/**
 * A LocationAlias holds the information for the possible aliases of
 * the location name in the different languages, a single location can have
 * multiple aliases for the same language.
 */
export type LocationAlias = {
  __typename?: 'LocationAlias';
  /** Uniquely identifies a location alias. */
  id: Scalars['ID']['output'];
  /** The language in which this alias was created for. */
  languageId: Scalars['Int']['output'];
  /** The last time this location alias was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this location alias. */
  lastModificationUser?: Maybe<User>;
  /** Identifies the location that this alias belongs to. */
  location?: Maybe<Location>;
  /**
   * The localized name of the location alias for the associated
   * location and language.
   */
  name: Scalars['String']['output'];
};

/**
 * A LocationCode holds the information for the possible codes a location can have,
 * generally use for assigning IATA (International Air Transport Association) or
 * UN/LOCODE (United Nations Code for Trade and Transport Locations).
 */
export type LocationCode = {
  __typename?: 'LocationCode';
  /** Uniquely identifies a location code. */
  id: Scalars['ID']['output'];
  /** The last time this location code was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this location code. */
  lastModificationUser?: Maybe<User>;
  /** Identifies the location that this code belongs to. */
  location?: Maybe<Location>;
  /** The name designed by the assigned location code, taken from the refence IATA or UN/LOCODE code. */
  name: Scalars['String']['output'];
  /** Type of code used to identify the location. */
  type: LocationCodeType;
};

/** Possible alternatives for the location code. */
export enum LocationCodeType {
  /**
   * An IATA airport code, also known as an IATA location identifier, IATA station code, or simply a
   * location identifier, is a three-letter geocode designating many airports and metropolitan areas
   * around the world, defined by the International Air Transport Association (IATA).
   */
  Iata = 'IATA',
  /**
   * UN/LOCODE, the United Nations Code for Trade and Transport Locations, is a geographic coding
   * scheme developed and maintained by United Nations Economic Commission for Europe (UNECE).
   */
  Unlocode = 'UNLOCODE'
}

export type LocationDetails = {
  __typename?: 'LocationDetails';
  /** Average time spent at this location. */
  averageTimeSpent?: Maybe<Scalars['Float']['output']>;
  /** Unit of the time used. */
  averageTimeSpentUnit?: Maybe<LocationDetailsTimeUnit>;
  /** Documents needed to access. */
  documentsNeeded?: Maybe<Scalars['String']['output']>;
  /** Dress code information. */
  dressCode?: Maybe<LocationDressCode>;
  /** Entrance types of the given location. */
  entranceType?: Maybe<Scalars['String']['output']>;
  /** Wether a security check is in place. */
  hasSecurityCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Uniquely identifies a location details. */
  id: Scalars['ID']['output'];
  /** The last time this location details was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this location details. */
  lastModificationUser?: Maybe<User>;
  /** Minimum age to access the location. */
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /** Wether this location is accessible by wheelchair. */
  wheelchairAccessible?: Maybe<Scalars['Boolean']['output']>;
};

/** Time unit of measure. */
export enum LocationDetailsTimeUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

/** Dress code information for the given location. */
export type LocationDressCode = {
  __typename?: 'LocationDressCode';
  /** Body parts that should be covered in this location. */
  covered?: Maybe<Array<Scalars['String']['output']>>;
  /** The type of dress code in the given location. */
  profile?: Maybe<Scalars['String']['output']>;
  /** All the prohibited clothes. */
  prohibited?: Maybe<Array<Scalars['String']['output']>>;
  /** All the required clothes. */
  required?: Maybe<Array<Scalars['String']['output']>>;
};

/** Geoshape data. */
export type LocationGeoshape = {
  __typename?: 'LocationGeoshape';
  /** Geojson of the location */
  geometry: Scalars['String']['output'];
  /** Uniquely identifies a geoshape. */
  geoshapeId: Scalars['ID']['output'];
  /** Location associated with this geoshape */
  location?: Maybe<Location>;
  /** Location identifier associated with this geoshape */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** Unlocalized name of the location. */
  name: Scalars['String']['output'];
  /** Type of location, it can take many values such as locality, region, country and so on. */
  placeType?: Maybe<Scalars['String']['output']>;
};

/** A LocationPicture holds the information for the possible pictures a location can have. */
export type LocationPicture = {
  __typename?: 'LocationPicture';
  /** Information on who holds the credits for the used picture. */
  attribution?: Maybe<LocationPictureAttribution>;
  /** File name generated while storing the picture. */
  filename: Scalars['String']['output'];
  /** Uniquely identifies a location picture. */
  id: Scalars['ID']['output'];
  /** The last time this location picture was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this location picture. */
  lastModificationUser?: Maybe<User>;
  /** Identifies the location that this picture belongs to. */
  location?: Maybe<Location>;
  /** The order in which the picture should be displayed from the overall pictures of the same location. */
  order?: Maybe<Scalars['Int']['output']>;
  /**
   * Type of the picture, generally used to facilitate the selection of which image to be used
   * on different layout positions.
   */
  type: LocationPictureType;
  /** URL of the file name generated while storing the picture. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Credits attribution for the picture used to represent the location. */
export type LocationPictureAttribution = {
  __typename?: 'LocationPictureAttribution';
  /** The author of the picture. */
  author?: Maybe<Scalars['String']['output']>;
  /** Portfolio of the author. */
  authorUrl?: Maybe<Scalars['String']['output']>;
  /** Original picture url. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Type of license used for the picture. */
  licenseType?: Maybe<Scalars['String']['output']>;
  /** Person or company holding rights for the picture. */
  title?: Maybe<Scalars['String']['output']>;
};

export type LocationPictureMutationPayload = {
  __typename?: 'LocationPictureMutationPayload';
  /** All errors related to the operation */
  errors?: Maybe<Array<Error>>;
  /** The returned picture if it was created/updated */
  picture?: Maybe<LocationPicture>;
  /** Whether the operation was successful or not */
  success: Scalars['Boolean']['output'];
};

/** Possible alternatives for the location picture type. */
export enum LocationPictureType {
  /** Default picture shown for the given location. */
  Normal = 'NORMAL',
  /** Optimzed picture to be shown in horizontally wide sections. */
  Wide = 'WIDE'
}

export type LocationSearch = {
  __typename?: 'LocationSearch';
  items: Array<Location>;
  pagination: Pagination;
};

export type LocationSuggestion = {
  __typename?: 'LocationSuggestion';
  /** Activity of the LocationSuggestion */
  activity?: Maybe<Activity>;
  /** Uniquely identifies a LocationSuggestion. */
  id: Scalars['ID']['output'];
  /** Google place and name of the LocationSuggestion */
  suggestions?: Maybe<Array<LocationSuggestionItem>>;
  updateTimestamp: Scalars['DateTime']['output'];
  updateUser?: Maybe<User>;
};

export type LocationSuggestionInput = {
  /** Activity of the LocationSuggestion */
  activityId: Scalars['Int']['input'];
  /** Uniquely identifies a LocationSuggestion. Missing if it's a new suggestion */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actual suggested locations. */
  suggestions?: InputMaybe<Array<LocationSuggestionItemInput>>;
};

export type LocationSuggestionItem = {
  __typename?: 'LocationSuggestionItem';
  entranceType?: Maybe<Scalars['String']['output']>;
  googlePlace?: Maybe<GooglePlace>;
  googlePlaceId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LocationSuggestionItemInput = {
  entranceType?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Supplier that has tours in the specified location. */
export type LocationSupplier = {
  __typename?: 'LocationSupplier';
  /** The location ID where the supplier has a tour */
  locationId?: Maybe<Scalars['Int']['output']>;
  /** Uniquely identifies a supplier */
  supplierId: Scalars['ID']['output'];
  /** The name of the supplier */
  supplierName?: Maybe<Scalars['String']['output']>;
  /** The status of the supplier */
  supplierStatus?: Maybe<Scalars['String']['output']>;
};

export type LocationSupplierSearch = {
  __typename?: 'LocationSupplierSearch';
  items: Array<LocationSupplier>;
  pagination: Pagination;
};

/**
 * A LocationTranslation holds the translations for the text fields of a
 * location in the associated language.
 */
export type LocationTranslation = {
  __typename?: 'LocationTranslation';
  /** The localized description of the location in the given language. */
  description?: Maybe<Scalars['String']['output']>;
  /** Uniquely identifies a location translation. */
  id: Scalars['ID']['output'];
  /** The language in which this translation was created for. */
  languageId: Scalars['Int']['output'];
  /** The last time this location translation was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this location translation. */
  lastModificationUser?: Maybe<User>;
  /** Identifies the location that this translation belongs to. */
  location?: Maybe<Location>;
  /** The localized name of the location in the given language. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The localized short name of the location in the given language,
   * short names have less than 25 characters.
   */
  shortName?: Maybe<Scalars['String']['output']>;
  /** The localized source of the location in the given language. */
  source?: Maybe<Scalars['String']['output']>;
  /** Tips for what to do in the given location localized in the given language. */
  tips?: Maybe<Scalars['String']['output']>;
};

/** The single branch of the location tree with all of the relevant info. */
export type LocationTreeEntry = {
  __typename?: 'LocationTreeEntry';
  accessMode?: Maybe<Scalars['String']['output']>;
  boosted?: Maybe<Scalars['Boolean']['output']>;
  details?: Maybe<LocationDetails>;
  entranceType?: Maybe<Scalars['String']['output']>;
  googlePlace?: Maybe<GooglePlace>;
  includeInRanking?: Maybe<Scalars['Boolean']['output']>;
  locationId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Location>;
  poiTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  revenueRelevant?: Maybe<Scalars['Boolean']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LocationType>;
  useCase?: Maybe<Scalars['String']['output']>;
};

/** All the possible types that a location can have. */
export enum LocationType {
  /** Everything above city level that is not a country as US states, provinces, regions, municipalities (Ile-de-France). */
  Area = 'AREA',
  /** From a small village to a big city (Paris). */
  City = 'CITY',
  /** A continent (Europe). */
  Continent = 'CONTINENT',
  /** A country (France). */
  Country = 'COUNTRY',
  /** In hierarchy between City and POI. */
  Neighborhood = 'NEIGHBORHOOD',
  /** Sight, landmark, attraction, or other touristically relevant places (Eiffel Tower). */
  Poi = 'POI',
  /** One hierarchical level above type country. */
  SubContinent = 'SUB_CONTINENT'
}

/** Location with city name */
export type LocationWithCity = {
  __typename?: 'LocationWithCity';
  /**
   * Defines how customers can access a POI.
   * Potential values are elevator, foot, stairs.
   */
  accessModes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Localized alternative names the location can have for each given language. */
  aliases?: Maybe<Array<LocationAlias>>;
  /**
   * Given bounding box of the location, such definition is generally used to draw an
   * area around the exact location coordinates.
   */
  boundingBox?: Maybe<BoundingBox>;
  /** This boolean field is used to mark locations with added business relevance. */
  businessRelevance?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the parent city if exists */
  city?: Maybe<Scalars['String']['output']>;
  /** Available location codes the given location can have. */
  codes?: Maybe<Array<LocationCode>>;
  /**
   * Given coordinates of the location, such coordinates are generally used to
   * pinpoint a location in a map.
   */
  coordinates?: Maybe<Coordinates>;
  /** The country in which this location is present. */
  country?: Maybe<Country>;
  /** Google place information associated with this location. */
  googlePlace?: Maybe<GooglePlace>;
  /** Uniquely identifies a location. */
  id: Scalars['ID']['output'];
  /** The last time this location was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this location. */
  lastModificationUser?: Maybe<User>;
  /** Unlocalized name of the location. */
  name: Scalars['String']['output'];
  /** The parent location. */
  parent?: Maybe<Location>;
  /** Available location pictures ordered ascending by the order field of the LocationPicture. */
  pictures?: Maybe<Array<LocationPicture>>;
  /** All the poi information if applicable to the location. */
  poiInformation?: Maybe<LocationDetails>;
  /** If the location is a POI then this field has it's types. */
  poiTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The priority of the location. */
  priority?: Maybe<Scalars['Int']['output']>;
  /** The source of the location. */
  source?: Maybe<Scalars['String']['output']>;
  /** The timezone that the location is in. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Localized free text fields of the location for each language. */
  translations?: Maybe<Array<LocationTranslation>>;
  /**
   * Type of the location, used to group and create an hierarchy across countries,
   * areas, cities and other possible type defined in the LocationType.
   */
  type?: Maybe<LocationType>;
  /** Boolean field indicating if the location has been optimized. */
  unoptimized?: Maybe<Scalars['Boolean']['output']>;
  /** Distinguishes the location?s relevance to the customer?s intention. */
  useCase?: Maybe<Scalars['String']['output']>;
};

export type LockCustomerPayload = OperationResult & {
  __typename?: 'LockCustomerPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogisticsLocation = {
  __typename?: 'LogisticsLocation';
  address?: Maybe<Scalars['String']['output']>;
  boundingBox?: Maybe<BoundingBox>;
  coordinates?: Maybe<Coordinates>;
  exact?: Maybe<Scalars['Boolean']['output']>;
  geoAddress?: Maybe<Scalars['String']['output']>;
  geoArea?: Maybe<Scalars['String']['output']>;
  geoCountryCode?: Maybe<Scalars['String']['output']>;
  googlePlace?: Maybe<GooglePlace>;
  latitude?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['Int']['output']>;
  mapZoomLevel?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type LogisticsLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  boundingBox?: InputMaybe<BoundingBoxInput>;
  coordinates?: InputMaybe<CoordinatesInput>;
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  geoAddress?: InputMaybe<Scalars['String']['input']>;
  geoArea?: InputMaybe<Scalars['String']['input']>;
  geoCountryCode?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Int']['input']>;
  mapZoomLevel: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ManagementSort = {
  __typename?: 'ManagementSort';
  /** Field to sort by */
  column?: Maybe<Scalars['String']['output']>;
  /** Direction to sort by */
  order?: Maybe<Scalars['String']['output']>;
};

export enum ManagementUserType {
  CronJob = 'cron_job',
  Customer = 'customer',
  Reseller = 'reseller',
  Staff = 'staff',
  Supplier = 'supplier'
}

export type ManagingDirector = {
  __typename?: 'ManagingDirector';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['Int']['output']>;
};

export type ManagingDirectorInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};

export enum MappingAction {
  Disable = 'DISABLE',
  Enable = 'ENABLE'
}

export type MasterBillStatement = FinancialIssuedEntity & Payment & {
  __typename?: 'MasterBillStatement';
  /** The amount of the payment */
  amount: Scalars['Float']['output'];
  /** Any comments about the payment */
  comment?: Maybe<Scalars['String']['output']>;
  /** The compound entry id representing the payment */
  compoundEntryId: Scalars['String']['output'];
  /** The currency ISO code of the payment */
  currencyIsoCode: Scalars['String']['output'];
  /** The date that the payment was conducted */
  dateOfPayment: Scalars['DateTime']['output'];
  /** The date that the date is due to be paid */
  dueDate?: Maybe<Scalars['String']['output']>;
  /** The reason the payment failed, if there was a failure */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The staff id that triggered the payment */
  gygStaffId: Scalars['Int']['output'];
  /** The date that the payment was invoiced */
  invoiceDate: Scalars['String']['output'];
  /** The source that the payment was issued from */
  issuingSource: IssuingSource;
  /** The note that we issue to the payee */
  noteToPayee: Scalars['String']['output'];
  /** The payment channel that the payment went through */
  paymentChannel?: Maybe<PaymentChannel>;
  /** The ID representation of the payment */
  paymentId: Scalars['ID']['output'];
  /** The reference date of the payment */
  referenceDate: Scalars['String']['output'];
  /** The type of reference date */
  referenceDateType: ReferenceDateType;
  /** The ID representation of the reseller associated with the payment */
  resellerId: Scalars['ID']['output'];
  /** The share of the reseller */
  resellerShare: Scalars['Float']['output'];
  /** The date that the payment was sent */
  sendDate?: Maybe<Scalars['String']['output']>;
  /** The status of the payment */
  status: PaymentStatus;
  /** The total price of the payment */
  totalPrice: Scalars['Float']['output'];
  /** The vat amount of the payment */
  vatAmountGermany?: Maybe<Scalars['Float']['output']>;
  /** The vat rate of the payment */
  vatRateGermany?: Maybe<Scalars['Float']['output']>;
};

export type MeetingPoint = {
  __typename?: 'MeetingPoint';
  /**
   * Defines the exact location with GPS coordinates where the traveler has to go to start the tour.
   * This value has a meaning only if 'ActivityOption.StartingPlaceType' is set to either 'MEETING_POINT'
   * or 'MEETING_POINT_PICK_UP'.
   */
  location?: Maybe<LogisticsLocation>;
  /**
   * The traveler should arrive at the meeting point some minutes before the starting time of the activity.
   * Displayed to the traveler i.e. like: Please arrive 30 minutes in advance
   */
  minutesBefore?: Maybe<Scalars['Int']['output']>;
  /** A cloud picture file name which shows the meeting point. */
  picture?: Maybe<Scalars['String']['output']>;
  /** The full url of the uploaded picture. */
  pictureUrl?: Maybe<Scalars['String']['output']>;
  transportationTypes?: Maybe<Array<TransportationType>>;
};

export type MeetingPointInput = {
  /**
   * Defines the exact location with GPS coordinates where the traveler has to go to start the tour.
   * This value has a meaning only if 'ActivityOption.StartingPlaceType' is set to either 'MEETING_POINT'
   * or 'MEETING_POINT_PICK_UP'.
   */
  location?: InputMaybe<LogisticsLocationInput>;
  /**
   * The traveler should arrive at the meeting point some minutes before the starting time of the activity.
   * Displayed to the traveler i.e. like: Please arrive 30 minutes in advance
   */
  minutesBefore?: InputMaybe<Scalars['Int']['input']>;
  /** A cloud picture file name which shows the meeting point. */
  picture?: InputMaybe<Scalars['String']['input']>;
  transportationTypes?: InputMaybe<Array<TransportationTypeInput>>;
};

export type MeetingPointPictureUploadInput = {
  /** Image file encoded as Base64 string */
  file?: InputMaybe<Scalars['String']['input']>;
  /** File name of the uploaded picture */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the activity option */
  optionId: Scalars['Int']['input'];
};

export type MergeLocationMutationPayload = {
  __typename?: 'MergeLocationMutationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** The original location with merged data. */
  location?: Maybe<Location>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type MissingAttribute = {
  __typename?: 'MissingAttribute';
  /** The attribute name */
  name: Scalars['String']['output'];
  /** Completeness status */
  status?: Maybe<CompletenessStatus>;
  /** The attribute value */
  value?: Maybe<Scalars['JSON']['output']>;
};

/** Entity holding fields relevant for pricing */
export type Money = {
  __typename?: 'Money';
  /** The currency iso code */
  currency: Scalars['String']['output'];
  /** The amount of money (float) */
  floatAmount: Scalars['Float']['output'];
};

/** Entity holding fields relevant for pricing */
export type MoneyInput = {
  /** The currency iso code */
  currency: Scalars['String']['input'];
  /** The amount of money (float) */
  floatAmount: Scalars['Float']['input'];
};

export type MoveTicketsOnSaleInput = {
  activityOptionId: Scalars['ID']['input'];
  fromValidity: MoveTicketsOnSaleValidityInput;
  ticketsToMove: Array<MoveTicketsOnSaleQuantityInput>;
  toValidity: MoveTicketsOnSaleValidityInput;
};

/** Payload with result of the operation of moving the specified tickets on sale. */
export type MoveTicketsOnSalePayload = {
  __typename?: 'MoveTicketsOnSalePayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type MoveTicketsOnSaleQuantityInput = {
  quantity: Scalars['Int']['input'];
  ticketCategory: Scalars['String']['input'];
};

export type MoveTicketsOnSaleValidityInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type MoveUnsoldTicketsOnBatchInput = {
  activityOptionId: Scalars['ID']['input'];
  batchId: Scalars['ID']['input'];
  ticketsToMove: Scalars['Int']['input'];
};

/**
 * Payload with result of the operation of moving the specified tickets
 * unsold in the batch upload.
 */
export type MoveUnsoldTicketsOnBatchPayload = {
  __typename?: 'MoveUnsoldTicketsOnBatchPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept external rating for a tour. */
  acceptActivityExternalReviewRating: ActivityAcceptExternalReviewResult;
  /** Accept an on-demand booking given a booking reference (e.g. GYG123456789) */
  acceptOnDemandBooking: Scalars['Boolean']['output'];
  accountChangePassword?: Maybe<Scalars['Boolean']['output']>;
  accountComplete?: Maybe<AccountConfirmation>;
  accountConfirm?: Maybe<AccountConfirmation>;
  accountCreate?: Maybe<SupplierAccount>;
  accountDelete?: Maybe<Scalars['Boolean']['output']>;
  accountForgotPassword?: Maybe<Scalars['Boolean']['output']>;
  accountLogout?: Maybe<Scalars['Boolean']['output']>;
  accountResendConfirmation?: Maybe<Scalars['Boolean']['output']>;
  accountResetPassword?: Maybe<Scalars['Boolean']['output']>;
  accountUpdate?: Maybe<SupplierAccount>;
  accountUpdateLocale: SupplierAccount;
  /** Take action on the supplier cancellation (i.e. accept or reject) */
  actOnSupplierCancellation: ActOnSupplierCancellationPayload;
  /** Activate an existing customer */
  activateCustomer: ActivateCustomerPayload;
  activityCommentCreate: ActivityCommentCreatePayload;
  /** Generate content for the given activity. */
  activityContentGenerationInit?: Maybe<Scalars['Boolean']['output']>;
  /** Copy an activity from one supplier to another */
  activityCopy: ActivityCopyPayload;
  /** Create an activity with the provided input information. */
  activityCreate: ActivityCreatePayload;
  /** Copy the given activity option. */
  activityOptionCopy: ActivityOptionCopyPayload;
  /** Create an activity option with the provided input information. */
  activityOptionCreate?: Maybe<ActivityOptionCreatePayload>;
  /** Transition the status of the activity option. */
  activityOptionTransitionStatus: ActivityOptionUpdatePayload;
  /** Update an activity option with the provided input information. */
  activityOptionUpdate: ActivityOptionUpdatePayload;
  /** Update an activity option with the provided input information and recalculate completeness. */
  activityOptionUpdateWithCompleteness: ActivityOptionUpdateWithCompletenessPayload;
  /** Submits an activity and/or options */
  activitySubmit: ActivitySubmitPayload;
  /** Transition the status of the activity */
  activityTransitionStatus: ActivityUpdatePayload;
  /** Update an activity with the provided input information. */
  activityUpdate: ActivityUpdatePayload;
  /** Update an activity with the provided input information and also return the recalculated tour completeness. */
  activityUpdateWithCompleteness: ActivityUpdateWithCompletenessPayload;
  /** Approves a coupon */
  approveCoupon: CouponActionPayload;
  /** Delete the given authorized badge */
  authorizedBadgeDelete: Scalars['Boolean']['output'];
  /** Creates an authorized badge if a tour does not already have one, otherwise edits the existing one */
  authorizedBadgeUpload: AuthorizedBadge;
  /** Batch upload tickets. */
  batchUploadTicket: BatchUploadTicketPayload;
  blockAvailabilityByActivityIds?: Maybe<BlockUnblockAvailabilityPayload>;
  /** Create a new broadcast */
  broadcastCreate: BroadcastCreatePayload;
  /** Edit an existing broadcast by id */
  broadcastUpdate?: Maybe<BroadcastUpdatePayload>;
  /** Cancel a booking */
  cancelBooking: CancelBookingPayload;
  /** Cancel bookings in bulk */
  cancelBookingsInBulk: Scalars['Boolean']['output'];
  /** Cancels a coupon */
  cancelCoupon: CouponActionPayload;
  cleanAvailabilityByActivityOptionIds?: Maybe<UpdatePayload>;
  connectAvailabilityToPricing?: Maybe<UpdateAvailabilityPayload>;
  /** Bulk connect or disconnect tour options from the reservation system */
  connectDisconnectByActivityOptionIds?: Maybe<UpdatePayload>;
  /** Create a content review comment */
  contentReviewCommentCreate: ContentReviewCommentMutatePayload;
  /** Delete a content review comment */
  contentReviewCommentDelete: ContentReviewCommentMutatePayload;
  /** Edit a content review comment */
  contentReviewCommentEdit: ContentReviewCommentMutatePayload;
  /** Prioritize open content reviews based on given input */
  contentReviewPrioritize: ContentReviewPrioritizePayload;
  /** Update a content review record */
  contentReviewUpdate: ContentReviewUpdatePayload;
  /** Creates a coupon as a refund option for a refund */
  convertRefund: ConvertRefundPayload;
  /** Copy billing address to lead address */
  copyBillingToLeadAddress: CopyBillingToLeadCustomerAddressPayload;
  /** Copy a list of reviews from a source option id to a target option id */
  copyReviewById?: Maybe<ReviewCopyMovePayload>;
  /** Copy all reviews from a source option id to a target option id */
  copyReviewByOptionId?: Maybe<ReviewCopyMoveByOptionIdPayload>;
  createAvailabilityAndPricing?: Maybe<AvailabilityAndPricingPayload>;
  createAvailabilityBlock?: Maybe<CreateAvailabilityPayload>;
  /** Create a new catalog category */
  createCategory?: Maybe<CreateCategoryPayload>;
  /** Create a new comment */
  createComment?: Maybe<CreateCommentPayload>;
  createCustomAvailability?: Maybe<CustomAvailabilityPayload>;
  /** Create a Deal */
  createDeal?: Maybe<DealPayload>;
  /** Create a new derived attribute configuration with a sandbox field or permanent to the catalog. */
  createDerivedAttributeConfiguration?: Maybe<CreateDerivedAttributeConfigurationPayload>;
  /** Create the given location picture and upload to CDN */
  createLocationPicture: LocationPictureMutationPayload;
  /** Create or edit a supplier email allowlist record. */
  createOrEditSupplierEmailAllowListEntry: SupplierEmailAllowListEntry;
  createPartnerAdjustmentPayment: CreatePartnerAdjustmentPaymentPayload;
  createPartnerNotification?: Maybe<PartnerNotification>;
  createPricing?: Maybe<PricingPayload>;
  /** Create a quality issue */
  createQualityIssue: CreateQualityIssuePayload;
  /** Create a new quality issue configuration that is automatically connected with the insights/content-quality service. */
  createQualityIssueConfiguration?: Maybe<CreateQualityIssueConfigurationPayload>;
  /** Create a quality rule */
  createQualityRule: CreateQualityRulePayload;
  /** Create a quality team */
  createQualityTeam: CreateQualityTeamPayload;
  /** Create a new restriction configuration. */
  createRestrictionConfiguration?: Maybe<CreateRestrictionConfigurationPayload>;
  createStaffAreaMapping: Scalars['Boolean']['output'];
  createSupplierAdjustmentPayment: CreateSupplierAdjustmentPaymentPayload;
  /** Create new catalog Tags */
  createTag?: Maybe<CreateTagPayload>;
  /** Create the given tour picture and upload to CDN */
  createTourPicture: PictureMutationPayload;
  deleteAvailabilityAndPricing?: Maybe<AvailabilityAndPricingPayload>;
  deleteAvailabilityAndPricingByOption?: Maybe<UpdatePayload>;
  deleteAvailabilityById?: Maybe<UpdatePayload>;
  deleteAvailabilityByTourOptionIdAndFromDate?: Maybe<UpdatePayload>;
  /** Delete an existing comment */
  deleteComment?: Maybe<DeleteCommentPayload>;
  /** Delete an existing customer */
  deleteCustomer: DeleteCustomerPayload;
  /** Delete a deal by it's id */
  deleteDeal?: Maybe<DealPayload>;
  /**
   * Delete an existing derived attribute configuration, this operation also deletes all the values of the attribute
   * in the selected entity type.
   */
  deleteDerivedAttributeConfiguration?: Maybe<DeleteDerivedAttributeConfigurationPayload>;
  /** Delete a location */
  deleteLocation: DeleteLocationMutationPayload;
  /** Delete the given location picture */
  deleteLocationPicture: LocationPictureMutationPayload;
  deletePartnerAdjustmentPayment: DeletePartnerAdjustmentPaymentPayload;
  deletePartnerNotification?: Maybe<Scalars['Boolean']['output']>;
  deletePricing?: Maybe<DeletePricingPayload>;
  /** Delete a quality issue */
  deleteQualityIssue: DeleteQualityIssuePayload;
  /**
   * Delete a quality issue configuration, this operation will also delete all the quality issues that are still todo
   * already created in the insights/content-quality service.
   */
  deleteQualityIssueConfiguration?: Maybe<DeleteQualityIssueConfigurationPayload>;
  /** Delete a quality rule by key */
  deleteQualityRuleByKey: DeleteQualityRulePayload;
  /** Deletes a refund */
  deleteRefund: DeleteRefundPayload;
  /** Delete a restriction configuration. */
  deleteRestrictionConfiguration?: Maybe<DeleteRestrictionConfigurationPayload>;
  deleteStaffAreaMapping: Scalars['Boolean']['output'];
  deleteSupplierAdjustmentPayment: DeleteSupplierAdjustmentPaymentPayload;
  /** Delete a supplier email allowlist record. */
  deleteSupplierEmailAllowListEntry: Scalars['Boolean']['output'];
  /** Delete the given tour picture */
  deleteTourPicture: PictureMutationPayload;
  disconnectAvailabilityToPricing?: Maybe<UpdateAvailabilityPayload>;
  /** Download the unsold tickets in a batch upload and send it to the speficied email. */
  downloadUnsoldTicketsOnBatch: DownloadUnsoldTicketsOnBatchPayload;
  /** Edit a quality issue */
  editQualityIssue: EditQualityIssuePayload;
  /** Edit a quality rule */
  editQualityRule: EditQualityRulePayload;
  /** Edit a quality rule by key */
  editQualityRuleByKey: EditQualityRulePayload;
  /** Edit ticket monitor settings for activity option. */
  editTicketMonitorSettings: EditTicketMonitorSettingsPayload;
  /** Executes a refund */
  executeRefundImmediately: ExecuteRefundPayload;
  /** Create a glossary */
  glossaryCreate: GlossaryCreatePayload;
  /** Delete a glossary */
  glossaryDelete: GlossaryDeletePayload;
  /** Create a glossary item */
  glossaryItemCreate: GlossaryItemCreatePayload;
  /** Delete a glossary item */
  glossaryItemDelete: GlossaryItemDeletePayload;
  /** Edit a glossary item */
  glossaryItemEdit: GlossaryItemEditPayload;
  /** Sync a glossary with the translation engine */
  glossarySynchronize: GlossarySynchronizePayload;
  /** Lock an existing customer */
  lockCustomer: LockCustomerPayload;
  /**
   * Uploads a meeting point picture.
   * Replaces the existing meeting point picture.
   * Can also be used to remove existing pictures by sending an empty input.
   */
  meetingPointPictureUpload: MeetingPoint;
  /** Merge duplicate locations */
  mergeLocations: MergeLocationMutationPayload;
  /** Move a list of reviews from a source option id to a target option id */
  moveReviewById?: Maybe<ReviewCopyMovePayload>;
  /** Move all reviews from a source option id to a target option id */
  moveReviewByOptionId?: Maybe<ReviewCopyMoveByOptionIdPayload>;
  /** Move tickets on sale for activity option. */
  moveTicketsOnSale: MoveTicketsOnSalePayload;
  /** Move the unsold tickets in a batch upload. */
  moveUnsoldTicketsOnBatch: MoveUnsoldTicketsOnBatchPayload;
  overwriteStaffRoles: StaffRoleOverwritePayload;
  /** Performs selected booking operation */
  performBookingOperation: BookingOperationPayload;
  /** Pushes activities for translation */
  pushForTranslation?: Maybe<PushForTranslationPayload>;
  /** Recomputes the delivery cache and changestream entries for the given entities. */
  recomputeCacheEntriesMutation: RecomputeCacheEntriesPayload;
  /** Redeem ticket by code */
  redeemTicketByCode: RedeemTicketByCodePayload;
  /** Refund a booking */
  refundBooking: RefundBookingPayload;
  /** Refunds a coupon */
  refundCoupon: CouponActionPayload;
  /** Refund the unsold tickets in a batch upload. */
  refundTicketsOnBatch: RefundTicketsOnBatchPayload;
  /** Reorder the given tour pictures */
  reorderTourPictures: ReorderMutationPayload;
  /**
   * Reprocess the given holding pen entry.
   * Returns true in case entry was released and pushed to XTM.
   */
  reprocessXTMDelayedTourPush: Scalars['Boolean']['output'];
  /** Trigger the synchronization of the business partner to CPI & SAP */
  resendBusinessPartnerToSap?: Maybe<ResendBusinessPartnerToSapResponse>;
  resendEmail: ResendEmailPayload;
  /** Re-generate FX rate updates in Kafka from existing daily exchange rate data in DB */
  resendFxRates: Scalars['Boolean']['output'];
  /** Re-generate and send supplier payment details confirmation email */
  resendSupplierPaymentDetailsChangedEmail: Scalars['Boolean']['output'];
  /** Resend validation email to a customer */
  resendValidationEmail: ResendValidationEmailPayload;
  resetOverwriteStaffRoles: StaffRoleOverwriteResetPayload;
  /** Mutation to process payment details change request */
  resolvePaymentDetailsChangeRequest?: Maybe<ResolvePaymentDetailsChangeRequestResponse>;
  splitPricing?: Maybe<PricingPayload>;
  supplierApiRegistrationComplete?: Maybe<SupplierApiRegistrationCompleteResponse>;
  supplierBatchUpdate?: Maybe<SupplierBatchUpdateResponse>;
  supplierBatchUpdateFishfarm?: Maybe<SupplierBatchUpdateResponse>;
  /** Allows suppliers to cancel a booking given a booking reference (e.g. GYG123456789) */
  supplierCancelBooking: Scalars['Boolean']['output'];
  supplierCreate?: Maybe<SupplierPayload>;
  supplierCreateInsuranceInformation?: Maybe<Array<Maybe<InsuranceInformation>>>;
  supplierDeleteInsuranceInformation?: Maybe<InsuranceInformation>;
  supplierDeleteTermsAndConditions?: Maybe<DeleteTermsAndConditionsPayload>;
  supplierEmailAction?: Maybe<Scalars['Boolean']['output']>;
  /** Edit supplier insight */
  supplierInsightUpdate?: Maybe<UpdateSupplierInsightPayload>;
  supplierPublicEmailAction?: Maybe<Scalars['Boolean']['output']>;
  supplierReminderEmailAction?: Maybe<Scalars['Boolean']['output']>;
  supplierTourStatusChangeEmail?: Maybe<Scalars['Void']['output']>;
  supplierUpdate?: Maybe<SupplierPayload>;
  supplierUpdateEuCompliance?: Maybe<SupplierPayload>;
  supplierUpdateFishfarm?: Maybe<Scalars['Void']['output']>;
  supplierUpdateInsuranceInformation?: Maybe<InsuranceInformation>;
  supplierUpdateManagingDirector?: Maybe<Array<Maybe<ManagingDirector>>>;
  supplierUpdatePrimaryAccount?: Maybe<Scalars['Int']['output']>;
  supplierUpdatePrivacyPolicy?: Maybe<UpdatePrivacyPolicyPayLoad>;
  supplierUpdateProfileItem?: Maybe<SupplierProfileItem>;
  supplierUpdateStatusChangeActions?: Maybe<SupplierPayload>;
  supplierUpdateTermsAndConditions?: Maybe<UpdateTermsAndConditionsPayLoad>;
  unblockAvailabilityByActivityIds?: Maybe<BlockUnblockAvailabilityPayload>;
  updateAvailabilityAndPricing?: Maybe<AvailabilityAndPricingPayload>;
  updateAvailabilityBlock?: Maybe<CreateAvailabilityPayload>;
  /** Update the availability of a tour option */
  updateAvailabilityByActivityOptionId?: Maybe<UpdatePayload>;
  /** Refund a booking */
  updateBillingDetails: UpdateBillingDetailsPayload;
  /** Update the booking */
  updateBooking: UpdateBookingPayload;
  /** Update an existing catalog category */
  updateCategory?: Maybe<UpdateCategoryPayload>;
  /** Update an existing comment */
  updateComment?: Maybe<UpdateCommentPayload>;
  /** Update the connectivity partner to supplier self mapping */
  updateConnectivityPartnerSelfMapping?: Maybe<UpdatePayload>;
  /** Update an existing configuration */
  updateConnectivitySettings?: Maybe<ConnectivitySettingsPayload>;
  /** Updates a coupon */
  updateCoupon: CouponActionPayload;
  /** Update an existing customer */
  updateCustomer: UpdateCustomerPayload;
  /** Update an existing customer address */
  updateCustomerAddress: UpdateCustomerAddressPayload;
  /** Update an existing permission */
  updateCustomerCommunicationPreferences?: Maybe<UpdatePermissionPayload>;
  /** Edit an existing deal by id */
  updateDeal?: Maybe<DealPayload>;
  /** Update an existing derived attribute configuration. */
  updateDerivedAttributeConfiguration?: Maybe<UpdateDerivedAttributeConfigurationPayload>;
  updateInventoryConfiguration?: Maybe<UpdateInventoryConfigurationPayload>;
  updateMultipleTimeSlots: UpdateMultipleTimeSlotsPayload;
  updatePartnerNotification?: Maybe<PartnerNotification>;
  /** Mutation to update payment details */
  updatePaymentDetails?: Maybe<UpdatePaymentDetailsResult>;
  /** Mutation to change the payment channel of the payment details */
  updatePaymentDetailsBankPaymentChannel?: Maybe<PaymentDetailsBankPaymentChannelChangeResponse>;
  /** Mutation to change the status of the payment details */
  updatePaymentDetailsStatus?: Maybe<PaymentDetailsStatusChangeResponse>;
  updatePricing?: Maybe<PricingPayload>;
  /** Update a quality issue configuration that is automatically already connected with the insights/content-quality service. */
  updateQualityIssueConfiguration?: Maybe<UpdateQualityIssueConfigurationPayload>;
  /** Marks a refund as failed_checked */
  updateRefund: UpdateRefundPayload;
  /** Update a restriction configuration. */
  updateRestrictionConfiguration?: Maybe<UpdateRestrictionConfigurationPayload>;
  /** Update a review status, anonymity, rating, enjoyment, message, optinal ratings, traveler type, and age group */
  updateReview: ReviewUpdatePayload;
  /** Update the assigned staff id to a review */
  updateReviewStaffId?: Maybe<ReviewUpdateStaffIdPayload>;
  /** Updates shopping cart */
  updateShoppingCart: UpdateShoppingCartPayload;
  updateStaffAreaMapping: Scalars['Boolean']['output'];
  updateSupplierPaymentDataStatus: UpdateSupplierPaymentDataPayload;
  updateSupplierPaymentMethod: UpdateSupplierPaymentDataPayload;
  /** Allows the mutation of the supplier's PaymentSettings */
  updateSupplierPaymentSettings?: Maybe<Scalars['Boolean']['output']>;
  /** Update the supplier reference number */
  updateSupplierReferenceNumber: UpdateSupplierReferenceNumberPayload;
  /** Update the supplier requested answer */
  updateSupplierRequestedAnswer: UpdateSupplierRequestedAnswerPayload;
  updateSupplierTaxDetails: UpdateSupplierTaxationDetailsPayload;
  /** Prioritize open content reviews based on given input */
  updateSuppliersToursCancellationPolicy: SuppliersToursCancellationPolicyPayload;
  /** Update existing catalog tags */
  updateTags?: Maybe<UpdateTagsPayload>;
  /** Update ticket configuration for activity option. */
  updateTicketConfiguration: UpdateTicketConfigurationPayload;
  /** Update the on sale tickets in a batch upload. */
  updateTicketsOnSaleOnBatchUpload: UpdateTicketsOnSaleOnBatchUploadPayload;
  /** Update the given tour picture */
  updateTourPicture: PictureMutationPayload;
};


export type MutationAcceptActivityExternalReviewRatingArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcceptOnDemandBookingArgs = {
  bookingReference: Scalars['String']['input'];
};


export type MutationAccountChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationAccountCompleteArgs = {
  input: CompleteAccountInput;
};


export type MutationAccountConfirmArgs = {
  confirmationCode: Scalars['String']['input'];
};


export type MutationAccountCreateArgs = {
  input: CreateAccountInput;
};


export type MutationAccountDeleteArgs = {
  accountId: Scalars['Int']['input'];
};


export type MutationAccountForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationAccountLogoutArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationAccountResendConfirmationArgs = {
  accountId: Scalars['Int']['input'];
};


export type MutationAccountResetPasswordArgs = {
  input: ResetAccountPasswordInput;
};


export type MutationAccountUpdateArgs = {
  input: UpdateAccountInput;
};


export type MutationAccountUpdateLocaleArgs = {
  input: UpdateLocaleInput;
};


export type MutationActOnSupplierCancellationArgs = {
  input: ActOnSupplierCancellationInput;
};


export type MutationActivateCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivityCommentCreateArgs = {
  input: ActivityCommentCreateInput;
};


export type MutationActivityContentGenerationInitArgs = {
  input: ActivityGenerateContentInput;
};


export type MutationActivityCopyArgs = {
  input: ActivityCopyInput;
};


export type MutationActivityCreateArgs = {
  input: ActivityCreateInput;
};


export type MutationActivityOptionCopyArgs = {
  input: ActivityOptionCopyInput;
};


export type MutationActivityOptionCreateArgs = {
  input: ActivityOptionCreateInput;
};


export type MutationActivityOptionTransitionStatusArgs = {
  input: ActivityOptionStatusTransitionInput;
};


export type MutationActivityOptionUpdateArgs = {
  input: ActivityOptionUpdateInput;
};


export type MutationActivityOptionUpdateWithCompletenessArgs = {
  input: ActivityOptionUpdateInput;
};


export type MutationActivitySubmitArgs = {
  input: ActivitySubmitInput;
};


export type MutationActivityTransitionStatusArgs = {
  input: ActivityStatusTransitionInput;
};


export type MutationActivityUpdateArgs = {
  input: ActivityUpdateInput;
};


export type MutationActivityUpdateWithCompletenessArgs = {
  input: ActivityUpdateInput;
};


export type MutationApproveCouponArgs = {
  input: ApproveCouponInput;
};


export type MutationAuthorizedBadgeDeleteArgs = {
  input?: InputMaybe<AuthorizedBadgeDeleteInput>;
};


export type MutationAuthorizedBadgeUploadArgs = {
  input: AuthorizedBadgeUploadInput;
};


export type MutationBatchUploadTicketArgs = {
  input: BatchUploadTicketInput;
};


export type MutationBlockAvailabilityByActivityIdsArgs = {
  input: BlockUnblockAvailabilityInput;
};


export type MutationBroadcastCreateArgs = {
  input: BroadcastCreateInput;
};


export type MutationBroadcastUpdateArgs = {
  input: BroadcastUpdateInput;
};


export type MutationCancelBookingArgs = {
  input: CancelBookingInput;
};


export type MutationCancelBookingsInBulkArgs = {
  input: CancelBookingsInBulkInput;
};


export type MutationCancelCouponArgs = {
  input: CancelCouponInput;
};


export type MutationCleanAvailabilityByActivityOptionIdsArgs = {
  input: CleanAvailabilityInput;
};


export type MutationConnectAvailabilityToPricingArgs = {
  input: AvailabilityToPricingInput;
};


export type MutationConnectDisconnectByActivityOptionIdsArgs = {
  input: ConnectDisconnectByActivityOptionIdsInput;
};


export type MutationContentReviewCommentCreateArgs = {
  input: ContentReviewCommentCreateInput;
};


export type MutationContentReviewCommentDeleteArgs = {
  input: ContentReviewCommentEditInput;
};


export type MutationContentReviewCommentEditArgs = {
  input: ContentReviewCommentEditInput;
};


export type MutationContentReviewPrioritizeArgs = {
  input: ContentReviewPrioritizeInput;
};


export type MutationContentReviewUpdateArgs = {
  input: ContentReviewUpdateInput;
};


export type MutationConvertRefundArgs = {
  input: ConvertRefundInput;
};


export type MutationCopyBillingToLeadAddressArgs = {
  input: CopyBillingToLeadCustomerAddressInput;
};


export type MutationCopyReviewByIdArgs = {
  input: ReviewCopyMoveByIdInput;
};


export type MutationCopyReviewByOptionIdArgs = {
  input: ReviewCopyMoveByOptionIdInput;
};


export type MutationCreateAvailabilityAndPricingArgs = {
  input: AvailabilityAndPricingInput;
};


export type MutationCreateAvailabilityBlockArgs = {
  input: AvailabilityBlockInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCustomAvailabilityArgs = {
  input: CustomAvailabilityInput;
};


export type MutationCreateDealArgs = {
  input: DealInput;
};


export type MutationCreateDerivedAttributeConfigurationArgs = {
  input: CreateDerivedAttributeConfigurationInput;
};


export type MutationCreateLocationPictureArgs = {
  input: CreateLocationPictureInput;
};


export type MutationCreateOrEditSupplierEmailAllowListEntryArgs = {
  input?: InputMaybe<SupplierEmailAllowListEntryInput>;
};


export type MutationCreatePartnerAdjustmentPaymentArgs = {
  input: CreatePartnerAdjustmentPaymentInput;
};


export type MutationCreatePartnerNotificationArgs = {
  input: CreatePartnerNotificationInput;
};


export type MutationCreatePricingArgs = {
  input: PricingInput;
};


export type MutationCreateQualityIssueArgs = {
  input: QualityIssueInput;
};


export type MutationCreateQualityIssueConfigurationArgs = {
  input: CreateQualityIssueConfigurationInput;
};


export type MutationCreateQualityRuleArgs = {
  input: QualityRuleInput;
};


export type MutationCreateQualityTeamArgs = {
  input: CreateQualityTeamInput;
};


export type MutationCreateRestrictionConfigurationArgs = {
  input: CreateRestrictionConfigurationInput;
};


export type MutationCreateStaffAreaMappingArgs = {
  input: CreateStaffAreaMappingInput;
};


export type MutationCreateSupplierAdjustmentPaymentArgs = {
  input: CreateSupplierAdjustmentPaymentInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTourPictureArgs = {
  input: CreatePictureInput;
};


export type MutationDeleteAvailabilityAndPricingArgs = {
  availabilityBlockId: Scalars['ID']['input'];
};


export type MutationDeleteAvailabilityAndPricingByOptionArgs = {
  optionId: Scalars['ID']['input'];
};


export type MutationDeleteAvailabilityByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAvailabilityByTourOptionIdAndFromDateArgs = {
  input: DeleteAvailabilityByTourOptionIdAndFromDateInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDealArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDerivedAttributeConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLocationPictureArgs = {
  pictureId: Scalars['ID']['input'];
};


export type MutationDeletePartnerAdjustmentPaymentArgs = {
  input: DeletePartnerAdjustmentPaymentInput;
};


export type MutationDeletePartnerNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePricingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQualityIssueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteQualityIssueConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQualityRuleByKeyArgs = {
  key: Scalars['String']['input'];
};


export type MutationDeleteRefundArgs = {
  input: DeleteRefundInput;
};


export type MutationDeleteRestrictionConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStaffAreaMappingArgs = {
  input: DeleteStaffAreaMappingInput;
};


export type MutationDeleteSupplierAdjustmentPaymentArgs = {
  input: DeleteSupplierAdjustmentPaymentInput;
};


export type MutationDeleteSupplierEmailAllowListEntryArgs = {
  entryId: Scalars['ID']['input'];
};


export type MutationDeleteTourPictureArgs = {
  input?: InputMaybe<DeletePictureInput>;
  pictureId: Scalars['ID']['input'];
};


export type MutationDisconnectAvailabilityToPricingArgs = {
  input: AvailabilityToPricingInput;
};


export type MutationDownloadUnsoldTicketsOnBatchArgs = {
  input: DownloadUnsoldTicketsOnBatchInput;
};


export type MutationEditQualityIssueArgs = {
  id: Scalars['Int']['input'];
  input: QualityIssueInput;
};


export type MutationEditQualityRuleArgs = {
  id: Scalars['ID']['input'];
  input: QualityRuleInput;
};


export type MutationEditQualityRuleByKeyArgs = {
  input: QualityRuleInput;
  key: Scalars['String']['input'];
};


export type MutationEditTicketMonitorSettingsArgs = {
  input: EditTicketMonitorSettingsInput;
};


export type MutationExecuteRefundImmediatelyArgs = {
  input: ExecuteRefundInput;
};


export type MutationGlossaryCreateArgs = {
  input: GlossaryCreateInput;
};


export type MutationGlossaryDeleteArgs = {
  input: GlossaryDeleteInput;
};


export type MutationGlossaryItemCreateArgs = {
  input: GlossaryItemCreateInput;
};


export type MutationGlossaryItemDeleteArgs = {
  input: GlossaryItemDeleteInput;
};


export type MutationGlossaryItemEditArgs = {
  input: GlossaryItemEditInput;
};


export type MutationGlossarySynchronizeArgs = {
  input: GlossarySynchronizeInput;
};


export type MutationLockCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMeetingPointPictureUploadArgs = {
  input: MeetingPointPictureUploadInput;
};


export type MutationMergeLocationsArgs = {
  duplicate_location_id: Scalars['ID']['input'];
  original_location_id: Scalars['ID']['input'];
};


export type MutationMoveReviewByIdArgs = {
  input: ReviewCopyMoveByIdInput;
};


export type MutationMoveReviewByOptionIdArgs = {
  input: ReviewCopyMoveByOptionIdInput;
};


export type MutationMoveTicketsOnSaleArgs = {
  input: MoveTicketsOnSaleInput;
};


export type MutationMoveUnsoldTicketsOnBatchArgs = {
  input: MoveUnsoldTicketsOnBatchInput;
};


export type MutationOverwriteStaffRolesArgs = {
  input: StaffRoleOverwriteInput;
};


export type MutationPerformBookingOperationArgs = {
  input: BookingOperationInput;
};


export type MutationPushForTranslationArgs = {
  input: PushForTranslationInput;
};


export type MutationRecomputeCacheEntriesMutationArgs = {
  input: RecomputeCacheEntriesInput;
};


export type MutationRedeemTicketByCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationRefundBookingArgs = {
  input: RefundBookingInput;
};


export type MutationRefundCouponArgs = {
  input: RefundCouponInput;
};


export type MutationRefundTicketsOnBatchArgs = {
  input: RefundTicketsOnBatchInput;
};


export type MutationReorderTourPicturesArgs = {
  activityId: Scalars['ID']['input'];
  input?: InputMaybe<Array<InputMaybe<ReorderPictureInput>>>;
};


export type MutationReprocessXtmDelayedTourPushArgs = {
  xtmDelayedTourPushId: Scalars['Int']['input'];
};


export type MutationResendBusinessPartnerToSapArgs = {
  resendBusinessPartnerToSapInput: ResendBusinessPartnerToSapInput;
};


export type MutationResendEmailArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationResendSupplierPaymentDetailsChangedEmailArgs = {
  supplierId: Scalars['Int']['input'];
};


export type MutationResendValidationEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetOverwriteStaffRolesArgs = {
  input: StaffRoleOverwriteResetInput;
};


export type MutationResolvePaymentDetailsChangeRequestArgs = {
  resolvePaymentDetailsChangeRequestInput?: InputMaybe<ResolvePaymentDetailsChangeRequestInput>;
};


export type MutationSplitPricingArgs = {
  input: SplitPricingInput;
};


export type MutationSupplierApiRegistrationCompleteArgs = {
  input: SupplierApiRegistrationCompleteInput;
};


export type MutationSupplierBatchUpdateArgs = {
  input: UpdateSupplierBatchInput;
};


export type MutationSupplierBatchUpdateFishfarmArgs = {
  input: UpdateSupplierBatchInput;
};


export type MutationSupplierCancelBookingArgs = {
  input: SupplierCancelBookingInput;
};


export type MutationSupplierCreateArgs = {
  input: CreateSupplierInput;
};


export type MutationSupplierCreateInsuranceInformationArgs = {
  input: CreateSupplierInsuranceInformationInput;
};


export type MutationSupplierDeleteInsuranceInformationArgs = {
  input: DeleteSupplierInsuranceInformationInput;
};


export type MutationSupplierDeleteTermsAndConditionsArgs = {
  input: DeleteTermsAndConditionsInput;
};


export type MutationSupplierEmailActionArgs = {
  input: SupplierEmailInput;
};


export type MutationSupplierInsightUpdateArgs = {
  input: UpdateSupplierInsightInput;
};


export type MutationSupplierPublicEmailActionArgs = {
  input: SupplierPublicEmailInput;
};


export type MutationSupplierReminderEmailActionArgs = {
  input: SupplierReminderEmailInput;
};


export type MutationSupplierTourStatusChangeEmailArgs = {
  input: SupplierTourStatusChangeEmailInput;
};


export type MutationSupplierUpdateArgs = {
  input: UpdateSupplierInput;
};


export type MutationSupplierUpdateEuComplianceArgs = {
  input: UpdateSupplierEuComplianceInput;
};


export type MutationSupplierUpdateFishfarmArgs = {
  input: UpdateSupplierFishfarmInput;
};


export type MutationSupplierUpdateInsuranceInformationArgs = {
  input: UpdateSupplierInsuranceInformationInput;
};


export type MutationSupplierUpdateManagingDirectorArgs = {
  input: Array<InputMaybe<ManagingDirectorInput>>;
};


export type MutationSupplierUpdatePrimaryAccountArgs = {
  input: UpdatePrimaryAccountInput;
};


export type MutationSupplierUpdatePrivacyPolicyArgs = {
  input: UpdatePrivacyPolicyInput;
};


export type MutationSupplierUpdateProfileItemArgs = {
  input: UpdateProfileItemsInput;
};


export type MutationSupplierUpdateStatusChangeActionsArgs = {
  input: UpdateSupplierGygStatusInput;
};


export type MutationSupplierUpdateTermsAndConditionsArgs = {
  input: UpdateTermsAndConditionsInput;
};


export type MutationUnblockAvailabilityByActivityIdsArgs = {
  input: BlockUnblockAvailabilityInput;
};


export type MutationUpdateAvailabilityAndPricingArgs = {
  availabilityBlockId: Scalars['ID']['input'];
  input: AvailabilityAndPricingInput;
  pricingId: Scalars['ID']['input'];
};


export type MutationUpdateAvailabilityBlockArgs = {
  id: Scalars['ID']['input'];
  input: AvailabilityBlockInput;
};


export type MutationUpdateAvailabilityByActivityOptionIdArgs = {
  input: UpdateAvailabilityByActivityOptionIdInput;
};


export type MutationUpdateBillingDetailsArgs = {
  input: UpdateBillingDetailsInput;
};


export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput;
};


export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateConnectivityPartnerSelfMappingArgs = {
  input: UpdateConnectivityPartnerSelfMappingInput;
};


export type MutationUpdateConnectivitySettingsArgs = {
  actionSendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  input: ConnectivitySettingsInput;
  tourOptionId: Scalars['Int']['input'];
};


export type MutationUpdateCouponArgs = {
  input: UpdateCouponInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerAddressArgs = {
  input: UpdateCustomerAddressInput;
};


export type MutationUpdateCustomerCommunicationPreferencesArgs = {
  input: UpdatePermissionInput;
};


export type MutationUpdateDealArgs = {
  input: DealInput;
};


export type MutationUpdateDerivedAttributeConfigurationArgs = {
  input: UpdateDerivedAttributeConfigurationInput;
};


export type MutationUpdateInventoryConfigurationArgs = {
  input: InventoryConfigurationInput;
  tourOptionId: Scalars['ID']['input'];
};


export type MutationUpdateMultipleTimeSlotsArgs = {
  input: TimeSlotUpdateInput;
};


export type MutationUpdatePartnerNotificationArgs = {
  input: UpdatePartnerNotificationInput;
};


export type MutationUpdatePaymentDetailsArgs = {
  paymentDetailsInput: PaymentDetailsInput;
};


export type MutationUpdatePaymentDetailsBankPaymentChannelArgs = {
  paymentDetailsBankPaymentChannelChangeInput: PaymentDetailsBankPaymentChannelChangeInput;
};


export type MutationUpdatePaymentDetailsStatusArgs = {
  paymentDetailsStatusChangeInput: PaymentDetailsStatusChangeInput;
};


export type MutationUpdatePricingArgs = {
  input: PricingInput;
  pricingId: Scalars['ID']['input'];
};


export type MutationUpdateQualityIssueConfigurationArgs = {
  input: UpdateQualityIssueConfigurationInput;
};


export type MutationUpdateRefundArgs = {
  input: UpdateRefundInput;
};


export type MutationUpdateRestrictionConfigurationArgs = {
  input: UpdateRestrictionConfigurationInput;
};


export type MutationUpdateReviewArgs = {
  input: ReviewUpdateInput;
};


export type MutationUpdateReviewStaffIdArgs = {
  input: ReviewUpdateStaffIdInput;
};


export type MutationUpdateShoppingCartArgs = {
  input: UpdateShoppingCartInput;
};


export type MutationUpdateStaffAreaMappingArgs = {
  input: UpdateStaffAreaMappingInput;
};


export type MutationUpdateSupplierPaymentDataStatusArgs = {
  input: UpdateSupplierPaymentDataStatusInput;
};


export type MutationUpdateSupplierPaymentMethodArgs = {
  input: UpdateSupplierPaymentMethodInput;
};


export type MutationUpdateSupplierPaymentSettingsArgs = {
  input: UpdateSupplierPaymentSettingsInput;
};


export type MutationUpdateSupplierReferenceNumberArgs = {
  input: UpdateSupplierReferenceNumberInput;
};


export type MutationUpdateSupplierRequestedAnswerArgs = {
  input: UpdateSupplierRequestedAnswerInput;
};


export type MutationUpdateSupplierTaxDetailsArgs = {
  input: UpdateSupplierTaxationDetailsInput;
};


export type MutationUpdateSuppliersToursCancellationPolicyArgs = {
  input: SuppliersToursCancellationPolicyInput;
};


export type MutationUpdateTagsArgs = {
  input: Array<UpdateTagInput>;
};


export type MutationUpdateTicketConfigurationArgs = {
  input: UpdateTicketConfigurationInput;
};


export type MutationUpdateTicketsOnSaleOnBatchUploadArgs = {
  input: UpdateTicketsOnSaleOnBatchUploadInput;
};


export type MutationUpdateTourPictureArgs = {
  input: UpdatePictureInput;
};

export enum NewTicketSource {
  CodeGenerator = 'CODE_GENERATOR',
  SupplierApi = 'SUPPLIER_API'
}

export type NotificationRecipient = {
  __typename?: 'NotificationRecipient';
  recipient?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OperationResult = {
  /** Error message if the operation fails */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag that indicates the success of the operation */
  success: Scalars['Boolean']['output'];
};

export type OperationResultImpl = OperationResult & {
  __typename?: 'OperationResultImpl';
  /** An additional message about the operation execution */
  message?: Maybe<Scalars['String']['output']>;
  /** True if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type OptionCompleteness = {
  __typename?: 'OptionCompleteness';
  /** Completeness of option-related fields, can be null if no options are present */
  completeness?: Maybe<OptionCompletenessValue>;
  /** Completeness id == option id */
  id: Scalars['ID']['output'];
};

export type OptionCompletenessValue = {
  __typename?: 'OptionCompletenessValue';
  activity_starting_place?: Maybe<CompletenessStatus>;
  availability_type?: Maybe<CompletenessStatus>;
  connectivity_properties?: Maybe<CompletenessStatus>;
  custom_booking_system?: Maybe<CompletenessStatus>;
  cut_off_time?: Maybe<CompletenessStatus>;
  drop_off_description?: Maybe<CompletenessStatus>;
  drop_off_location?: Maybe<CompletenessStatus>;
  drop_off_transportation_types?: Maybe<CompletenessStatus>;
  drop_off_type?: Maybe<CompletenessStatus>;
  group_size_max?: Maybe<CompletenessStatus>;
  group_size_min?: Maybe<CompletenessStatus>;
  languages_audio_guide?: Maybe<CompletenessStatus>;
  languages_booklet?: Maybe<CompletenessStatus>;
  languages_live_guide?: Maybe<CompletenessStatus>;
  meeting_point_description?: Maybe<CompletenessStatus>;
  meeting_point_location?: Maybe<CompletenessStatus>;
  meeting_point_minutes_before?: Maybe<CompletenessStatus>;
  meeting_point_picture?: Maybe<CompletenessStatus>;
  meeting_point_transportation_types?: Maybe<CompletenessStatus>;
  option_checkout_questions?: Maybe<CompletenessStatus>;
  option_code?: Maybe<CompletenessStatus>;
  option_description?: Maybe<CompletenessStatus>;
  option_pricing_category_class?: Maybe<CompletenessStatus>;
  option_title?: Maybe<CompletenessStatus>;
  pick_up_areas?: Maybe<CompletenessStatus>;
  pick_up_confirmation_time?: Maybe<CompletenessStatus>;
  pick_up_description?: Maybe<CompletenessStatus>;
  pick_up_locations?: Maybe<CompletenessStatus>;
  pick_up_minutes_before?: Maybe<CompletenessStatus>;
  pick_up_transportation_types?: Maybe<CompletenessStatus>;
  pick_up_type?: Maybe<CompletenessStatus>;
  private_flag?: Maybe<CompletenessStatus>;
  skip_the_line_type?: Maybe<CompletenessStatus>;
  time_type?: Maybe<CompletenessStatus>;
  time_unit?: Maybe<CompletenessStatus>;
  time_valid_from?: Maybe<CompletenessStatus>;
  time_value?: Maybe<CompletenessStatus>;
  tour_availability_block?: Maybe<CompletenessStatus>;
  tour_pricing?: Maybe<CompletenessStatus>;
  wheelchair_accessible_flag?: Maybe<CompletenessStatus>;
};

/** Response returned when fetching outbound product mapping for an integration */
export type OutboundProductMappingForIntegration = {
  __typename?: 'OutboundProductMappingForIntegration';
  /** Json schema for the outbound product mapping in string format */
  productMappingJson?: Maybe<Scalars['String']['output']>;
};

/** Response returned after validating Supplier provided externalProductId mapping values */
export type OutboundProductMappingValidationResponse = {
  __typename?: 'OutboundProductMappingValidationResponse';
  /** Is the externalProductId mapping valid ? True / False */
  isValid?: Maybe<Scalars['Boolean']['output']>;
  /** If validation fails, errorMessage for the supplier */
  validationErrors?: Maybe<Array<Maybe<ProductIdFieldValidationError>>>;
};

export type OverlappingSchedule = {
  __typename?: 'OverlappingSchedule';
  dateRange: DateRange;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  timeSlot?: Maybe<Scalars['String']['output']>;
};

export enum OvernightStay {
  None = 'NONE',
  WithoutAccommodation = 'WITHOUT_ACCOMMODATION',
  WithAccommodation = 'WITH_ACCOMMODATION'
}

/** Pagination information for search results. */
export type Pagination = {
  __typename?: 'Pagination';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Max number of items to show. */
  limit: Scalars['Int']['output'];
  /** Current selected item offset. */
  offset: Scalars['Int']['output'];
  /** Total number of items. */
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type ParticipantsRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** Entity holding fields relevant for a Partner */
export type Partner = {
  __typename?: 'Partner';
  /** The company name of the Partner */
  companyName?: Maybe<Scalars['String']['output']>;
  /** ISO code for the currency */
  currency: Scalars['String']['output'];
  /** The unique identifier of the Partner */
  id: Scalars['ID']['output'];
  partnerNotifications?: Maybe<Array<PartnerNotification>>;
  /** The most recent payment details for a given currency and status */
  paymentDetails?: Maybe<PaymentDetails>;
  /** Payment details that are or were active for any currency */
  relevantPaymentDetails: Array<PaymentDetails>;
  /** The type of partner */
  type: Scalars['String']['output'];
};


/** Entity holding fields relevant for a Partner */
export type PartnerPaymentDetailsArgs = {
  currency: Scalars['String']['input'];
  statuses?: InputMaybe<Array<PaymentDetailsStatus>>;
};

export type PartnerAdjustmentPayment = {
  __typename?: 'PartnerAdjustmentPayment';
  amount: Money;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  creationDate: Scalars['DateTime']['output'];
  gygComment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  partner: Partner;
  partnerComment?: Maybe<Scalars['String']['output']>;
  partnerId: Scalars['ID']['output'];
  partnerPaymentId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<PartnerAdjustmentPaymentReason>;
  staff?: Maybe<Staff>;
  status: PartnerAdjustmentPaymentStatus;
  subReason?: Maybe<PartnerAdjustmentPaymentSubReason>;
  type: PartnerAdjustmentPaymentType;
};

export enum PartnerAdjustmentPaymentReason {
  CareFlaw = 'CARE_FLAW',
  DestinationManagerFlaw = 'DESTINATION_MANAGER_FLAW',
  GygSystemError = 'GYG_SYSTEM_ERROR',
  PartnerFlaw = 'PARTNER_FLAW'
}

export type PartnerAdjustmentPaymentSearch = {
  __typename?: 'PartnerAdjustmentPaymentSearch';
  items: Array<PartnerAdjustmentPayment>;
  pagination: Pagination;
  totalItems: Scalars['Int']['output'];
};

export enum PartnerAdjustmentPaymentStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export enum PartnerAdjustmentPaymentSubReason {
  CommissionAdjustment = 'COMMISSION_ADJUSTMENT',
  RetailRateAdjustment = 'RETAIL_RATE_ADJUSTMENT'
}

export enum PartnerAdjustmentPaymentType {
  Adjustment = 'ADJUSTMENT',
  ManualPartnerAdjustment = 'MANUAL_PARTNER_ADJUSTMENT'
}

export type PartnerExample = {
  __typename?: 'PartnerExample';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PartnerNotification = {
  __typename?: 'PartnerNotification';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notificationType: PartnerNotificationType;
  partnerId: Scalars['ID']['output'];
};

export enum PartnerNotificationType {
  Accounting = 'ACCOUNTING',
  Booking = 'BOOKING',
  StatisticsDaily = 'STATISTICS_DAILY',
  StatisticsMonthly = 'STATISTICS_MONTHLY',
  StatisticsWeekly = 'STATISTICS_WEEKLY',
  Technical = 'TECHNICAL'
}

export type Payment = {
  /** The amount of the payment */
  amount: Scalars['Float']['output'];
  /** Any comments about the payment */
  comment?: Maybe<Scalars['String']['output']>;
  /** The compound entry id representing the payment */
  compoundEntryId: Scalars['String']['output'];
  /** The currency ISO code of the payment */
  currencyIsoCode: Scalars['String']['output'];
  /** The date that the payment was conducted */
  dateOfPayment: Scalars['DateTime']['output'];
  /** The reason the payment failed, if there was a failure */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The staff id that triggered the payment */
  gygStaffId: Scalars['Int']['output'];
  /** The note that we issue to the payee */
  noteToPayee: Scalars['String']['output'];
  /** The payment channel that the payment went through */
  paymentChannel?: Maybe<PaymentChannel>;
  /** The ID representation of the payment */
  paymentId: Scalars['ID']['output'];
  /** The status of the payment */
  status: PaymentStatus;
};

/** Enum representing different channels used for payments */
export enum PaymentChannel {
  Afex = 'AFEX',
  Hyperwallet = 'HYPERWALLET',
  Paypal = 'PAYPAL',
  UnicreditForeignPayment = 'UNICREDIT_FOREIGN_PAYMENT',
  UnicreditSepa = 'UNICREDIT_SEPA'
}

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  /** ID of the associated business partner */
  businessPartnerId: Scalars['Int']['output'];
  /** Type of the associated business partner */
  businessPartnerType: BusinessPartnerType;
  /** ISO code for the currency */
  currency: Scalars['String']['output'];
  /** Flag indicating if the payment details are valid on the SAP Validation */
  isSapValid: Scalars['Boolean']['output'];
  /** Type of payment channel (e.g. AFEX, UNICREDIT_SEPA, UNICREDIT_FOREIGN_PAYMENT, PAYPAL, HYPERWALLET) */
  paymentChannel?: Maybe<PaymentChannel>;
  /** Type of payment (e.g., BANK, PAYPAL) */
  paymentMethod: PaymentMethodType;
  /** Detailed data about the payment method */
  paymentMethodDetails: PaymentMethodDetails;
  /** Status of the payment details */
  status: PaymentDetailsStatus;
  /** Update timestamp of the payment details */
  updateTimestamp: Scalars['DateTime']['output'];
  /** Update user ID */
  updateUserId?: Maybe<Scalars['Int']['output']>;
  /** Update user type, e.g. STAFF, SUPPLIER, RESELLER, CUSTOMER, CRON_JOB */
  updateUserType?: Maybe<UpdateUserType>;
  /** Unique identifier for the payment details */
  uuid: Scalars['ID']['output'];
};

export type PaymentDetailsBankPaymentChannelChangeError = {
  __typename?: 'PaymentDetailsBankPaymentChannelChangeError';
  error?: Maybe<PaymentDetailsBankPaymentChannelChangeErrorType>;
};

export enum PaymentDetailsBankPaymentChannelChangeErrorType {
  /** The payment details method is not a bank */
  PaymentDetailsNotBank = 'PAYMENT_DETAILS_NOT_BANK',
  /** The payment details are not found */
  PaymentDetailsNotFound = 'PAYMENT_DETAILS_NOT_FOUND',
  /** Unknown error */
  UnknownError = 'UNKNOWN_ERROR'
}

export type PaymentDetailsBankPaymentChannelChangeInput = {
  /** Type of payment channel (e.g. AFEX, UNICREDIT_SEPA, UNICREDIT_FOREIGN_PAYMENT, PAYPAL, HYPERWALLET) */
  paymentChannel?: InputMaybe<PaymentChannel>;
  /** Unique identifier for the payment details */
  uuid: Scalars['ID']['input'];
};

export type PaymentDetailsBankPaymentChannelChangeResponse = PaymentDetailsBankPaymentChannelChangeError | PaymentDetailsBankPaymentChannelChangeSuccess;

export type PaymentDetailsBankPaymentChannelChangeSuccess = {
  __typename?: 'PaymentDetailsBankPaymentChannelChangeSuccess';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentDetailsChangeRequest = {
  __typename?: 'PaymentDetailsChangeRequest';
  /** The current active payment details */
  activePaymentDetails?: Maybe<PaymentDetails>;
  /** The new payment details */
  newPaymentDetails: PaymentDetails;
};

/** Enum representing the type of action that the mutation will resolve */
export enum PaymentDetailsChangeRequestActionInput {
  /** Choice for accepting the token */
  Accept = 'ACCEPT',
  /** Choice for rejecting the token */
  Reject = 'REJECT'
}

export type PaymentDetailsChangeRequestError = {
  __typename?: 'PaymentDetailsChangeRequestError';
  error?: Maybe<PaymentDetailsChangeRequestErrorType>;
};

export enum PaymentDetailsChangeRequestErrorType {
  /** The change request token is not found */
  ChangeRequestNotFound = 'CHANGE_REQUEST_NOT_FOUND',
  /** The change request token is invalid */
  ChangeRequestTokenInvalid = 'CHANGE_REQUEST_TOKEN_INVALID',
  /** Unknown error */
  UnknownError = 'UNKNOWN_ERROR'
}

export type PaymentDetailsChangeRequestInput = {
  /** ID of the associated business partner */
  businessPartnerKey: BusinessPartnerKeyInput;
  /** The change request token */
  changeRequestToken: Scalars['String']['input'];
  /** The currency of the payment details */
  currency: Scalars['String']['input'];
};

export type PaymentDetailsChangeRequestResponse = PaymentDetailsChangeRequest | PaymentDetailsChangeRequestError;

export type PaymentDetailsChangeRequestSuccess = {
  __typename?: 'PaymentDetailsChangeRequestSuccess';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentDetailsField = {
  __typename?: 'PaymentDetailsField';
  description?: Maybe<Scalars['String']['output']>;
  fieldId: PaymentDetailsFieldId;
  fieldName: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  requirementLevel: PaymentDetailsFieldRequirementLevel;
  validation?: Maybe<Validation>;
};

export enum PaymentDetailsFieldId {
  AccountNumber = 'ACCOUNT_NUMBER',
  AccountType = 'ACCOUNT_TYPE',
  BeneficiaryName = 'BENEFICIARY_NAME',
  Iban = 'IBAN',
  IntermediateBank = 'INTERMEDIATE_BANK',
  LegacyBankAddress = 'LEGACY_BANK_ADDRESS',
  LegacyBankCity = 'LEGACY_BANK_CITY',
  LegacyBankName = 'LEGACY_BANK_NAME',
  LegacyBankZip = 'LEGACY_BANK_ZIP',
  LegacyPaymentReference = 'LEGACY_PAYMENT_REFERENCE',
  LegacyRoutingNumber = 'LEGACY_ROUTING_NUMBER',
  NationalId = 'NATIONAL_ID',
  SwiftBic = 'SWIFT_BIC'
}

export enum PaymentDetailsFieldRequirementLevel {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type PaymentDetailsInfo = {
  __typename?: 'PaymentDetailsInfo';
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PaymentDetailsInput = {
  /** The bank details of the payment details */
  bankDetails?: InputMaybe<BankDetailsInput>;
  /** ID of the associated business partner */
  businessPartnerKey: BusinessPartnerKeyInput;
  /** The currency of the payment details */
  currency: Scalars['String']['input'];
  /** The Paypal details of the payment details */
  paypalDetails?: InputMaybe<PaypalDetailsInput>;
};

export type PaymentDetailsOld = {
  __typename?: 'PaymentDetailsOld';
  active: Scalars['Boolean']['output'];
  currencyId: Scalars['Int']['output'];
  information?: Maybe<Array<Maybe<PaymentDetailsInfo>>>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Enum representing different statuses for approval */
export enum PaymentDetailsStatus {
  Active = 'ACTIVE',
  AwaitingBusinessPartnerConfirmation = 'AWAITING_BUSINESS_PARTNER_CONFIRMATION',
  AwaitingFinanceConfirmation = 'AWAITING_FINANCE_CONFIRMATION',
  Invalid = 'INVALID'
}

export type PaymentDetailsStatusChangeError = {
  __typename?: 'PaymentDetailsStatusChangeError';
  error?: Maybe<PaymentDetailsStatusChangeErrorType>;
};

export enum PaymentDetailsStatusChangeErrorType {
  /** The payment details are not found */
  PaymentDetailsNotFound = 'PAYMENT_DETAILS_NOT_FOUND',
  /** Unknown error */
  UnknownError = 'UNKNOWN_ERROR'
}

export type PaymentDetailsStatusChangeInput = {
  /** Status of the payment details */
  status: PaymentDetailsStatus;
  /** Unique identifier for the payment details */
  uuid: Scalars['ID']['input'];
};

export type PaymentDetailsStatusChangeResponse = PaymentDetailsStatusChangeError | PaymentDetailsStatusChangeSuccess;

export type PaymentDetailsStatusChangeSuccess = {
  __typename?: 'PaymentDetailsStatusChangeSuccess';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentDetailsValidationInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType: Scalars['String']['input'];
  bankCountry: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  nationalId?: InputMaybe<Scalars['String']['input']>;
  supplierCountry: Scalars['String']['input'];
  supplierCurrency: Scalars['String']['input'];
  swiftCode?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

/** Type representing different payment details data */
export type PaymentMethodDetails = {
  __typename?: 'PaymentMethodDetails';
  bankDetails?: Maybe<BankDetails>;
  hyperwalletDetails?: Maybe<HyperwalletDetails>;
  paypalDetails?: Maybe<PaypalDetails>;
};

/** Enum representing different payment methods */
export enum PaymentMethodType {
  Bank = 'BANK',
  Hyperwallet = 'HYPERWALLET',
  Paypal = 'PAYPAL'
}

export type PaymentOperationYearsInput = {
  businessPartnerKey: BusinessPartnerKeyInput;
  financialOperation?: InputMaybe<FinancialOperation>;
};

export enum PaymentStatus {
  /** Deleted means that for all intends and purposes this payment is not relevant for our systems */
  Deleted = 'DELETED',
  /** Executed means that the the payment was carried out */
  Executed = 'EXECUTED',
  /** Failed means that the payment failed */
  Failed = 'FAILED',
  /** In progress means that the payment was sent and is in progress to be paid-out */
  InProgress = 'IN_PROGRESS',
  /** Manual means that the payment was generated manually */
  Manual = 'MANUAL',
  /** Pending means that the payment was generated and is pending to be sent */
  Pending = 'PENDING'
}

export type PaypalDetails = {
  __typename?: 'PaypalDetails';
  /** ISO code for the country of the PayPal account holder */
  country?: Maybe<Scalars['String']['output']>;
  /** Email associated with the PayPal account */
  email: Scalars['String']['output'];
};

export type PaypalDetailsInput = {
  paypalAccountCountry: Scalars['String']['input'];
  paypalEmail: Scalars['String']['input'];
};

/** Type holding phone number relevant fields */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  /** The phone number */
  number: Scalars['String']['output'];
  /** The phone number prefix (example: +1, +41) */
  prefix: Scalars['String']['output'];
};

export type PhoneNumberInput = {
  number: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type PickUp = {
  __typename?: 'PickUp';
  /**
   * Defines the possible areas in which a traveler can get picked up from any hotel or address.
   * In contrast to 'PickUp.locations' these values are supposed to mark a greater area instead of a precise location
   * (i.e. anywhere in Brooklyn, NY).
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   * This value has a meaning only if 'PickUp.pickUpType' is set to 'FROM_AREAS'.
   */
  areas?: Maybe<Array<LogisticsLocation>>;
  /**
   * Defines how the pickup will be confirmed by the supplier.
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   */
  confirmationType?: Maybe<PickUpConfirmationType>;
  /**
   * Defines the specific locations a traveler can get picked up from.
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   * This value has a meaning only if 'PickUp.pickUpType' is set to 'FROM_LOCATIONS'.
   */
  locations?: Maybe<Array<LogisticsLocation>>;
  /**
   * The supplier will pick up the traveler before the activity starts.
   * This value will tell how long before it starts (in minutes).
   * The values is interpreted as a max.
   * This means the supplier will pick up the traveler 0 - [value] minutes before the activity starts.
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   */
  minutesBefore?: Maybe<Scalars['Int']['output']>;
  /**
   * Defines how the traveler can be picked up.
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   */
  pickUpType?: Maybe<PickUpType>;
  transportationTypes?: Maybe<Array<TransportationType>>;
};

export enum PickUpConfirmationType {
  ActivityStart = 'ACTIVITY_START',
  DayBeforePickUp = 'DAY_BEFORE_PICK_UP',
  DayFromPurchase = 'DAY_FROM_PURCHASE',
  TravelerContactsSupplier = 'TRAVELER_CONTACTS_SUPPLIER'
}

export type PickUpInput = {
  /**
   * Defines the possible areas in which a traveler can get picked up from any hotel or address.
   * In contrast to 'PickUp.locations' these values are supposed to mark a greater area instead of a precise location
   * (i.e. anywhere in Brooklyn, NY).
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   * This value has a meaning only if 'PickUp.pickUpType' is set to 'FROM_AREAS'.
   */
  areas?: InputMaybe<Array<LogisticsLocationInput>>;
  /**
   * Defines how the pickup will be confirmed by the supplier.
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   */
  confirmationType?: InputMaybe<PickUpConfirmationType>;
  /**
   * Defines the specific locations a traveler can get picked up from.
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   * This value has a meaning only if 'PickUp.pickUpType' is set to 'FROM_LOCATIONS'.
   */
  locations?: InputMaybe<Array<LogisticsLocationInput>>;
  /**
   * The supplier will pick up the traveler before the activity starts.
   * This value will tell how long before it starts (in minutes).
   * The values is interpreted as a max.
   * This means the supplier will pick up the traveler 0 - [value] minutes before the activity starts.
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   */
  minutesBefore?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Defines how the traveler can be picked up.
   * This value has a meaning only if 'ActivityOption.startingPlaceType' is set to either 'PICK_UP'
   * or 'MEETING_POINT_PICK_UP'.
   */
  pickUpType?: InputMaybe<PickUpType>;
  transportationTypes?: InputMaybe<Array<TransportationTypeInput>>;
};

export enum PickUpType {
  DoNotUse = 'DO_NOT_USE',
  /**
   * From any hotel or address in the city/location.
   * If this is the value, then a value for 'PickUp.areas' should be set.
   */
  FromAreas = 'FROM_AREAS',
  /**
   * From a list of certain hotels, addresses, airports or other pickup points.
   * If this is the value, then a value for 'PickUp.locations' should be set.
   */
  FromLocations = 'FROM_LOCATIONS'
}

export type PictureInsight = {
  __typename?: 'PictureInsight';
  insight?: Maybe<Scalars['String']['output']>;
  tour_picture_id?: Maybe<Scalars['ID']['output']>;
};

export type PictureMutationPayload = {
  __typename?: 'PictureMutationPayload';
  /** All errors related to the operation */
  errors?: Maybe<Array<Error>>;
  /**
   * Can only be true in case of a 409 Conflict exception.
   * Indicates whether this picture has already been uploaded for the same tour.
   */
  isDuplicate?: Maybe<Scalars['Boolean']['output']>;
  /** The returned picture if it was created/updated */
  picture?: Maybe<ActivityPicture>;
  /** Whether the operation was successful or not */
  success: Scalars['Boolean']['output'];
};

export type PriceOverride = {
  __typename?: 'PriceOverride';
  /** The date ranges for which the override will be applied */
  dateRanges?: Maybe<Array<DateRange>>;
  /** The unique identifier of the override */
  id: Scalars['ID']['output'];
  /** The name of the price override */
  name: Scalars['String']['output'];
  /** The prices per category that will be applied instead of the default pricing */
  pricingPrices?: Maybe<Array<PriceOverridePrices>>;
};

export type PriceOverrideInput = {
  dateRanges: Array<InventoryDateRangeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  pricingPrices?: InputMaybe<Array<PriceOverridePricesInput>>;
};

export type PriceOverridePrices = {
  __typename?: 'PriceOverridePrices';
  /** @deprecated Field is deprecated. Use prices.breakagePrice instead. */
  breakagePrice?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Field is deprecated. Use prices.netRatePrice instead. */
  netRatePrice?: Maybe<Scalars['Float']['output']>;
  prices: PriceOverridePricingPricePrices;
  pricingCategoryId: Scalars['ID']['output'];
  pricingId: Scalars['ID']['output'];
  pricingScale: PriceOverridePricingScale;
  pricingScaleId: Scalars['ID']['output'];
  /** @deprecated Field is deprecated. Use prices.retailPrice instead. */
  retailPrice: Scalars['Float']['output'];
  /** @deprecated Field is deprecated. Use prices.returnPrice instead. */
  returnPrice?: Maybe<Scalars['Float']['output']>;
};

export type PriceOverridePricesInput = {
  /** @deprecated Field is deprecated. Use prices.breakagePrice instead. */
  breakagePrice?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Field is deprecated. Use prices.netRatePrice instead. */
  netRatePrice?: InputMaybe<Scalars['Float']['input']>;
  prices?: InputMaybe<PriceOverridePricingPricePricesInput>;
  pricingCategoryId: Scalars['ID']['input'];
  pricingId: Scalars['ID']['input'];
  pricingScaleId: Scalars['ID']['input'];
  retailPrice: Scalars['Float']['input'];
  /** @deprecated Field is deprecated. Use prices.returnPrice instead. */
  returnPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceOverridePricingPricePrices = PricesInterface & {
  __typename?: 'PriceOverridePricingPricePrices';
  /** The price GYG will incur on just receiving (changement of ownership) the ticket */
  breakagePrice?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier of a prices */
  id?: Maybe<Scalars['ID']['output']>;
  /** The final price customer will pay in a non-commission model */
  netRatePrice?: Maybe<Scalars['Float']['output']>;
  /** The price charged to GYG's customer excluding discounts */
  retailPrice: Scalars['Float']['output'];
  /** The price GYG will pay if the ticket is returned to the supplier */
  returnPrice?: Maybe<Scalars['Float']['output']>;
};

export type PriceOverridePricingPricePricesInput = {
  /** The price GYG will incur on just receiving (changement of ownership) the ticket */
  breakagePrice?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of a prices */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The final price customer will pay in a non-commission model */
  netRatePrice?: InputMaybe<Scalars['Float']['input']>;
  /** The price charged to GYG's customer excluding discounts */
  retailPrice: Scalars['Float']['input'];
  /** The price GYG will pay if the ticket is returned to the supplier */
  returnPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceOverridePricingScale = {
  __typename?: 'PriceOverridePricingScale';
  id: Scalars['ID']['output'];
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  minParticipants?: Maybe<Scalars['Int']['output']>;
};

export type Prices = PricesInterface & {
  __typename?: 'Prices';
  /** The price GYG will incur on just receiving (changement of ownership) the ticket */
  breakagePrice?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier of a prices */
  id?: Maybe<Scalars['ID']['output']>;
  /** The final price customer will pay in a non-commission model */
  netRatePrice?: Maybe<Scalars['Float']['output']>;
  /** The price charged to GYG's customer excluding discounts */
  retailPrice?: Maybe<Scalars['Float']['output']>;
  /** The price GYG will pay if the ticket is returned to the supplier */
  returnPrice?: Maybe<Scalars['Float']['output']>;
};

export type PricesInput = {
  /** The price GYG will incur on just receiving (changement of ownership) the ticket */
  breakagePrice?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of a prices */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The final price customer will pay in a non-commission model */
  netRatePrice?: InputMaybe<Scalars['Float']['input']>;
  /** The price charged to GYG's customer excluding discounts */
  retailPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The price GYG will pay if the ticket is returned to the supplier */
  returnPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PricesInterface = {
  /** The price GYG will incur on just receiving (changement of ownership) the ticket */
  breakagePrice?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier of a prices */
  id?: Maybe<Scalars['ID']['output']>;
  /** The final price customer will pay in a non-commission model */
  netRatePrice?: Maybe<Scalars['Float']['output']>;
  /** The price charged to GYG's customer excluding discounts */
  retailPrice?: Maybe<Scalars['Float']['output']>;
  /** The price GYG will pay if the ticket is returned to the supplier */
  returnPrice?: Maybe<Scalars['Float']['output']>;
};

/** Response returned when fetching pricing categories */
export type PricingCategoriesResponse = {
  __typename?: 'PricingCategoriesResponse';
  pricingCategories?: Maybe<Array<Maybe<CategoryConfiguration>>>;
};

export type PricingCategory = {
  /** The commission rate set to a pricing category */
  commissionRate?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier of a pricing category */
  id?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the pricing related to the category */
  pricingId?: Maybe<Scalars['ID']['output']>;
  /** The pricing scales for a pricing category */
  pricingScales?: Maybe<Array<PricingScale>>;
  /** The commission rate applied to a pricing category */
  resolvedCommissionRate?: Maybe<Scalars['Float']['output']>;
};

export enum PricingCategoryBookingType {
  Free = 'free',
  FreeNoTicket = 'free_no_ticket',
  NotPermitted = 'not_permitted',
  Standard = 'standard'
}

export type PricingCategoryInput = {
  /** The min and max age for a pricing category */
  ageRange?: InputMaybe<AgeRangeInput>;
  /** Flag indicating if a pricing category can be booked indepdently from other categories */
  bookIndependently?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates the booking type for the category */
  bookingType?: InputMaybe<Scalars['String']['input']>;
  /** The commission rate applied to a pricing category */
  commissionRate?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of a pricing category */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** For group pricing, states that the category is just an extension for extra pax */
  isAdditionalPaxForGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifier of the pricing related to the category */
  pricingId?: InputMaybe<Scalars['ID']['input']>;
  /** The pricing scales for a pricing category */
  pricingScales?: InputMaybe<Array<PricingScaleInput>>;
  /** Category of the group (Infant, Child, Adult, etc.) */
  ticketCategory?: InputMaybe<Scalars['String']['input']>;
};

export type PricingInput = {
  /** Activity Id which relates to the pricing */
  activityId: Scalars['ID']['input'];
  /** Activity Option Id which relates to the pricing */
  activityOptionId: Scalars['ID']['input'];
  /** List with the Addons */
  addons?: InputMaybe<Array<AddonInput>>;
  /** Maximum number of group vacancies per time slot */
  groupVacanciesPerTimeSlot?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of vacancies for a timeslot */
  maxIndividualParticipantsPerTimeSlot?: InputMaybe<Scalars['Int']['input']>;
  /** Descriptive name for the pricing */
  name: Scalars['String']['input'];
  /** Range of participants who can join the tour */
  participantsRange?: InputMaybe<ParticipantsRangeInput>;
  /** List with the Pricing Categories */
  pricingCategories?: InputMaybe<Array<PricingCategoryInput>>;
  /** Information on the type of pricing, wether individual or group */
  pricingType: PricingType;
};

export type PricingParticipants = {
  __typename?: 'PricingParticipants';
  /** The max participants for every booking */
  max?: Maybe<Scalars['Int']['output']>;
  /** The min participants per booking or first booking only */
  min?: Maybe<Scalars['Int']['output']>;
};

export type PricingPayload = {
  __typename?: 'PricingPayload';
  /** The created Pricing */
  activityOptionPricing?: Maybe<ActivityOptionPricing>;
  /** Message with details of the error, if the creation fails */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag that indicates if the Pricing was created */
  success: Scalars['Boolean']['output'];
};

export type PricingScale = {
  __typename?: 'PricingScale';
  /** The unique identifier of a pricing scale */
  id?: Maybe<Scalars['ID']['output']>;
  /** The maximum number of participants for a pricing scale */
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  /** The minimum number of participants for a pricing scale */
  minParticipants?: Maybe<Scalars['Int']['output']>;
  /** The prices set per pricing scale */
  prices: Prices;
};

export type PricingScaleInput = {
  /** The unique identifier of a pricing scale */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The maximum number of participants for a pricing scale */
  maxParticipants?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum number of participants for a pricing scale */
  minParticipants?: InputMaybe<Scalars['Int']['input']>;
  /** The prices set per pricing scale */
  prices?: InputMaybe<PricesInput>;
};

export type PricingToAvailabilityBlock = {
  __typename?: 'PricingToAvailabilityBlock';
  activityOption?: Maybe<ActivityOption>;
  activityOptionPricing?: Maybe<ActivityOptionPricing>;
  availabilityBlock?: Maybe<AvailabilityBlock>;
  id: Scalars['ID']['output'];
};

export type PricingToAvailabilityBlockSearch = {
  __typename?: 'PricingToAvailabilityBlockSearch';
  items: Array<PricingToAvailabilityBlock>;
  pagination: Pagination;
};

export enum PricingType {
  Group = 'group',
  Individual = 'individual'
}

export type Product = {
  __typename?: 'Product';
  /** Product ID as found in the external partner API */
  productId?: Maybe<Scalars['String']['output']>;
  /** Product title as found in the external partner API */
  productTitle?: Maybe<Scalars['String']['output']>;
};

export type ProductAddon = {
  __typename?: 'ProductAddon';
  currencyISOCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  retailPrice: Scalars['Float']['output'];
};

export type ProductConfiguration = {
  __typename?: 'ProductConfiguration';
  /** Used to set the participants configuration of a product */
  participantsConfiguration?: Maybe<ProductDetailsParticipantsConfiguration>;
};

/** Successful Product Details Response */
export type ProductDetails = {
  __typename?: 'ProductDetails';
  configuration?: Maybe<ProductConfiguration>;
  destinationLocation?: Maybe<DestinationLocation>;
  /** The description of the product in your system. Must be between 100 and 200 characters long. */
  productDescription?: Maybe<Scalars['String']['output']>;
  /** The title of the product in your system. Max 512 characters. */
  productTitle?: Maybe<Scalars['String']['output']>;
};

/** Used to set the participants configuration of a product */
export type ProductDetailsParticipantsConfiguration = {
  __typename?: 'ProductDetailsParticipantsConfiguration';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

/** Validation Error Item with fieldName that failed validation and the errorMessage */
export type ProductIdFieldValidationError = {
  __typename?: 'ProductIdFieldValidationError';
  /** Validation Error message for the field */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Product ID field name */
  fieldName?: Maybe<Scalars['String']['output']>;
};

/** Response returned when fetching external products from a supplier */
export type ProductsFromExternalSupplier = {
  __typename?: 'ProductsFromExternalSupplier';
  /** Supplier ID as found in the external partner API */
  externalSupplierId?: Maybe<Scalars['String']['output']>;
  /** List of products associated with the supplier */
  products?: Maybe<Array<Maybe<Product>>>;
  /** Name of the supplier */
  supplierName?: Maybe<Scalars['String']['output']>;
};

export enum ProfileItemTypeEnum {
  Company = 'company',
  CompanySizeEmployees = 'company_size_employees',
  CompanySizeMonthlyBookings = 'company_size_monthly_bookings',
  GetToKnowGyg = 'get_to_know_gyg',
  OperationalLocations = 'operational_locations',
  Services = 'services',
  SupplierProfileWeb = 'supplier_profile_web'
}

export type ProfileItemValueEntry = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum PublicEmailTypeEnum {
  RegistrationConfirmation = 'REGISTRATION_CONFIRMATION'
}

export type PushForTranslationInput = {
  /** Ids of activity to be translated */
  activityIds: Array<Scalars['Int']['input']>;
  /** Activity fields to translate */
  fieldsToTranslate: Array<ActivityField>;
  /** Ids of languages to translate to */
  languageIds: Array<Scalars['Int']['input']>;
  /** Whether to translate all languages or only the ones that are already translated */
  onlyExistingTranslations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of translation */
  translationType: TranslationType;
};

export type PushForTranslationPayload = {
  __typename?: 'PushForTranslationPayload';
  /** Whether the push was successful */
  success: Scalars['Boolean']['output'];
};

/** Object representing a single quality issue */
export type QualityIssue = {
  __typename?: 'QualityIssue';
  /** The team currently assigned to the issue */
  assignedTeam?: Maybe<QualityTeam>;
  /** The issue's assignee */
  assignee: QualityUser;
  /** The list of attributes that are associated with this issue */
  attributes: Array<QualityIssueAttribute>;
  /** The list of comments made about this issue */
  comments: Array<QualityIssueComment>;
  /** The creation timestamp */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The issue's creator */
  creator: QualityUser;
  /** The list of entities that are associated with this issue */
  entities: Array<QualityIssueEntity>;
  /** The unique identifier of the issue */
  id: Scalars['ID']['output'];
  /** The rule to which this issue belongs */
  rule: QualityRule;
  /** The issue's state */
  state: QualityIssueState;
  /** The issue's status */
  status: QualityIssueStatus;
  /** The update timestamp */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type QualityIssueAdminSearchResultItem = {
  __typename?: 'QualityIssueAdminSearchResultItem';
  /** The id of the user assigned to the issue */
  assigneeId?: Maybe<Scalars['Int']['output']>;
  /** The type of user assigned to the issue */
  assigneeType?: Maybe<Scalars['String']['output']>;
  /** The country iso code associated with the issue */
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  /** When the issue was created */
  creationTimestamp?: Maybe<Scalars['String']['output']>;
  /** The id of the user who created the issue */
  creationUserId?: Maybe<Scalars['Int']['output']>;
  /** The type of user who created the issue */
  creationUserType?: Maybe<Scalars['String']['output']>;
  /** The id of the issue's entity */
  entityId?: Maybe<Scalars['Int']['output']>;
  /** The name of the issue's entity */
  entityName?: Maybe<Scalars['String']['output']>;
  /** Whether or not the issue is within a top 250 location */
  inTop250?: Maybe<Scalars['Boolean']['output']>;
  /** The issue id */
  issueId: Scalars['Int']['output'];
  /** The localized language associated with the issue */
  localisedLanguage?: Maybe<Scalars['String']['output']>;
  /** The location id associated with the issue */
  locationId?: Maybe<Scalars['Int']['output']>;
  /** The net revenue associated with the issue */
  netRevenue?: Maybe<Scalars['Float']['output']>;
  /** The issue priority (inherited from its rule) */
  priority?: Maybe<QualityRulePriority>;
  /** The id of the issue's rule */
  ruleId?: Maybe<Scalars['Int']['output']>;
  /** The key of the issue's rule */
  ruleKey?: Maybe<Scalars['String']['output']>;
  /** The name of the issue's rule */
  ruleName?: Maybe<Scalars['String']['output']>;
  /** The issue source (e.g. automatic, manual, etc.) */
  source?: Maybe<Scalars['String']['output']>;
  /** The issue state */
  stateName: QualityIssueState;
  /** The team assigned to resolve this issue */
  team?: Maybe<Scalars['String']['output']>;
};

/** An attribute related to QualityIssue, represented as a key-value pair */
export type QualityIssueAttribute = {
  __typename?: 'QualityIssueAttribute';
  /** The name of the attribute */
  name: Scalars['String']['output'];
  /** The attribute's value */
  value?: Maybe<Scalars['String']['output']>;
};

export type QualityIssueAttributeInput = {
  /** The name of the attribute */
  name: Scalars['String']['input'];
  /** The attribute's value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Object representing a single quality issue comment */
export type QualityIssueComment = {
  __typename?: 'QualityIssueComment';
  /** The commenter */
  commenter: QualityUser;
  /** The creation timestamp */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The comment text */
  text: Scalars['String']['output'];
  /** The update timestamp */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type QualityIssueCommentInput = {
  /** The commenter */
  commenter: QualityUserInput;
  /** The creation timestamp */
  creationTimestamp?: InputMaybe<Scalars['String']['input']>;
  /** The comment text */
  text: Scalars['String']['input'];
  /** The update timestamp */
  updateTimestamp?: InputMaybe<Scalars['String']['input']>;
};

export type QualityIssueConfiguration = {
  __typename?: 'QualityIssueConfiguration';
  /** Rules that are available for selection for the given entity type. */
  availableRules: Array<RulesEngineRule>;
  /** When the attribute was created. */
  creationTime?: Maybe<Scalars['DateTime']['output']>;
  /** If the attribute is enabled or not. */
  enabled: Scalars['Boolean']['output'];
  /** Which entity to consider as context. */
  entityType: Scalars['String']['output'];
  /** Unique identified of the attribute. */
  id: Scalars['ID']['output'];
  /** The field name to store the value in the provided entityType. */
  internalName: Scalars['String']['output'];
  /** The last time this attribute was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this attribute. */
  lastModificationUser?: Maybe<User>;
  /** Name of the attribute to show in the UI. */
  name: Scalars['String']['output'];
  /** Order in which the attribute is evaluated. */
  order: Scalars['Int']['output'];
  /** Rules that define if this attribute should be evaluated. */
  rules: Array<RulesEngineRuleItem>;
};

export type QualityIssueConfigurationInput = {
  entityType: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rules: Array<RulesEngineRuleItemInput>;
};

export type QualityIssueConfigurationPreview = {
  __typename?: 'QualityIssueConfigurationPreview';
  items?: Maybe<Array<QualityIssueConfigurationPreviewItem>>;
};

export type QualityIssueConfigurationPreviewInput = {
  /** The preview configuration to be evaluated. */
  configuration: QualityIssueConfigurationInput;
  /** Entity ids to check against, if not provided will use a predefined list. */
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QualityIssueConfigurationPreviewItem = {
  __typename?: 'QualityIssueConfigurationPreviewItem';
  check: Scalars['Boolean']['output'];
  entityId: Scalars['ID']['output'];
};

export type QualityIssueConfigurationSearch = {
  __typename?: 'QualityIssueConfigurationSearch';
  items: Array<QualityIssueConfiguration>;
  pagination: Pagination;
};

/** Object used as a reference to an entity */
export type QualityIssueEntity = {
  __typename?: 'QualityIssueEntity';
  /** The unique identifier of the entity */
  entityId: Scalars['Int']['output'];
  /** The type of entity */
  entityType: Scalars['String']['output'];
};

export type QualityIssueEntityInput = {
  /** The unique identifier of the entity */
  entityId: Scalars['Int']['input'];
  /** The type of entity */
  entityType: Scalars['String']['input'];
};

export type QualityIssueInput = {
  /** The team currently assigned to the issue */
  assignedTeam?: InputMaybe<QualityTeamInput>;
  /** The issue's assignee */
  assignee?: InputMaybe<QualityUserInput>;
  /** The list of attributes that are associated with this issue */
  attributes?: InputMaybe<Array<QualityIssueAttributeInput>>;
  /** The list of comments made about this issue */
  comments?: InputMaybe<Array<QualityIssueCommentInput>>;
  /** The issue's creator */
  creator?: InputMaybe<QualityUserInput>;
  /** The list of entities that are associated with this issue */
  entities?: InputMaybe<Array<QualityIssueEntityInput>>;
  /** The rule to which this issue belongs */
  rule: QualityRuleInput;
  /** The issue's state */
  state?: InputMaybe<QualityIssueState>;
  /** The issue's status */
  status?: InputMaybe<QualityIssueStatus>;
};

export enum QualityIssueState {
  InProgress = 'IN_PROGRESS',
  Reopened = 'REOPENED',
  Resolved = 'RESOLVED',
  Silenced = 'SILENCED',
  Todo = 'TODO'
}

export enum QualityIssueStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

/** Object representing a quality rule  */
export type QualityRule = {
  __typename?: 'QualityRule';
  /** The default team assigned to issues of this rule */
  defaultTeam?: Maybe<QualityTeam>;
  /** The description of the rule */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the rule */
  id: Scalars['ID']['output'];
  /** The unique key used to identify the rule */
  key: Scalars['String']['output'];
  /** The name of the rule */
  name?: Maybe<Scalars['String']['output']>;
  /** The priority of this rule */
  priority?: Maybe<QualityRulePriority>;
  /** The rule's status */
  status: QualityRuleStatus;
};

export type QualityRuleAdminSearchResultItem = {
  __typename?: 'QualityRuleAdminSearchResultItem';
  /** When the rule was created */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The default team assigned to this rule's issues */
  defaultTeam?: Maybe<Scalars['String']['output']>;
  /** The rule description */
  description?: Maybe<Scalars['String']['output']>;
  /** The rule id */
  id: Scalars['Int']['output'];
  /** The rule key */
  key: Scalars['String']['output'];
  /** The rule name */
  name: Scalars['String']['output'];
  /** The rule priority */
  priority?: Maybe<QualityRulePriority>;
  /** The rule status */
  status?: Maybe<QualityRuleStatus>;
  /** The rule type (e.g. automatic, manual, etc.) */
  type?: Maybe<Scalars['String']['output']>;
};

export type QualityRuleInput = {
  /** The default team assigned to issues of this rule */
  defaultTeam?: InputMaybe<QualityTeamInput>;
  /** The description of the rule */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique key used to identify the rule */
  key: Scalars['String']['input'];
  /** The name of the rule */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The priority of this rule */
  priority?: InputMaybe<QualityRulePriority>;
  /** The rule's status */
  status?: InputMaybe<QualityRuleStatus>;
};

export enum QualityRulePriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum QualityRuleStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export enum QualityRuleType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

/** Object representing a team which can be assigned to quality issues  */
export type QualityTeam = {
  __typename?: 'QualityTeam';
  /** The unique identifier of the team */
  id: Scalars['ID']['output'];
  /** The name of the team */
  name: Scalars['String']['output'];
};

export type QualityTeamInput = {
  /** The unique identifier of the team */
  id: Scalars['ID']['input'];
  /** The name of the team */
  name: Scalars['String']['input'];
};

export type QualityUser = {
  __typename?: 'QualityUser';
  /** The unique identifier of the user */
  id: Scalars['Int']['output'];
  /** The user's type */
  type: QualityUserType;
};

export type QualityUserInput = {
  /** The unique identifier of the user */
  id: Scalars['Int']['input'];
  /** Provided only when `type = service`. Value is a descriptive name of the service */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The user's type */
  type: QualityUserType;
};

export enum QualityUserType {
  Service = 'SERVICE',
  Staff = 'STAFF',
  Supplier = 'SUPPLIER'
}

export type Query = {
  __typename?: 'Query';
  account?: Maybe<SupplierAccount>;
  accountConfirmation?: Maybe<AccountConfirmation>;
  accounts?: Maybe<SupplierAccounts>;
  /** Get all the activities from the provided list of id's */
  activities: Array<Activity>;
  /** Get the activity by the provided id */
  activity?: Maybe<Activity>;
  /**
   * This search behaves the same way that a normal search does, but it is limited to only return
   * the id, title and thumbnail of the activities. This is used on Supplier Portal pages where users
   * with limited access to other features (e.g guides) still need to search for activities.
   */
  activityLimitedSearch?: Maybe<ActivityLimitedSearch>;
  /** Get the option by the provided id */
  activityOption?: Maybe<ActivityOption>;
  activityOptionDebug?: Maybe<AvailabilityDebugInfo>;
  /**
   * This search behaves the same way that a normal search does, but it is limited to only return
   * the id and title of the options. This is used on Supplier Portal pages where users
   * with limited access to other features (e.g guides) still need to search for options.
   */
  activityOptionLimitedSearch?: Maybe<ActivityOptionLimitedSearch>;
  activityOptionPricing?: Maybe<ActivityOptionPricing>;
  activityOptionSearch?: Maybe<ActivityOptionSearch>;
  /** Get all the options from the provided list of ids */
  activityOptions: Array<ActivityOption>;
  activitySearch?: Maybe<ActivitySearch>;
  activitySearchStats?: Maybe<ActivitySearchStats>;
  addonText?: Maybe<Array<AddonText>>;
  /** Get all the countries */
  addressCountries: Array<AddressCountry>;
  /** Search for quality issues matching a set of provided search criteria */
  adminSearchQualityIssues?: Maybe<AdminSearchResult>;
  /** Search for quality rules matching a set of provided search criteria */
  adminSearchQualityRules?: Maybe<AdminSearchResult>;
  agenda: Agenda;
  /** Get the list of all the countries */
  allCountries?: Maybe<Array<Country>>;
  allGlossaries: Array<Maybe<Glossary>>;
  /** Get all activities for a supplier */
  allSupplierActivities: Array<Activity>;
  availabilityAndPricing?: Maybe<AvailabilityAndPricing>;
  availabilityBlockSearch?: Maybe<AvailabilityBlockSearch>;
  /** Query to fetch the available bank country codes for given currency */
  bankCountries: Array<Scalars['String']['output']>;
  /** Get the billing by the billing id */
  billing: Billing;
  /** Get the billings by billing ids */
  billingsByIds: Array<Billing>;
  /** Get the billings by shopping cart id */
  billingsByShoppingCartId: Array<Billing>;
  booking: Booking;
  /** Get the booking by the booking reference */
  bookingByBookingReference: Booking;
  /** Get booking cancellation reasons */
  bookingCancellationReasons: BookingCancellationReasons;
  /** Get the bookings by booking ids */
  bookingsByIds: Array<Booking>;
  bookingsSearch: BookingSearch;
  /** Get all the broadcasts */
  broadcasts: Array<Broadcast>;
  /** Get the broadcasts from the provided list of id's */
  broadcastsByIds: Array<Broadcast>;
  calendar: Array<Maybe<CalendarItem>>;
  /** Get the list of categories by it's provided list of ids */
  categories: Array<Category>;
  /** List all categories in the catalog */
  categoriesCatalog: Array<Category>;
  /** Get the category by it's id */
  category?: Maybe<Category>;
  /** Get the comment by it's unique identifier */
  comment?: Maybe<Comment>;
  /** Get all comments of a given entity and it's stored id */
  commentsByEntity?: Maybe<Array<Comment>>;
  /** Compute all the cancellation fees based on the value provided for one of them */
  computedCancellationFees: ComputedCancellationFeesPayload;
  /** Get supplier api configurations */
  connectivityPartnerApiConfigs?: Maybe<SupplierApiConfigResponse>;
  /** Get all source configurations */
  connectivitySourceConfigurations?: Maybe<Array<Maybe<ConnectivitySourceConfig>>>;
  /** Get all content changes of given tour */
  contentChangesByTourId: Array<Maybe<ContentReview>>;
  /** Get content review by id */
  contentReview?: Maybe<ContentReview>;
  /** Core keywords */
  coreKeywords: Array<CoreKeyword>;
  /** Get the list of countries by it's provided list of ids */
  countries?: Maybe<Array<Country>>;
  /** Get the country by it's id */
  country?: Maybe<Country>;
  /** Get the coupon by the coupon id */
  coupon: Coupon;
  /** Get the coupons by coupon ids */
  couponsByIds: Array<Coupon>;
  /** Get coupons that match the search input */
  couponsSearch: CouponSearch;
  /** Get all the currencies */
  currencies: Array<Currency>;
  /** The currently authenticated staff user. */
  currentStaff?: Maybe<Staff>;
  customer: Customer;
  /** Get the customer addresses by customer addresses ids */
  customerAddressesByIds: Array<CustomerAddress>;
  /** Get customer addresses that match the search input */
  customerAddressesSearch: CustomerAddressSearch;
  customersByIds: Array<Customer>;
  customersSearch: CustomerSearch;
  /** Fetch preview for deals price */
  dealPricePreview: DealPreviewResult;
  /** Search deals */
  dealsSearch?: Maybe<DealSearch>;
  derivedAttributeConfiguration?: Maybe<DerivedAttributeConfiguration>;
  derivedAttributeConfigurationPreview?: Maybe<DerivedAttributeConfigurationPreview>;
  derivedAttributeConfigurationSearch?: Maybe<DerivedAttributeConfigurationSearch>;
  /** Get full details of an email by UUID */
  email?: Maybe<EmailWithContextsBodyAndAttachments>;
  /** Get emails that match the search input */
  emailSearch?: Maybe<EmailSearch>;
  /** Get the emails by email UUIDs */
  emailsByIds: Array<Email>;
  /** Retrieve external rating by activity id */
  externalRatingByActivityId?: Maybe<ExternalRatingResponse>;
  /**
   * Returns Features associated with the integration id
   *
   * Equivalent to GET /features?integrationId={integrationId}
   */
  featuresFromIntegration?: Maybe<GetFeaturesResponse>;
  /** Find all blocking queue items for an XTM delayed tour push item. */
  findBlockingContentReviews: Array<Maybe<ContentReview>>;
  fuzzyActivityOptionsSearch?: Maybe<ActivityOptionSearch>;
  fuzzyActivitySearch?: Maybe<ActivitySearch>;
  /** Search for locations using a query string */
  fuzzyLocationSearch?: Maybe<FuzzyLocationSearch>;
  /** Get all supplier email allowlist records by supplierId. */
  getAllowedSupplierEmailsConfiguration: Array<Maybe<SupplierEmailAllowListEntry>>;
  getTicketByCode?: Maybe<Ticket>;
  /** Fetch all unconfirmed connected bookings */
  getUnconfirmedConnectedBookings?: Maybe<UnconfirmedBookingSearchResult>;
  glossary?: Maybe<Glossary>;
  /** Get the google place by it's google place id */
  googlePlace?: Maybe<GooglePlace>;
  /** Get the google place by it's database id */
  googlePlaceById?: Maybe<GooglePlace>;
  /** Get a list of changes made to a given row in a given table by primary key */
  history?: Maybe<Array<HistoryRecord>>;
  /** Import an external review rating for a tour. */
  importActivityExternalReviewRating: ActivityExternalReviewRatingPayload;
  insights: SupplierInsights;
  /** Fetches all the associated locations of a given location. */
  keywordsSuggestion?: Maybe<Array<Tag>>;
  /** Get the location by its id */
  location?: Maybe<Location>;
  /** Fetches all the associated locations of a given location. */
  locationExtractorSuggestions?: Maybe<Array<Location>>;
  /** Search for locations */
  locationSearch?: Maybe<LocationSearch>;
  /** Search for suppliers that have tours in specified locations */
  locationSuppliersSearch?: Maybe<LocationSupplierSearch>;
  /** Fetches all the associated locations of a given location. */
  locationTree?: Maybe<Array<LocationTreeEntry>>;
  /** Fetches all the associated child locations of a given location. */
  locationTreeChildren?: Maybe<Array<LocationTreeEntry>>;
  /** Get the list of locations by it's provided list of ids */
  locations?: Maybe<Array<Location>>;
  /**
   * Returns outbound product mapping associated with the integration id
   *
   * Equivalent to GET /supplier-api-config/{integrationId}/product-mapping
   */
  outboundProductMapping?: Maybe<OutboundProductMappingForIntegration>;
  partner?: Maybe<Partner>;
  partnerAdjustmentPaymentsByBookingId: Array<PartnerAdjustmentPayment>;
  partnerAdjustmentPaymentsSearch: PartnerAdjustmentPaymentSearch;
  partnerExample?: Maybe<PartnerExample>;
  partnersByIds: Array<Partner>;
  /** Query to fetch the Payment Detail Change Request */
  paymentDetailsChangeRequest: PaymentDetailsChangeRequestResponse;
  /** Query to fetch the bank requirements foreach country */
  paymentDetailsFields: Array<PaymentDetailsField>;
  /** Query to fetch the years of the supplier payment operation (either invoices or payments */
  paymentOperationYears: Array<Scalars['Int']['output']>;
  /** Check the status of the tour content generation */
  pollTourGeneratedContent?: Maybe<TourContentGenerationResponse>;
  /**
   * Returns pricing categories associated with the product
   *
   * Equivalent to GET /pricing-categories
   */
  pricingCategories?: Maybe<PricingCategoriesResponse>;
  pricingToAvailabilityBlockSearch?: Maybe<PricingToAvailabilityBlockSearch>;
  /**
   * Returns addons associated with the product
   *
   * Equivalent to GET /products/{productId}/addons/
   */
  productAddons?: Maybe<Array<ProductAddon>>;
  /**
   * Returns details of a product
   *
   * Equivalent to GET /supplier/{supplierId}/integration/{integrationId}/externalProductId/{externalProductId}
   */
  productDetails?: Maybe<ProductDetails>;
  /**
   * Returns products associated with the external supplier id
   *
   * Equivalent to GET /supplier/{supplierId}/integration/{integrationId}/products
   */
  productsFromExternalSupplier?: Maybe<ProductsFromExternalSupplier>;
  /** Get the quality issue by the provided id */
  qualityIssue?: Maybe<QualityIssue>;
  qualityIssueConfiguration?: Maybe<QualityIssueConfiguration>;
  qualityIssueConfigurationPreview?: Maybe<QualityIssueConfigurationPreview>;
  qualityIssueConfigurationSearch?: Maybe<QualityIssueConfigurationSearch>;
  /** Get the rule by the provided id */
  qualityRule?: Maybe<QualityRule>;
  /** Get the rule by its key */
  qualityRuleByKey?: Maybe<QualityRule>;
  /** Get all rules (optionally filtering by owner and/or status) */
  qualityRules: Array<QualityRule>;
  /** Get the team by the provided id */
  qualityTeam?: Maybe<QualityTeam>;
  /** Get all teams */
  qualityTeams: Array<QualityTeam>;
  quickBookingsSearch: SearchResult;
  /** Quickly search by coupons that match the search input */
  quickCouponsSearch: SearchResult;
  quickCustomersSearch: SearchResult;
  /** Quickly search by bookings that match the search input */
  quickShoppingCartsSearch: SearchResult;
  restrictionConfiguration?: Maybe<RestrictionConfiguration>;
  restrictionConfigurationPreview?: Maybe<RestrictionConfigurationPreview>;
  restrictionConfigurationSearch?: Maybe<RestrictionConfigurationSearch>;
  /** Retrieve review by id */
  review?: Maybe<Review>;
  /** Search for reviews (activity id, assigned staff id, status, date from and to) with sorting capability */
  reviewSearch?: Maybe<ReviewSearch>;
  /** Retrieve activity review stats for the given activityIds */
  reviewStatsByActivityIds?: Maybe<ActivityReviewStatsResult>;
  /** Retrieve review by activity id */
  reviewsByActivityId?: Maybe<Reviews>;
  /** Retrieve review by booking id */
  reviewsByBookingId?: Maybe<ReviewsByBooking>;
  /** Query to fetch the SAP payload for the given business partner */
  sapBusinessPartnerPayload?: Maybe<Scalars['String']['output']>;
  /** Get the shopping cart by the shopping cart ID */
  shoppingCart: ShoppingCart;
  /** Get a list of shopping carts by the list of shopping cart IDs */
  shoppingCartsByIds: Array<ShoppingCart>;
  /** Get shopping carts that match the search input */
  shoppingCartsSearch: ShoppingCartSearch;
  /** Fetch Staff by ID */
  staff: UnionStaffEntityNotFound;
  /** Fetch Staff Area Management list */
  staffAreaManagementList: StaffAreaManagementListResult;
  /** Get all the staff users of the given roles. */
  staffByRoles: Array<Staff>;
  supplier?: Maybe<Supplier>;
  supplierAccountSearch?: Maybe<SupplierAccountSearch>;
  supplierAdjustmentPaymentsByBookingId: Array<SupplierAdjustmentPayment>;
  supplierAdjustmentPaymentsSearch: SupplierAdjustmentPaymentSearch;
  /**
   * Fetch bookings based on a supplier_id. This is created to facilitate the new bookings page at Supplier Portal.
   * This query has extra field restrictions for staff users compared to bookingsSearch
   */
  supplierBookingsSearch: BookingSearch;
  /** Get supplier invoice registration issue */
  supplierInvoiceRegistrationIssue?: Maybe<Scalars['String']['output']>;
  /** Query to fetch the supplier invoices */
  supplierInvoices: SupplierInvoicesResponse;
  /** Get the missing completeness information by supplier id */
  supplierMissingCompleteness?: Maybe<SupplierMissingAttributes>;
  /** Query to fetch the supplier paymentsSupp */
  supplierPayments: SupplierPaymentsResponse;
  /** Retrieve review for the given supplier & filters */
  supplierReviews: SupplierReviewsResult;
  supplierSearch?: Maybe<SupplierSearch>;
  /** Get the tag by its id */
  tag?: Maybe<Tag>;
  tagSearch?: Maybe<TagSearchResult>;
  /** Get the list of tags by the provided list of ids */
  tags?: Maybe<Array<Tag>>;
  /** Get the list of all tags matching any of the given types. */
  tagsByType: Array<Maybe<Tag>>;
  /** Fetches all the associated locations of a given tour. */
  tourLocationTree?: Maybe<Array<LocationTreeEntry>>;
  tourRestrictions: Array<Maybe<TourRestriction>>;
  travelerPage?: Maybe<TravelerPage>;
  /**
   * Returns if outbound integration's external product mappings are valid and returns any error messages.
   *
   * Equivalent to POST /supplier-api-config/{integrationId}/product-mapping/validate
   */
  validateOutboundProductMapping?: Maybe<OutboundProductMappingValidationResponse>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountConfirmationArgs = {
  confirmationCode: Scalars['String']['input'];
};


export type QueryAccountsArgs = {
  input: SupplierAccountsInput;
};


export type QueryActivitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityLimitedSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryActivityOptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityOptionDebugArgs = {
  input: ActivityOptionDebug;
};


export type QueryActivityOptionLimitedSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryActivityOptionPricingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityOptionSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryActivityOptionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryActivitySearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryActivitySearchStatsArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryAddonTextArgs = {
  description: Scalars['String']['input'];
  languageId: Scalars['ID']['input'];
};


export type QueryAdminSearchQualityIssuesArgs = {
  query: AdminSearchQuery;
};


export type QueryAdminSearchQualityRulesArgs = {
  query: AdminSearchQuery;
};


export type QueryAgendaArgs = {
  input: AgendaInput;
};


export type QueryAllSupplierActivitiesArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryAvailabilityAndPricingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAvailabilityBlockSearchArgs = {
  input: SearchInput;
};


export type QueryBankCountriesArgs = {
  currencyCode: Scalars['String']['input'];
};


export type QueryBillingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillingsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryBillingsByShoppingCartIdArgs = {
  shoppingCartId: Scalars['ID']['input'];
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingByBookingReferenceArgs = {
  bookingReference: Scalars['String']['input'];
};


export type QueryBookingCancellationReasonsArgs = {
  input: BookingCancellationReasonsInput;
};


export type QueryBookingsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryBookingsSearchArgs = {
  input: SearchInput;
};


export type QueryBroadcastsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCalendarArgs = {
  input: CalendarInput;
};


export type QueryCategoriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommentsByEntityArgs = {
  entity: Scalars['String']['input'];
  entityId: Scalars['Int']['input'];
};


export type QueryComputedCancellationFeesArgs = {
  input: ComputedCancellationFeesInput;
};


export type QueryConnectivityPartnerApiConfigsArgs = {
  supplierApiConfigId: Scalars['Int']['input'];
};


export type QueryConnectivitySourceConfigurationsArgs = {
  apiType?: InputMaybe<Scalars['Int']['input']>;
  supplierApiConfigId?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContentChangesByTourIdArgs = {
  tourId: Scalars['ID']['input'];
};


export type QueryContentReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoreKeywordsArgs = {
  languageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouponArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouponsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCouponsSearchArgs = {
  input: SearchInput;
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerAddressesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCustomerAddressesSearchArgs = {
  input: SearchInput;
};


export type QueryCustomersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCustomersSearchArgs = {
  input: SearchInput;
};


export type QueryDealPricePreviewArgs = {
  input: DealPreviewInput;
};


export type QueryDealsSearchArgs = {
  input: SearchInput;
};


export type QueryDerivedAttributeConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDerivedAttributeConfigurationPreviewArgs = {
  input: DerivedAttributeConfigurationPreviewInput;
};


export type QueryDerivedAttributeConfigurationSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryEmailArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryEmailSearchArgs = {
  input: SearchInput;
};


export type QueryEmailsByIdsArgs = {
  uuids: Array<Scalars['ID']['input']>;
};


export type QueryExternalRatingByActivityIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeaturesFromIntegrationArgs = {
  featureClientId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
};


export type QueryFindBlockingContentReviewsArgs = {
  xtmDelayedTourPushId: Scalars['Int']['input'];
};


export type QueryFuzzyActivityOptionsSearchArgs = {
  input?: InputMaybe<QuerySearchInput>;
};


export type QueryFuzzyActivitySearchArgs = {
  input?: InputMaybe<QuerySearchInput>;
};


export type QueryFuzzyLocationSearchArgs = {
  input?: InputMaybe<FuzzyLocationQuerySearchInput>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllowedSupplierEmailsConfigurationArgs = {
  supplierId: Scalars['Long']['input'];
};


export type QueryGetTicketByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetUnconfirmedConnectedBookingsArgs = {
  input: UnconfirmedBookingSearchInput;
};


export type QueryGlossaryArgs = {
  glossaryId: Scalars['ID']['input'];
};


export type QueryGooglePlaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGooglePlaceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHistoryArgs = {
  query: HistoryQuery;
};


export type QueryImportActivityExternalReviewRatingArgs = {
  input: ImportActivityExternalReviewRatingRequest;
};


export type QueryInsightsArgs = {
  query: SupplierInsightsQuery;
};


export type QueryKeywordsSuggestionArgs = {
  activityId: Scalars['ID']['input'];
  languageId: Scalars['Int']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
  languageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationExtractorSuggestionsArgs = {
  activityId: Scalars['ID']['input'];
  languageId: Scalars['Int']['input'];
};


export type QueryLocationSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryLocationSuppliersSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryLocationTreeArgs = {
  languageId?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
};


export type QueryLocationTreeChildrenArgs = {
  languageId?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
};


export type QueryLocationsArgs = {
  ids: Array<Scalars['ID']['input']>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOutboundProductMappingArgs = {
  integrationId: Scalars['Int']['input'];
};


export type QueryPartnerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerAdjustmentPaymentsByBookingIdArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryPartnerAdjustmentPaymentsSearchArgs = {
  input: SearchInput;
};


export type QueryPartnerExampleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPaymentDetailsChangeRequestArgs = {
  paymentDetailsChangeRequestInput: PaymentDetailsChangeRequestInput;
};


export type QueryPaymentDetailsFieldsArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
};


export type QueryPaymentOperationYearsArgs = {
  supplierOperationYearsInput: PaymentOperationYearsInput;
};


export type QueryPollTourGeneratedContentArgs = {
  activityId: Scalars['Int']['input'];
};


export type QueryPricingCategoriesArgs = {
  externalProductId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
};


export type QueryPricingToAvailabilityBlockSearchArgs = {
  input: SearchInput;
};


export type QueryProductAddonsArgs = {
  externalProductId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
};


export type QueryProductDetailsArgs = {
  externalProductId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  supplierId: Scalars['Int']['input'];
};


export type QueryProductsFromExternalSupplierArgs = {
  integrationId: Scalars['Int']['input'];
  supplierId: Scalars['Int']['input'];
};


export type QueryQualityIssueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualityIssueConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQualityIssueConfigurationPreviewArgs = {
  input: QualityIssueConfigurationPreviewInput;
};


export type QueryQualityIssueConfigurationSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryQualityRuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualityRuleByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryQualityRulesArgs = {
  onlyActive?: Scalars['Boolean']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQualityTeamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuickBookingsSearchArgs = {
  input: SearchInput;
};


export type QueryQuickCouponsSearchArgs = {
  input: SearchInput;
};


export type QueryQuickCustomersSearchArgs = {
  input: SearchInput;
};


export type QueryQuickShoppingCartsSearchArgs = {
  input: SearchInput;
};


export type QueryRestrictionConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRestrictionConfigurationPreviewArgs = {
  input: RestrictionConfigurationPreviewInput;
};


export type QueryRestrictionConfigurationSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryReviewStatsByActivityIdsArgs = {
  activityIds: Array<Scalars['ID']['input']>;
};


export type QueryReviewsByActivityIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewsByBookingIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySapBusinessPartnerPayloadArgs = {
  businessPartnerKey: BusinessPartnerKeyInput;
};


export type QueryShoppingCartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShoppingCartsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryShoppingCartsSearchArgs = {
  input: SearchInput;
};


export type QueryStaffArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStaffAreaManagementListArgs = {
  input: StaffAreaManagementListInput;
};


export type QueryStaffByRolesArgs = {
  roles: Array<Scalars['String']['input']>;
};


export type QuerySupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierAccountSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QuerySupplierAdjustmentPaymentsByBookingIdArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QuerySupplierAdjustmentPaymentsSearchArgs = {
  input: SearchInput;
};


export type QuerySupplierBookingsSearchArgs = {
  input: SearchInput;
};


export type QuerySupplierInvoiceRegistrationIssueArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QuerySupplierInvoicesArgs = {
  supplierInvoiceInput: SupplierInvoiceInput;
};


export type QuerySupplierMissingCompletenessArgs = {
  input: SupplierMissingCompletenessInput;
};


export type QuerySupplierPaymentsArgs = {
  supplierPaymentsInput: SupplierPaymentsInput;
};


export type QuerySupplierReviewsArgs = {
  input: SupplierReviewsInput;
};


export type QuerySupplierSearchArgs = {
  input?: InputMaybe<SearchInput>;
};


export type QueryTagArgs = {
  id: Scalars['ID']['input'];
  languageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagSearchArgs = {
  input?: InputMaybe<SearchInput>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagsArgs = {
  ids: Array<Scalars['ID']['input']>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagsByTypeArgs = {
  languageId?: InputMaybe<Scalars['Int']['input']>;
  tagTypes: Array<TagType>;
};


export type QueryTourLocationTreeArgs = {
  languageId?: InputMaybe<Scalars['Int']['input']>;
  tourId: Scalars['ID']['input'];
};


export type QueryTourRestrictionsArgs = {
  tourId: Scalars['Int']['input'];
};


export type QueryTravelerPageArgs = {
  input: TravelerPageInput;
};


export type QueryValidateOutboundProductMappingArgs = {
  externalProductId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
};

/** Search input using a query. */
export type QuerySearchInput = {
  /** Max number of items to show. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Current selected item offset. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter results by. */
  query: Scalars['String']['input'];
};

export enum RecipientMethod {
  Bcc = 'BCC',
  Cc = 'CC',
  To = 'TO'
}

export enum RecipientStatus {
  Bounce = 'BOUNCE',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  EmailDispatched = 'EMAIL_DISPATCHED',
  Processed = 'PROCESSED'
}

export type RecomputeCacheEntriesInput = {
  /** The IDs of the activities to recompute. */
  activityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the activity options to recompute. */
  activityOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the categories to recompute. */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the category to location mappings to recompute. */
  categoryToLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the category to supplier mappings to recompute. */
  categoryToSupplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the continents to recompute. */
  continentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the countries to recompute. */
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the locations to recompute. */
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the tags to recompute. */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RecomputeCacheEntriesPayload = {
  __typename?: 'RecomputeCacheEntriesPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

/** Payload with result of the operation of redeeming the ticket by code. */
export type RedeemTicketByCodePayload = {
  __typename?: 'RedeemTicketByCodePayload';
  /** Booking reference of the ticket. */
  bookingReference?: Maybe<Scalars['String']['output']>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** Flag showing if the ticket was redeemed or not. */
  isRedeemed?: Maybe<Scalars['Boolean']['output']>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
  /** The tickets that were redeemed. */
  tickets?: Maybe<Array<Ticket>>;
};

export enum ReferenceDateType {
  /** Date of purchase means that we base the payment on checkout-date */
  DateOfPurchase = 'DATE_OF_PURCHASE',
  /** Date of travel means that we base the payment on travel-date */
  DateOfTravel = 'DATE_OF_TRAVEL'
}

export type Refund = {
  __typename?: 'Refund';
  /** The amount of the refund */
  amount: Money;
  /** Refund identifier related to the payment provider */
  arn?: Maybe<Scalars['String']['output']>;
  /** The billing associated with the refund */
  billing?: Maybe<Billing>;
  /** Whether the refund can be converted into a coupon */
  canBeConvertedToCoupon: Scalars['Boolean']['output'];
  /** Whether the refund can be converted to a cancel promo code */
  canBeConvertedToPromoCode: Scalars['Boolean']['output'];
  /** Whether the refund can be deleted */
  canBeDeleted: Scalars['Boolean']['output'];
  /** Whether the refund can be executed */
  canBeExecuted: Scalars['Boolean']['output'];
  /** Whether the refund can be executed by staff */
  canBeExecutedByStaff: Scalars['Boolean']['output'];
  /** The coupon if part of a promotion on coupons as a refund option */
  cancelPromoCoupon?: Maybe<Coupon>;
  /** The date the refund was created */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Flag marking whether a fraud or not */
  fraud: Scalars['Boolean']['output'];
  /** The unique identifier of the refund */
  id: Scalars['ID']['output'];
  /** The id of the item associated with the refund */
  itemId: Scalars['Int']['output'];
  /** The type of item associated with the refund */
  itemType: RefundItemType;
  /** The date the refund was paid */
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** An enum representing the type of payment associated with the refund */
  paymentType: RefundPaymentType;
  /** The reason for the refund */
  reasonText: Scalars['String']['output'];
  /** The date the refund is scheduled for */
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  /** True if the refund should have been executed, false otherwise */
  shouldHaveBeenExecuted: Scalars['Boolean']['output'];
  /** The refund status */
  status: RefundStatus;
  /** The coupon if used as a refund method for the transaction */
  transactionCoupon?: Maybe<Coupon>;
  /** An enum representing the type of transaction associated with the refund */
  transactionType?: Maybe<RefundTransactionType>;
};

export type RefundBookingInput = {
  /** The amount to be refunded */
  amount: Scalars['Float']['input'];
  /** The unique identifier for the booking */
  bookingId: Scalars['ID']['input'];
  /** The currency type used to perform the refund. If not provided the customer currency is used */
  currencyType?: InputMaybe<CurrencyType>;
  /** An enum representing the preferred refund method */
  preferredRefundMethod: RefundMethod;
  /** The text of the reason for the refund. It can be any custom text */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The reason id for the refund */
  reasonId: Scalars['Int']['input'];
  /** An enum representing the type of refund (discount/reduction) */
  type: RefundType;
};

export type RefundBookingPayload = {
  __typename?: 'RefundBookingPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RefundCouponInput = {
  /** The amount that should be refunded for the coupon. Relevant only if the type is CUSTOM_AMOUNT */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** The ID of the coupon */
  couponId: Scalars['ID']['input'];
  /** The reason that the coupon is being refunded. Relevant only if the type is CUSTOM_AMOUNT */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The refund type of the coupon */
  refundType: CouponRefundType;
};

export enum RefundItemType {
  Billing = 'BILLING',
  Booking = 'BOOKING',
  Coupon = 'COUPON'
}

export enum RefundMethod {
  Coupon = 'COUPON',
  Payback = 'PAYBACK'
}

export enum RefundPaymentType {
  Cancelation = 'CANCELATION',
  Discount = 'DISCOUNT',
  Modification = 'MODIFICATION',
  Reduction = 'REDUCTION'
}

export enum RefundStatus {
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  FailedChecked = 'FAILED_CHECKED',
  Paid = 'PAID',
  Requested = 'REQUESTED',
  Suspended = 'SUSPENDED'
}

export type RefundTicketsOnBatchInput = {
  batchId: Scalars['ID']['input'];
  staffEmail: Scalars['String']['input'];
};

/**
 * Payload with result of the operation of refunding all the tickets
 * unsold in the batch upload.
 */
export type RefundTicketsOnBatchPayload = {
  __typename?: 'RefundTicketsOnBatchPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export enum RefundTransactionType {
  Adyen = 'ADYEN',
  Concardis = 'CONCARDIS',
  Coupon = 'COUPON',
  MasterBill = 'MASTER_BILL',
  Moneybookers = 'MONEYBOOKERS',
  Other = 'OTHER',
  PaymentService = 'PAYMENT_SERVICE',
  Paypal = 'PAYPAL',
  Virtual = 'VIRTUAL'
}

export enum RefundType {
  Discount = 'DISCOUNT',
  Reduction = 'REDUCTION'
}

export type Regex = {
  __typename?: 'Regex';
  pattern: Scalars['String']['output'];
};

export enum RegistrationSource {
  Api = 'API',
  Web = 'WEB'
}

export type ReorderMutationPayload = {
  __typename?: 'ReorderMutationPayload';
  success: Scalars['Boolean']['output'];
};

export type ReorderPictureInput = {
  order: Scalars['Int']['input'];
  pictureId: Scalars['ID']['input'];
};

export type RescheduledBookings = {
  __typename?: 'RescheduledBookings';
  /** The list of bookings the current booking was rescheduled from */
  rescheduledFrom: Array<Booking>;
  /** The associated rescheduled booking */
  rescheduledTo?: Maybe<Booking>;
};

export type ResellerPayment = FinancialIssuedEntity & Payment & {
  __typename?: 'ResellerPayment';
  /** The amount of the payment */
  amount: Scalars['Float']['output'];
  /** Any comments about the payment */
  comment?: Maybe<Scalars['String']['output']>;
  /** The compound entry id representing the payment */
  compoundEntryId: Scalars['String']['output'];
  /** The currency ISO code of the payment */
  currencyIsoCode: Scalars['String']['output'];
  /** The date that the payment was generated */
  dateOfGeneration: Scalars['DateTime']['output'];
  /** The date that the payment was conducted */
  dateOfPayment: Scalars['DateTime']['output'];
  /** The date that the payment was settled */
  dateOfSettlement: Scalars['DateTime']['output'];
  /** The reason the payment failed, if there was a failure */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The staff id that triggered the payment */
  gygStaffId: Scalars['Int']['output'];
  /** The source that the payment was issued from */
  issuingSource: IssuingSource;
  /** The note that we issue to the payee */
  noteToPayee: Scalars['String']['output'];
  /** The payment channel that the payment went through */
  paymentChannel?: Maybe<PaymentChannel>;
  /** The ID representation of the payment */
  paymentId: Scalars['ID']['output'];
  /** The ID representation of the reseller associated with the payment */
  resellerId: Scalars['ID']['output'];
  /** The status of the payment */
  status: PaymentStatus;
  /** The vat amount of the payment */
  vatAmountGermany?: Maybe<Scalars['Float']['output']>;
  /** The vat rate of the payment */
  vatRateGermany?: Maybe<Scalars['Float']['output']>;
};

export type ResendBusinessPartnerToSapInput = {
  /** Business partner key */
  businessPartnerKey: BusinessPartnerKeyInput;
  /** Business partner exists in SAP system */
  isKnownToSap: Scalars['Boolean']['input'];
};

export type ResendBusinessPartnerToSapResponse = ResendBusinessPartnerToSapResponseError | ResendBusinessPartnerToSapResponseSuccess;

export type ResendBusinessPartnerToSapResponseError = {
  __typename?: 'ResendBusinessPartnerToSapResponseError';
  error?: Maybe<ResendBusinessPartnerToSapResponseType>;
};

export type ResendBusinessPartnerToSapResponseSuccess = {
  __typename?: 'ResendBusinessPartnerToSapResponseSuccess';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export enum ResendBusinessPartnerToSapResponseType {
  /** Business partner not found */
  BusinessPartnerNotFound = 'BUSINESS_PARTNER_NOT_FOUND',
  /** Unknown error */
  UnknownError = 'UNKNOWN_ERROR'
}

export type ResendEmailPayload = OperationResult & {
  __typename?: 'ResendEmailPayload';
  message?: Maybe<Scalars['String']['output']>;
  newUuid?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResendValidationEmailPayload = OperationResult & {
  __typename?: 'ResendValidationEmailPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetAccountPasswordInput = {
  confirmationCode: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** The input required to resolve the payment details change request token mutation */
export type ResolvePaymentDetailsChangeRequestInput = {
  /** The action that is going to be processed */
  action: PaymentDetailsChangeRequestActionInput;
  /** ID of the associated business partner */
  businessPartnerKey: BusinessPartnerKeyInput;
  /** The change request token */
  changeRequestToken: Scalars['String']['input'];
};

/** Result of the resolution of the payment detail change request token */
export type ResolvePaymentDetailsChangeRequestResponse = PaymentDetailsChangeRequestError | PaymentDetailsChangeRequestSuccess;

export type RestrictedCustomerAddress = {
  __typename?: 'RestrictedCustomerAddress';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type RestrictionCheckInput = {
  restrictionEntryPoint: RestrictionEntryPoint;
};

export type RestrictionCheckResult = {
  __typename?: 'RestrictionCheckResult';
  results: Array<RestrictionCheckResultItem>;
};

export type RestrictionCheckResultItem = {
  __typename?: 'RestrictionCheckResultItem';
  restrictionId: Scalars['Int']['output'];
  restrictionName: Scalars['String']['output'];
};

export type RestrictionConfiguration = {
  __typename?: 'RestrictionConfiguration';
  /** Rules that are available for selection for the given entity type. */
  availableRules: Array<RulesEngineRule>;
  /** When the attribute was created. */
  creationTime?: Maybe<Scalars['DateTime']['output']>;
  /** If the attribute is enabled or not. */
  enabled: Scalars['Boolean']['output'];
  /** Which entity to consider as context. */
  entityType: Scalars['String']['output'];
  /** Unique identified of the attribute. */
  id: Scalars['ID']['output'];
  /** The field name to store the value in the provided entityType. */
  internalName: Scalars['String']['output'];
  /** The last time this attribute was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this attribute. */
  lastModificationUser?: Maybe<Staff>;
  /** Name of the attribute to show in the UI. */
  name: Scalars['String']['output'];
  /** Order in which the attribute is evaluated. */
  order: Scalars['Int']['output'];
  /** Statistics of the given restriction. */
  restrictionStats?: Maybe<RestrictionStatsPage>;
  /** Rules that define if this attribute should be evaluated. */
  rules: Array<RulesEngineRuleItem>;
};


export type RestrictionConfigurationRestrictionStatsArgs = {
  input?: InputMaybe<RestrictionStatsInput>;
};

export type RestrictionConfigurationInput = {
  entityType: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rules: Array<RulesEngineRuleItemInput>;
};

export type RestrictionConfigurationPreview = {
  __typename?: 'RestrictionConfigurationPreview';
  items?: Maybe<Array<RestrictionConfigurationPreviewItem>>;
};

export type RestrictionConfigurationPreviewInput = {
  /** The preview configuration to be evaluated. */
  configuration: RestrictionConfigurationInput;
  /** Entity ids to check against, if not provided will use a predefined list. */
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RestrictionConfigurationPreviewItem = {
  __typename?: 'RestrictionConfigurationPreviewItem';
  check: Scalars['Boolean']['output'];
  entityId: Scalars['ID']['output'];
};

export type RestrictionConfigurationProperties = {
  __typename?: 'RestrictionConfigurationProperties';
  country?: Maybe<Scalars['String']['output']>;
};

export type RestrictionConfigurationSearch = {
  __typename?: 'RestrictionConfigurationSearch';
  items: Array<RestrictionConfiguration>;
  pagination: Pagination;
};

export enum RestrictionEntryPoint {
  ProductCreate = 'PRODUCT_CREATE'
}

export type RestrictionStat = {
  __typename?: 'RestrictionStat';
  /** When the stat was created for the first time. */
  createdAt: Scalars['DateTime']['output'];
  /** The entity identifier that has been restricted. */
  entityId: Scalars['Int']['output'];
  /** The entity type that was restricted. */
  entityType: Scalars['String']['output'];
  /** The entrypoint of the restriction. */
  entryPoint: Scalars['String']['output'];
  /** The last time the restriction was applied. */
  updatedAt: Scalars['DateTime']['output'];
};

export type RestrictionStatsInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RestrictionStatsPage = {
  __typename?: 'RestrictionStatsPage';
  page: Scalars['Int']['output'];
  stats: Array<RestrictionStat>;
  totalResults: Scalars['Int']['output'];
};

export type Review = {
  __typename?: 'Review';
  /** Activity id the review belongs to */
  activityId: Scalars['Int']['output'];
  /** Review author age group (`18-29`, `30-39`, `40-49`, `50-59`, `60-69`, `70+`) */
  ageGroup?: Maybe<Scalars['String']['output']>;
  /** Staff id the review is assigned to (null if not assigned) */
  assignedStaff?: Maybe<Staff>;
  /** Review author */
  author: ReviewAuthor;
  /** Booking id the review belongs to */
  bookingId?: Maybe<Scalars['Int']['output']>;
  /** ISO date the review was created */
  created: Scalars['String']['output'];
  /** Review enjoyment field */
  enjoyment?: Maybe<Scalars['String']['output']>;
  /** Review id */
  id: Scalars['ID']['output'];
  /** Determines if the review is anonymous */
  isAnonymous: Scalars['Boolean']['output'];
  /** Whether review is for testing */
  isTestData?: Maybe<Scalars['Boolean']['output']>;
  /** The language the review was written in */
  language?: Maybe<Scalars['String']['output']>;
  /** Review message field, aka the main review comment */
  message: Scalars['String']['output'];
  /** Option id the review belongs to */
  optionId: Scalars['Int']['output'];
  /** Review rating value (1-5) */
  rating: Scalars['Int']['output'];
  /** List of review optional ratings (transport, guide, value_for_money, organization, safety, service, meeting_point) */
  ratings: Array<ReviewRating>;
  /** Review status */
  status: Scalars['String']['output'];
  /** Review title (deprecated) */
  title: Scalars['String']['output'];
  /** Review traveler type (`couple`, `friends`, `family_young`, `family_old`, `solo`) */
  travelerType?: Maybe<Scalars['String']['output']>;
};

export enum ReviewAgeGroup {
  /** Review age group 70+ */
  AgeGroup_70 = 'AGE_GROUP_70',
  /** Review age group 18-29 */
  AgeGroup_1829 = 'AGE_GROUP_1829',
  /** Review age group 30-39 */
  AgeGroup_3039 = 'AGE_GROUP_3039',
  /** Review age group 40-49 */
  AgeGroup_4049 = 'AGE_GROUP_4049',
  /** Review age group 50-59 */
  AgeGroup_5059 = 'AGE_GROUP_5059',
  /** Review age group 60-69 */
  AgeGroup_6069 = 'AGE_GROUP_6069'
}

export type ReviewAuthor = {
  __typename?: 'ReviewAuthor';
  /** Review author's country */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Review author's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Review author's last name */
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ReviewCopyMoveByIdInput = {
  /** A list of reviews to be copied or moved */
  ids: Array<Scalars['ID']['input']>;
  /** Target option id to copy or move reviews from */
  targetOptionId: Scalars['Int']['input'];
};

export type ReviewCopyMoveByOptionIdInput = {
  /** Source option id to copy or move reviews from */
  sourceOptionId: Scalars['Int']['input'];
  /** Target option id to copy or move reviews from */
  targetOptionId: Scalars['Int']['input'];
};

export type ReviewCopyMoveByOptionIdPayload = {
  __typename?: 'ReviewCopyMoveByOptionIdPayload';
  /** A list errors that occurred during the copy or move operation */
  errors?: Maybe<Array<Error>>;
  /** Result of the copy or move operation */
  success: Scalars['Boolean']['output'];
  /** Option id that reviews were copied or moved to */
  targetOptionId: Scalars['Int']['output'];
};

export type ReviewCopyMovePayload = {
  __typename?: 'ReviewCopyMovePayload';
  /** A list errors that occurred during the copy or move operation */
  errors?: Maybe<Array<Error>>;
  /** A list of reviews ids that were copied or moved */
  reviewId?: Maybe<Array<Scalars['Int']['output']>>;
  /** Result of the copy or move operation */
  success: Scalars['Boolean']['output'];
  targetOptionId: Scalars['Int']['output'];
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  /** Review rating type (`transport`, `guide`, `value_for_money`, `organization`, `safety`, `service`, `meeting_point`, `rating`) */
  ratingType?: Maybe<Scalars['String']['output']>;
  /** Review rating value (1-5) */
  ratingValue?: Maybe<Scalars['Int']['output']>;
};

export type ReviewSearch = {
  __typename?: 'ReviewSearch';
  /** A list of reviews */
  items?: Maybe<Array<Review>>;
  /** Pagination information such as offset, limit, and total count */
  pagination: Pagination;
};

export type ReviewSearchArguments = {
  __typename?: 'ReviewSearchArguments';
  /** Search for reviews that belong to an activity id */
  activityId?: Maybe<Scalars['Int']['output']>;
  /** Search for reviews assigned to the provided staff id */
  assignedStaffId?: Maybe<Array<Scalars['Int']['output']>>;
  /** Search for reviews with the provided booking ids */
  bookingId?: Maybe<Array<Scalars['Int']['output']>>;
  /** Search for reviews left starting on this date */
  dateFrom?: Maybe<Scalars['String']['output']>;
  /** Search for reviews left up to this date */
  dateTo?: Maybe<Scalars['String']['output']>;
  /** Limit of reviews to return */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Offset of reviews to return */
  offset?: Maybe<Scalars['Int']['output']>;
  /** Search for reviews with the provided ids */
  reviewId?: Maybe<Array<Scalars['Int']['output']>>;
  /** Sorting order of reviews */
  sort?: Maybe<Scalars['String']['output']>;
  /** Search for reviews with the provided status */
  status?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ReviewTravelerType {
  /** Review traveler type couple */
  Couple = 'couple',
  /** Review traveler type family with teenagers or young adults */
  FamilyOld = 'family_old',
  /** Review traveler type family with small children */
  FamilyYoung = 'family_young',
  /** Review traveler type friends */
  Friends = 'friends',
  /** Review traveler type solo */
  Solo = 'solo'
}

export type ReviewUpdateInput = {
  /** Review age group (`18-29`, `30-39`, `40-49`, `50-59`, `60-69`, `70+`) */
  ageGroup?: InputMaybe<ReviewAgeGroup>;
  /** Review enjoyment field */
  enjoyment?: InputMaybe<Scalars['String']['input']>;
  /** Review id to update */
  id: Scalars['ID']['input'];
  /** Determines if the review is anonymous */
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  /** The language the review was written in */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Review message field, aka the main review comment */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Review rating (1-5) */
  rating?: InputMaybe<Scalars['Int']['input']>;
  /** Review status (`active` or `rejected`) */
  status?: InputMaybe<ReviewUpdateStatus>;
  /** Review traveler type (`couple`, `friends`, `family_young`, `family_old`, `solo`) */
  travelerType?: InputMaybe<ReviewTravelerType>;
};

export type ReviewUpdatePayload = {
  __typename?: 'ReviewUpdatePayload';
  /** A list errors that occurred during the update operation */
  errors?: Maybe<Array<Error>>;
  /** Updated review object */
  review?: Maybe<Review>;
  /** Result of the review update operation */
  success: Scalars['Boolean']['output'];
};

export type ReviewUpdateStaffIdInput = {
  /** A list of review ids to update */
  ids: Array<Scalars['ID']['input']>;
  /** Staff id to assign to the reviews */
  staffId: Scalars['Int']['input'];
};

export type ReviewUpdateStaffIdPayload = {
  __typename?: 'ReviewUpdateStaffIdPayload';
  /** A list errors that occurred during the update operation */
  errors?: Maybe<Array<Error>>;
  /** A list of reviews ids that were updated */
  reviewIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Result of the review update staff id operation */
  success: Scalars['Boolean']['output'];
};

export enum ReviewUpdateStatus {
  /** Review is active */
  Active = 'active',
  /** Review is rejected */
  Rejected = 'rejected'
}

export type Reviews = {
  __typename?: 'Reviews';
  /** A list of reviews */
  items?: Maybe<Array<Review>>;
  /** Pagination information such as offset, limit, and total count */
  pagination: Pagination;
};

export type ReviewsByBooking = {
  __typename?: 'ReviewsByBooking';
  /** Communication object containing `numberOfReminders` and `nextReminderDate` (used for booking page) */
  communication?: Maybe<ReviewsByBookingCommunication>;
  /** A list of reviews */
  reviews?: Maybe<Array<Review>>;
};

export type ReviewsByBookingCommunication = {
  __typename?: 'ReviewsByBookingCommunication';
  /** Next reminder date, if any */
  nextReminderDate?: Maybe<Scalars['String']['output']>;
  /** Number of review reminders sent to the user */
  numberOfReminders?: Maybe<Scalars['Int']['output']>;
};

export type RulesEngineAttributeOption = {
  __typename?: 'RulesEngineAttributeOption';
  /** When the option was created. */
  creationTime?: Maybe<Scalars['DateTime']['output']>;
  /** If this option should be enabled or not. */
  enabled: Scalars['Boolean']['output'];
  /** Unique identifier of the attribute option. */
  id: Scalars['ID']['output'];
  /** The last time this attribute option was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this attribute option. */
  lastModificationUser?: Maybe<User>;
  /** Order of execution whitin all other options. */
  order: Scalars['Int']['output'];
  /** Rules to evaluate deciding if this option would apply or not. */
  rules: Array<RulesEngineRuleItem>;
  /** Value to be applied if this option rules evaluate to true. */
  value: Scalars['String']['output'];
};

export type RulesEngineAttributeOptionInput = {
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  rules: Array<RulesEngineRuleItemInput>;
  value: Scalars['String']['input'];
};

export enum RulesEngineDerivedAttributeType {
  Sandbox = 'SANDBOX',
  Schema = 'SCHEMA'
}

/** A rule that is used by the rules engine when evaluating if it should perform certain actions. */
export type RulesEngineRule = {
  __typename?: 'RulesEngineRule';
  /** When the option was created. */
  creationTime?: Maybe<Scalars['DateTime']['output']>;
  /** A descriptive information of the rule explaining what happens when it is executed. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the rule. */
  id: Scalars['ID']['output'];
  /** All the possible inputs this rule can have. */
  inputs?: Maybe<Array<RulesEngineRuleInputConfig>>;
  /** Unique internal name of the rule, used to reference the rule. */
  internalName: Scalars['String']['output'];
  /** The last time this attribute option was updated. */
  lastModificationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this attribute option. */
  lastModificationUser?: Maybe<User>;
  /** Name of the rule. */
  name: Scalars['String']['output'];
};

export type RulesEngineRuleInputConfig = {
  __typename?: 'RulesEngineRuleInputConfig';
  internalName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  validation?: Maybe<RulesEngineRuleInputValidation>;
};

export type RulesEngineRuleInputValidation = RulesEngineRuleInputValidationDropdown | RulesEngineRuleInputValidationFreeText | RulesEngineRuleInputValidationInteger | RulesEngineRuleInputValidationInterval;

export type RulesEngineRuleInputValidationDropdown = {
  __typename?: 'RulesEngineRuleInputValidationDropdown';
  items?: Maybe<Array<RulesEngineRuleInputValidationDropdownItem>>;
  multiSelect?: Maybe<Scalars['Boolean']['output']>;
};

export type RulesEngineRuleInputValidationDropdownItem = {
  __typename?: 'RulesEngineRuleInputValidationDropdownItem';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RulesEngineRuleInputValidationFreeText = {
  __typename?: 'RulesEngineRuleInputValidationFreeText';
  maxCharLength?: Maybe<Scalars['Int']['output']>;
  minCharLength?: Maybe<Scalars['Int']['output']>;
};

export type RulesEngineRuleInputValidationInteger = {
  __typename?: 'RulesEngineRuleInputValidationInteger';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  multiInput?: Maybe<Scalars['Boolean']['output']>;
};

export type RulesEngineRuleInputValidationInterval = {
  __typename?: 'RulesEngineRuleInputValidationInterval';
  lowerBound?: Maybe<Scalars['Float']['output']>;
  upperBound?: Maybe<Scalars['Float']['output']>;
};

export type RulesEngineRuleItem = {
  __typename?: 'RulesEngineRuleItem';
  /** The clause to execute when processing the rule. */
  clause: RulesEngineRuleItemClause;
  /** The operation to execute when processing the rule. */
  operation: RulesEngineRuleItemOperation;
  /** Parameters that will be taken into consideration for the given rule. */
  params?: Maybe<Array<RulesEngineRuleItemParams>>;
  /** The parent of this rule item, if null then the item is in the top level. */
  parent?: Maybe<RulesEngineRuleItem>;
  /** Rule that will be used. */
  ruleId?: Maybe<Scalars['ID']['output']>;
  /** Generated in the graph to enable a flat recursive structure. */
  uid: Scalars['ID']['output'];
};

export enum RulesEngineRuleItemClause {
  And = 'AND',
  Or = 'OR'
}

export type RulesEngineRuleItemInput = {
  clause: RulesEngineRuleItemClause;
  operation: RulesEngineRuleItemOperation;
  params?: InputMaybe<Array<RulesEngineRuleItemParamsInput>>;
  ruleId?: InputMaybe<Scalars['ID']['input']>;
  rules?: InputMaybe<Array<RulesEngineRuleItemInput>>;
};

export enum RulesEngineRuleItemOperation {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export type RulesEngineRuleItemParams = {
  __typename?: 'RulesEngineRuleItemParams';
  key: Scalars['String']['output'];
  value?: Maybe<RulesEngineRuleItemParamsValue>;
};

export type RulesEngineRuleItemParamsDropdown = {
  __typename?: 'RulesEngineRuleItemParamsDropdown';
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type RulesEngineRuleItemParamsDropdownInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RulesEngineRuleItemParamsFreeText = {
  __typename?: 'RulesEngineRuleItemParamsFreeText';
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type RulesEngineRuleItemParamsFreeTextInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RulesEngineRuleItemParamsInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<RulesEngineRuleItemParamsValueInput>;
};

export type RulesEngineRuleItemParamsInteger = {
  __typename?: 'RulesEngineRuleItemParamsInteger';
  value?: Maybe<Scalars['Int']['output']>;
};

export type RulesEngineRuleItemParamsIntegerInput = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type RulesEngineRuleItemParamsInterval = {
  __typename?: 'RulesEngineRuleItemParamsInterval';
  lowerBound?: Maybe<Scalars['Float']['output']>;
  upperBound?: Maybe<Scalars['Float']['output']>;
};

export type RulesEngineRuleItemParamsIntervalInput = {
  lowerBound?: InputMaybe<Scalars['Float']['input']>;
  upperBound?: InputMaybe<Scalars['Float']['input']>;
};

/** All the possible param types that an item can have. */
export type RulesEngineRuleItemParamsValue = {
  __typename?: 'RulesEngineRuleItemParamsValue';
  dropdown?: Maybe<RulesEngineRuleItemParamsDropdown>;
  freeText?: Maybe<RulesEngineRuleItemParamsFreeText>;
  integer?: Maybe<RulesEngineRuleItemParamsInteger>;
  interval?: Maybe<RulesEngineRuleItemParamsInterval>;
};

export type RulesEngineRuleItemParamsValueInput = {
  dropdown?: InputMaybe<RulesEngineRuleItemParamsDropdownInput>;
  freeText?: InputMaybe<RulesEngineRuleItemParamsFreeTextInput>;
  integer?: InputMaybe<RulesEngineRuleItemParamsIntegerInput>;
  interval?: InputMaybe<RulesEngineRuleItemParamsIntervalInput>;
};

export type SearchActivityInsights = {
  __typename?: 'SearchActivityInsights';
  baseRankingScore?: Maybe<Scalars['Float']['output']>;
  bestRankedOptionId?: Maybe<Scalars['Int']['output']>;
  fromPrice?: Maybe<Money>;
  hasAvailability: Scalars['Boolean']['output'];
  isIndexed: Scalars['Boolean']['output'];
};

export type SearchActivityOptionInsightAvailability = {
  __typename?: 'SearchActivityOptionInsightAvailability';
  fromPrice: Money;
  fromPriceStartDatetime: Scalars['DateTime']['output'];
  nextStartDatetime: Scalars['DateTime']['output'];
};

export type SearchActivityOptionInsights = {
  __typename?: 'SearchActivityOptionInsights';
  availability?: Maybe<SearchActivityOptionInsightAvailability>;
  baseRankingScore?: Maybe<Scalars['Float']['output']>;
  hasAvailability: Scalars['Boolean']['output'];
  isIndexed: Scalars['Boolean']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
};

/** Search input enabling flexible search. */
export type SearchInput = {
  /** Filter results by. */
  filters?: InputMaybe<Array<FilterInput>>;
  /** Max number of items to show. */
  limit?: Scalars['Int']['input'];
  /** Current selected item offset. */
  offset?: Scalars['Int']['input'];
  /** Sort results by. */
  sorts?: InputMaybe<Array<SortInput>>;
};

export type SearchItem = {
  __typename?: 'SearchItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  items: Array<SearchItem>;
};

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  /** The list of billings associated to this shopping cart */
  billings: Array<Billing>;
  /** The list of booking items in the shopping cart (empty if no booking type items) */
  bookingItems: Array<ShoppingCartBookingItem>;
  /** The checkout date of the shopping cart */
  checkoutDate?: Maybe<Scalars['DateTime']['output']>;
  /** The coupon associated with the shopping cart if present */
  coupon?: Maybe<Coupon>;
  /** The list of coupon items in the shopping cart (empty if no booking type items) */
  couponItems: Array<ShoppingCartCouponItem>;
  /** The percentage value of shopping cart's coupon */
  couponPercentageValue?: Maybe<Scalars['Float']['output']>;
  /** The customer for the shopping cart */
  customer?: Maybe<Customer>;
  /** The customer address of the shopping cart */
  customerAddress?: Maybe<CustomerAddress>;
  /** The campaign used in the shopping cart */
  gygCampaign?: Maybe<GygCampaign>;
  /** The unique hash code for the shopping cart */
  hashCode: Scalars['String']['output'];
  /** The unique ID for the shopping cart */
  id: Scalars['ID']['output'];
  /** Whether the shopping cart is MasterBill or not */
  isMasterBill: Scalars['Boolean']['output'];
  /** Whether the shopping cart is reserved */
  isReserved: Scalars['Boolean']['output'];
  /** The reseller/partner information if one is involved with the shopping cart */
  partner?: Maybe<Partner>;
  /** The price of the shopping cart before a coupon was applied */
  preCouponPrice: Money;
  /** The available refund methods for the shopping cart */
  refundMethods: Array<RefundMethod>;
  /** ReserveNowPayLater object */
  shoppingCartAutoCapture?: Maybe<ShoppingCartAutoCapture>;
  /** The total price of a shopping cart at checkout */
  totalPrice: Money;
};

export type ShoppingCartAutoCapture = {
  __typename?: 'ShoppingCartAutoCapture';
  /** The date when the attempted payment will happen or happened */
  dateOfCapturing?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the shopping cart auto capture */
  id: Scalars['ID']['output'];
  /** The last date of attempted capture */
  lastCaptureAttemptDate?: Maybe<Scalars['DateTime']['output']>;
  /** Error message if the last capture failed */
  lastCaptureAttemptStatus?: Maybe<Scalars['String']['output']>;
  /** The payment status of the reserved shopping cart */
  paymentStatus: ShoppingCartAutoCapturePaymentStatus;
};

export enum ShoppingCartAutoCapturePaymentStatus {
  Cancelled = 'CANCELLED',
  Captured = 'CAPTURED',
  FailedPermanently = 'FAILED_PERMANENTLY',
  FailedRetry = 'FAILED_RETRY',
  Scheduled = 'SCHEDULED'
}

export type ShoppingCartBookingItem = {
  __typename?: 'ShoppingCartBookingItem';
  booking: Booking;
  /** The unique identifier of the shopping cart item */
  id: Scalars['ID']['output'];
  /** The status of the booking cart item */
  status: ShoppingCartItemStatus;
};

export type ShoppingCartCouponItem = {
  __typename?: 'ShoppingCartCouponItem';
  coupon: Coupon;
  /** The unique identifier of the shopping cart item */
  id: Scalars['ID']['output'];
  /** The status of the booking cart item */
  status: ShoppingCartItemStatus;
};

export enum ShoppingCartItemStatus {
  Active = 'ACTIVE',
  DeactivatedByDaemon = 'DEACTIVATED_BY_DAEMON',
  Deleted = 'DELETED'
}

export type ShoppingCartSearch = {
  __typename?: 'ShoppingCartSearch';
  items: Array<ShoppingCart>;
  pagination: Pagination;
  totalItems: Scalars['Int']['output'];
};

export type SlotTime = {
  __typename?: 'SlotTime';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

/** Available sorting directions. */
export enum SortDirection {
  /** Ascending order. */
  Asc = 'ASC',
  /** Descending order. */
  Desc = 'DESC'
}

/** Field specific sorting configuration. */
export type SortInput = {
  /** The direction in which the column must be sorted. */
  direction: SortDirection;
  /** Field name to apply the sort. */
  field: Scalars['String']['input'];
};

export type SpecialDate = {
  __typename?: 'SpecialDate';
  date: Scalars['String']['output'];
  timeSlots: Array<TimeSlot>;
};

export type SpecialDateInput = {
  date: Scalars['String']['input'];
  timeSlots: Array<TimeSlotInput>;
};

export type SplitPricingInput = {
  activityOptionIds: Array<Scalars['ID']['input']>;
  splitDate: Scalars['String']['input'];
};

/** Type holding fields relevant to the staff. */
export type Staff = {
  __typename?: 'Staff';
  /** If the staff is active. */
  active: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  /** The staff email address. */
  email: Scalars['String']['output'];
  /** Unique identifier of the staff. */
  id: Scalars['ID']['output'];
  /** The staff name. */
  name: Scalars['String']['output'];
  /** The most recent payment details for a given currency and status */
  paymentDetails?: Maybe<PaymentDetails>;
  /** All the privileges the staff has. */
  privileges: Array<Scalars['String']['output']>;
  /** Payment details that are or were active for any currency */
  relevantPaymentDetails: Array<PaymentDetails>;
  /** All the roles associated with the staff. */
  roles: Array<Scalars['String']['output']>;
};


/** Type holding fields relevant to the staff. */
export type StaffPaymentDetailsArgs = {
  currency: Scalars['String']['input'];
  statuses?: InputMaybe<Array<PaymentDetailsStatus>>;
};

export type StaffAreaManagementListInput = {
  /** Max number of items to show/ page size */
  limit?: Scalars['Int']['input'];
  /** Current selected page. */
  page?: Scalars['Int']['input'];
};

export type StaffAreaManagementListResult = {
  __typename?: 'StaffAreaManagementListResult';
  staffAreaMappings: Array<StaffAreaMapping>;
  totalItems: Scalars['Int']['output'];
};

export type StaffAreaMapping = {
  __typename?: 'StaffAreaMapping';
  /** The continent Id assigned to staff */
  continentId: Scalars['Int']['output'];
  /** The country assigned to staff */
  country?: Maybe<Country>;
  /** The unique identifier of the staff area mapping */
  id: Scalars['ID']['output'];
  /** The location assigned to staff */
  location?: Maybe<Location>;
  /** Is primary staff for the associated location */
  primary: Scalars['Boolean']['output'];
  /** The staff associated with the location */
  staff: Staff;
};

export type StaffRoleOverwriteInput = {
  /** Comma separated list of roles to set to the staff's JWT token */
  roles: Scalars['String']['input'];
  /** ID from the staff to overwrite JWT token roles */
  staffId: Scalars['ID']['input'];
};

export type StaffRoleOverwritePayload = {
  __typename?: 'StaffRoleOverwritePayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StaffRoleOverwriteResetInput = {
  /** ID from the staff to reset JWT token roles based on DB values */
  staffId: Scalars['ID']['input'];
};

export type StaffRoleOverwriteResetPayload = {
  __typename?: 'StaffRoleOverwriteResetPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum StatusTransition {
  Activate = 'ACTIVATE',
  Delete = 'DELETE',
  Lock = 'LOCK'
}

export type SubscriptionGroup = {
  __typename?: 'SubscriptionGroup';
  state: SubscriptionState;
  subscriptionId: Scalars['String']['output'];
};

export enum SubscriptionState {
  Subscribed = 'SUBSCRIBED',
  Unsubscribed = 'UNSUBSCRIBED'
}

export type Supplier = {
  __typename?: 'Supplier';
  accountManager?: Maybe<Scalars['String']['output']>;
  accounts?: Maybe<Array<SupplierAccount>>;
  acquired?: Maybe<Scalars['Boolean']['output']>;
  acquisitionMedium?: Maybe<AcquisitionMedium>;
  address?: Maybe<SupplierAddress>;
  assessmentOwner?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availablePaymentDataStatuses: Array<Scalars['String']['output']>;
  bookingsSummary: SupplierBookingsSummary;
  canAddOptions?: Maybe<Scalars['Boolean']['output']>;
  canAddProduct?: Maybe<Scalars['Boolean']['output']>;
  canEditContent?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  commissionRate?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRegistrationNr?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumberType?: Maybe<CompanyRegistrationNumberType>;
  contacts?: Maybe<SupplierContacts>;
  contentAgreement?: Maybe<Scalars['Boolean']['output']>;
  contractExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  contractSignDate?: Maybe<Scalars['DateTime']['output']>;
  contractSpecificClause?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contractType?: Maybe<Scalars['String']['output']>;
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  currencyISOCode?: Maybe<Scalars['String']['output']>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  deals?: Maybe<Array<Deal>>;
  documents?: Maybe<Array<Maybe<SupplierDocument>>>;
  enabledPaymentMethods?: Maybe<Array<PaymentMethod>>;
  freshDeskUrl?: Maybe<Scalars['String']['output']>;
  hasMwst?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insuranceConfirmationDate?: Maybe<Scalars['DateTime']['output']>;
  insuranceInformation?: Maybe<Array<Maybe<InsuranceInformation>>>;
  insurancePolicyMissingReason?: Maybe<Scalars['String']['output']>;
  isBot?: Maybe<Scalars['Boolean']['output']>;
  isEuCompliant: Scalars['Boolean']['output'];
  isGygSupplier?: Maybe<Scalars['Boolean']['output']>;
  isNewAvailabilityPricingFlow?: Maybe<Scalars['Boolean']['output']>;
  isRegistrationComplete?: Maybe<Scalars['Boolean']['output']>;
  isSmallBusiness?: Maybe<Scalars['Boolean']['output']>;
  isTestData?: Maybe<Scalars['Boolean']['output']>;
  legalCompanyName?: Maybe<Scalars['String']['output']>;
  legalStatus?: Maybe<LegalStatus>;
  linkedSupplier?: Maybe<Scalars['Int']['output']>;
  management?: Maybe<SupplierManagement>;
  managingDirectors?: Maybe<Array<Maybe<ManagingDirector>>>;
  maxNumberOfTourPictures?: Maybe<Scalars['Int']['output']>;
  operationalLocations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The most recent payment details for a given currency and status */
  paymentDetails?: Maybe<PaymentDetails>;
  paymentDetailsOld?: Maybe<Array<Maybe<PaymentDetailsOld>>>;
  paymentSettings: SupplierPaymentSettings;
  phoneNr?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<SupplierPreferences>;
  primaryAccount?: Maybe<SupplierAccount>;
  priority?: Maybe<Scalars['Int']['output']>;
  privacyPolicy?: Maybe<Array<Maybe<LegalText>>>;
  professionalLicenceNr?: Maybe<Scalars['String']['output']>;
  profileItems?: Maybe<Array<Maybe<SupplierProfileItem>>>;
  publicCompanyEmail?: Maybe<Scalars['String']['output']>;
  publicCompanyPhoneNr?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  registrationSource?: Maybe<RegistrationSource>;
  /** Payment details that are or were active for any currency */
  relevantPaymentDetails: Array<PaymentDetails>;
  reviews?: Maybe<SupplierReviewStats>;
  selfDescription?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplierExpiringAvailability?: Maybe<SupplierExpiringAvailability>;
  supplierGygStatus?: Maybe<SupplierGygStatus>;
  taxDetails: SupplierTaxationDetails;
  termsAndConditions?: Maybe<Array<Maybe<LegalText>>>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  verificationStatus?: Maybe<VerificationStatus>;
  vtigerRecord?: Maybe<Scalars['Int']['output']>;
};


export type SupplierBookingsSummaryArgs = {
  duration: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type SupplierPaymentDetailsArgs = {
  currency: Scalars['String']['input'];
  statuses?: InputMaybe<Array<PaymentDetailsStatus>>;
};

/**
 * A supplier account is used to access a given supplier,
 * one supplier can have multiple accounts for it's many employees.
 */
export type SupplierAccount = {
  __typename?: 'SupplierAccount';
  /** Wether this account is allowed to login. */
  allowLogin?: Maybe<Scalars['Boolean']['output']>;
  /** Wether this account is allowed to receive marketing emails. */
  allowMarketingEmails?: Maybe<Scalars['Boolean']['output']>;
  /** Wether this account is allowed to receive notifications */
  allowNotification?: Maybe<Scalars['Boolean']['output']>;
  /** The account description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The account holder email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** The supplier account id on Firebase. */
  firebaseId?: Maybe<Scalars['ID']['output']>;
  /** The account holder first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the supplier account. */
  id: Scalars['ID']['output'];
  /** Wether this account is the primary supplier account. */
  isPrimary: Scalars['Boolean']['output'];
  /** The account holder last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The account preferred locale. */
  locale: Scalars['String']['output'];
  /** The account holder display name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The types of notification this account accepts. */
  notificationRoles?: Maybe<Array<Scalars['String']['output']>>;
  /** The account holder phone number. */
  phoneNr?: Maybe<Scalars['String']['output']>;
  /** The account holder role within the supplier. */
  role?: Maybe<Scalars['String']['output']>;
  /** The account status. */
  status?: Maybe<Scalars['String']['output']>;
  /** A list of marketing subscription groups that this account is subscribed to. */
  subscriptionGroups?: Maybe<Array<SubscriptionGroup>>;
  /** The supplier id. */
  supplierId: Scalars['ID']['output'];
};

export type SupplierAccountSearch = {
  __typename?: 'SupplierAccountSearch';
  items: Array<SupplierAccount>;
  pagination?: Maybe<Pagination>;
};

export type SupplierAccounts = {
  __typename?: 'SupplierAccounts';
  items: Array<Maybe<SupplierAccount>>;
  pagination?: Maybe<Pagination>;
};

export type SupplierAccountsInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  supplierId: Scalars['Int']['input'];
};

export type SupplierAddress = {
  __typename?: 'SupplierAddress';
  city?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type SupplierAdjustmentPayment = {
  __typename?: 'SupplierAdjustmentPayment';
  amount: Money;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  creationDate: Scalars['DateTime']['output'];
  gygComment: Scalars['String']['output'];
  hasBeenReverted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCancellationFee: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPartOfReversion: Scalars['Boolean']['output'];
  isSupplierCancellationCompensation: Scalars['Boolean']['output'];
  reason?: Maybe<SupplierAdjustmentPaymentReason>;
  staff: Staff;
  status: SupplierAdjustmentPaymentStatus;
  subReason?: Maybe<SupplierAdjustmentPaymentSubReason>;
  supplier: Supplier;
  supplierComment: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  supplierInvoiceId?: Maybe<Scalars['ID']['output']>;
  type: SupplierAdjustmentPaymentType;
};

export enum SupplierAdjustmentPaymentReason {
  CareFlaw = 'CARE_FLAW',
  DestinationManagerFlaw = 'DESTINATION_MANAGER_FLAW',
  GygSystemError = 'GYG_SYSTEM_ERROR',
  SupplierBonus = 'SUPPLIER_BONUS',
  SupplierFlaw = 'SUPPLIER_FLAW'
}

export type SupplierAdjustmentPaymentSearch = {
  __typename?: 'SupplierAdjustmentPaymentSearch';
  items: Array<SupplierAdjustmentPayment>;
  pagination: Pagination;
  totalItems: Scalars['Int']['output'];
};

export enum SupplierAdjustmentPaymentStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Requested = 'REQUESTED'
}

export enum SupplierAdjustmentPaymentSubReason {
  CancellationAdjustment = 'CANCELLATION_ADJUSTMENT',
  CommissionAdjustment = 'COMMISSION_ADJUSTMENT',
  ReferralAdjustment = 'REFERRAL_ADJUSTMENT',
  RetailRateAdjustment = 'RETAIL_RATE_ADJUSTMENT'
}

export enum SupplierAdjustmentPaymentType {
  Adjustment = 'ADJUSTMENT',
  CancellationFee = 'CANCELLATION_FEE',
  ManualSupplierCancellationAdjustment = 'MANUAL_SUPPLIER_CANCELLATION_ADJUSTMENT',
  ManualSupplierCommissionAdjustment = 'MANUAL_SUPPLIER_COMMISSION_ADJUSTMENT',
  ManualSupplierReferralAdjustment = 'MANUAL_SUPPLIER_REFERRAL_ADJUSTMENT',
  SupplierCancellationCompensation = 'SUPPLIER_CANCELLATION_COMPENSATION'
}

export type SupplierApiConfigResponse = {
  __typename?: 'SupplierApiConfigResponse';
  active?: Maybe<Scalars['Boolean']['output']>;
  chunkSize?: Maybe<Scalars['Int']['output']>;
  connectionMethod?: Maybe<Scalars['String']['output']>;
  isSelfMapEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationRecipient?: Maybe<Array<NotificationRecipient>>;
  supplierApiConfigID: Scalars['Int']['output'];
  supplierApiConfigLabel: Scalars['String']['output'];
  supplierApiType?: Maybe<Scalars['String']['output']>;
  timeZoneAware?: Maybe<Scalars['Boolean']['output']>;
  updateFrequency?: Maybe<Array<UpdateRunInterval>>;
};

export type SupplierApiRegistrationCompleteInput = {
  confirmationCode: Scalars['String']['input'];
  operationalLocations: Array<CreateSupplierInputOperationalLocations>;
  password: Scalars['String']['input'];
};

export type SupplierApiRegistrationCompleteResponse = {
  __typename?: 'SupplierApiRegistrationCompleteResponse';
  result: Scalars['Boolean']['output'];
};

export type SupplierBatchUpdateResponse = {
  __typename?: 'SupplierBatchUpdateResponse';
  failedIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  successfulIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type SupplierBookingsSummary = {
  __typename?: 'SupplierBookingsSummary';
  bookings: Scalars['Int']['output'];
  participants: Scalars['Int']['output'];
};

export type SupplierCancelBookingInput = {
  /** Additional Information */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** The alternative date for the booking */
  alternativeDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The reference of the booking */
  bookingReference: Scalars['String']['input'];
  /** If the customer was informed */
  customerInformed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the customer accepted, rejected or didn't reply */
  customerReplied?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** External link */
  externalLink?: InputMaybe<Scalars['String']['input']>;
  /** Issue full refund */
  fullRefund?: InputMaybe<Scalars['Boolean']['input']>;
  /** The reason for the cancellation */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The reason id for the cancellation */
  reasonId: Scalars['Int']['input'];
};

export enum SupplierCancellationAction {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export type SupplierContacts = {
  __typename?: 'SupplierContacts';
  faxNr?: Maybe<Scalars['String']['output']>;
  phoneNr?: Maybe<Scalars['String']['output']>;
};

export type SupplierDocument = {
  __typename?: 'SupplierDocument';
  fileName?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SupplierEmailAllowListEntry = {
  __typename?: 'SupplierEmailAllowListEntry';
  changesPermitted: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  supplierId: Scalars['Long']['output'];
  updateUser?: Maybe<User>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SupplierEmailAllowListEntryInput = {
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierId: Scalars['Long']['input'];
};

export type SupplierEmailInput = {
  emailType: EmailTypeEnum;
  supplierId: Scalars['Int']['input'];
};

export type SupplierExpiringAvailability = {
  __typename?: 'SupplierExpiringAvailability';
  hasAvailabilitiesExpiringSoon?: Maybe<Scalars['Boolean']['output']>;
  hasExpiredAvailabilities?: Maybe<Scalars['Boolean']['output']>;
};

export enum SupplierField {
  AccountManager = 'accountManager',
  Priority = 'priority'
}

export enum SupplierGygStatus {
  Active = 'ACTIVE',
  Confirmed = 'CONFIRMED',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
  New = 'NEW',
  Rejected = 'REJECTED'
}

export type SupplierInsights = {
  __typename?: 'SupplierInsights';
  insights: Array<Insight>;
  supplier_id?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SupplierInsightsQuery = {
  creationDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  entities?: InputMaybe<Array<InsightEntityInput>>;
  insightTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<InsightState>;
  states?: InputMaybe<Array<InsightState>>;
  supplierId: Scalars['ID']['input'];
};

export type SupplierInsurance = {
  coverageAmount: Scalars['Float']['input'];
  coverageEndDate: Scalars['String']['input'];
  coverageStartDate: Scalars['String']['input'];
  currencyId: Scalars['Int']['input'];
  policyNumber: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
};

export type SupplierInvoice = FinancialIssuedEntity & {
  __typename?: 'SupplierInvoice';
  /** The amount of the invoice */
  amount: Scalars['Float']['output'];
  /** The country relevant for the invoice */
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  /** The currency of the invoice */
  currencyIsoCode: Scalars['String']['output'];
  /** The date that the invoice was generated */
  dateOfGeneration: Scalars['DateTime']['output'];
  /** The date that the invoice was settled */
  dateOfSettlement: Scalars['DateTime']['output'];
  /** The commissions amount of GetYourGuide */
  gygCommissionAmount?: Maybe<Scalars['Float']['output']>;
  /** The string representation of the invoice */
  invoiceReference: Scalars['String']['output'];
  /** The type of the invoice */
  invoiceType: InvoiceType;
  /** The source that the payment was issued from */
  issuingSource: IssuingSource;
  /** The status of the invoice */
  status: InvoiceStatus;
  /** The ID representation of the supplier associated with the invoice */
  supplierId: Scalars['ID']['output'];
  /** The ID representation of the invoice */
  supplierInvoiceId: Scalars['ID']['output'];
  /** The ID representation of the payment linked to the invoice */
  supplierPaymentId?: Maybe<Scalars['ID']['output']>;
  /** The VAT amount of the invoice */
  vatAmountGermany?: Maybe<Scalars['Float']['output']>;
  /** The VAT rate of the invoice */
  vatRateGermany?: Maybe<Scalars['Float']['output']>;
};

export type SupplierInvoiceInput = {
  /** ID of the associated business partner */
  businessPartnerKey: BusinessPartnerKeyInput;
  /** The status of the invoices that are included in the query */
  includedInvoiceStatuses: Array<InvoiceStatus>;
  /** The types of invoices that are included in the query */
  includedInvoiceTypes: Array<InvoiceType>;
  /** The year that the invoices are issued */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierInvoices = {
  __typename?: 'SupplierInvoices';
  supplierInvoices: Array<SupplierInvoice>;
};

export enum SupplierInvoicesErrorType {
  /** Unknown error */
  UnknownError = 'UNKNOWN_ERROR'
}

export type SupplierInvoicesErrors = {
  __typename?: 'SupplierInvoicesErrors';
  error?: Maybe<SupplierInvoicesErrorType>;
};

export type SupplierInvoicesResponse = SupplierInvoices | SupplierInvoicesErrors;

export type SupplierManagement = {
  __typename?: 'SupplierManagement';
  directorFirstName?: Maybe<Scalars['String']['output']>;
  directorLastName?: Maybe<Scalars['String']['output']>;
};

export type SupplierMissingAttribute = {
  __typename?: 'SupplierMissingAttribute';
  /** Attribute name */
  name: Scalars['String']['output'];
  /** Options information */
  options?: Maybe<Array<ActivityOptionMissingAttributes>>;
  /** Tour information */
  tour: ActivityMissingAttributes;
};

export type SupplierMissingAttributes = {
  __typename?: 'SupplierMissingAttributes';
  /** List of missing attributes by tour */
  query: SupplierMissingAttributesQuery;
  /** List of missing attributes */
  results: Array<SupplierMissingAttribute>;
  /** Total number of missing attributes for this supplier */
  total: Scalars['Int']['output'];
};

export type SupplierMissingAttributesQuery = {
  __typename?: 'SupplierMissingAttributesQuery';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
};

export type SupplierMissingCompletenessInput = {
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type SupplierPayload = {
  __typename?: 'SupplierPayload';
  supplier?: Maybe<Supplier>;
};

export type SupplierPayment = FinancialIssuedEntity & Payment & {
  __typename?: 'SupplierPayment';
  /** The amount of the payment */
  amount: Scalars['Float']['output'];
  /** Any comments about the payment */
  comment?: Maybe<Scalars['String']['output']>;
  /** The compound entry id representing the payment */
  compoundEntryId: Scalars['String']['output'];
  /** The currency ISO code of the payment */
  currencyIsoCode: Scalars['String']['output'];
  /** The date that the payment was conducted */
  dateOfPayment: Scalars['DateTime']['output'];
  /** The reason the payment failed, if there was a failure */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The staff id that triggered the payment */
  gygStaffId: Scalars['Int']['output'];
  /** The invoices associated with the payment */
  invoices: Array<SupplierInvoice>;
  /** The source that the payment was issued froms */
  issuingSource: IssuingSource;
  /** The note that we issue to the payee */
  noteToPayee: Scalars['String']['output'];
  /** The payment channel that the payment went through */
  paymentChannel?: Maybe<PaymentChannel>;
  /** The ID representation of the payment */
  paymentId: Scalars['ID']['output'];
  /** The status of the payment */
  status: PaymentStatus;
  /** The supplier associated with the payment */
  supplierId: Scalars['ID']['output'];
};

export type SupplierPaymentSettings = {
  __typename?: 'SupplierPaymentSettings';
  allowedToChangeCurrency: Scalars['Boolean']['output'];
  canHaveFixedNetRates: Scalars['Boolean']['output'];
  chargeCancellationCompensation: Scalars['Boolean']['output'];
  paymentBlocked: Scalars['Boolean']['output'];
  vatRate: Scalars['Float']['output'];
};

export type SupplierPayments = {
  __typename?: 'SupplierPayments';
  supplierPayments: Array<SupplierPayment>;
};

export enum SupplierPaymentsErrorType {
  /** Unknown error */
  UnknownReason = 'UNKNOWN_REASON'
}

export type SupplierPaymentsErrors = {
  __typename?: 'SupplierPaymentsErrors';
  error?: Maybe<SupplierPaymentsErrorType>;
};

export type SupplierPaymentsInput = {
  /** ID of the associated business partner */
  businessPartnerKey: BusinessPartnerKeyInput;
  /** The year that the payments are issued */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierPaymentsResponse = SupplierPayments | SupplierPaymentsErrors;

export type SupplierPreferences = {
  __typename?: 'SupplierPreferences';
  currencyId?: Maybe<Scalars['Int']['output']>;
  languageId?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<SupplierTimePreferences>;
};

export type SupplierProfileItem = {
  __typename?: 'SupplierProfileItem';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type SupplierPublicEmailInput = {
  emailType: PublicEmailTypeEnum;
  supplierId: Scalars['Int']['input'];
};

export type SupplierReminderEmailInput = {
  emailType: Scalars['String']['input'];
  missingPaymentDetails?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId: Scalars['Int']['input'];
};

export type SupplierRequestedAnswer = {
  __typename?: 'SupplierRequestedAnswer';
  /** The booking level answers */
  bookingLevel: Array<Answer>;
  /** The fallback answer */
  fallback?: Maybe<AnswerInfo>;
  /** The traveler level answers */
  travelerLevel: Array<TravelersAnswers>;
};

export type SupplierReview = {
  __typename?: 'SupplierReview';
  /** Activity the review belongs to */
  activity: Activity;
  /** ISO date the review was created */
  activityEndDate?: Maybe<Scalars['String']['output']>;
  /** Activity Option the review belongs to */
  activityOption: ActivityOption;
  /** ISO date the review was created */
  activityStartDate?: Maybe<Scalars['String']['output']>;
  /** Review author */
  author?: Maybe<SupplierReviewAuthor>;
  /** Booking the review belongs to */
  booking?: Maybe<Booking>;
  /** Booking reference the review belongs to */
  bookingReference?: Maybe<Scalars['String']['output']>;
  /** Review comment field, aka the main review content */
  comment?: Maybe<Scalars['String']['output']>;
  /** Review enjoyment field */
  commentEnjoyedMost?: Maybe<Scalars['String']['output']>;
  /** ISO date the review was created */
  createdAt: Scalars['String']['output'];
  /** Determines if the review is anonymous */
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  /** The language the review was written in */
  language?: Maybe<Scalars['String']['output']>;
  /** Review rating value (1-5) */
  rating: Scalars['Int']['output'];
  /** List of review optional ratings (transport, guide, value_for_money, organization, safety, service, meeting_point) */
  ratings: Array<ReviewRating>;
  /** Review id */
  reviewId: Scalars['ID']['output'];
  /** Review title */
  title?: Maybe<Scalars['String']['output']>;
  /** Review traveler age group (`18-29`, `30-39`, `40-49`, `50-59`, `60-69`, `70+`) */
  travelerAgeGroup?: Maybe<Scalars['String']['output']>;
  /** Review traveler type (`couple`, `friends`, `family_young`, `family_old`, `solo`) */
  travelerType?: Maybe<Scalars['String']['output']>;
};

export type SupplierReviewAuthor = {
  __typename?: 'SupplierReviewAuthor';
  /** Review author's country */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Review author's full name */
  fullName?: Maybe<Scalars['String']['output']>;
};

export type SupplierReviewStats = {
  __typename?: 'SupplierReviewStats';
  /** Average rating */
  averageRating?: Maybe<Scalars['Float']['output']>;
  /** Reviews count change percentage from the previous 30 days */
  changePercentage?: Maybe<Scalars['Float']['output']>;
  /** Total # of reviews */
  total?: Maybe<Scalars['Int']['output']>;
};

export type SupplierReviewsInput = {
  /** A list of review ids to update */
  activityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** A list of review ids to update */
  activityOptionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Max number of items to show. */
  limit: Scalars['Int']['input'];
  /** Current selected item offset. */
  offset: Scalars['Int']['input'];
  /** A list of review ratings to be filterd [1-5] */
  ratings?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Search for reviews after the given date */
  reviewDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Search for reviews before the given date */
  reviewDateTo?: InputMaybe<Scalars['String']['input']>;
  /** Field specific sorting configuration. */
  sort: SortInput;
  /** Supplier id to filter */
  supplierId: Scalars['Int']['input'];
  /** Search for reviews after the given date */
  travelDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Search for reviews before the given date */
  travelDateTo?: InputMaybe<Scalars['String']['input']>;
  /** traveler type */
  travelerTypes?: InputMaybe<Array<ReviewTravelerType>>;
};

export type SupplierReviewsResult = {
  __typename?: 'SupplierReviewsResult';
  /** A list of reviews */
  reviews: Array<SupplierReview>;
  /** Average rating calculated based on the applied filters */
  reviewsAverageRating?: Maybe<Scalars['Float']['output']>;
  /** Total # of reviews */
  total?: Maybe<Scalars['Int']['output']>;
};

export type SupplierSearch = {
  __typename?: 'SupplierSearch';
  items: Array<Supplier>;
  pagination?: Maybe<Pagination>;
};

export type SupplierTaxDetails = {
  __typename?: 'SupplierTaxDetails';
  einNumber?: Maybe<Scalars['String']['output']>;
  hasVatId?: Maybe<Scalars['Boolean']['output']>;
  tinCountryId?: Maybe<Scalars['Int']['output']>;
  tinId?: Maybe<Scalars['String']['output']>;
  vatCountryId?: Maybe<Scalars['Int']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  w9File?: Maybe<Scalars['String']['output']>;
};

export type SupplierTaxationDetails = {
  __typename?: 'SupplierTaxationDetails';
  einNumber?: Maybe<Scalars['String']['output']>;
  hasVatId: Scalars['Boolean']['output'];
  tinCountryId?: Maybe<Scalars['Int']['output']>;
  tinId?: Maybe<Scalars['String']['output']>;
  vatCountryId?: Maybe<Scalars['Int']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  w9file?: Maybe<Scalars['String']['output']>;
};

export type SupplierTimePreferences = {
  __typename?: 'SupplierTimePreferences';
  timeFormat?: Maybe<Scalars['String']['output']>;
  timezoneId?: Maybe<Scalars['Int']['output']>;
};

export type SupplierTourStatusChangeEmailInput = {
  activityId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SuppliersToursCancellationPolicyInput = {
  /** The cancellation policy type to be set to tours */
  cancellationPolicyType: CancellationPolicyType;
  /** The details for the custom cancellation policy */
  customCancellationPolicy?: InputMaybe<CustomCancellationPolicyInput>;
  /** The list of supplier IDs to be updated */
  supplierIds: Array<Scalars['ID']['input']>;
};

export type SuppliersToursCancellationPolicyPayload = {
  __typename?: 'SuppliersToursCancellationPolicyPayload';
  /** The list of suppliers that were updated (key as string) and their tours (value as string array) */
  suppliersTours: Array<Maybe<SuppliersToursItem>>;
};

export type SuppliersToursItem = {
  __typename?: 'SuppliersToursItem';
  /** The supplier ID */
  supplierId: Scalars['ID']['output'];
  /** The list of tours IDs */
  tourIds: Array<Scalars['ID']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  /** Children of tag. */
  children?: Maybe<Array<Tag>>;
  /** Non-localised tag description for internal purposes. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the tag should be hidden in the tag selector */
  hideFromTagSelector?: Maybe<Scalars['Boolean']['output']>;
  /** Uniquely identifies a tag. */
  id: Scalars['ID']['output'];
  /** Normalised representation of the tag name. */
  internalName: Scalars['String']['output'];
  /** Unlocalized name of the tag. */
  name: Scalars['String']['output'];
  /** Parent tag. */
  parent?: Maybe<Tag>;
  /** If tag was rejected, this field holds information as to why. */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Tag status. */
  status?: Maybe<TagStatus>;
  /** Number of tours the tag is assigned to */
  tours?: Maybe<Scalars['Int']['output']>;
  /** Localized free text fields of the tag for each language. */
  translations?: Maybe<Array<TagTranslation>>;
  /** Type of the given tag. */
  type?: Maybe<TagType>;
  /** The last time this tag was updated. */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user that last updated this tag. */
  updateUser?: Maybe<User>;
};

export type TagSearchResult = {
  __typename?: 'TagSearchResult';
  items: Array<Tag>;
  pagination: Pagination;
};

export enum TagStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Entity holding fields relevant to a tag translation */
export type TagTranslation = {
  __typename?: 'TagTranslation';
  /** The language this translation is in */
  languageId: Scalars['Int']['output'];
  /** The localized name of the tag in the given language */
  name: Scalars['String']['output'];
  /** The tag this translation belongs to */
  tag?: Maybe<Tag>;
  /** The last time the tag translation was updated */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The user who made the last change to the tag translation */
  updateUser?: Maybe<User>;
};

export enum TagType {
  Audience = 'AUDIENCE',
  ConfiguratorFoodAndDrink = 'CONFIGURATOR_FOOD_AND_DRINK',
  DietaryRestrictions = 'DIETARY_RESTRICTIONS',
  Drinks = 'DRINKS',
  DrinksAlcoholic = 'DRINKS_ALCOHOLIC',
  DrinksNonAlcoholic = 'DRINKS_NON_ALCOHOLIC',
  Food = 'FOOD',
  FoodType = 'FOOD_TYPE',
  InternalKeywords = 'INTERNAL_KEYWORDS',
  ItemsToBring = 'ITEMS_TO_BRING',
  ItineraryActivity = 'ITINERARY_ACTIVITY',
  ItineraryGenericLocation = 'ITINERARY_GENERIC_LOCATION',
  Keywords = 'KEYWORDS',
  LocationAreaType = 'LOCATION_AREA_TYPE',
  NotSuitableFor = 'NOT_SUITABLE_FOR',
  RentalItems = 'RENTAL_ITEMS',
  Restrictions = 'RESTRICTIONS',
  Seasonal = 'SEASONAL',
  Theme = 'THEME',
  ThemeGroup = 'THEME_GROUP',
  UnclassifiedAttribute = 'UNCLASSIFIED_ATTRIBUTE'
}

export type Ticket = {
  __typename?: 'Ticket';
  batchReference?: Maybe<Scalars['String']['output']>;
  bookingReference?: Maybe<Scalars['String']['output']>;
  breakagePrice?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  impairmentCost?: Maybe<Money>;
  purchaseDate?: Maybe<Scalars['String']['output']>;
  purchasePrice?: Maybe<Money>;
  redemptionDate?: Maybe<Scalars['String']['output']>;
  refundDate?: Maybe<Scalars['String']['output']>;
  refundPrice?: Maybe<Scalars['Float']['output']>;
  retailPrice?: Maybe<Money>;
  returnCost?: Maybe<Money>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  ticketCategory?: Maybe<Scalars['String']['output']>;
  ticketCategorySoldAs?: Maybe<Scalars['String']['output']>;
  ticketCode?: Maybe<Scalars['String']['output']>;
  ticketCodeType?: Maybe<Scalars['String']['output']>;
  ticketReference?: Maybe<Scalars['String']['output']>;
  ticketStatus?: Maybe<Scalars['String']['output']>;
  tourOption?: Maybe<ActivityOption>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type TicketAdvanceInventoryMonitor = TicketConfigurationMonitor & {
  __typename?: 'TicketAdvanceInventoryMonitor';
  additionalRecipients: Array<Scalars['String']['output']>;
  days: Scalars['Int']['output'];
  sendToAccountManager: Scalars['Boolean']['output'];
  ticketCategory: Scalars['String']['output'];
};

export type TicketAdvanceInventoryMonitorInput = {
  additionalRecipients: Array<Scalars['String']['input']>;
  days: Scalars['Int']['input'];
  sendToAccountManager: Scalars['Boolean']['input'];
  ticketCategory: Scalars['String']['input'];
};

export type TicketBatchStatistics = {
  __typename?: 'TicketBatchStatistics';
  activityOption?: Maybe<ActivityOption>;
  count: Scalars['Int']['output'];
  deleted: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isOnSale: Scalars['Boolean']['output'];
  onSale: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  uploadTimestamp?: Maybe<Scalars['DateTime']['output']>;
  uploadedByStaff?: Maybe<Staff>;
};

export type TicketConfiguration = {
  __typename?: 'TicketConfiguration';
  allowDuplicateCodes?: Maybe<Scalars['Boolean']['output']>;
  allowMissingCodes?: Maybe<Scalars['Boolean']['output']>;
  hasLongValidity?: Maybe<Scalars['Boolean']['output']>;
  hasTimePeriodValidity?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketConfigurationMonitor = {
  additionalRecipients: Array<Scalars['String']['output']>;
  sendToAccountManager: Scalars['Boolean']['output'];
  ticketCategory: Scalars['String']['output'];
};

export type TicketInfoInput = {
  /** The ticket code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The ticket sequence number */
  sequenceNumber: Scalars['Int']['input'];
};

export type TicketLowInventoryMonitor = TicketConfigurationMonitor & {
  __typename?: 'TicketLowInventoryMonitor';
  additionalRecipients: Array<Scalars['String']['output']>;
  minVacancies: Scalars['Int']['output'];
  sendToAccountManager: Scalars['Boolean']['output'];
  ticketCategory: Scalars['String']['output'];
};

export type TicketLowInventoryMonitorInput = {
  additionalRecipients: Array<Scalars['String']['input']>;
  minVacancies: Scalars['Int']['input'];
  sendToAccountManager: Scalars['Boolean']['input'];
  ticketCategory: Scalars['String']['input'];
};

export type TicketMonitorSettings = {
  __typename?: 'TicketMonitorSettings';
  advanceInventory?: Maybe<Array<TicketAdvanceInventoryMonitor>>;
  lowInventory?: Maybe<Array<TicketLowInventoryMonitor>>;
  preBuyQuantity?: Maybe<Array<TicketPreBuyQuantityMonitor>>;
  refundInventory?: Maybe<Array<TicketRefundInventoryMonitor>>;
};

export type TicketPreBuyQuantityMonitor = TicketConfigurationMonitor & {
  __typename?: 'TicketPreBuyQuantityMonitor';
  additionalRecipients: Array<Scalars['String']['output']>;
  daysInAdvance: Scalars['Int']['output'];
  sendToAccountManager: Scalars['Boolean']['output'];
  ticketCategory: Scalars['String']['output'];
  ticketNeedTicketCategory: Scalars['String']['output'];
};

export type TicketPreBuyQuantityMonitorInput = {
  additionalRecipients: Array<Scalars['String']['input']>;
  daysInAdvance: Scalars['Int']['input'];
  sendToAccountManager: Scalars['Boolean']['input'];
  ticketCategory: Scalars['String']['input'];
  ticketNeedTicketCategory: Scalars['String']['input'];
};

export type TicketRefundInventoryMonitor = TicketConfigurationMonitor & {
  __typename?: 'TicketRefundInventoryMonitor';
  additionalRecipients: Array<Scalars['String']['output']>;
  maxAllowedHoursToRefund: Scalars['String']['output'];
  maxHoursBetweenCronRuns: Scalars['String']['output'];
  sendToAccountManager: Scalars['Boolean']['output'];
  ticketCategory: Scalars['String']['output'];
};

export type TicketRefundInventoryMonitorInput = {
  additionalRecipients: Array<Scalars['String']['input']>;
  maxAllowedHoursToRefund: Scalars['String']['input'];
  maxHoursBetweenCronRuns: Scalars['String']['input'];
  sendToAccountManager: Scalars['Boolean']['input'];
  ticketCategory: Scalars['String']['input'];
};

export type TicketStatistics = {
  __typename?: 'TicketStatistics';
  activityOption?: Maybe<ActivityOption>;
  inTransition?: Maybe<Scalars['Int']['output']>;
  onSale?: Maybe<Scalars['Int']['output']>;
  refunded?: Maybe<Scalars['Int']['output']>;
  sold?: Maybe<Scalars['Int']['output']>;
  ticketCategory?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  validity?: Maybe<TicketStatisticsValidity>;
};

export type TicketStatisticsValidity = {
  __typename?: 'TicketStatisticsValidity';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type TicketsBatchStatisticsSearch = {
  __typename?: 'TicketsBatchStatisticsSearch';
  items: Array<TicketBatchStatistics>;
  pagination: Pagination;
};

export type TicketsStatisticsSearch = {
  __typename?: 'TicketsStatisticsSearch';
  items: Array<TicketStatistics>;
  pagination: Pagination;
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  from: Scalars['String']['output'];
  to?: Maybe<Scalars['String']['output']>;
};

export type TimeSlotInput = {
  from: Scalars['String']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
};

export type TimeSlotUpdateInput = {
  cutOffTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  ids: Array<Scalars['ID']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  vacancies?: InputMaybe<Scalars['Int']['input']>;
};

export type TourCompleteness = {
  __typename?: 'TourCompleteness';
  /** Calculated completeness score across all required fields (not required fields are always complete) */
  completenessRate: Scalars['Float']['output'];
  /** Completeness id == tour id */
  id: Scalars['ID']['output'];
  /** Completeness of option-related fields, can be null if no options are present */
  options?: Maybe<Array<Maybe<OptionCompleteness>>>;
  /** Completeness of tour-related fields */
  tour: TourCompletenessValue;
};

export type TourCompletenessValue = {
  __typename?: 'TourCompletenessValue';
  abstract?: Maybe<CompletenessStatus>;
  additional_information?: Maybe<CompletenessStatus>;
  change_in_itinerary?: Maybe<CompletenessStatus>;
  description?: Maybe<CompletenessStatus>;
  drinks?: Maybe<CompletenessStatus>;
  emergency_phone_number?: Maybe<CompletenessStatus>;
  emergency_phone_prefix?: Maybe<CompletenessStatus>;
  exclusions?: Maybe<CompletenessStatus>;
  food?: Maybe<CompletenessStatus>;
  guide_type?: Maybe<CompletenessStatus>;
  highlights?: Maybe<CompletenessStatus>;
  how_to_receive_voucher?: Maybe<CompletenessStatus>;
  includes_overnight_stay?: Maybe<CompletenessStatus>;
  inclusions?: Maybe<CompletenessStatus>;
  is_drinks_included?: Maybe<CompletenessStatus>;
  is_food_included?: Maybe<CompletenessStatus>;
  is_outside_the_city?: Maybe<CompletenessStatus>;
  items_to_bring?: Maybe<CompletenessStatus>;
  itinerary_enabled?: Maybe<CompletenessStatus>;
  keywords?: Maybe<CompletenessStatus>;
  locations?: Maybe<CompletenessStatus>;
  locations_access_mode?: Maybe<CompletenessStatus>;
  locations_entrance_type?: Maybe<CompletenessStatus>;
  meals?: Maybe<CompletenessStatus>;
  must_book_online?: Maybe<CompletenessStatus>;
  not_suitable_for?: Maybe<CompletenessStatus>;
  pictures?: Maybe<CompletenessStatus>;
  rental_items?: Maybe<CompletenessStatus>;
  restrictions?: Maybe<CompletenessStatus>;
  slug?: Maybe<CompletenessStatus>;
  title?: Maybe<CompletenessStatus>;
  tour_checkout_questions?: Maybe<CompletenessStatus>;
  tour_class?: Maybe<CompletenessStatus>;
  tour_code?: Maybe<CompletenessStatus>;
  transportation_types?: Maybe<CompletenessStatus>;
  transportation_types_has_air_con?: Maybe<CompletenessStatus>;
  transportation_types_has_wifi?: Maybe<CompletenessStatus>;
  transportation_types_is_private?: Maybe<CompletenessStatus>;
  transportation_types_number_of_luggage?: Maybe<CompletenessStatus>;
  voucher_information?: Maybe<CompletenessStatus>;
};

/** TourContentGenerationResponse: */
export type TourContentGenerationResponse = {
  __typename?: 'TourContentGenerationResponse';
  activityId: Scalars['Int']['output'];
  contentGenerationMessage?: Maybe<Scalars['String']['output']>;
  contentGenerationStatus?: Maybe<Scalars['String']['output']>;
  inputText?: Maybe<Scalars['String']['output']>;
};

export type TourRestriction = {
  __typename?: 'TourRestriction';
  restrictionId: Scalars['Int']['output'];
  restrictionName: Scalars['String']['output'];
};

export enum TransactionType {
  Adyen = 'ADYEN',
  Bitpay = 'BITPAY',
  Concardis = 'CONCARDIS',
  MasterBill = 'MASTER_BILL',
  Moneybookers = 'MONEYBOOKERS',
  PaymentService = 'PAYMENT_SERVICE',
  Paypal = 'PAYPAL'
}

export enum TranslationEngineType {
  Deepl = 'DEEPL',
  Google = 'GOOGLE'
}

export enum TranslationType {
  MachineTranslation = 'MACHINE_TRANSLATION',
  Xtm = 'XTM'
}

export type TransportationType = {
  __typename?: 'TransportationType';
  mode?: Maybe<TransportationTypeMode>;
};

export type TransportationTypeInput = {
  mode: TransportationTypeMode;
};

export enum TransportationTypeMode {
  Airplane = 'AIRPLANE',
  AirBoat = 'AIR_BOAT',
  Balloon = 'BALLOON',
  BananaBoat = 'BANANA_BOAT',
  BeerBike = 'BEER_BIKE',
  BeerBoat = 'BEER_BOAT',
  Bicycle = 'BICYCLE',
  BlackCab = 'BLACK_CAB',
  BusCoach = 'BUS_COACH',
  CableCar = 'CABLE_CAR',
  Camel = 'CAMEL',
  Canoe = 'CANOE',
  Car = 'CAR',
  Catamaran = 'CATAMARAN',
  Dhow = 'DHOW',
  DuckBoat = 'DUCK_BOAT',
  ElectricBicycle = 'ELECTRIC_BICYCLE',
  ElectricCar = 'ELECTRIC_CAR',
  Ferry = 'FERRY',
  GlassBottomBoat = 'GLASS_BOTTOM_BOAT',
  Glider = 'GLIDER',
  GolfCart = 'GOLF_CART',
  Gondola = 'GONDOLA',
  Helicopter = 'HELICOPTER',
  Horse = 'HORSE',
  HorseCarriage = 'HORSE_CARRIAGE',
  JeepSuv = 'JEEP_SUV',
  JetSki = 'JET_SKI',
  Kayak = 'KAYAK',
  LakeCruise = 'LAKE_CRUISE',
  Limousine = 'LIMOUSINE',
  Motorcycle = 'MOTORCYCLE',
  MotorizedTukTuk = 'MOTORIZED_TUK_TUK',
  MountainBike = 'MOUNTAIN_BIKE',
  OnFoot = 'ON_FOOT',
  OtherAnimal = 'OTHER_ANIMAL',
  OtherWaterTransport = 'OTHER_WATER_TRANSPORT',
  PedicabRickshaw = 'PEDICAB_RICKSHAW',
  Public = 'PUBLIC',
  QuadAtv = 'QUAD_ATV',
  Raft = 'RAFT',
  RiverBoat = 'RIVER_BOAT',
  Sailboat = 'SAILBOAT',
  Scooter = 'SCOOTER',
  Segway = 'SEGWAY',
  SightseeingCruise = 'SIGHTSEEING_CRUISE',
  Sled = 'SLED',
  Snowmobile = 'SNOWMOBILE',
  SpeedBoat = 'SPEED_BOAT',
  StandUpPaddleBoard = 'STAND_UP_PADDLE_BOARD',
  Submarine = 'SUBMARINE',
  Subway = 'SUBWAY',
  Surfboard = 'SURFBOARD',
  Train = 'TRAIN',
  Tram = 'TRAM',
  Trike = 'TRIKE',
  Trolley = 'TROLLEY',
  TukTuk = 'TUK_TUK',
  Van = 'VAN',
  VintageCar = 'VINTAGE_CAR',
  WaterTaxi = 'WATER_TAXI',
  Yacht = 'YACHT'
}

export type TravelerActivityType = {
  __typename?: 'TravelerActivityType';
  backgroundColor: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type TravelerPage = {
  __typename?: 'TravelerPage';
  layout: LayoutType;
};

export type TravelerPageInput = {
  id: Scalars['ID']['input'];
};

export type TravelersAnswers = {
  __typename?: 'TravelersAnswers';
  /** The answers for each travel */
  answers: Array<Array<AnswerInfo>>;
  /** The category id (e.g dietaryRestrictions) */
  id: Scalars['ID']['output'];
};

export type TravelersAnswersInput = {
  /** The answers for each travel */
  answers: Array<Array<AnswerInfoInput>>;
  /** The category id (e.g dietaryRestrictions) */
  id: Scalars['ID']['input'];
};

export enum UnconfirmedBookingFilterType {
  ExcludeNoAvailability = 'EXCLUDE_NO_AVAILABILITY',
  NoAvailability = 'NO_AVAILABILITY',
  PermanentlyFailed = 'PERMANENTLY_FAILED'
}

export type UnconfirmedBookingSearchInput = {
  filterType: UnconfirmedBookingFilterType;
  /** Max number of items to show. */
  limit?: Scalars['Int']['input'];
  /** Current selected item offset. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Current selected page. */
  page?: Scalars['Int']['input'];
  /** Optional sorting parameters */
  sorts?: InputMaybe<Array<SortInput>>;
};

export type UnconfirmedBookingSearchResult = {
  __typename?: 'UnconfirmedBookingSearchResult';
  items: Array<Booking>;
  pagination: Pagination;
};

export type UnionStaffEntityNotFound = EntityNotFound | Staff;

export type UpdateAccountInput = {
  allowLogin?: InputMaybe<Scalars['Boolean']['input']>;
  allowMarketingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  notificationRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNr?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AccountRoleInput>;
  status?: InputMaybe<AccountStatus>;
  subscriptionGroups?: InputMaybe<Array<AccountSubscriptionStateInput>>;
  supplierId: Scalars['Int']['input'];
};

export type UpdateAvailabilityByActivityOptionIdInput = {
  /** The ID of the Activity Option related to the Availability */
  activityOptionId: Scalars['Int']['input'];
  /** Date from which availability will be updated */
  fromDate: Scalars['String']['input'];
  /** Date to which availability will be updated */
  toDate: Scalars['String']['input'];
};

export type UpdateAvailabilityPayload = {
  __typename?: 'UpdateAvailabilityPayload';
  /** Message with details of the error, if the creation fails */
  message?: Maybe<Scalars['String']['output']>;
  /** The created link between the Pricing and the Availability Block */
  pricingToAvailabilityBlock?: Maybe<PricingToAvailabilityBlock>;
  /** Flag that indicates if the Pricing was created */
  success: Scalars['Boolean']['output'];
};

export type UpdateBillingDetailsInput = {
  /** The billing details to be updated */
  billingDetailsItems?: InputMaybe<Array<UpdateBillingDetailsItemInput>>;
  /** The unique identifier of the booking */
  bookingId: Scalars['ID']['input'];
};

export type UpdateBillingDetailsItemInput = {
  /** The commission rate */
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the billing detail item */
  id: Scalars['ID']['input'];
  /** The number of the participants */
  numberOfParticipants?: InputMaybe<Scalars['Int']['input']>;
  /** The price of the billing detail item */
  price?: InputMaybe<MoneyInput>;
  /** The quantity of addons */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBillingDetailsPayload = {
  __typename?: 'UpdateBillingDetailsPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateBookingInput = {
  /** The ID of the booking to be edited */
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  /** The language tour option link id */
  conductionLanguageDetails?: InputMaybe<LegacyConductionLanguageInput>;
  /** The customer accommodation */
  customerAccommodation?: InputMaybe<Scalars['String']['input']>;
  /** The customer comment */
  customerComment?: InputMaybe<Scalars['String']['input']>;
  /** The flag for Fraud */
  isFraud?: InputMaybe<Scalars['Boolean']['input']>;
  /** The flag for supplier contact */
  isSupplierContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** The flag for email support */
  isSupportEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** The flag for phone support */
  isSupportPhone?: InputMaybe<Scalars['Boolean']['input']>;
  /** The flag for Value Added Tax */
  isVat?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the rescheduled booking */
  rescheduledBookingId?: InputMaybe<Scalars['ID']['input']>;
  /** The reseller reference code */
  resellerReferenceCode?: InputMaybe<Scalars['String']['input']>;
  /** The tour option ID */
  tourOptionId?: InputMaybe<Scalars['ID']['input']>;
  /** The tour start date and time */
  tourStart?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateBookingPayload = {
  __typename?: 'UpdateBookingPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input holding fields necessary to update a category */
export type UpdateCategoryInput = {
  /** The id of the category */
  id: Scalars['Int']['input'];
  /** Wheter or not the category is externally exposed */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the category */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The parent category id */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** The status of the category */
  status?: InputMaybe<CategoryStatus>;
  /** Tags to associate with the updated category */
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Translations for the given category */
  translations: Array<UpdateCategoryTranslationInput>;
};

/** Return type of UpdateCategoryInput */
export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  /** The updated Category */
  category?: Maybe<Category>;
};

/** Input holding fields necessary to update a category translation */
export type UpdateCategoryTranslationInput = {
  /** The language id to use for the translation */
  languageId: Scalars['Int']['input'];
  /** The localized name of the category in the given language */
  name: Scalars['String']['input'];
};

/** Input holding fields necessary to update a comment */
export type UpdateCommentInput = {
  /** The content of the comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The date of the comment */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The entity id of the comment */
  id: Scalars['ID']['input'];
  /** The type of the comment */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Return type of UpdateCommentInput */
export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  /** The updated comment */
  comment?: Maybe<Comment>;
};

export type UpdateConnectivityPartnerSelfMappingInput = {
  /** Action enable or disable the partner mapping for the supplier */
  action: MappingAction;
  /** The unique ID of the Connectivity Partner or Integration */
  integrationId: Scalars['Int']['input'];
  /** The unique ID of the Supplier */
  supplierReference?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCouponInput = {
  /** The discount percentage */
  couponId: Scalars['ID']['input'];
  /** The expiry date of the coupon */
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCustomerAddressInput = {
  /** The name of the city of the customer */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company of the customer */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** The iso code of the country */
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  /** The date of birth of the customer */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** The email of the customer */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the customer address */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The iso code of the language the customer has chosen */
  languageIsoCode?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the customer */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the customer */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The name of the state of the customer */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The name of the street of the customer */
  street?: InputMaybe<Scalars['String']['input']>;
  /** The suffix of the address */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The zip code of the address of the customer */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerAddressPayload = OperationResult & {
  __typename?: 'UpdateCustomerAddressPayload';
  customerAddress: CustomerAddress;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCustomerInput = {
  /** The email of the customer */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the customer */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The last name of the customer */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerPayload = OperationResult & {
  __typename?: 'UpdateCustomerPayload';
  customer?: Maybe<Customer>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Update input of a derived attribute configuration. */
export type UpdateDerivedAttributeConfigurationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<RulesEngineAttributeOptionInput>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Array<RulesEngineRuleItemInput>>;
  type?: InputMaybe<RulesEngineDerivedAttributeType>;
};

/** Payload containing all relevant fields related to a derived attribute update operation. */
export type UpdateDerivedAttributeConfigurationPayload = {
  __typename?: 'UpdateDerivedAttributeConfigurationPayload';
  /** The derived attribute that was updated. */
  derivedAttributeConfiguration?: Maybe<DerivedAttributeConfiguration>;
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type UpdateInventoryConfigurationPayload = {
  __typename?: 'UpdateInventoryConfigurationPayload';
  inventoryConfiguration?: Maybe<InventoryConfiguration>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateLegalTextInput = {
  languageId: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UpdateLocaleInput = {
  id: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
};

export type UpdateMultipleTimeSlotsPayload = {
  __typename?: 'UpdateMultipleTimeSlotsPayload';
  result?: Maybe<Array<UpdateTimeSlotResultItem>>;
};

export type UpdatePartnerNotificationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notificationType: PartnerNotificationType;
  partnerId: Scalars['ID']['input'];
};

export type UpdatePayload = {
  __typename?: 'UpdatePayload';
  /** Message with details of the error, if the creation fails */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag that indicates if the Pricing was created */
  success: Scalars['Boolean']['output'];
};

export type UpdatePaymentDetailsProblems = {
  __typename?: 'UpdatePaymentDetailsProblems';
  /** The list of bank validation problems */
  errors: Array<BankValidationProblem>;
};

export type UpdatePaymentDetailsResult = UpdatePaymentDetailsProblems | UpdatePaymentDetailsSuccess;

export type UpdatePaymentDetailsSuccess = {
  __typename?: 'UpdatePaymentDetailsSuccess';
  result?: Maybe<Scalars['Boolean']['output']>;
};

/** Data required to update a permission */
export type UpdatePermissionInput = {
  /** Category (permission) id to update (newsletter/action-based/reviews/etc) */
  categoryName: Scalars['String']['input'];
  /** Channel id to update (email/app/etc) */
  channelName: Scalars['String']['input'];
  /** Customer's id to update permission */
  customerId: Scalars['String']['input'];
  /** Status update (true/false) */
  isEnabled: Scalars['Boolean']['input'];
};

/** Response to update a permission */
export type UpdatePermissionPayload = {
  __typename?: 'UpdatePermissionPayload';
  /** The updated permission */
  communicationPreferences?: Maybe<CustomerCommunicationPreferences>;
  /** The result of the update operation */
  success: Scalars['Boolean']['output'];
};

export type UpdatePictureInput = {
  copyright?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<ActivityPictureSource>;
  verticalAlignment?: InputMaybe<ActivityPictureVerticalAlignment>;
};

export type UpdatePrimaryAccountInput = {
  accountId: Scalars['Int']['input'];
  supplierId: Scalars['Int']['input'];
};

export type UpdatePrivacyPolicyInput = {
  id: Scalars['String']['input'];
  privacyPolicy: UpdateLegalTextInput;
};

export type UpdatePrivacyPolicyPayLoad = {
  __typename?: 'UpdatePrivacyPolicyPayLoad';
  privacyPolicy?: Maybe<LegalText>;
};

export type UpdateProfileItemInput = {
  type: ProfileItemTypeEnum;
  value: Array<ProfileItemValueEntry>;
};

export type UpdateProfileItemsInput = {
  profileItem: UpdateProfileItemInput;
  supplierId: Scalars['Int']['input'];
};

/** Update input of a quality issue configuration. */
export type UpdateQualityIssueConfigurationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Array<RulesEngineRuleItemInput>>;
};

/** Payload containing all relevant fields related to a quality issue configuration update operation. */
export type UpdateQualityIssueConfigurationPayload = {
  __typename?: 'UpdateQualityIssueConfigurationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** The quality issue configuration that was updated. */
  qualityIssueConfiguration?: Maybe<QualityIssueConfiguration>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type UpdateRefundInput = {
  /** The ID of refund to be updated */
  refundId: Scalars['ID']['input'];
  /** The updated status of the refund */
  status: RefundStatus;
};

export type UpdateRefundPayload = {
  __typename?: 'UpdateRefundPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Update input of a restriction configuration. */
export type UpdateRestrictionConfigurationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Array<RulesEngineRuleItemInput>>;
};

/** Payload containing all relevant fields related to a restriction configuration update operation. */
export type UpdateRestrictionConfigurationPayload = {
  __typename?: 'UpdateRestrictionConfigurationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** The restriction configuration that was updated. */
  restrictionConfiguration?: Maybe<RestrictionConfiguration>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type UpdateRunInterval = {
  __typename?: 'UpdateRunInterval';
  fetchDays?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
};

export type UpdateShoppingCartInput = {
  /** The partner Id of the shopping cart */
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of shopping cart to be updated */
  shoppingCartId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateShoppingCartPayload = {
  __typename?: 'UpdateShoppingCartPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateStaffAreaMappingInput = {
  continentId: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
  isPrimary: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  mappingId: Scalars['ID']['input'];
  staffId: Scalars['Int']['input'];
};

export type UpdateSupplierBatchInput = {
  field?: InputMaybe<Field>;
  supplierIds: Array<Scalars['Int']['input']>;
};

export type UpdateSupplierEuComplianceInput = {
  isEuCompliant: Scalars['Boolean']['input'];
  supplierId: Scalars['ID']['input'];
};

export type UpdateSupplierFishfarmInput = {
  accountManagerId?: InputMaybe<Scalars['Int']['input']>;
  supplierId: Scalars['Int']['input'];
};

export type UpdateSupplierGygStatusInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  supplierGygStatus?: InputMaybe<SupplierGygStatus>;
  supplierId: Scalars['Int']['input'];
};

export type UpdateSupplierInput = {
  acquired?: InputMaybe<Scalars['Boolean']['input']>;
  acquisitionMedium?: InputMaybe<AcquisitionMedium>;
  canAddOptions?: InputMaybe<Scalars['Boolean']['input']>;
  canAddProduct?: InputMaybe<Scalars['Boolean']['input']>;
  canEditContent?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNr?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumberType?: InputMaybe<CompanyRegistrationNumberType>;
  contentAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  contractExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  contractSignDate?: InputMaybe<Scalars['DateTime']['input']>;
  contractSpecificClause?: InputMaybe<Array<Scalars['String']['input']>>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  directorFirstName?: InputMaybe<Scalars['String']['input']>;
  directorLastName?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<UpdateSupplierInputDocument>>;
  faxNr?: InputMaybe<Scalars['String']['input']>;
  hasMwst?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  insuranceConfirmationDate?: InputMaybe<Scalars['DateTime']['input']>;
  insurancePolicyMissingReason?: InputMaybe<Scalars['String']['input']>;
  isAutomatedData?: InputMaybe<Scalars['Boolean']['input']>;
  isEuCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  isGygSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  isSmallBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  isTestData?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
  legalCompanyName?: InputMaybe<Scalars['String']['input']>;
  legalStatus?: InputMaybe<LegalStatus>;
  linkedSupplier?: InputMaybe<Scalars['Int']['input']>;
  managingDirectors?: InputMaybe<Array<ManagingDirectorInput>>;
  maxNumberOfTourPictures?: InputMaybe<Scalars['Int']['input']>;
  phoneNr?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  professionalLicenceNr?: InputMaybe<Scalars['String']['input']>;
  profileItems?: InputMaybe<Array<UpdateSupplierInputProfileItem>>;
  publicCompanyEmail?: InputMaybe<Scalars['String']['input']>;
  publicCompanyPhoneNr?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  registrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  supplierGygStatus?: InputMaybe<SupplierGygStatus>;
  timeFormat?: InputMaybe<Scalars['String']['input']>;
  timezoneId?: InputMaybe<Scalars['Int']['input']>;
  vtigerRecord?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierInputDocument = {
  fileName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateSupplierInputProfileItem = {
  type: Scalars['String']['input'];
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSupplierInsightInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['ID']['input'];
  state: InsightState;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSupplierInsightPayload = {
  __typename?: 'UpdateSupplierInsightPayload';
  insight: Insight;
};

export type UpdateSupplierInsuranceInformationInput = {
  insuranceId: Scalars['Int']['input'];
  supplierId: Scalars['Int']['input'];
  updateInsuranceInformation: SupplierInsurance;
};

export type UpdateSupplierPaymentDataPayload = OperationResult & {
  __typename?: 'UpdateSupplierPaymentDataPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSupplierPaymentDataStatusInput = {
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  paymentDataStatus?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSupplierPaymentMethodInput = {
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSupplierPaymentSettingsInput = {
  chargeSupplierCompensation?: InputMaybe<Scalars['Boolean']['input']>;
  paymentBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSupplierReferenceNumberInput = {
  /** The unique identifier of the booking to be updated */
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  /** The booking reference */
  bookingReference?: InputMaybe<Scalars['String']['input']>;
  /** The code type */
  codeType?: InputMaybe<BookingTicketCodeType>;
  /** The tickets of the booking * */
  ticketData?: InputMaybe<Array<TicketInfoInput>>;
  /** The PDF ticket file encoded in Base64 */
  ticketFiles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSupplierReferenceNumberPayload = {
  __typename?: 'UpdateSupplierReferenceNumberPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSupplierRequestedAnswerInput = {
  /** The hash of the booking to be updated */
  bookingHash: Scalars['ID']['input'];
  /** The booking level answers */
  bookingLevel: Array<BookingLevelInput>;
  /** The fallback answer */
  fallback?: InputMaybe<AnswerInfoInput>;
  /** The traveler level answers */
  travelerLevel: Array<TravelersAnswersInput>;
};

export type UpdateSupplierRequestedAnswerPayload = {
  __typename?: 'UpdateSupplierRequestedAnswerPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSupplierTaxationDetailsInput = {
  einNumber?: InputMaybe<Scalars['String']['input']>;
  hasVatId?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  tinCountryId?: InputMaybe<Scalars['Int']['input']>;
  tinId?: InputMaybe<Scalars['String']['input']>;
  vatCountryId?: InputMaybe<Scalars['Int']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  w9file?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierTaxationDetailsPayload = OperationResult & {
  __typename?: 'UpdateSupplierTaxationDetailsPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateTagInput = {
  /** Children tags. */
  childrenIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Non-localised tag description for internal purposes. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the tag should be hidden in the tag selector */
  hideFromTagSelector?: InputMaybe<Scalars['Boolean']['input']>;
  /** Uniquely identifies a tag. */
  id: Scalars['ID']['input'];
  /** Unlocalized name of the tag. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Parent tag. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** If tag was rejected, this field holds information as to why. */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** Tag status. */
  status?: InputMaybe<TagStatus>;
  /** Localized free text fields of the tag for each language. */
  translations?: InputMaybe<Array<UpdateTagTranslationInput>>;
};

/** Input holding fields necessary to update a tag translation */
export type UpdateTagTranslationInput = {
  /** The language id to use for the translation */
  languageId: Scalars['Int']['input'];
  /** The localized name of the tag in the given language */
  name: Scalars['String']['input'];
};

/** Return type of [UpdateTagInput] */
export type UpdateTagsPayload = {
  __typename?: 'UpdateTagsPayload';
  /** The created Tags */
  tags: Array<Maybe<Tag>>;
};

export type UpdateTermsAndConditionsInput = {
  id: Scalars['String']['input'];
  termsAndConditions: UpdateLegalTextInput;
};

export type UpdateTermsAndConditionsPayLoad = {
  __typename?: 'UpdateTermsAndConditionsPayLoad';
  termsAndConditions?: Maybe<LegalText>;
};

export type UpdateTicketConfigurationInput = {
  activityOptionId: Scalars['ID']['input'];
  allowDuplicateCodes?: InputMaybe<Scalars['Boolean']['input']>;
  allowMissingCodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasLongValidity?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimePeriodValidity?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Payload containing all relevant fields related to an ticket con figuration
 * update operation, operation errors are also available here.
 */
export type UpdateTicketConfigurationPayload = {
  __typename?: 'UpdateTicketConfigurationPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
  /** The ticket configuration that was updated. */
  ticketConfiguration?: Maybe<TicketConfiguration>;
};

export type UpdateTicketsOnSaleOnBatchUploadInput = {
  activityOptionId: Scalars['ID']['input'];
  batchId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  impairmentCost?: InputMaybe<Scalars['Float']['input']>;
  isPrebuy?: InputMaybe<Scalars['Boolean']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  returnCost?: InputMaybe<Scalars['Float']['input']>;
  staffEmail: Scalars['String']['input'];
  ticketCategory?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Payload with result of the operation of editing the tickets
 * batch upload.
 */
export type UpdateTicketsOnSaleOnBatchUploadPayload = {
  __typename?: 'UpdateTicketsOnSaleOnBatchUploadPayload';
  /** All errors related to this operation. */
  errors?: Maybe<Array<Error>>;
  /** If the operation was successful or not. */
  success: Scalars['Boolean']['output'];
};

export type UpdateTimeSlotResult = {
  __typename?: 'UpdateTimeSlotResult';
  cutOffIsActive: Scalars['Boolean']['output'];
  cutOffTimeInSeconds: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateTimeSlotResultItem = {
  __typename?: 'UpdateTimeSlotResultItem';
  id: Scalars['ID']['output'];
  result: UpdateTimeSlotResult;
};

/** Enum representing different update user types */
export enum UpdateUserType {
  CronJob = 'CRON_JOB',
  Customer = 'CUSTOMER',
  Reseller = 'RESELLER',
  Staff = 'STAFF',
  Supplier = 'SUPPLIER'
}

/** Type holding fields relevant to a user */
export type User = {
  __typename?: 'User';
  /** The unique identifier of the user for the given type */
  id: Scalars['ID']['output'];
  /** The type of the user */
  type: Scalars['String']['output'];
};

export enum ValidFrom {
  DoNotUse = 'DO_NOT_USE',
  /**
   * Valid for a period of time starting with the first activation of the ticket.
   * See 'Validity.value' and 'Validity.unit' for details.
   */
  TimeActivated = 'TIME_ACTIVATED',
  /**
   * Valid for a period of time from date booked.
   * See 'Validity.value' and 'Validity.unit' for details.
   */
  TimeBooked = 'TIME_BOOKED',
  /** Valid on booked date. */
  TimeSelected = 'TIME_SELECTED'
}

export type Validation = Regex | ValueOptions;

export type Validity = {
  __typename?: 'Validity';
  from?: Maybe<ValidFrom>;
  unit?: Maybe<ValidityUnit>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ValidityInput = {
  from: ValidFrom;
  unit: ValidityUnit;
  value: Scalars['Float']['input'];
};

export enum ValidityUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type ValueOption = {
  __typename?: 'ValueOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ValueOptions = {
  __typename?: 'ValueOptions';
  values: Array<ValueOption>;
};

export enum VerificationStatus {
  Approved = 'APPROVED',
  NotVerified = 'NOT_VERIFIED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED'
}

export type VerticalListLayout = {
  __typename?: 'VerticalListLayout';
  blocks: Array<Maybe<BlockType>>;
};

export type Weekday = {
  __typename?: 'Weekday';
  day: Scalars['String']['output'];
  timeSlots: Array<TimeSlot>;
};

export type WeekdayInput = {
  day: Scalars['String']['input'];
  timeSlots: Array<TimeSlotInput>;
};

export type ActivityDatatableQueryVariables = Exact<{
  input: SearchInput;
}>;


export type ActivityDatatableQuery = { __typename?: 'Query', activitySearch?: { __typename?: 'ActivitySearch', items: Array<{ __typename?: 'Activity', id: string, bestseller?: boolean | null, online?: boolean | null, status?: ActivityStatus | null, category?: ActivityCategory | null, originals?: boolean | null, supplierActivityCode?: string | null, isTestData?: boolean | null, sourceText?: { __typename?: 'ActivityTranslation', title?: string | null } | null }>, pagination: { __typename?: 'Pagination', totalItems?: number | null, offset: number, limit: number, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetActivityKeywordsSuggestionQueryVariables = Exact<{
  activityId: Scalars['ID']['input'];
}>;


export type GetActivityKeywordsSuggestionQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', keywordsSuggestion?: Array<{ __typename?: 'Tag', id: string }> | null } | null };

export type ActivityCommentFieldsFragment = { __typename?: 'ActivityComment', id: string, tourId: number, type: ActivityCommentType, comment: string, status: EntityStatus, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null };

export type CreateActivityCommentMutationVariables = Exact<{
  input: ActivityCommentCreateInput;
}>;


export type CreateActivityCommentMutation = { __typename?: 'Mutation', activityCommentCreate: { __typename?: 'ActivityCommentCreatePayload', success: boolean, comment?: { __typename?: 'ActivityComment', id: string, tourId: number, type: ActivityCommentType, comment: string, status: EntityStatus, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type GetGeneratedContentInputOfActivityQueryVariables = Exact<{
  activityId: Scalars['ID']['input'];
}>;


export type GetGeneratedContentInputOfActivityQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', generatedContentUserInput?: { __typename?: 'GeneratedContentUserInput', inputText?: string | null, inputUrl?: string | null, inputUrlWebsiteContent?: string | null } | null } | null };

export type UploadMeetingPointPictureMutationVariables = Exact<{
  input: MeetingPointPictureUploadInput;
}>;


export type UploadMeetingPointPictureMutation = { __typename?: 'Mutation', meetingPointPictureUpload: { __typename?: 'MeetingPoint', picture?: string | null, pictureUrl?: string | null } };

export type CreateTourPictureMutationVariables = Exact<{
  input: CreatePictureInput;
}>;


export type CreateTourPictureMutation = { __typename?: 'Mutation', createTourPicture: { __typename?: 'PictureMutationPayload', success: boolean, isDuplicate?: boolean | null, picture?: { __typename?: 'ActivityPicture', id?: string | null, url?: string | null, order?: number | null, fileName?: string | null, originalFileName?: string | null, verticalAlignment?: ActivityPictureVerticalAlignment | null, source?: ActivityPictureSource | null } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type UpdateTourPictureMutationVariables = Exact<{
  input: UpdatePictureInput;
}>;


export type UpdateTourPictureMutation = { __typename?: 'Mutation', updateTourPicture: { __typename?: 'PictureMutationPayload', success: boolean, isDuplicate?: boolean | null, picture?: { __typename?: 'ActivityPicture', id?: string | null, url?: string | null, order?: number | null, fileName?: string | null, originalFileName?: string | null, verticalAlignment?: ActivityPictureVerticalAlignment | null, source?: ActivityPictureSource | null } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type ReorderTourPicturesMutationVariables = Exact<{
  activityId: Scalars['ID']['input'];
  input?: InputMaybe<Array<InputMaybe<ReorderPictureInput>> | InputMaybe<ReorderPictureInput>>;
}>;


export type ReorderTourPicturesMutation = { __typename?: 'Mutation', reorderTourPictures: { __typename?: 'ReorderMutationPayload', success: boolean } };

export type GetAllPicturesOfActivityQueryVariables = Exact<{
  activityId: Scalars['ID']['input'];
}>;


export type GetAllPicturesOfActivityQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', pictures?: Array<{ __typename?: 'ActivityPicture', checked?: boolean | null, copyright?: string | null, fileName?: string | null, id?: string | null, order?: number | null, source?: ActivityPictureSource | null, status?: ActivityPictureStatus | null, url?: string | null, verticalAlignment?: ActivityPictureVerticalAlignment | null, activity?: { __typename?: 'Activity', id: string } | null }> | null } | null };

export type DeleteTourPictureMutationVariables = Exact<{
  pictureId: Scalars['ID']['input'];
  input?: InputMaybe<DeletePictureInput>;
}>;


export type DeleteTourPictureMutation = { __typename?: 'Mutation', deleteTourPicture: { __typename?: 'PictureMutationPayload', success: boolean, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type UploadAuthorizedBadgeMutationVariables = Exact<{
  input: AuthorizedBadgeUploadInput;
}>;


export type UploadAuthorizedBadgeMutation = { __typename?: 'Mutation', authorizedBadgeUpload: { __typename?: 'AuthorizedBadge', id?: string | null, url?: string | null, pictureFileName?: string | null, location?: { __typename?: 'Location', id: string, name: string } | null } };

export type DeleteAuthorizedBadgeMutationVariables = Exact<{
  input: AuthorizedBadgeDeleteInput;
}>;


export type DeleteAuthorizedBadgeMutation = { __typename?: 'Mutation', authorizedBadgeDelete: boolean };

export type ActivityOptionQueryVariables = Exact<{
  activityOptionId: Scalars['ID']['input'];
}>;


export type ActivityOptionQuery = { __typename?: 'Query', activityOption?: { __typename?: 'ActivityOption', connectivitySettings?: { __typename?: 'ConnectivitySettings', managedByConnector?: boolean | null, acquisitionChannel?: string | null, externalProductId?: string | null, availabilityUpdateEnabled?: boolean | null, priceUpdateEnabled?: boolean | null, sourceConfigKey?: string | null, clientId?: number | null, target?: string | null } | null } | null };

export type UpdateConnectivitySettingsMutationVariables = Exact<{
  tourOptionId: Scalars['Int']['input'];
  input: ConnectivitySettingsInput;
  actionSendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateConnectivitySettingsMutation = { __typename?: 'Mutation', updateConnectivitySettings?: { __typename?: 'ConnectivitySettingsPayload', success?: boolean | null, message?: string | null } | null };

export type ConnectivitySourceConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectivitySourceConfigurationsQuery = { __typename?: 'Query', connectivitySourceConfigurations?: Array<{ __typename?: 'ConnectivitySourceConfig', sourceConfigKey?: string | null, sourceConfigLabel?: string | null, clients: Array<{ __typename?: 'ConnectivityClient', id?: number | null, name?: string | null }> } | null> | null };

export type SearchAddonTextsQueryVariables = Exact<{
  description: Scalars['String']['input'];
  languageId: Scalars['ID']['input'];
}>;


export type SearchAddonTextsQuery = { __typename?: 'Query', addonText?: Array<{ __typename?: 'AddonText', addonId?: string | null, description?: string | null, id?: string | null, languageId?: string | null }> | null };

export type RecomputeCacheEntriesMutationVariables = Exact<{
  input: RecomputeCacheEntriesInput;
}>;


export type RecomputeCacheEntriesMutation = { __typename?: 'Mutation', recomputeCacheEntriesMutation: { __typename?: 'RecomputeCacheEntriesPayload', success: boolean, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type CommentsByEntityQueryVariables = Exact<{
  entity: Scalars['String']['input'];
  entityId: Scalars['Int']['input'];
}>;


export type CommentsByEntityQuery = { __typename?: 'Query', commentsByEntity?: Array<{ __typename?: 'Comment', comment: string, creationTime?: string | null }> | null };

export type GlossaryFieldsFragment = { __typename?: 'Glossary', glossaryId?: string | null, externalGlossaryId?: string | null, targetLanguageId?: number | null, sourceLanguageId?: number | null, engineType?: TranslationEngineType | null };

export type GlossaryItemFieldsFragment = { __typename?: 'GlossaryItem', glossaryId?: string | null, glossaryItemId?: string | null, sourceText?: string | null, targetText?: string | null };

export type CreateGlossaryMutationVariables = Exact<{
  input: GlossaryCreateInput;
}>;


export type CreateGlossaryMutation = { __typename?: 'Mutation', glossaryCreate: { __typename?: 'GlossaryCreatePayload', glossary?: { __typename?: 'Glossary', glossaryId?: string | null, externalGlossaryId?: string | null, targetLanguageId?: number | null, sourceLanguageId?: number | null, engineType?: TranslationEngineType | null } | null } };

export type SynchronizeGlossaryMutationVariables = Exact<{
  input: GlossarySynchronizeInput;
}>;


export type SynchronizeGlossaryMutation = { __typename?: 'Mutation', glossarySynchronize: { __typename?: 'GlossarySynchronizePayload', glossary?: { __typename?: 'Glossary', glossaryId?: string | null, externalGlossaryId?: string | null, targetLanguageId?: number | null, sourceLanguageId?: number | null, engineType?: TranslationEngineType | null } | null } };

export type DeleteGlossaryMutationVariables = Exact<{
  input: GlossaryDeleteInput;
}>;


export type DeleteGlossaryMutation = { __typename?: 'Mutation', glossaryDelete: { __typename?: 'GlossaryDeletePayload', success: boolean } };

export type AllGlossariesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGlossariesQuery = { __typename?: 'Query', allGlossaries: Array<{ __typename?: 'Glossary', glossaryId?: string | null, externalGlossaryId?: string | null, targetLanguageId?: number | null, sourceLanguageId?: number | null, engineType?: TranslationEngineType | null } | null> };

export type GlossaryQueryVariables = Exact<{
  glossaryId: Scalars['ID']['input'];
}>;


export type GlossaryQuery = { __typename?: 'Query', glossary?: { __typename?: 'Glossary', glossaryId?: string | null, externalGlossaryId?: string | null, targetLanguageId?: number | null, sourceLanguageId?: number | null, engineType?: TranslationEngineType | null, items?: Array<{ __typename?: 'GlossaryItem', glossaryId?: string | null, glossaryItemId?: string | null, sourceText?: string | null, targetText?: string | null } | null> | null } | null };

export type CreateGlossaryItemMutationVariables = Exact<{
  input: GlossaryItemCreateInput;
}>;


export type CreateGlossaryItemMutation = { __typename?: 'Mutation', glossaryItemCreate: { __typename?: 'GlossaryItemCreatePayload', glossaryItems?: Array<{ __typename?: 'GlossaryItem', glossaryId?: string | null, glossaryItemId?: string | null, sourceText?: string | null, targetText?: string | null } | null> | null } };

export type EditGlossaryItemMutationVariables = Exact<{
  input: GlossaryItemEditInput;
}>;


export type EditGlossaryItemMutation = { __typename?: 'Mutation', glossaryItemEdit: { __typename?: 'GlossaryItemEditPayload', glossaryItem?: { __typename?: 'GlossaryItem', glossaryId?: string | null, glossaryItemId?: string | null, sourceText?: string | null, targetText?: string | null } | null } };

export type DeleteGlossaryItemMutationVariables = Exact<{
  input: GlossaryItemDeleteInput;
}>;


export type DeleteGlossaryItemMutation = { __typename?: 'Mutation', glossaryItemDelete: { __typename?: 'GlossaryItemDeletePayload', success: boolean } };

export type InventoryConfigurationByOptionIdQueryVariables = Exact<{
  activityOptionId: Scalars['ID']['input'];
}>;


export type InventoryConfigurationByOptionIdQuery = { __typename?: 'Query', activityOption?: { __typename?: 'ActivityOption', inventoryConfiguration?: { __typename?: 'InventoryConfiguration', availabilityType?: AvailabilityType | null } | null } | null };

export type CreateLocationPictureInputMutationVariables = Exact<{
  input: CreateLocationPictureInput;
}>;


export type CreateLocationPictureInputMutation = { __typename?: 'Mutation', createLocationPicture: { __typename?: 'LocationPictureMutationPayload', success: boolean, errors?: Array<{ __typename?: 'Error', message: string }> | null, picture?: { __typename?: 'LocationPicture', id: string, filename: string, order?: number | null, url?: string | null, type: LocationPictureType, location?: { __typename?: 'Location', id: string } | null } | null } };

export type DeleteLocationPictureMutationVariables = Exact<{
  pictureId: Scalars['ID']['input'];
}>;


export type DeleteLocationPictureMutation = { __typename?: 'Mutation', deleteLocationPicture: { __typename?: 'LocationPictureMutationPayload', success: boolean, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type LocationDatatableQueryVariables = Exact<{
  input: SearchInput;
}>;


export type LocationDatatableQuery = { __typename?: 'Query', locationSearch?: { __typename?: 'LocationSearch', items: Array<{ __typename?: 'Location', id: string, name: string, type?: LocationType | null }>, pagination: { __typename?: 'Pagination', totalItems?: number | null, offset: number, limit: number, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type LocationSuppliersSearchQueryVariables = Exact<{
  input: SearchInput;
}>;


export type LocationSuppliersSearchQuery = { __typename?: 'Query', locationSuppliersSearch?: { __typename?: 'LocationSupplierSearch', items: Array<{ __typename?: 'LocationSupplier', supplierId: string, supplierName?: string | null, supplierStatus?: string | null, locationId?: number | null }>, pagination: { __typename?: 'Pagination', totalItems?: number | null, offset: number, limit: number, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type LocationSearchQueryVariables = Exact<{
  input?: InputMaybe<SearchInput>;
}>;


export type LocationSearchQuery = { __typename?: 'Query', locationSearch?: { __typename?: 'LocationSearch', items: Array<{ __typename?: 'Location', id: string, name: string, type?: LocationType | null }>, pagination: { __typename?: 'Pagination', hasPreviousPage: boolean, hasNextPage: boolean, totalItems?: number | null } } | null };

export type LocationGeoshapeCandidatesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LocationGeoshapeCandidatesQuery = { __typename?: 'Query', googlePlace?: { __typename?: 'GooglePlace', locationGeoshapeCandidates?: Array<{ __typename?: 'LocationGeoshape', geoshapeId: string, name: string, placeType?: string | null, geometry: string, location?: { __typename?: 'Location', id: string, name: string } | null }> | null } | null };

export type MergeLocationsMutationVariables = Exact<{
  originalLocationId: Scalars['ID']['input'];
  duplicateLocationId: Scalars['ID']['input'];
}>;


export type MergeLocationsMutation = { __typename?: 'Mutation', mergeLocations: { __typename?: 'MergeLocationMutationPayload', success: boolean, location?: { __typename?: 'Location', id: string, name: string } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: { __typename?: 'DeleteLocationMutationPayload', success: boolean, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type IndividualPricingCategoryFieldsFragment = { __typename?: 'IndividualPricingCategory', id?: string | null, bookIndependently?: boolean | null, bookingType?: PricingCategoryBookingType | null, commissionRate?: number | null, ticketCategory?: string | null, ageRange?: { __typename?: 'AgeRange', maxAge?: number | null, minAge?: number | null } | null };

export type GroupPricingCategoryFieldsFragment = { __typename?: 'GroupPricingCategory', id?: string | null, commissionRate?: number | null, isAdditionalPaxForGroup?: boolean | null };

export type AvailabilityBlockFieldsFragment = { __typename?: 'AvailabilityBlock', id: string, name: string, type: AvailabilityType, activityId: string, activityOptionId?: string | null, activityOptionPricingId?: string | null, validityDateRange: { __typename?: 'DateRange', start?: string | null, end?: string | null }, specialDates?: Array<{ __typename?: 'SpecialDate', date: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null, weekdays?: Array<{ __typename?: 'Weekday', day: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null };

export type AddonFieldsFragment = { __typename?: 'Addon', id?: string | null, pricingId?: string | null, commissionRate?: number | null, resolvedCommissionRate?: number | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, text?: { __typename?: 'AddonText', id?: string | null, addonId?: string | null, description?: string | null, languageId?: string | null } | null };

export type PricingFieldsFragment = { __typename?: 'ActivityOptionPricing', id: string, name?: string | null, groupVacanciesPerTimeSlot?: number | null, maxIndividualParticipantsPerTimeSlot?: number | null, participantsRange?: { __typename?: 'PricingParticipants', max?: number | null, min?: number | null } | null, pricesPerCategory?: Array<{ __typename?: 'GroupPricingCategory', id?: string | null, commissionRate?: number | null, isAdditionalPaxForGroup?: boolean | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null } | { __typename?: 'IndividualPricingCategory', id?: string | null, bookIndependently?: boolean | null, bookingType?: PricingCategoryBookingType | null, commissionRate?: number | null, ticketCategory?: string | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, ageRange?: { __typename?: 'AgeRange', maxAge?: number | null, minAge?: number | null } | null }> | null, addons?: Array<{ __typename?: 'Addon', id?: string | null, pricingId?: string | null, commissionRate?: number | null, resolvedCommissionRate?: number | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, text?: { __typename?: 'AddonText', id?: string | null, addonId?: string | null, description?: string | null, languageId?: string | null } | null }> | null };

export type PricingConfigurationFieldsFragment = { __typename?: 'ActivityOptionPricing', id: string, name?: string | null, groupVacanciesPerTimeSlot?: number | null, maxIndividualParticipantsPerTimeSlot?: number | null, pricingToAvailabilityBlocks?: Array<{ __typename?: 'PricingToAvailabilityBlock', id: string, availabilityBlock?: { __typename?: 'AvailabilityBlock', id: string, name: string, type: AvailabilityType, activityId: string, activityOptionId?: string | null, activityOptionPricingId?: string | null, validityDateRange: { __typename?: 'DateRange', start?: string | null, end?: string | null }, specialDates?: Array<{ __typename?: 'SpecialDate', date: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null, weekdays?: Array<{ __typename?: 'Weekday', day: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null } | null }> | null, participantsRange?: { __typename?: 'PricingParticipants', max?: number | null, min?: number | null } | null, pricesPerCategory?: Array<{ __typename?: 'GroupPricingCategory', id?: string | null, commissionRate?: number | null, isAdditionalPaxForGroup?: boolean | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null } | { __typename?: 'IndividualPricingCategory', id?: string | null, bookIndependently?: boolean | null, bookingType?: PricingCategoryBookingType | null, commissionRate?: number | null, ticketCategory?: string | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, ageRange?: { __typename?: 'AgeRange', maxAge?: number | null, minAge?: number | null } | null }> | null, addons?: Array<{ __typename?: 'Addon', id?: string | null, pricingId?: string | null, commissionRate?: number | null, resolvedCommissionRate?: number | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, text?: { __typename?: 'AddonText', id?: string | null, addonId?: string | null, description?: string | null, languageId?: string | null } | null }> | null };

export type PricingConfigurationsByActivityOptionQueryVariables = Exact<{
  activityOptionId: Scalars['ID']['input'];
}>;


export type PricingConfigurationsByActivityOptionQuery = { __typename?: 'Query', activityOption?: { __typename?: 'ActivityOption', id: string, activity?: { __typename?: 'Activity', id: string, supplier?: { __typename?: 'Supplier', id: string, isGygSupplier?: boolean | null, preferences?: { __typename?: 'SupplierPreferences', currencyId?: number | null } | null } | null } | null, inventoryConfiguration?: { __typename?: 'InventoryConfiguration', usesGroupPricing?: boolean | null, usesPricingOverApi?: boolean | null, minParticipantsOnlyForFirstBooking?: boolean | null } | null, pricingConfigurations?: Array<{ __typename?: 'ActivityOptionPricing', id: string, name?: string | null, groupVacanciesPerTimeSlot?: number | null, maxIndividualParticipantsPerTimeSlot?: number | null, pricingToAvailabilityBlocks?: Array<{ __typename?: 'PricingToAvailabilityBlock', id: string, availabilityBlock?: { __typename?: 'AvailabilityBlock', id: string, name: string, type: AvailabilityType, activityId: string, activityOptionId?: string | null, activityOptionPricingId?: string | null, validityDateRange: { __typename?: 'DateRange', start?: string | null, end?: string | null }, specialDates?: Array<{ __typename?: 'SpecialDate', date: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null, weekdays?: Array<{ __typename?: 'Weekday', day: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null } | null }> | null, participantsRange?: { __typename?: 'PricingParticipants', max?: number | null, min?: number | null } | null, pricesPerCategory?: Array<{ __typename?: 'GroupPricingCategory', id?: string | null, commissionRate?: number | null, isAdditionalPaxForGroup?: boolean | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null } | { __typename?: 'IndividualPricingCategory', id?: string | null, bookIndependently?: boolean | null, bookingType?: PricingCategoryBookingType | null, commissionRate?: number | null, ticketCategory?: string | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, ageRange?: { __typename?: 'AgeRange', maxAge?: number | null, minAge?: number | null } | null }> | null, addons?: Array<{ __typename?: 'Addon', id?: string | null, pricingId?: string | null, commissionRate?: number | null, resolvedCommissionRate?: number | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, text?: { __typename?: 'AddonText', id?: string | null, addonId?: string | null, description?: string | null, languageId?: string | null } | null }> | null }> | null, inactiveAvailabilityBlocks?: Array<{ __typename?: 'AvailabilityBlock', id: string, name: string, type: AvailabilityType, activityId: string, activityOptionId?: string | null, activityOptionPricingId?: string | null, validityDateRange: { __typename?: 'DateRange', start?: string | null, end?: string | null }, specialDates?: Array<{ __typename?: 'SpecialDate', date: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null, weekdays?: Array<{ __typename?: 'Weekday', day: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null }> | null } | null };

export type DeletePricingByIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePricingByIdMutation = { __typename?: 'Mutation', deletePricing?: { __typename?: 'DeletePricingPayload', deleted: boolean, message?: string | null } | null };

export type UpdatePricingMutationVariables = Exact<{
  input: PricingInput;
  pricingId: Scalars['ID']['input'];
}>;


export type UpdatePricingMutation = { __typename?: 'Mutation', updatePricing?: { __typename?: 'PricingPayload', success: boolean, message?: string | null, activityOptionPricing?: { __typename?: 'ActivityOptionPricing', id: string, name?: string | null, groupVacanciesPerTimeSlot?: number | null, maxIndividualParticipantsPerTimeSlot?: number | null, participantsRange?: { __typename?: 'PricingParticipants', max?: number | null, min?: number | null } | null, pricesPerCategory?: Array<{ __typename?: 'GroupPricingCategory', id?: string | null, commissionRate?: number | null, isAdditionalPaxForGroup?: boolean | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null } | { __typename?: 'IndividualPricingCategory', id?: string | null, bookIndependently?: boolean | null, bookingType?: PricingCategoryBookingType | null, commissionRate?: number | null, ticketCategory?: string | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, ageRange?: { __typename?: 'AgeRange', maxAge?: number | null, minAge?: number | null } | null }> | null, addons?: Array<{ __typename?: 'Addon', id?: string | null, pricingId?: string | null, commissionRate?: number | null, resolvedCommissionRate?: number | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, text?: { __typename?: 'AddonText', id?: string | null, addonId?: string | null, description?: string | null, languageId?: string | null } | null }> | null } | null } | null };

export type CreatePricingMutationVariables = Exact<{
  input: PricingInput;
}>;


export type CreatePricingMutation = { __typename?: 'Mutation', createPricing?: { __typename?: 'PricingPayload', success: boolean, message?: string | null, activityOptionPricing?: { __typename?: 'ActivityOptionPricing', id: string, name?: string | null, groupVacanciesPerTimeSlot?: number | null, maxIndividualParticipantsPerTimeSlot?: number | null, pricingToAvailabilityBlocks?: Array<{ __typename?: 'PricingToAvailabilityBlock', id: string, availabilityBlock?: { __typename?: 'AvailabilityBlock', id: string, name: string, type: AvailabilityType, activityId: string, activityOptionId?: string | null, activityOptionPricingId?: string | null, validityDateRange: { __typename?: 'DateRange', start?: string | null, end?: string | null }, specialDates?: Array<{ __typename?: 'SpecialDate', date: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null, weekdays?: Array<{ __typename?: 'Weekday', day: string, timeSlots: Array<{ __typename?: 'TimeSlot', from: string, to?: string | null }> }> | null } | null }> | null, participantsRange?: { __typename?: 'PricingParticipants', max?: number | null, min?: number | null } | null, pricesPerCategory?: Array<{ __typename?: 'GroupPricingCategory', id?: string | null, commissionRate?: number | null, isAdditionalPaxForGroup?: boolean | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null } | { __typename?: 'IndividualPricingCategory', id?: string | null, bookIndependently?: boolean | null, bookingType?: PricingCategoryBookingType | null, commissionRate?: number | null, ticketCategory?: string | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, ageRange?: { __typename?: 'AgeRange', maxAge?: number | null, minAge?: number | null } | null }> | null, addons?: Array<{ __typename?: 'Addon', id?: string | null, pricingId?: string | null, commissionRate?: number | null, resolvedCommissionRate?: number | null, pricingScales?: Array<{ __typename?: 'PricingScale', id?: string | null, maxParticipants?: number | null, minParticipants?: number | null, prices: { __typename?: 'Prices', breakagePrice?: number | null, id?: string | null, netRatePrice?: number | null, retailPrice?: number | null, returnPrice?: number | null } }> | null, text?: { __typename?: 'AddonText', id?: string | null, addonId?: string | null, description?: string | null, languageId?: string | null } | null }> | null } | null } | null };

export type ConnectAvailabilityToPricingMutationVariables = Exact<{
  input: AvailabilityToPricingInput;
}>;


export type ConnectAvailabilityToPricingMutation = { __typename?: 'Mutation', connectAvailabilityToPricing?: { __typename?: 'UpdateAvailabilityPayload', success: boolean, message?: string | null, pricingToAvailabilityBlock?: { __typename?: 'PricingToAvailabilityBlock', id: string } | null } | null };

export type DisconnectAvailabilityToPricingMutationVariables = Exact<{
  input: AvailabilityToPricingInput;
}>;


export type DisconnectAvailabilityToPricingMutation = { __typename?: 'Mutation', disconnectAvailabilityToPricing?: { __typename?: 'UpdateAvailabilityPayload', success: boolean, message?: string | null } | null };

export type ContentReviewFieldsFragment = { __typename?: 'ContentReview', id: string, entity?: string | null, entityId?: number | null, context?: string | null, assignedStaffId?: number | null, reviewSection?: string | null, reviewStatus?: string | null, currentState?: string | null, previousState?: string | null, supplierEmailSent?: boolean | null, reverted?: boolean | null, masterLanguageId?: number | null, creationTimestamp?: any | null, updateTimestamp?: any | null, activationTimestamp?: any | null, inProgressTimestamp?: any | null, finalizedTimestamp?: any | null, priority?: number | null, contentReviewQualityIssues: Array<{ __typename?: 'ContentReviewQualityIssue', id: string, contentReviewId?: number | null, entity?: string | null, entityId?: number | null, status?: string | null, qualityIssueType?: string | null, qualityIssueSubtype?: string | null, qualityIssueDescription?: string | null }>, contentReviewChecks: Array<{ __typename?: 'ContentReviewCheck', id: string, contentReviewId?: number | null, type?: string | null, category?: string | null, status?: string | null, assignedStaffId?: number | null }>, contentReviewComments: Array<{ __typename?: 'ContentReviewComment', id: string, contentReviewId?: number | null, comment?: string | null, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null, updateStaff?: { __typename?: 'Staff', name: string } | null }>, updateUser?: { __typename?: 'User', id: string, type: string } | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null };

export type GetContentReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContentReviewQuery = { __typename?: 'Query', contentReview?: { __typename?: 'ContentReview', id: string, entity?: string | null, entityId?: number | null, context?: string | null, assignedStaffId?: number | null, reviewSection?: string | null, reviewStatus?: string | null, currentState?: string | null, previousState?: string | null, supplierEmailSent?: boolean | null, reverted?: boolean | null, masterLanguageId?: number | null, creationTimestamp?: any | null, updateTimestamp?: any | null, activationTimestamp?: any | null, inProgressTimestamp?: any | null, finalizedTimestamp?: any | null, priority?: number | null, contentReviewQualityIssues: Array<{ __typename?: 'ContentReviewQualityIssue', id: string, contentReviewId?: number | null, entity?: string | null, entityId?: number | null, status?: string | null, qualityIssueType?: string | null, qualityIssueSubtype?: string | null, qualityIssueDescription?: string | null }>, contentReviewChecks: Array<{ __typename?: 'ContentReviewCheck', id: string, contentReviewId?: number | null, type?: string | null, category?: string | null, status?: string | null, assignedStaffId?: number | null }>, contentReviewComments: Array<{ __typename?: 'ContentReviewComment', id: string, contentReviewId?: number | null, comment?: string | null, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null, updateStaff?: { __typename?: 'Staff', name: string } | null }>, updateUser?: { __typename?: 'User', id: string, type: string } | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null } | null };

export type SaveContentReviewMutationVariables = Exact<{
  input: ContentReviewUpdateInput;
}>;


export type SaveContentReviewMutation = { __typename?: 'Mutation', contentReviewUpdate: { __typename?: 'ContentReviewUpdatePayload', success: boolean, contentReview?: { __typename?: 'ContentReview', id: string, entity?: string | null, entityId?: number | null, context?: string | null, assignedStaffId?: number | null, reviewSection?: string | null, reviewStatus?: string | null, currentState?: string | null, previousState?: string | null, supplierEmailSent?: boolean | null, reverted?: boolean | null, masterLanguageId?: number | null, creationTimestamp?: any | null, updateTimestamp?: any | null, activationTimestamp?: any | null, inProgressTimestamp?: any | null, finalizedTimestamp?: any | null, priority?: number | null, contentReviewQualityIssues: Array<{ __typename?: 'ContentReviewQualityIssue', id: string, contentReviewId?: number | null, entity?: string | null, entityId?: number | null, status?: string | null, qualityIssueType?: string | null, qualityIssueSubtype?: string | null, qualityIssueDescription?: string | null }>, contentReviewChecks: Array<{ __typename?: 'ContentReviewCheck', id: string, contentReviewId?: number | null, type?: string | null, category?: string | null, status?: string | null, assignedStaffId?: number | null }>, contentReviewComments: Array<{ __typename?: 'ContentReviewComment', id: string, contentReviewId?: number | null, comment?: string | null, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null, updateStaff?: { __typename?: 'Staff', name: string } | null }>, updateUser?: { __typename?: 'User', id: string, type: string } | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type ContentReviewPrioritizeMutationVariables = Exact<{
  input: ContentReviewPrioritizeInput;
}>;


export type ContentReviewPrioritizeMutation = { __typename?: 'Mutation', contentReviewPrioritize: { __typename?: 'ContentReviewPrioritizePayload', success: boolean, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type ContentReviewCommentCreateMutationVariables = Exact<{
  input: ContentReviewCommentCreateInput;
}>;


export type ContentReviewCommentCreateMutation = { __typename?: 'Mutation', contentReviewCommentCreate: { __typename?: 'ContentReviewCommentMutatePayload', success: boolean, contentReview?: { __typename?: 'ContentReview', id: string, entity?: string | null, entityId?: number | null, context?: string | null, assignedStaffId?: number | null, reviewSection?: string | null, reviewStatus?: string | null, currentState?: string | null, previousState?: string | null, supplierEmailSent?: boolean | null, reverted?: boolean | null, masterLanguageId?: number | null, creationTimestamp?: any | null, updateTimestamp?: any | null, activationTimestamp?: any | null, inProgressTimestamp?: any | null, finalizedTimestamp?: any | null, priority?: number | null, contentReviewQualityIssues: Array<{ __typename?: 'ContentReviewQualityIssue', id: string, contentReviewId?: number | null, entity?: string | null, entityId?: number | null, status?: string | null, qualityIssueType?: string | null, qualityIssueSubtype?: string | null, qualityIssueDescription?: string | null }>, contentReviewChecks: Array<{ __typename?: 'ContentReviewCheck', id: string, contentReviewId?: number | null, type?: string | null, category?: string | null, status?: string | null, assignedStaffId?: number | null }>, contentReviewComments: Array<{ __typename?: 'ContentReviewComment', id: string, contentReviewId?: number | null, comment?: string | null, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null, updateStaff?: { __typename?: 'Staff', name: string } | null }>, updateUser?: { __typename?: 'User', id: string, type: string } | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type ContentReviewCommentEditMutationVariables = Exact<{
  input: ContentReviewCommentEditInput;
}>;


export type ContentReviewCommentEditMutation = { __typename?: 'Mutation', contentReviewCommentEdit: { __typename?: 'ContentReviewCommentMutatePayload', success: boolean, contentReview?: { __typename?: 'ContentReview', id: string, entity?: string | null, entityId?: number | null, context?: string | null, assignedStaffId?: number | null, reviewSection?: string | null, reviewStatus?: string | null, currentState?: string | null, previousState?: string | null, supplierEmailSent?: boolean | null, reverted?: boolean | null, masterLanguageId?: number | null, creationTimestamp?: any | null, updateTimestamp?: any | null, activationTimestamp?: any | null, inProgressTimestamp?: any | null, finalizedTimestamp?: any | null, priority?: number | null, contentReviewQualityIssues: Array<{ __typename?: 'ContentReviewQualityIssue', id: string, contentReviewId?: number | null, entity?: string | null, entityId?: number | null, status?: string | null, qualityIssueType?: string | null, qualityIssueSubtype?: string | null, qualityIssueDescription?: string | null }>, contentReviewChecks: Array<{ __typename?: 'ContentReviewCheck', id: string, contentReviewId?: number | null, type?: string | null, category?: string | null, status?: string | null, assignedStaffId?: number | null }>, contentReviewComments: Array<{ __typename?: 'ContentReviewComment', id: string, contentReviewId?: number | null, comment?: string | null, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null, updateStaff?: { __typename?: 'Staff', name: string } | null }>, updateUser?: { __typename?: 'User', id: string, type: string } | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type ContentReviewCommentDeleteMutationVariables = Exact<{
  input: ContentReviewCommentEditInput;
}>;


export type ContentReviewCommentDeleteMutation = { __typename?: 'Mutation', contentReviewCommentDelete: { __typename?: 'ContentReviewCommentMutatePayload', success: boolean, contentReview?: { __typename?: 'ContentReview', id: string, entity?: string | null, entityId?: number | null, context?: string | null, assignedStaffId?: number | null, reviewSection?: string | null, reviewStatus?: string | null, currentState?: string | null, previousState?: string | null, supplierEmailSent?: boolean | null, reverted?: boolean | null, masterLanguageId?: number | null, creationTimestamp?: any | null, updateTimestamp?: any | null, activationTimestamp?: any | null, inProgressTimestamp?: any | null, finalizedTimestamp?: any | null, priority?: number | null, contentReviewQualityIssues: Array<{ __typename?: 'ContentReviewQualityIssue', id: string, contentReviewId?: number | null, entity?: string | null, entityId?: number | null, status?: string | null, qualityIssueType?: string | null, qualityIssueSubtype?: string | null, qualityIssueDescription?: string | null }>, contentReviewChecks: Array<{ __typename?: 'ContentReviewCheck', id: string, contentReviewId?: number | null, type?: string | null, category?: string | null, status?: string | null, assignedStaffId?: number | null }>, contentReviewComments: Array<{ __typename?: 'ContentReviewComment', id: string, contentReviewId?: number | null, comment?: string | null, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null, updateStaff?: { __typename?: 'Staff', name: string } | null }>, updateUser?: { __typename?: 'User', id: string, type: string } | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type FindBlockingContentReviewsQueryVariables = Exact<{
  xtmDelayedTourPushId: Scalars['Int']['input'];
}>;


export type FindBlockingContentReviewsQuery = { __typename?: 'Query', findBlockingContentReviews: Array<{ __typename?: 'ContentReview', id: string, entity?: string | null, entityId?: number | null, context?: string | null, assignedStaffId?: number | null, reviewSection?: string | null, reviewStatus?: string | null, currentState?: string | null, previousState?: string | null, supplierEmailSent?: boolean | null, reverted?: boolean | null, masterLanguageId?: number | null, creationTimestamp?: any | null, updateTimestamp?: any | null, activationTimestamp?: any | null, inProgressTimestamp?: any | null, finalizedTimestamp?: any | null, priority?: number | null, contentReviewQualityIssues: Array<{ __typename?: 'ContentReviewQualityIssue', id: string, contentReviewId?: number | null, entity?: string | null, entityId?: number | null, status?: string | null, qualityIssueType?: string | null, qualityIssueSubtype?: string | null, qualityIssueDescription?: string | null }>, contentReviewChecks: Array<{ __typename?: 'ContentReviewCheck', id: string, contentReviewId?: number | null, type?: string | null, category?: string | null, status?: string | null, assignedStaffId?: number | null }>, contentReviewComments: Array<{ __typename?: 'ContentReviewComment', id: string, contentReviewId?: number | null, comment?: string | null, creationTimestamp?: any | null, updateTimestamp?: any | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null, updateUser?: { __typename?: 'User', id: string, type: string } | null, updateStaff?: { __typename?: 'Staff', name: string } | null }>, updateUser?: { __typename?: 'User', id: string, type: string } | null, creationUser?: { __typename?: 'User', id: string, type: string } | null, creationStaff?: { __typename?: 'Staff', name: string } | null } | null> };

export type StatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<RestrictionStatsInput>;
}>;


export type StatsQuery = { __typename?: 'Query', restrictionConfiguration?: { __typename?: 'RestrictionConfiguration', restrictionStats?: { __typename?: 'RestrictionStatsPage', totalResults: number, stats: Array<{ __typename?: 'RestrictionStat', entityId: number, createdAt: any, updatedAt: any, entryPoint: string, entityType: string }> } | null } | null };

export type CreateDerivedAttributeConfigurationMutationVariables = Exact<{
  input: CreateDerivedAttributeConfigurationInput;
}>;


export type CreateDerivedAttributeConfigurationMutation = { __typename?: 'Mutation', createDerivedAttributeConfiguration?: { __typename?: 'CreateDerivedAttributeConfigurationPayload', success: boolean, derivedAttributeConfiguration?: { __typename?: 'DerivedAttributeConfiguration', id: string } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } | null };

export type DeleteDerivedAttributeConfigurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDerivedAttributeConfigurationMutation = { __typename?: 'Mutation', deleteDerivedAttributeConfiguration?: { __typename?: 'DeleteDerivedAttributeConfigurationPayload', success: boolean } | null };

export type DerivedAttributePageFieldsFragment = { __typename?: 'DerivedAttributeConfiguration', id: string, type: RulesEngineDerivedAttributeType, entityType: string, internalName: string, name: string, order: number, enabled: boolean, multiple: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'User', id: string, type: string } | null, options: Array<{ __typename?: 'RulesEngineAttributeOption', id: string, value: string, enabled: boolean, order: number, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> }>, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> };

export type DerivedAttributeConfigurationPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DerivedAttributeConfigurationPageQuery = { __typename?: 'Query', derivedAttributeConfiguration?: { __typename?: 'DerivedAttributeConfiguration', id: string, type: RulesEngineDerivedAttributeType, entityType: string, internalName: string, name: string, order: number, enabled: boolean, multiple: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'User', id: string, type: string } | null, options: Array<{ __typename?: 'RulesEngineAttributeOption', id: string, value: string, enabled: boolean, order: number, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> }>, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> } | null };

export type EditDerivedAttributeConfigurationMutationVariables = Exact<{
  input: UpdateDerivedAttributeConfigurationInput;
}>;


export type EditDerivedAttributeConfigurationMutation = { __typename?: 'Mutation', updateDerivedAttributeConfiguration?: { __typename?: 'UpdateDerivedAttributeConfigurationPayload', success: boolean, derivedAttributeConfiguration?: { __typename?: 'DerivedAttributeConfiguration', id: string, type: RulesEngineDerivedAttributeType, entityType: string, internalName: string, name: string, order: number, enabled: boolean, multiple: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'User', id: string, type: string } | null, options: Array<{ __typename?: 'RulesEngineAttributeOption', id: string, value: string, enabled: boolean, order: number, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> }>, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } | null };

export type DerivedAttributeConfigurationPreviewQueryVariables = Exact<{
  input: DerivedAttributeConfigurationPreviewInput;
}>;


export type DerivedAttributeConfigurationPreviewQuery = { __typename?: 'Query', derivedAttributeConfigurationPreview?: { __typename?: 'DerivedAttributeConfigurationPreview', items: Array<{ __typename?: 'DerivedAttributeConfigurationPreviewItem', check: boolean, entityId: string, option: { __typename?: 'DerivedAttributeConfigurationOptionPreview', check: boolean, value?: string | null } }> } | null };

export type DerivedAttributeConfigurationSearchPageQueryVariables = Exact<{
  input?: InputMaybe<SearchInput>;
}>;


export type DerivedAttributeConfigurationSearchPageQuery = { __typename?: 'Query', derivedAttributeConfigurationSearch?: { __typename?: 'DerivedAttributeConfigurationSearch', pagination: { __typename?: 'Pagination', totalItems?: number | null, offset: number, limit: number, hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'DerivedAttributeConfiguration', id: string, entityType: string, internalName: string, name: string, type: RulesEngineDerivedAttributeType, enabled: boolean }> } | null };

export type CreateQualityIssueConfigurationMutationVariables = Exact<{
  input: CreateQualityIssueConfigurationInput;
}>;


export type CreateQualityIssueConfigurationMutation = { __typename?: 'Mutation', createQualityIssueConfiguration?: { __typename?: 'CreateQualityIssueConfigurationPayload', success: boolean, qualityIssueConfiguration?: { __typename?: 'QualityIssueConfiguration', id: string } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } | null };

export type DeleteQualityIssueConfigurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteQualityIssueConfigurationMutation = { __typename?: 'Mutation', deleteQualityIssueConfiguration?: { __typename?: 'DeleteQualityIssueConfigurationPayload', success: boolean } | null };

export type SelectedRuleItemsFieldsFragment = { __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null };

export type QualityIssuePageFieldsFragment = { __typename?: 'QualityIssueConfiguration', id: string, entityType: string, internalName: string, name: string, order: number, enabled: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'User', id: string, type: string } | null, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> };

export type QualityIssueConfigurationPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QualityIssueConfigurationPageQuery = { __typename?: 'Query', qualityIssueConfiguration?: { __typename?: 'QualityIssueConfiguration', id: string, entityType: string, internalName: string, name: string, order: number, enabled: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'User', id: string, type: string } | null, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> } | null };

export type EditQualityIssueConfigurationMutationVariables = Exact<{
  input: UpdateQualityIssueConfigurationInput;
}>;


export type EditQualityIssueConfigurationMutation = { __typename?: 'Mutation', updateQualityIssueConfiguration?: { __typename?: 'UpdateQualityIssueConfigurationPayload', success: boolean, qualityIssueConfiguration?: { __typename?: 'QualityIssueConfiguration', id: string, entityType: string, internalName: string, name: string, order: number, enabled: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'User', id: string, type: string } | null, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } | null };

export type QualityIssueConfigurationPreviewQueryVariables = Exact<{
  input: QualityIssueConfigurationPreviewInput;
}>;


export type QualityIssueConfigurationPreviewQuery = { __typename?: 'Query', qualityIssueConfigurationPreview?: { __typename?: 'QualityIssueConfigurationPreview', items?: Array<{ __typename?: 'QualityIssueConfigurationPreviewItem', check: boolean, entityId: string }> | null } | null };

export type QualityIssueConfigurationSearchQueryVariables = Exact<{
  input?: InputMaybe<SearchInput>;
}>;


export type QualityIssueConfigurationSearchQuery = { __typename?: 'Query', qualityIssueConfigurationSearch?: { __typename?: 'QualityIssueConfigurationSearch', pagination: { __typename?: 'Pagination', totalItems?: number | null, offset: number, limit: number, hasPreviousPage: boolean, hasNextPage: boolean }, items: Array<{ __typename?: 'QualityIssueConfiguration', id: string, entityType: string, internalName: string, name: string, enabled: boolean }> } | null };

export type CreateRestrictionConfigurationMutationVariables = Exact<{
  input: CreateRestrictionConfigurationInput;
}>;


export type CreateRestrictionConfigurationMutation = { __typename?: 'Mutation', createRestrictionConfiguration?: { __typename?: 'CreateRestrictionConfigurationPayload', success: boolean, restrictionConfiguration?: { __typename?: 'RestrictionConfiguration', id: string } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } | null };

export type DeleteRestrictionConfigurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRestrictionConfigurationMutation = { __typename?: 'Mutation', deleteRestrictionConfiguration?: { __typename?: 'DeleteRestrictionConfigurationPayload', success: boolean } | null };

export type RestrictionPageFieldsFragment = { __typename?: 'RestrictionConfiguration', id: string, entityType: string, internalName: string, name: string, order: number, enabled: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'Staff', id: string, name: string } | null, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> };

export type RestrictionConfigurationPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestrictionConfigurationPageQuery = { __typename?: 'Query', restrictionConfiguration?: { __typename?: 'RestrictionConfiguration', id: string, entityType: string, internalName: string, name: string, order: number, enabled: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'Staff', id: string, name: string } | null, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> } | null };

export type EditRestrictionConfigurationMutationVariables = Exact<{
  input: UpdateRestrictionConfigurationInput;
}>;


export type EditRestrictionConfigurationMutation = { __typename?: 'Mutation', updateRestrictionConfiguration?: { __typename?: 'UpdateRestrictionConfigurationPayload', success: boolean, restrictionConfiguration?: { __typename?: 'RestrictionConfiguration', id: string, entityType: string, internalName: string, name: string, order: number, enabled: boolean, creationTime?: any | null, lastModificationTime?: any | null, lastModificationUser?: { __typename?: 'Staff', id: string, name: string } | null, availableRules: Array<{ __typename?: 'RulesEngineRule', id: string, name: string, internalName: string, description?: string | null, inputs?: Array<{ __typename?: 'RulesEngineRuleInputConfig', internalName: string, label: string, order?: number | null, validation?: { __typename: 'RulesEngineRuleInputValidationDropdown', multiSelect?: boolean | null, items?: Array<{ __typename?: 'RulesEngineRuleInputValidationDropdownItem', label: string, value: string }> | null } | { __typename: 'RulesEngineRuleInputValidationFreeText', minCharLength?: number | null, maxCharLength?: number | null } | { __typename: 'RulesEngineRuleInputValidationInteger', multiInput?: boolean | null, min?: number | null, max?: number | null } | { __typename: 'RulesEngineRuleInputValidationInterval', lowerBound?: number | null, upperBound?: number | null } | null }> | null }>, rules: Array<{ __typename?: 'RulesEngineRuleItem', uid: string, clause: RulesEngineRuleItemClause, operation: RulesEngineRuleItemOperation, ruleId?: string | null, parent?: { __typename?: 'RulesEngineRuleItem', uid: string } | null, params?: Array<{ __typename?: 'RulesEngineRuleItemParams', key: string, value?: { __typename?: 'RulesEngineRuleItemParamsValue', dropdown?: { __typename?: 'RulesEngineRuleItemParamsDropdown', values?: Array<string> | null } | null, freeText?: { __typename?: 'RulesEngineRuleItemParamsFreeText', values?: Array<string> | null } | null, integer?: { __typename?: 'RulesEngineRuleItemParamsInteger', value?: number | null } | null, interval?: { __typename?: 'RulesEngineRuleItemParamsInterval', lowerBound?: number | null, upperBound?: number | null } | null } | null }> | null }> } | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } | null };

export type RestrictionConfigurationPreviewQueryVariables = Exact<{
  input: RestrictionConfigurationPreviewInput;
}>;


export type RestrictionConfigurationPreviewQuery = { __typename?: 'Query', restrictionConfigurationPreview?: { __typename?: 'RestrictionConfigurationPreview', items?: Array<{ __typename?: 'RestrictionConfigurationPreviewItem', check: boolean, entityId: string }> | null } | null };

export type RestrictionConfigurationSearchQueryVariables = Exact<{
  input?: InputMaybe<SearchInput>;
}>;


export type RestrictionConfigurationSearchQuery = { __typename?: 'Query', restrictionConfigurationSearch?: { __typename?: 'RestrictionConfigurationSearch', pagination: { __typename?: 'Pagination', totalItems?: number | null, offset: number, limit: number, hasPreviousPage: boolean, hasNextPage: boolean }, items: Array<{ __typename?: 'RestrictionConfiguration', id: string, entityType: string, internalName: string, name: string, enabled: boolean }> } | null };

export type SupplierEmailActionMutationVariables = Exact<{
  input: SupplierEmailInput;
}>;


export type SupplierEmailActionMutation = { __typename?: 'Mutation', supplierEmailAction?: boolean | null };

export type TagsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TagsQuery = { __typename?: 'Query', tags?: Array<{ __typename?: 'Tag', id: string, name: string, internalName: string, type?: TagType | null, status?: TagStatus | null, hideFromTagSelector?: boolean | null, rejectionReason?: string | null, description?: string | null, updateTimestamp?: any | null }> | null };

export type UpdateTagsMutationVariables = Exact<{
  input: Array<UpdateTagInput> | UpdateTagInput;
}>;


export type UpdateTagsMutation = { __typename?: 'Mutation', updateTags?: { __typename?: 'UpdateTagsPayload', tags: Array<{ __typename?: 'Tag', id: string, name: string, internalName: string, type?: TagType | null, status?: TagStatus | null, hideFromTagSelector?: boolean | null, rejectionReason?: string | null, description?: string | null, updateTimestamp?: any | null, parent?: { __typename?: 'Tag', id: string, name: string, internalName: string, status?: TagStatus | null, type?: TagType | null, hideFromTagSelector?: boolean | null, updateTimestamp?: any | null } | null, children?: Array<{ __typename?: 'Tag', id: string, name: string, hideFromTagSelector?: boolean | null, status?: TagStatus | null, type?: TagType | null, updateTimestamp?: any | null }> | null, translations?: Array<{ __typename?: 'TagTranslation', name: string, languageId: number, updateTimestamp?: any | null }> | null } | null> } | null };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag?: { __typename?: 'CreateTagPayload', tag?: { __typename?: 'Tag', id: string, name: string, internalName: string, type?: TagType | null, status?: TagStatus | null, hideFromTagSelector?: boolean | null, rejectionReason?: string | null, description?: string | null, updateTimestamp?: any | null, parent?: { __typename?: 'Tag', id: string, name: string, internalName: string, status?: TagStatus | null, type?: TagType | null, hideFromTagSelector?: boolean | null, updateTimestamp?: any | null } | null, children?: Array<{ __typename?: 'Tag', id: string, name: string, hideFromTagSelector?: boolean | null, status?: TagStatus | null, type?: TagType | null, updateTimestamp?: any | null }> | null, translations?: Array<{ __typename?: 'TagTranslation', name: string, languageId: number, updateTimestamp?: any | null }> | null } | null } | null };

export type TagQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', id: string, name: string, internalName: string, type?: TagType | null, status?: TagStatus | null, hideFromTagSelector?: boolean | null, rejectionReason?: string | null, description?: string | null, updateTimestamp?: any | null, parent?: { __typename?: 'Tag', id: string, name: string, internalName: string, status?: TagStatus | null, type?: TagType | null, hideFromTagSelector?: boolean | null, updateTimestamp?: any | null } | null, children?: Array<{ __typename?: 'Tag', id: string, name: string, hideFromTagSelector?: boolean | null, status?: TagStatus | null, type?: TagType | null, updateTimestamp?: any | null }> | null, translations?: Array<{ __typename?: 'TagTranslation', name: string, languageId: number, updateTimestamp?: any | null }> | null } | null };

export type TagsSearchNameIncludesQueryVariables = Exact<{
  input: SearchInput;
}>;


export type TagsSearchNameIncludesQuery = { __typename?: 'Query', tagSearch?: { __typename?: 'TagSearchResult', items: Array<{ __typename?: 'Tag', id: string, name: string, internalName: string, hideFromTagSelector?: boolean | null, status?: TagStatus | null, type?: TagType | null, updateTimestamp?: any | null }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, hasPreviousPage: boolean, totalItems?: number | null, offset: number, limit: number } } | null };

export type TagDatatableQueryVariables = Exact<{
  input: SearchInput;
}>;


export type TagDatatableQuery = { __typename?: 'Query', tagSearch?: { __typename?: 'TagSearchResult', items: Array<{ __typename?: 'Tag', id: string, name: string, internalName: string, hideFromTagSelector?: boolean | null, status?: TagStatus | null, tours?: number | null, type?: TagType | null, updateTimestamp?: any | null, parent?: { __typename?: 'Tag', id: string, name: string } | null }>, pagination: { __typename?: 'Pagination', hasNextPage: boolean, hasPreviousPage: boolean, totalItems?: number | null, offset: number, limit: number } } | null };

export type PushForTranslationMutationVariables = Exact<{
  input: PushForTranslationInput;
}>;


export type PushForTranslationMutation = { __typename?: 'Mutation', pushForTranslation?: { __typename?: 'PushForTranslationPayload', success: boolean } | null };

export type ReprocessDelayedXtmTourPushMutationVariables = Exact<{
  xtmDelayedTourPushId: Scalars['Int']['input'];
}>;


export type ReprocessDelayedXtmTourPushMutation = { __typename?: 'Mutation', reprocessXTMDelayedTourPush: boolean };
